/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var _defineProperty2 = __webpack_require__(75);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _CITC_PANEL_ID$OFCA_P;
	
	var _browser = __webpack_require__(95);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _tracing = __webpack_require__(126);
	
	__webpack_require__(202);
	
	var _changeStyles = __webpack_require__(146);
	
	var _changeStyles2 = _interopRequireDefault(_changeStyles);
	
	var _setupTest = __webpack_require__(150);
	
	var _setupTest2 = _interopRequireDefault(_setupTest);
	
	var _setupAnimatedTest = __webpack_require__(149);
	
	var _setupAnimatedTest2 = _interopRequireDefault(_setupAnimatedTest);
	
	var _qs = __webpack_require__(24);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _detectDevice = __webpack_require__(147);
	
	var _detectDevice2 = _interopRequireDefault(_detectDevice);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Sentry.init({
	  dsn: 'https://6bc834b2b80847539956bbe6be536663@sentry.io/4361155',
	
	  release: 'my-project-name@' + process.env.npm_package_version,
	  integrations: [new _tracing.Integrations.BrowserTracing()],
	  environment: process.env.NODE_ENV
	});
	
	var OFCA_PANEL_ID = 261;
	var CITC_PANEL_ID = 235;
	var VIRGIN_PANEL_ID = 1013;
	var STG_WEB_AGENTS_DEMO = 1025;
	
	var targetSet = (_CITC_PANEL_ID$OFCA_P = {}, (0, _defineProperty3.default)(_CITC_PANEL_ID$OFCA_P, CITC_PANEL_ID, 'offnet-citc'), (0, _defineProperty3.default)(_CITC_PANEL_ID$OFCA_P, OFCA_PANEL_ID, 'ofca-web-datapacket'), (0, _defineProperty3.default)(_CITC_PANEL_ID$OFCA_P, VIRGIN_PANEL_ID, 'offnet-virgin-100g'), (0, _defineProperty3.default)(_CITC_PANEL_ID$OFCA_P, STG_WEB_AGENTS_DEMO, 'offnet-virgin-100g'), _CITC_PANEL_ID$OFCA_P)[(0, _qs2.default)('panel-id')];
	
	var options = {
	  global: {
	    targetSet: targetSet,
	    useTestServersInParallel: true
	  },
	  download: {},
	  upload: {},
	  ingestion: {
	    ingestionApi: ("https://ingestion-api.samknows.com"),
	    panelId: parseInt((0, _qs2.default)('panel-id'), 10)
	  }
	};
	
	if ((0, _qs2.default)('test-server')) {
	  options.global.testServers = [(0, _qs2.default)('test-server')];
	}
	
	if (parseInt((0, _qs2.default)('panel-id'), 10) === OFCA_PANEL_ID) {
	  options.global.warmupDuration = 6000;
	  options.download.duration = 9000;
	  options.upload.duration = 9000;
	}
	
	if (parseInt((0, _qs2.default)('panel-id'), 10) === CITC_PANEL_ID) {
	  options.global.wsTestServerPort = location.protocol === 'https:' ? 443 : 6501;
	}
	
	if ((0, _qs2.default)('test') === 'animated') {
	  (0, _setupAnimatedTest2.default)(options);
	} else {
	  (0, _setupTest2.default)(options);
	}
	
	(0, _changeStyles2.default)();
	
	_detectDevice2.default.getDevice().then(function (device) {
	  options.ingestion.device = device;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	tslib_1.__exportStar(__webpack_require__(137), exports);
	tslib_1.__exportStar(__webpack_require__(66), exports);
	tslib_1.__exportStar(__webpack_require__(138), exports);
	tslib_1.__exportStar(__webpack_require__(41), exports);
	tslib_1.__exportStar(__webpack_require__(139), exports);
	tslib_1.__exportStar(__webpack_require__(11), exports);
	tslib_1.__exportStar(__webpack_require__(42), exports);
	tslib_1.__exportStar(__webpack_require__(67), exports);
	tslib_1.__exportStar(__webpack_require__(18), exports);
	tslib_1.__exportStar(__webpack_require__(43), exports);
	tslib_1.__exportStar(__webpack_require__(44), exports);
	tslib_1.__exportStar(__webpack_require__(140), exports);
	tslib_1.__exportStar(__webpack_require__(142), exports);
	tslib_1.__exportStar(__webpack_require__(45), exports);
	tslib_1.__exportStar(__webpack_require__(46), exports);
	tslib_1.__exportStar(__webpack_require__(68), exports);
	tslib_1.__exportStar(__webpack_require__(69), exports);
	tslib_1.__exportStar(__webpack_require__(143), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var minimal_1 = __webpack_require__(114);
	exports.addBreadcrumb = minimal_1.addBreadcrumb;
	exports.captureException = minimal_1.captureException;
	exports.captureEvent = minimal_1.captureEvent;
	exports.captureMessage = minimal_1.captureMessage;
	exports.configureScope = minimal_1.configureScope;
	exports.startTransaction = minimal_1.startTransaction;
	exports.setContext = minimal_1.setContext;
	exports.setExtra = minimal_1.setExtra;
	exports.setExtras = minimal_1.setExtras;
	exports.setTag = minimal_1.setTag;
	exports.setTags = minimal_1.setTags;
	exports.setUser = minimal_1.setUser;
	exports.withScope = minimal_1.withScope;
	var hub_1 = __webpack_require__(7);
	exports.addGlobalEventProcessor = hub_1.addGlobalEventProcessor;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.Scope = hub_1.Scope;
	var api_1 = __webpack_require__(104);
	exports.API = api_1.API;
	var baseclient_1 = __webpack_require__(106);
	exports.BaseClient = baseclient_1.BaseClient;
	var basebackend_1 = __webpack_require__(105);
	exports.BaseBackend = basebackend_1.BaseBackend;
	var request_1 = __webpack_require__(111);
	exports.eventToSentryRequest = request_1.eventToSentryRequest;
	exports.sessionToSentryRequest = request_1.sessionToSentryRequest;
	var sdk_1 = __webpack_require__(112);
	exports.initAndBind = sdk_1.initAndBind;
	var noop_1 = __webpack_require__(61);
	exports.NoopTransport = noop_1.NoopTransport;
	var Integrations = __webpack_require__(110);
	exports.Integrations = Integrations;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(87)('wks');
	var uid = __webpack_require__(91);
	var Symbol = __webpack_require__(5).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var scope_1 = __webpack_require__(62);
	exports.addGlobalEventProcessor = scope_1.addGlobalEventProcessor;
	exports.Scope = scope_1.Scope;
	var session_1 = __webpack_require__(63);
	exports.Session = session_1.Session;
	var hub_1 = __webpack_require__(113);
	exports.getActiveDomain = hub_1.getActiveDomain;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.getMainCarrier = hub_1.getMainCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.setHubOnCarrier = hub_1.setHubOnCarrier;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var loglevel_1 = __webpack_require__(132);
	exports.LogLevel = loglevel_1.LogLevel;
	var session_1 = __webpack_require__(133);
	exports.SessionStatus = session_1.SessionStatus;
	var severity_1 = __webpack_require__(134);
	exports.Severity = severity_1.Severity;
	var status_1 = __webpack_require__(135);
	exports.Status = status_1.Status;
	var transaction_1 = __webpack_require__(136);
	exports.TransactionSamplingMethod = transaction_1.TransactionSamplingMethod;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(4);
	var ctx = __webpack_require__(27);
	var hide = __webpack_require__(15);
	var has = __webpack_require__(29);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hub_1 = __webpack_require__(7);
	exports.TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
	    '([0-9a-f]{32})?' + // trace_id
	    '-?([0-9a-f]{16})?' + // span_id
	    '-?([01])?' + // sampled
	    '[ \\t]*$');
	/**
	 * Determines if tracing is currently enabled.
	 *
	 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
	 */
	function hasTracingEnabled(options) {
	    return 'tracesSampleRate' in options || 'tracesSampler' in options;
	}
	exports.hasTracingEnabled = hasTracingEnabled;
	/**
	 * Extract transaction context data from a `sentry-trace` header.
	 *
	 * @param traceparent Traceparent string
	 *
	 * @returns Object containing data from the header, or undefined if traceparent string is malformed
	 */
	function extractTraceparentData(traceparent) {
	    var matches = traceparent.match(exports.TRACEPARENT_REGEXP);
	    if (matches) {
	        var parentSampled = void 0;
	        if (matches[3] === '1') {
	            parentSampled = true;
	        }
	        else if (matches[3] === '0') {
	            parentSampled = false;
	        }
	        return {
	            traceId: matches[1],
	            parentSampled: parentSampled,
	            parentSpanId: matches[2],
	        };
	    }
	    return undefined;
	}
	exports.extractTraceparentData = extractTraceparentData;
	/** Grabs active transaction off scope, if any */
	function getActiveTransaction(hub) {
	    if (hub === void 0) { hub = hub_1.getCurrentHub(); }
	    var _a, _b;
	    return (_b = (_a = hub) === null || _a === void 0 ? void 0 : _a.getScope()) === null || _b === void 0 ? void 0 : _b.getTransaction();
	}
	exports.getActiveTransaction = getActiveTransaction;
	/**
	 * Converts from milliseconds to seconds
	 * @param time time in ms
	 */
	function msToSec(time) {
	    return time / 1000;
	}
	exports.msToSec = msToSec;
	/**
	 * Converts from seconds to milliseconds
	 * @param time time in seconds
	 */
	function secToMs(time) {
	    return time * 1000;
	}
	exports.secToMs = secToMs;
	// so it can be used in manual instrumentation without necessitating a hard dependency on @sentry/utils
	var utils_1 = __webpack_require__(1);
	exports.stripUrlQueryAndFragment = utils_1.stripUrlQueryAndFragment;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Checks whether given value's type is one of a few Error or Error-like
	 * {@link isError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isError(wat) {
	    switch (Object.prototype.toString.call(wat)) {
	        case '[object Error]':
	            return true;
	        case '[object Exception]':
	            return true;
	        case '[object DOMException]':
	            return true;
	        default:
	            return isInstanceOf(wat, Error);
	    }
	}
	exports.isError = isError;
	/**
	 * Checks whether given value's type is ErrorEvent
	 * {@link isErrorEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isErrorEvent(wat) {
	    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
	}
	exports.isErrorEvent = isErrorEvent;
	/**
	 * Checks whether given value's type is DOMError
	 * {@link isDOMError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMError(wat) {
	    return Object.prototype.toString.call(wat) === '[object DOMError]';
	}
	exports.isDOMError = isDOMError;
	/**
	 * Checks whether given value's type is DOMException
	 * {@link isDOMException}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMException(wat) {
	    return Object.prototype.toString.call(wat) === '[object DOMException]';
	}
	exports.isDOMException = isDOMException;
	/**
	 * Checks whether given value's type is a string
	 * {@link isString}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isString(wat) {
	    return Object.prototype.toString.call(wat) === '[object String]';
	}
	exports.isString = isString;
	/**
	 * Checks whether given value's is a primitive (undefined, null, number, boolean, string, bigint, symbol)
	 * {@link isPrimitive}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPrimitive(wat) {
	    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
	}
	exports.isPrimitive = isPrimitive;
	/**
	 * Checks whether given value's type is an object literal
	 * {@link isPlainObject}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPlainObject(wat) {
	    return Object.prototype.toString.call(wat) === '[object Object]';
	}
	exports.isPlainObject = isPlainObject;
	/**
	 * Checks whether given value's type is an Event instance
	 * {@link isEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isEvent(wat) {
	    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
	}
	exports.isEvent = isEvent;
	/**
	 * Checks whether given value's type is an Element instance
	 * {@link isElement}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isElement(wat) {
	    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
	}
	exports.isElement = isElement;
	/**
	 * Checks whether given value's type is an regexp
	 * {@link isRegExp}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isRegExp(wat) {
	    return Object.prototype.toString.call(wat) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	/**
	 * Checks whether given value has a then function.
	 * @param wat A value to be checked.
	 */
	function isThenable(wat) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return Boolean(wat && wat.then && typeof wat.then === 'function');
	}
	exports.isThenable = isThenable;
	/**
	 * Checks whether given value's type is a SyntheticEvent
	 * {@link isSyntheticEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isSyntheticEvent(wat) {
	    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
	}
	exports.isSyntheticEvent = isSyntheticEvent;
	/**
	 * Checks whether given value's type is an instance of provided constructor.
	 * {@link isInstanceOf}.
	 *
	 * @param wat A value to be checked.
	 * @param base A constructor to be used in a check.
	 * @returns A boolean representing the result.
	 */
	function isInstanceOf(wat, base) {
	    try {
	        return wat instanceof base;
	    }
	    catch (_e) {
	        return false;
	    }
	}
	exports.isInstanceOf = isInstanceOf;
	//# sourceMappingURL=is.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(28)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** The status of an Span. */
	// eslint-disable-next-line import/export
	var SpanStatus;
	(function (SpanStatus) {
	    /** The operation completed successfully. */
	    SpanStatus["Ok"] = "ok";
	    /** Deadline expired before operation could complete. */
	    SpanStatus["DeadlineExceeded"] = "deadline_exceeded";
	    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */
	    SpanStatus["Unauthenticated"] = "unauthenticated";
	    /** 403 Forbidden */
	    SpanStatus["PermissionDenied"] = "permission_denied";
	    /** 404 Not Found. Some requested entity (file or directory) was not found. */
	    SpanStatus["NotFound"] = "not_found";
	    /** 429 Too Many Requests */
	    SpanStatus["ResourceExhausted"] = "resource_exhausted";
	    /** Client specified an invalid argument. 4xx. */
	    SpanStatus["InvalidArgument"] = "invalid_argument";
	    /** 501 Not Implemented */
	    SpanStatus["Unimplemented"] = "unimplemented";
	    /** 503 Service Unavailable */
	    SpanStatus["Unavailable"] = "unavailable";
	    /** Other/generic 5xx. */
	    SpanStatus["InternalError"] = "internal_error";
	    /** Unknown. Any non-standard HTTP status code. */
	    SpanStatus["UnknownError"] = "unknown_error";
	    /** The operation was cancelled (typically by the user). */
	    SpanStatus["Cancelled"] = "cancelled";
	    /** Already exists (409) */
	    SpanStatus["AlreadyExists"] = "already_exists";
	    /** Operation was rejected because the system is not in a state required for the operation's */
	    SpanStatus["FailedPrecondition"] = "failed_precondition";
	    /** The operation was aborted, typically due to a concurrency issue. */
	    SpanStatus["Aborted"] = "aborted";
	    /** Operation was attempted past the valid range. */
	    SpanStatus["OutOfRange"] = "out_of_range";
	    /** Unrecoverable data loss or corruption */
	    SpanStatus["DataLoss"] = "data_loss";
	})(SpanStatus = exports.SpanStatus || (exports.SpanStatus = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (SpanStatus) {
	    /**
	     * Converts a HTTP status code into a {@link SpanStatus}.
	     *
	     * @param httpStatus The HTTP response status code.
	     * @returns The span status or {@link SpanStatus.UnknownError}.
	     */
	    function fromHttpCode(httpStatus) {
	        if (httpStatus < 400) {
	            return SpanStatus.Ok;
	        }
	        if (httpStatus >= 400 && httpStatus < 500) {
	            switch (httpStatus) {
	                case 401:
	                    return SpanStatus.Unauthenticated;
	                case 403:
	                    return SpanStatus.PermissionDenied;
	                case 404:
	                    return SpanStatus.NotFound;
	                case 409:
	                    return SpanStatus.AlreadyExists;
	                case 413:
	                    return SpanStatus.FailedPrecondition;
	                case 429:
	                    return SpanStatus.ResourceExhausted;
	                default:
	                    return SpanStatus.InvalidArgument;
	            }
	        }
	        if (httpStatus >= 500 && httpStatus < 600) {
	            switch (httpStatus) {
	                case 501:
	                    return SpanStatus.Unimplemented;
	                case 503:
	                    return SpanStatus.Unavailable;
	                case 504:
	                    return SpanStatus.DeadlineExceeded;
	                default:
	                    return SpanStatus.InternalError;
	            }
	        }
	        return SpanStatus.UnknownError;
	    }
	    SpanStatus.fromHttpCode = fromHttpCode;
	})(SpanStatus = exports.SpanStatus || (exports.SpanStatus = {}));
	//# sourceMappingURL=spanstatus.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(21);
	var createDesc = __webpack_require__(86);
	module.exports = __webpack_require__(13) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var core_1 = __webpack_require__(3);
	var utils_1 = __webpack_require__(1);
	var ignoreOnError = 0;
	/**
	 * @hidden
	 */
	function shouldIgnoreOnError() {
	    return ignoreOnError > 0;
	}
	exports.shouldIgnoreOnError = shouldIgnoreOnError;
	/**
	 * @hidden
	 */
	function ignoreNextOnError() {
	    // onerror should trigger before setTimeout
	    ignoreOnError += 1;
	    setTimeout(function () {
	        ignoreOnError -= 1;
	    });
	}
	exports.ignoreNextOnError = ignoreNextOnError;
	/**
	 * Instruments the given function and sends an event to Sentry every time the
	 * function throws an exception.
	 *
	 * @param fn A function to wrap.
	 * @returns The wrapped function.
	 * @hidden
	 */
	function wrap(fn, options, before) {
	    if (options === void 0) { options = {}; }
	    if (typeof fn !== 'function') {
	        return fn;
	    }
	    try {
	        // We don't wanna wrap it twice
	        if (fn.__sentry__) {
	            return fn;
	        }
	        // If this has already been wrapped in the past, return that wrapped function
	        if (fn.__sentry_wrapped__) {
	            return fn.__sentry_wrapped__;
	        }
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        // Bail on wrapping and return the function as-is (defers to window.onerror).
	        return fn;
	    }
	    /* eslint-disable prefer-rest-params */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var sentryWrapped = function () {
	        var args = Array.prototype.slice.call(arguments);
	        try {
	            if (before && typeof before === 'function') {
	                before.apply(this, arguments);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
	            if (fn.handleEvent) {
	                // Attempt to invoke user-land function
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	                //       means the sentry.javascript SDK caught an error invoking your application code. This
	                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                return fn.handleEvent.apply(this, wrappedArguments);
	            }
	            // Attempt to invoke user-land function
	            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	            //       means the sentry.javascript SDK caught an error invoking your application code. This
	            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
	            return fn.apply(this, wrappedArguments);
	        }
	        catch (ex) {
	            ignoreNextOnError();
	            core_1.withScope(function (scope) {
	                scope.addEventProcessor(function (event) {
	                    var processedEvent = tslib_1.__assign({}, event);
	                    if (options.mechanism) {
	                        utils_1.addExceptionTypeValue(processedEvent, undefined, undefined);
	                        utils_1.addExceptionMechanism(processedEvent, options.mechanism);
	                    }
	                    processedEvent.extra = tslib_1.__assign(tslib_1.__assign({}, processedEvent.extra), { arguments: args });
	                    return processedEvent;
	                });
	                core_1.captureException(ex);
	            });
	            throw ex;
	        }
	    };
	    /* eslint-enable prefer-rest-params */
	    // Accessing some objects may throw
	    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
	    try {
	        for (var property in fn) {
	            if (Object.prototype.hasOwnProperty.call(fn, property)) {
	                sentryWrapped[property] = fn[property];
	            }
	        }
	    }
	    catch (_oO) { } // eslint-disable-line no-empty
	    fn.prototype = fn.prototype || {};
	    sentryWrapped.prototype = fn.prototype;
	    Object.defineProperty(fn, '__sentry_wrapped__', {
	        enumerable: false,
	        value: sentryWrapped,
	    });
	    // Signal that this function has been wrapped/filled already
	    // for both debugging and to prevent it to being wrapped/filled twice
	    Object.defineProperties(sentryWrapped, {
	        __sentry__: {
	            enumerable: false,
	            value: true,
	        },
	        __sentry_original__: {
	            enumerable: false,
	            value: fn,
	        },
	    });
	    // Restore original function name (not all browsers allow that)
	    try {
	        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
	        if (descriptor.configurable) {
	            Object.defineProperty(sentryWrapped, 'name', {
	                get: function () {
	                    return fn.name;
	                },
	            });
	        }
	        // eslint-disable-next-line no-empty
	    }
	    catch (_oO) { }
	    return sentryWrapped;
	}
	exports.wrap = wrap;
	/**
	 * Injects the Report Dialog script
	 * @hidden
	 */
	function injectReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    if (!options.eventId) {
	        utils_1.logger.error("Missing eventId option in showReportDialog call");
	        return;
	    }
	    if (!options.dsn) {
	        utils_1.logger.error("Missing dsn option in showReportDialog call");
	        return;
	    }
	    var script = document.createElement('script');
	    script.async = true;
	    script.src = new core_1.API(options.dsn).getReportDialogEndpoint(options);
	    if (options.onLoad) {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        script.onload = options.onLoad;
	    }
	    (document.head || document.body).appendChild(script);
	}
	exports.injectReportDialog = injectReportDialog;
	//# sourceMappingURL=helpers.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });
	var node_1 = __webpack_require__(43);
	var string_1 = __webpack_require__(46);
	var fallbackGlobalObject = {};
	/**
	 * Safely get global scope object
	 *
	 * @returns Global scope object
	 */
	function getGlobalObject() {
	    return (node_1.isNodeEnv()
	        ? global
	        : typeof window !== 'undefined'
	            ? window
	            : typeof self !== 'undefined'
	                ? self
	                : fallbackGlobalObject);
	}
	exports.getGlobalObject = getGlobalObject;
	/**
	 * UUID4 generator
	 *
	 * @returns string Generated UUID4.
	 */
	function uuid4() {
	    var global = getGlobalObject();
	    var crypto = global.crypto || global.msCrypto;
	    if (!(crypto === void 0) && crypto.getRandomValues) {
	        // Use window.crypto API if available
	        var arr = new Uint16Array(8);
	        crypto.getRandomValues(arr);
	        // set 4 in byte 7
	        // eslint-disable-next-line no-bitwise
	        arr[3] = (arr[3] & 0xfff) | 0x4000;
	        // set 2 most significant bits of byte 9 to '10'
	        // eslint-disable-next-line no-bitwise
	        arr[4] = (arr[4] & 0x3fff) | 0x8000;
	        var pad = function (num) {
	            var v = num.toString(16);
	            while (v.length < 4) {
	                v = "0" + v;
	            }
	            return v;
	        };
	        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
	    }
	    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        // eslint-disable-next-line no-bitwise
	        var r = (Math.random() * 16) | 0;
	        // eslint-disable-next-line no-bitwise
	        var v = c === 'x' ? r : (r & 0x3) | 0x8;
	        return v.toString(16);
	    });
	}
	exports.uuid4 = uuid4;
	/**
	 * Parses string form of URL into an object
	 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	 * // intentionally using regex and not <a/> href parsing trick because React Native and other
	 * // environments where DOM might not be available
	 * @returns parsed URL object
	 */
	function parseUrl(url) {
	    if (!url) {
	        return {};
	    }
	    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	    if (!match) {
	        return {};
	    }
	    // coerce to undefined values to empty string so we don't get 'undefined'
	    var query = match[6] || '';
	    var fragment = match[8] || '';
	    return {
	        host: match[4],
	        path: match[5],
	        protocol: match[2],
	        relative: match[5] + query + fragment,
	    };
	}
	exports.parseUrl = parseUrl;
	/**
	 * Extracts either message or type+value from an event that can be used for user-facing logs
	 * @returns event's description
	 */
	function getEventDescription(event) {
	    if (event.message) {
	        return event.message;
	    }
	    if (event.exception && event.exception.values && event.exception.values[0]) {
	        var exception = event.exception.values[0];
	        if (exception.type && exception.value) {
	            return exception.type + ": " + exception.value;
	        }
	        return exception.type || exception.value || event.event_id || '<unknown>';
	    }
	    return event.event_id || '<unknown>';
	}
	exports.getEventDescription = getEventDescription;
	/** JSDoc */
	function consoleSandbox(callback) {
	    var global = getGlobalObject();
	    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
	    if (!('console' in global)) {
	        return callback();
	    }
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    var originalConsole = global.console;
	    var wrappedLevels = {};
	    // Restore all wrapped console methods
	    levels.forEach(function (level) {
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        if (level in global.console && originalConsole[level].__sentry_original__) {
	            wrappedLevels[level] = originalConsole[level];
	            originalConsole[level] = originalConsole[level].__sentry_original__;
	        }
	    });
	    // Perform callback manipulations
	    var result = callback();
	    // Revert restoration to wrapped state
	    Object.keys(wrappedLevels).forEach(function (level) {
	        originalConsole[level] = wrappedLevels[level];
	    });
	    return result;
	}
	exports.consoleSandbox = consoleSandbox;
	/**
	 * Adds exception values, type and value to an synthetic Exception.
	 * @param event The event to modify.
	 * @param value Value of the exception.
	 * @param type Type of the exception.
	 * @hidden
	 */
	function addExceptionTypeValue(event, value, type) {
	    event.exception = event.exception || {};
	    event.exception.values = event.exception.values || [];
	    event.exception.values[0] = event.exception.values[0] || {};
	    event.exception.values[0].value = event.exception.values[0].value || value || '';
	    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
	}
	exports.addExceptionTypeValue = addExceptionTypeValue;
	/**
	 * Adds exception mechanism to a given event.
	 * @param event The event to modify.
	 * @param mechanism Mechanism of the mechanism.
	 * @hidden
	 */
	function addExceptionMechanism(event, mechanism) {
	    if (mechanism === void 0) { mechanism = {}; }
	    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
	    try {
	        // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
	        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
	        Object.keys(mechanism).forEach(function (key) {
	            // @ts-ignore Mechanism has no index signature
	            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	            event.exception.values[0].mechanism[key] = mechanism[key];
	        });
	    }
	    catch (_oO) {
	        // no-empty
	    }
	}
	exports.addExceptionMechanism = addExceptionMechanism;
	/**
	 * A safe form of location.href
	 */
	function getLocationHref() {
	    try {
	        return document.location.href;
	    }
	    catch (oO) {
	        return '';
	    }
	}
	exports.getLocationHref = getLocationHref;
	// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
	var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
	/**
	 * Parses input into a SemVer interface
	 * @param input string representation of a semver version
	 */
	function parseSemver(input) {
	    var match = input.match(SEMVER_REGEXP) || [];
	    var major = parseInt(match[1], 10);
	    var minor = parseInt(match[2], 10);
	    var patch = parseInt(match[3], 10);
	    return {
	        buildmetadata: match[5],
	        major: isNaN(major) ? undefined : major,
	        minor: isNaN(minor) ? undefined : minor,
	        patch: isNaN(patch) ? undefined : patch,
	        prerelease: match[4],
	    };
	}
	exports.parseSemver = parseSemver;
	var defaultRetryAfter = 60 * 1000; // 60 seconds
	/**
	 * Extracts Retry-After value from the request header or returns default value
	 * @param now current unix timestamp
	 * @param header string representation of 'Retry-After' header
	 */
	function parseRetryAfterHeader(now, header) {
	    if (!header) {
	        return defaultRetryAfter;
	    }
	    var headerDelay = parseInt("" + header, 10);
	    if (!isNaN(headerDelay)) {
	        return headerDelay * 1000;
	    }
	    var headerDate = Date.parse("" + header);
	    if (!isNaN(headerDate)) {
	        return headerDate - now;
	    }
	    return defaultRetryAfter;
	}
	exports.parseRetryAfterHeader = parseRetryAfterHeader;
	/**
	 * This function adds context (pre/post/line) lines to the provided frame
	 *
	 * @param lines string[] containing all lines
	 * @param frame StackFrame that will be mutated
	 * @param linesOfContext number of context lines we want to add pre/post
	 */
	function addContextToFrame(lines, frame, linesOfContext) {
	    if (linesOfContext === void 0) { linesOfContext = 5; }
	    var lineno = frame.lineno || 0;
	    var maxLines = lines.length;
	    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
	    frame.pre_context = lines
	        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	    frame.context_line = string_1.snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
	    frame.post_context = lines
	        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	}
	exports.addContextToFrame = addContextToFrame;
	/**
	 * Strip the query string and fragment off of a given URL or path (if present)
	 *
	 * @param urlPath Full URL or path, including possible query string and/or fragment
	 * @returns URL or path without query string or fragment
	 */
	function stripUrlQueryAndFragment(urlPath) {
	    // eslint-disable-next-line no-useless-escape
	    return urlPath.split(/[\?#]/, 1)[0];
	}
	exports.stripUrlQueryAndFragment = stripUrlQueryAndFragment;
	//# sourceMappingURL=misc.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(12);
	var IE8_DOM_DEFINE = __webpack_require__(167);
	var toPrimitive = __webpack_require__(187);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(13) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var generateUniqueID_1 = __webpack_require__(123);
	exports.initMetric = function (name, value) {
	    if (value === void 0) { value = -1; }
	    return {
	        name: name,
	        value: value,
	        delta: 0,
	        entries: [],
	        id: generateUniqueID_1.generateUniqueID(),
	        isFinal: false,
	    };
	};
	//# sourceMappingURL=initMetric.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var isUnloading = false;
	var listenersAdded = false;
	var onPageHide = function (event) {
	    isUnloading = !event.persisted;
	};
	var addListeners = function () {
	    addEventListener('pagehide', onPageHide);
	    // `beforeunload` is needed to fix this bug:
	    // https://bugs.chromium.org/p/chromium/issues/detail?id=987409
	    // eslint-disable-next-line @typescript-eslint/no-empty-function
	    addEventListener('beforeunload', function () { });
	};
	exports.onHidden = function (cb, once) {
	    if (once === void 0) { once = false; }
	    if (!listenersAdded) {
	        addListeners();
	        listenersAdded = true;
	    }
	    addEventListener('visibilitychange', function (_a) {
	        var timeStamp = _a.timeStamp;
	        if (document.visibilityState === 'hidden') {
	            cb({ timeStamp: timeStamp, isUnloading: isUnloading });
	        }
	    }, { capture: true, once: once });
	};
	//# sourceMappingURL=onHidden.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = qs;
	var search = window.location.search.split(/[?=&]/);
	
	function qs(segment) {
	  if (search.indexOf(segment) === -1) {
	    return undefined;
	  }
	
	  return decodeURIComponent(search[search.indexOf(segment) + 1]);
	}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(25);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(1);
	var parsers_1 = __webpack_require__(58);
	var tracekit_1 = __webpack_require__(32);
	/**
	 * Builds and Event from a Exception
	 * @hidden
	 */
	function eventFromException(options, exception, hint) {
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromUnknownInput(exception, syntheticException, {
	        attachStacktrace: options.attachStacktrace,
	    });
	    utils_1.addExceptionMechanism(event, {
	        handled: true,
	        type: 'generic',
	    });
	    event.level = types_1.Severity.Error;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.SyncPromise.resolve(event);
	}
	exports.eventFromException = eventFromException;
	/**
	 * Builds and Event from a Message
	 * @hidden
	 */
	function eventFromMessage(options, message, level, hint) {
	    if (level === void 0) { level = types_1.Severity.Info; }
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromString(message, syntheticException, {
	        attachStacktrace: options.attachStacktrace,
	    });
	    event.level = level;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.SyncPromise.resolve(event);
	}
	exports.eventFromMessage = eventFromMessage;
	/**
	 * @hidden
	 */
	function eventFromUnknownInput(exception, syntheticException, options) {
	    if (options === void 0) { options = {}; }
	    var event;
	    if (utils_1.isErrorEvent(exception) && exception.error) {
	        // If it is an ErrorEvent with `error` property, extract it to get actual Error
	        var errorEvent = exception;
	        // eslint-disable-next-line no-param-reassign
	        exception = errorEvent.error;
	        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
	        return event;
	    }
	    if (utils_1.isDOMError(exception) || utils_1.isDOMException(exception)) {
	        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
	        // then we just extract the name, code, and message, as they don't provide anything else
	        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
	        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
	        var domException = exception;
	        var name_1 = domException.name || (utils_1.isDOMError(domException) ? 'DOMError' : 'DOMException');
	        var message = domException.message ? name_1 + ": " + domException.message : name_1;
	        event = eventFromString(message, syntheticException, options);
	        utils_1.addExceptionTypeValue(event, message);
	        if ('code' in domException) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, event.tags), { 'DOMException.code': "" + domException.code });
	        }
	        return event;
	    }
	    if (utils_1.isError(exception)) {
	        // we have a real Error object, do nothing
	        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
	        return event;
	    }
	    if (utils_1.isPlainObject(exception) || utils_1.isEvent(exception)) {
	        // If it is plain Object or Event, serialize it manually and extract options
	        // This will allow us to group events based on top-level keys
	        // which is much better than creating new group when any key/value change
	        var objectException = exception;
	        event = parsers_1.eventFromPlainObject(objectException, syntheticException, options.rejection);
	        utils_1.addExceptionMechanism(event, {
	            synthetic: true,
	        });
	        return event;
	    }
	    // If none of previous checks were valid, then it means that it's not:
	    // - an instance of DOMError
	    // - an instance of DOMException
	    // - an instance of Event
	    // - an instance of Error
	    // - a valid ErrorEvent (one with an error property)
	    // - a plain Object
	    //
	    // So bail out and capture it as a simple message:
	    event = eventFromString(exception, syntheticException, options);
	    utils_1.addExceptionTypeValue(event, "" + exception, undefined);
	    utils_1.addExceptionMechanism(event, {
	        synthetic: true,
	    });
	    return event;
	}
	exports.eventFromUnknownInput = eventFromUnknownInput;
	/**
	 * @hidden
	 */
	function eventFromString(input, syntheticException, options) {
	    if (options === void 0) { options = {}; }
	    var event = {
	        message: input,
	    };
	    if (options.attachStacktrace && syntheticException) {
	        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
	        var frames_1 = parsers_1.prepareFramesForEvent(stacktrace.stack);
	        event.stacktrace = {
	            frames: frames_1,
	        };
	    }
	    return event;
	}
	exports.eventFromString = eventFromString;
	//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var globalhandlers_1 = __webpack_require__(97);
	exports.GlobalHandlers = globalhandlers_1.GlobalHandlers;
	var trycatch_1 = __webpack_require__(99);
	exports.TryCatch = trycatch_1.TryCatch;
	var breadcrumbs_1 = __webpack_require__(96);
	exports.Breadcrumbs = breadcrumbs_1.Breadcrumbs;
	var linkederrors_1 = __webpack_require__(98);
	exports.LinkedErrors = linkederrors_1.LinkedErrors;
	var useragent_1 = __webpack_require__(100);
	exports.UserAgent = useragent_1.UserAgent;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * This was originally forked from https://github.com/occ/TraceKit, but has since been
	 * largely modified and is now maintained as part of Sentry JS SDK.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	// global reference to slice
	var UNKNOWN_FUNCTION = '?';
	// Chromium based browsers: Chrome, Brave, new Opera, new Edge
	var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
	// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
	// We need this specific case for now because we want no other regex to match.
	var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
	var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
	var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
	var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
	// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
	var reactMinifiedRegexp = /Minified React error #\d+;/i;
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	function computeStackTrace(ex) {
	    var stack = null;
	    var popSize = 0;
	    if (ex) {
	        if (typeof ex.framesToPop === 'number') {
	            popSize = ex.framesToPop;
	        }
	        else if (reactMinifiedRegexp.test(ex.message)) {
	            popSize = 1;
	        }
	    }
	    try {
	        // This must be tried first because Opera 10 *destroys*
	        // its stacktrace property if you try to access the stack
	        // property first!!
	        stack = computeStackTraceFromStacktraceProp(ex);
	        if (stack) {
	            return popFrames(stack, popSize);
	        }
	    }
	    catch (e) {
	        // no-empty
	    }
	    try {
	        stack = computeStackTraceFromStackProp(ex);
	        if (stack) {
	            return popFrames(stack, popSize);
	        }
	    }
	    catch (e) {
	        // no-empty
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex && ex.name,
	        stack: [],
	        failed: true,
	    };
	}
	exports.computeStackTrace = computeStackTrace;
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
	function computeStackTraceFromStackProp(ex) {
	    if (!ex || !ex.stack) {
	        return null;
	    }
	    var stack = [];
	    var lines = ex.stack.split('\n');
	    var isEval;
	    var submatch;
	    var parts;
	    var element;
	    for (var i = 0; i < lines.length; ++i) {
	        if ((parts = chrome.exec(lines[i]))) {
	            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
	            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
	                // throw out eval line/column and use top-most line/column number
	                parts[2] = submatch[1]; // url
	                parts[3] = submatch[2]; // line
	                parts[4] = submatch[3]; // column
	            }
	            element = {
	                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
	                // prefix here seems like the quickest solution for now.
	                url: parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: isNative ? [parts[2]] : [],
	                line: parts[3] ? +parts[3] : null,
	                column: parts[4] ? +parts[4] : null,
	            };
	        }
	        else if ((parts = winjs.exec(lines[i]))) {
	            element = {
	                url: parts[2],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: [],
	                line: +parts[3],
	                column: parts[4] ? +parts[4] : null,
	            };
	        }
	        else if ((parts = gecko.exec(lines[i]))) {
	            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
	                // throw out eval line/column and use top-most line number
	                parts[1] = parts[1] || "eval";
	                parts[3] = submatch[1];
	                parts[4] = submatch[2];
	                parts[5] = ''; // no column when eval
	            }
	            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
	                // FireFox uses this awesome columnNumber property for its top frame
	                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	                // so adding 1
	                // NOTE: this hack doesn't work if top-most frame is eval
	                stack[0].column = ex.columnNumber + 1;
	            }
	            element = {
	                url: parts[3],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: parts[2] ? parts[2].split(',') : [],
	                line: parts[4] ? +parts[4] : null,
	                column: parts[5] ? +parts[5] : null,
	            };
	        }
	        else {
	            continue;
	        }
	        if (!element.func && element.line) {
	            element.func = UNKNOWN_FUNCTION;
	        }
	        stack.push(element);
	    }
	    if (!stack.length) {
	        return null;
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex.name,
	        stack: stack,
	    };
	}
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function computeStackTraceFromStacktraceProp(ex) {
	    if (!ex || !ex.stacktrace) {
	        return null;
	    }
	    // Access and store the stacktrace property before doing ANYTHING
	    // else to it because Opera is not very good at providing it
	    // reliably in other circumstances.
	    var stacktrace = ex.stacktrace;
	    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
	    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
	    var lines = stacktrace.split('\n');
	    var stack = [];
	    var parts;
	    for (var line = 0; line < lines.length; line += 2) {
	        var element = null;
	        if ((parts = opera10Regex.exec(lines[line]))) {
	            element = {
	                url: parts[2],
	                func: parts[3],
	                args: [],
	                line: +parts[1],
	                column: null,
	            };
	        }
	        else if ((parts = opera11Regex.exec(lines[line]))) {
	            element = {
	                url: parts[6],
	                func: parts[3] || parts[4],
	                args: parts[5] ? parts[5].split(',') : [],
	                line: +parts[1],
	                column: +parts[2],
	            };
	        }
	        if (element) {
	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }
	            stack.push(element);
	        }
	    }
	    if (!stack.length) {
	        return null;
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex.name,
	        stack: stack,
	    };
	}
	/** Remove N number of frames from the stack */
	function popFrames(stacktrace, popSize) {
	    try {
	        return tslib_1.__assign(tslib_1.__assign({}, stacktrace), { stack: stacktrace.stack.slice(popSize) });
	    }
	    catch (e) {
	        return stacktrace;
	    }
	}
	/**
	 * There are cases where stacktrace.message is an Event object
	 * https://github.com/getsentry/sentry-javascript/issues/1949
	 * In this specific case we try to extract stacktrace.message.error.message
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function extractMessage(ex) {
	    var message = ex && ex.message;
	    if (!message) {
	        return 'No error message';
	    }
	    if (message.error && typeof message.error.message === 'string') {
	        return message.error.message;
	    }
	    return message;
	}
	//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var core_1 = __webpack_require__(3);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(1);
	/** Base Transport class implementation */
	var BaseTransport = /** @class */ (function () {
	    function BaseTransport(options) {
	        this.options = options;
	        /** A simple buffer holding all requests. */
	        this._buffer = new utils_1.PromiseBuffer(30);
	        /** Locks transport after receiving rate limits in a response */
	        this._rateLimits = {};
	        this._api = new core_1.API(this.options.dsn);
	        // eslint-disable-next-line deprecation/deprecation
	        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
	    }
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.sendEvent = function (_) {
	        throw new utils_1.SentryError('Transport Class has to implement `sendEvent` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.close = function (timeout) {
	        return this._buffer.drain(timeout);
	    };
	    /**
	     * Handle Sentry repsonse for promise-based transports.
	     */
	    BaseTransport.prototype._handleResponse = function (_a) {
	        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
	        var status = types_1.Status.fromHttpCode(response.status);
	        /**
	         * "The name is case-insensitive."
	         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
	         */
	        var limited = this._handleRateLimit(headers);
	        if (limited)
	            utils_1.logger.warn("Too many requests, backing off until: " + this._disabledUntil(requestType));
	        if (status === types_1.Status.Success) {
	            resolve({ status: status });
	            return;
	        }
	        reject(response);
	    };
	    /**
	     * Gets the time that given category is disabled until for rate limiting
	     */
	    BaseTransport.prototype._disabledUntil = function (category) {
	        return this._rateLimits[category] || this._rateLimits.all;
	    };
	    /**
	     * Checks if a category is rate limited
	     */
	    BaseTransport.prototype._isRateLimited = function (category) {
	        return this._disabledUntil(category) > new Date(Date.now());
	    };
	    /**
	     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
	     */
	    BaseTransport.prototype._handleRateLimit = function (headers) {
	        var e_1, _a, e_2, _b;
	        var now = Date.now();
	        var rlHeader = headers['x-sentry-rate-limits'];
	        var raHeader = headers['retry-after'];
	        if (rlHeader) {
	            try {
	                // rate limit headers are of the form
	                //     <header>,<header>,..
	                // where each <header> is of the form
	                //     <retry_after>: <categories>: <scope>: <reason_code>
	                // where
	                //     <retry_after> is a delay in ms
	                //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
	                //         <category>;<category>;...
	                //     <scope> is what's being limited (org, project, or key) - ignored by SDK
	                //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
	                for (var _c = tslib_1.__values(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
	                    var limit = _d.value;
	                    var parameters = limit.split(':', 2);
	                    var headerDelay = parseInt(parameters[0], 10);
	                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
	                    try {
	                        for (var _e = (e_2 = void 0, tslib_1.__values(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                            var category = _f.value;
	                            this._rateLimits[category || 'all'] = new Date(now + delay);
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            return true;
	        }
	        else if (raHeader) {
	            this._rateLimits.all = new Date(now + utils_1.parseRetryAfterHeader(now, raHeader));
	            return true;
	        }
	        return false;
	    };
	    return BaseTransport;
	}());
	exports.BaseTransport = BaseTransport;
	//# sourceMappingURL=base.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bindReporter = function (callback, metric, po, observeAllUpdates) {
	    var prevValue;
	    return function () {
	        if (po && metric.isFinal) {
	            po.disconnect();
	        }
	        if (metric.value >= 0) {
	            if (observeAllUpdates || metric.isFinal || document.visibilityState === 'hidden') {
	                metric.delta = metric.value - (prevValue || 0);
	                // Report the metric if there's a non-zero delta, if the metric is
	                // final, or if no previous value exists (which can happen in the case
	                // of the document becoming hidden when the metric value is 0).
	                // See: https://github.com/GoogleChrome/web-vitals/issues/14
	                if (metric.delta || metric.isFinal || prevValue === undefined) {
	                    callback(metric);
	                    prevValue = metric.value;
	                }
	            }
	        }
	    };
	};
	//# sourceMappingURL=bindReporter.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var onHidden_1 = __webpack_require__(23);
	var firstHiddenTime;
	exports.getFirstHidden = function () {
	    if (firstHiddenTime === undefined) {
	        // If the document is hidden when this code runs, assume it was hidden
	        // since navigation start. This isn't a perfect heuristic, but it's the
	        // best we can do until an API is available to support querying past
	        // visibilityState.
	        firstHiddenTime = document.visibilityState === 'hidden' ? 0 : Infinity;
	        // Update the time if/when the document becomes hidden.
	        onHidden_1.onHidden(function (_a) {
	            var timeStamp = _a.timeStamp;
	            return (firstHiddenTime = timeStamp);
	        }, true);
	    }
	    return {
	        get timeStamp() {
	            return firstHiddenTime;
	        },
	    };
	};
	//# sourceMappingURL=getFirstHidden.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Takes a performance entry type and a callback function, and creates a
	 * `PerformanceObserver` instance that will observe the specified entry type
	 * with buffering enabled and call the callback _for each entry_.
	 *
	 * This function also feature-detects entry support and wraps the logic in a
	 * try/catch to avoid errors in unsupporting browsers.
	 */
	exports.observe = function (type, callback) {
	    try {
	        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
	            var po = new PerformanceObserver(function (l) { return l.getEntries().map(callback); });
	            po.observe({ type: type, buffered: true });
	            return po;
	        }
	    }
	    catch (e) {
	        // Do nothing.
	    }
	    return;
	};
	//# sourceMappingURL=observe.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var hub_1 = __webpack_require__(7);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(1);
	var errors_1 = __webpack_require__(125);
	var idletransaction_1 = __webpack_require__(38);
	var transaction_1 = __webpack_require__(40);
	var utils_2 = __webpack_require__(10);
	/** Returns all trace headers that are currently on the top scope. */
	function traceHeaders() {
	    var scope = this.getScope();
	    if (scope) {
	        var span = scope.getSpan();
	        if (span) {
	            return {
	                'sentry-trace': span.toTraceparent(),
	            };
	        }
	    }
	    return {};
	}
	/**
	 * Makes a sampling decision for the given transaction and stores it on the transaction.
	 *
	 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
	 * sent to Sentry.
	 *
	 * @param hub: The hub off of which to read config options
	 * @param transaction: The transaction needing a sampling decision
	 * @param samplingContext: Default and user-provided data which may be used to help make the decision
	 *
	 * @returns The given transaction with its `sampled` value set
	 */
	function sample(hub, transaction, samplingContext) {
	    var _a;
	    var client = hub.getClient();
	    var options = (client && client.getOptions()) || {};
	    // nothing to do if there's no client or if tracing is disabled
	    if (!client || !utils_2.hasTracingEnabled(options)) {
	        transaction.sampled = false;
	        return transaction;
	    }
	    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
	    if (transaction.sampled !== undefined) {
	        transaction.tags = tslib_1.__assign(tslib_1.__assign({}, transaction.tags), { __sentry_samplingMethod: types_1.TransactionSamplingMethod.Explicit });
	        return transaction;
	    }
	    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
	    // work; prefer the hook if so
	    var sampleRate;
	    if (typeof options.tracesSampler === 'function') {
	        sampleRate = options.tracesSampler(samplingContext);
	        // cast the rate to a number first in case it's a boolean
	        transaction.tags = tslib_1.__assign(tslib_1.__assign({}, transaction.tags), { __sentry_samplingMethod: types_1.TransactionSamplingMethod.Sampler, 
	            // TODO kmclb - once tag types are loosened, don't need to cast to string here
	            __sentry_sampleRate: String(Number(sampleRate)) });
	    }
	    else if (samplingContext.parentSampled !== undefined) {
	        sampleRate = samplingContext.parentSampled;
	        transaction.tags = tslib_1.__assign(tslib_1.__assign({}, transaction.tags), { __sentry_samplingMethod: types_1.TransactionSamplingMethod.Inheritance });
	    }
	    else {
	        sampleRate = options.tracesSampleRate;
	        // cast the rate to a number first in case it's a boolean
	        transaction.tags = tslib_1.__assign(tslib_1.__assign({}, transaction.tags), { __sentry_samplingMethod: types_1.TransactionSamplingMethod.Rate, 
	            // TODO kmclb - once tag types are loosened, don't need to cast to string here
	            __sentry_sampleRate: String(Number(sampleRate)) });
	    }
	    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
	    // only valid values are booleans or numbers between 0 and 1.)
	    if (!isValidSampleRate(sampleRate)) {
	        utils_1.logger.warn("[Tracing] Discarding transaction because of invalid sample rate.");
	        transaction.sampled = false;
	        return transaction;
	    }
	    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
	    if (!sampleRate) {
	        utils_1.logger.log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function'
	            ? 'tracesSampler returned 0 or false'
	            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
	        transaction.sampled = false;
	        return transaction;
	    }
	    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
	    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
	    transaction.sampled = Math.random() < sampleRate;
	    // if we're not going to keep it, we're done
	    if (!transaction.sampled) {
	        utils_1.logger.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
	        return transaction;
	    }
	    // at this point we know we're keeping the transaction, whether because of an inherited decision or because it got
	    // lucky with the dice roll
	    transaction.initSpanRecorder((_a = options._experiments) === null || _a === void 0 ? void 0 : _a.maxSpans);
	    utils_1.logger.log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
	    return transaction;
	}
	/**
	 * Gets the correct context to pass to the tracesSampler, based on the environment (i.e., which SDK is being used)
	 *
	 * @returns The default sample context
	 */
	function getDefaultSamplingContext(transactionContext) {
	    // promote parent sampling decision (if any) for easy access
	    var parentSampled = transactionContext.parentSampled;
	    var defaultSamplingContext = { transactionContext: transactionContext, parentSampled: parentSampled };
	    if (utils_1.isNodeEnv()) {
	        var domain = hub_1.getActiveDomain();
	        if (domain) {
	            // for all node servers that we currently support, we store the incoming request object (which is an instance of
	            // http.IncomingMessage) on the domain
	            // the domain members are stored as an array, so our only way to find the request is to iterate through the array
	            // and compare types
	            var nodeHttpModule = utils_1.dynamicRequire(module, 'http');
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            var requestType_1 = nodeHttpModule.IncomingMessage;
	            var request = domain.members.find(function (member) { return utils_1.isInstanceOf(member, requestType_1); });
	            if (request) {
	                defaultSamplingContext.request = utils_1.extractNodeRequestData(request);
	            }
	        }
	    }
	    // we must be in browser-js (or some derivative thereof)
	    else {
	        // we use `getGlobalObject()` rather than `window` since service workers also have a `location` property on `self`
	        var globalObject = utils_1.getGlobalObject();
	        if ('location' in globalObject) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	            defaultSamplingContext.location = tslib_1.__assign({}, globalObject.location);
	        }
	    }
	    return defaultSamplingContext;
	}
	/**
	 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
	 */
	function isValidSampleRate(rate) {
	    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    if (isNaN(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
	        utils_1.logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
	        return false;
	    }
	    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
	    if (rate < 0 || rate > 1) {
	        utils_1.logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
	        return false;
	    }
	    return true;
	}
	/**
	 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
	 *
	 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
	 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
	 * "extension method."
	 *
	 * @param this: The Hub starting the transaction
	 * @param transactionContext: Data used to configure the transaction
	 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
	 *
	 * @returns The new transaction
	 *
	 * @see {@link Hub.startTransaction}
	 */
	function _startTransaction(transactionContext, customSamplingContext) {
	    var transaction = new transaction_1.Transaction(transactionContext, this);
	    return sample(this, transaction, tslib_1.__assign(tslib_1.__assign({}, getDefaultSamplingContext(transactionContext)), customSamplingContext));
	}
	/**
	 * Create new idle transaction.
	 */
	function startIdleTransaction(hub, transactionContext, idleTimeout, onScope) {
	    var transaction = new idletransaction_1.IdleTransaction(transactionContext, hub, idleTimeout, onScope);
	    return sample(hub, transaction, getDefaultSamplingContext(transactionContext));
	}
	exports.startIdleTransaction = startIdleTransaction;
	/**
	 * @private
	 */
	function _addTracingExtensions() {
	    var carrier = hub_1.getMainCarrier();
	    if (carrier.__SENTRY__) {
	        carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
	        if (!carrier.__SENTRY__.extensions.startTransaction) {
	            carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
	        }
	        if (!carrier.__SENTRY__.extensions.traceHeaders) {
	            carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
	        }
	    }
	}
	exports._addTracingExtensions = _addTracingExtensions;
	/**
	 * This patches the global object and injects the Tracing extensions methods
	 */
	function addExtensionMethods() {
	    _addTracingExtensions();
	    // If an error happens globally, we should make sure transaction status is set to error.
	    errors_1.registerErrorInstrumentation();
	}
	exports.addExtensionMethods = addExtensionMethods;
	//# sourceMappingURL=hubextensions.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var utils_1 = __webpack_require__(1);
	var span_1 = __webpack_require__(39);
	var spanstatus_1 = __webpack_require__(14);
	var transaction_1 = __webpack_require__(40);
	exports.DEFAULT_IDLE_TIMEOUT = 1000;
	/**
	 * @inheritDoc
	 */
	var IdleTransactionSpanRecorder = /** @class */ (function (_super) {
	    tslib_1.__extends(IdleTransactionSpanRecorder, _super);
	    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
	        if (transactionSpanId === void 0) { transactionSpanId = ''; }
	        var _this = _super.call(this, maxlen) || this;
	        _this._pushActivity = _pushActivity;
	        _this._popActivity = _popActivity;
	        _this.transactionSpanId = transactionSpanId;
	        return _this;
	    }
	    /**
	     * @inheritDoc
	     */
	    IdleTransactionSpanRecorder.prototype.add = function (span) {
	        var _this = this;
	        // We should make sure we do not push and pop activities for
	        // the transaction that this span recorder belongs to.
	        if (span.spanId !== this.transactionSpanId) {
	            // We patch span.finish() to pop an activity after setting an endTimestamp.
	            span.finish = function (endTimestamp) {
	                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : utils_1.timestampWithMs();
	                _this._popActivity(span.spanId);
	            };
	            // We should only push new activities if the span does not have an end timestamp.
	            if (span.endTimestamp === undefined) {
	                this._pushActivity(span.spanId);
	            }
	        }
	        _super.prototype.add.call(this, span);
	    };
	    return IdleTransactionSpanRecorder;
	}(span_1.SpanRecorder));
	exports.IdleTransactionSpanRecorder = IdleTransactionSpanRecorder;
	/**
	 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
	 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
	 * put itself on the scope on creation.
	 */
	var IdleTransaction = /** @class */ (function (_super) {
	    tslib_1.__extends(IdleTransaction, _super);
	    function IdleTransaction(transactionContext, _idleHub, 
	    // The time to wait in ms until the idle transaction will be finished. Default: 1000
	    _idleTimeout, 
	    // If an idle transaction should be put itself on and off the scope automatically.
	    _onScope) {
	        if (_idleTimeout === void 0) { _idleTimeout = exports.DEFAULT_IDLE_TIMEOUT; }
	        if (_onScope === void 0) { _onScope = false; }
	        var _this = _super.call(this, transactionContext, _idleHub) || this;
	        _this._idleHub = _idleHub;
	        _this._idleTimeout = _idleTimeout;
	        _this._onScope = _onScope;
	        // Activities store a list of active spans
	        _this.activities = {};
	        // Stores reference to the timeout that calls _beat().
	        _this._heartbeatTimer = 0;
	        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
	        _this._heartbeatCounter = 0;
	        // We should not use heartbeat if we finished a transaction
	        _this._finished = false;
	        _this._beforeFinishCallbacks = [];
	        if (_idleHub && _onScope) {
	            // There should only be one active transaction on the scope
	            clearActiveTransaction(_idleHub);
	            // We set the transaction here on the scope so error events pick up the trace
	            // context and attach it to the error.
	            utils_1.logger.log("Setting idle transaction on scope. Span ID: " + _this.spanId);
	            _idleHub.configureScope(function (scope) { return scope.setSpan(_this); });
	        }
	        return _this;
	    }
	    /** {@inheritDoc} */
	    IdleTransaction.prototype.finish = function (endTimestamp) {
	        var e_1, _a;
	        var _this = this;
	        if (endTimestamp === void 0) { endTimestamp = utils_1.timestampWithMs(); }
	        this._finished = true;
	        this.activities = {};
	        if (this.spanRecorder) {
	            utils_1.logger.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
	            try {
	                for (var _b = tslib_1.__values(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var callback = _c.value;
	                    callback(this, endTimestamp);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
	                // If we are dealing with the transaction itself, we just return it
	                if (span.spanId === _this.spanId) {
	                    return true;
	                }
	                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
	                if (!span.endTimestamp) {
	                    span.endTimestamp = endTimestamp;
	                    span.setStatus(spanstatus_1.SpanStatus.Cancelled);
	                    utils_1.logger.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
	                }
	                var keepSpan = span.startTimestamp < endTimestamp;
	                if (!keepSpan) {
	                    utils_1.logger.log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
	                }
	                return keepSpan;
	            });
	            // this._onScope is true if the transaction was previously on the scope.
	            if (this._onScope) {
	                clearActiveTransaction(this._idleHub);
	            }
	            utils_1.logger.log('[Tracing] flushing IdleTransaction');
	        }
	        else {
	            utils_1.logger.log('[Tracing] No active IdleTransaction');
	        }
	        return _super.prototype.finish.call(this, endTimestamp);
	    };
	    /**
	     * Register a callback function that gets excecuted before the transaction finishes.
	     * Useful for cleanup or if you want to add any additional spans based on current context.
	     *
	     * This is exposed because users have no other way of running something before an idle transaction
	     * finishes.
	     */
	    IdleTransaction.prototype.registerBeforeFinishCallback = function (callback) {
	        this._beforeFinishCallbacks.push(callback);
	    };
	    /**
	     * @inheritDoc
	     */
	    IdleTransaction.prototype.initSpanRecorder = function (maxlen) {
	        var _this = this;
	        if (!this.spanRecorder) {
	            this._initTimeout = setTimeout(function () {
	                if (!_this._finished) {
	                    _this.finish();
	                }
	            }, this._idleTimeout);
	            var pushActivity = function (id) {
	                if (_this._finished) {
	                    return;
	                }
	                _this._pushActivity(id);
	            };
	            var popActivity = function (id) {
	                if (_this._finished) {
	                    return;
	                }
	                _this._popActivity(id);
	            };
	            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);
	            // Start heartbeat so that transactions do not run forever.
	            utils_1.logger.log('Starting heartbeat');
	            this._pingHeartbeat();
	        }
	        this.spanRecorder.add(this);
	    };
	    /**
	     * Start tracking a specific activity.
	     * @param spanId The span id that represents the activity
	     */
	    IdleTransaction.prototype._pushActivity = function (spanId) {
	        if (this._initTimeout) {
	            clearTimeout(this._initTimeout);
	            this._initTimeout = undefined;
	        }
	        utils_1.logger.log("[Tracing] pushActivity: " + spanId);
	        this.activities[spanId] = true;
	        utils_1.logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
	    };
	    /**
	     * Remove an activity from usage
	     * @param spanId The span id that represents the activity
	     */
	    IdleTransaction.prototype._popActivity = function (spanId) {
	        var _this = this;
	        if (this.activities[spanId]) {
	            utils_1.logger.log("[Tracing] popActivity " + spanId);
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete this.activities[spanId];
	            utils_1.logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
	        }
	        if (Object.keys(this.activities).length === 0) {
	            var timeout = this._idleTimeout;
	            // We need to add the timeout here to have the real endtimestamp of the transaction
	            // Remember timestampWithMs is in seconds, timeout is in ms
	            var end_1 = utils_1.timestampWithMs() + timeout / 1000;
	            setTimeout(function () {
	                if (!_this._finished) {
	                    _this.finish(end_1);
	                }
	            }, timeout);
	        }
	    };
	    /**
	     * Checks when entries of this.activities are not changing for 3 beats.
	     * If this occurs we finish the transaction.
	     */
	    IdleTransaction.prototype._beat = function () {
	        clearTimeout(this._heartbeatTimer);
	        // We should not be running heartbeat if the idle transaction is finished.
	        if (this._finished) {
	            return;
	        }
	        var keys = Object.keys(this.activities);
	        var heartbeatString = keys.length ? keys.reduce(function (prev, current) { return prev + current; }) : '';
	        if (heartbeatString === this._prevHeartbeatString) {
	            this._heartbeatCounter += 1;
	        }
	        else {
	            this._heartbeatCounter = 1;
	        }
	        this._prevHeartbeatString = heartbeatString;
	        if (this._heartbeatCounter >= 3) {
	            utils_1.logger.log("[Tracing] Transaction finished because of no change for 3 heart beats");
	            this.setStatus(spanstatus_1.SpanStatus.DeadlineExceeded);
	            this.setTag('heartbeat', 'failed');
	            this.finish();
	        }
	        else {
	            this._pingHeartbeat();
	        }
	    };
	    /**
	     * Pings the heartbeat
	     */
	    IdleTransaction.prototype._pingHeartbeat = function () {
	        var _this = this;
	        utils_1.logger.log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
	        this._heartbeatTimer = setTimeout(function () {
	            _this._beat();
	        }, 5000);
	    };
	    return IdleTransaction;
	}(transaction_1.Transaction));
	exports.IdleTransaction = IdleTransaction;
	/**
	 * Reset active transaction on scope
	 */
	function clearActiveTransaction(hub) {
	    if (hub) {
	        var scope = hub.getScope();
	        if (scope) {
	            var transaction = scope.getTransaction();
	            if (transaction) {
	                scope.setSpan(undefined);
	            }
	        }
	    }
	}
	//# sourceMappingURL=idletransaction.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var utils_1 = __webpack_require__(1);
	var spanstatus_1 = __webpack_require__(14);
	/**
	 * Keeps track of finished spans for a given transaction
	 * @internal
	 * @hideconstructor
	 * @hidden
	 */
	var SpanRecorder = /** @class */ (function () {
	    function SpanRecorder(maxlen) {
	        if (maxlen === void 0) { maxlen = 1000; }
	        this.spans = [];
	        this._maxlen = maxlen;
	    }
	    /**
	     * This is just so that we don't run out of memory while recording a lot
	     * of spans. At some point we just stop and flush out the start of the
	     * trace tree (i.e.the first n spans with the smallest
	     * start_timestamp).
	     */
	    SpanRecorder.prototype.add = function (span) {
	        if (this.spans.length > this._maxlen) {
	            span.spanRecorder = undefined;
	        }
	        else {
	            this.spans.push(span);
	        }
	    };
	    return SpanRecorder;
	}());
	exports.SpanRecorder = SpanRecorder;
	/**
	 * Span contains all data about a span
	 */
	var Span = /** @class */ (function () {
	    /**
	     * You should never call the constructor manually, always use `Sentry.startTransaction()`
	     * or call `startChild()` on an existing span.
	     * @internal
	     * @hideconstructor
	     * @hidden
	     */
	    function Span(spanContext) {
	        /**
	         * @inheritDoc
	         */
	        this.traceId = utils_1.uuid4();
	        /**
	         * @inheritDoc
	         */
	        this.spanId = utils_1.uuid4().substring(16);
	        /**
	         * Timestamp in seconds when the span was created.
	         */
	        this.startTimestamp = utils_1.timestampWithMs();
	        /**
	         * @inheritDoc
	         */
	        this.tags = {};
	        /**
	         * @inheritDoc
	         */
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        this.data = {};
	        if (!spanContext) {
	            return this;
	        }
	        if (spanContext.traceId) {
	            this.traceId = spanContext.traceId;
	        }
	        if (spanContext.spanId) {
	            this.spanId = spanContext.spanId;
	        }
	        if (spanContext.parentSpanId) {
	            this.parentSpanId = spanContext.parentSpanId;
	        }
	        // We want to include booleans as well here
	        if ('sampled' in spanContext) {
	            this.sampled = spanContext.sampled;
	        }
	        if (spanContext.op) {
	            this.op = spanContext.op;
	        }
	        if (spanContext.description) {
	            this.description = spanContext.description;
	        }
	        if (spanContext.data) {
	            this.data = spanContext.data;
	        }
	        if (spanContext.tags) {
	            this.tags = spanContext.tags;
	        }
	        if (spanContext.status) {
	            this.status = spanContext.status;
	        }
	        if (spanContext.startTimestamp) {
	            this.startTimestamp = spanContext.startTimestamp;
	        }
	        if (spanContext.endTimestamp) {
	            this.endTimestamp = spanContext.endTimestamp;
	        }
	    }
	    /**
	     * @inheritDoc
	     * @deprecated
	     */
	    Span.prototype.child = function (spanContext) {
	        return this.startChild(spanContext);
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.startChild = function (spanContext) {
	        var childSpan = new Span(tslib_1.__assign(tslib_1.__assign({}, spanContext), { parentSpanId: this.spanId, sampled: this.sampled, traceId: this.traceId }));
	        childSpan.spanRecorder = this.spanRecorder;
	        if (childSpan.spanRecorder) {
	            childSpan.spanRecorder.add(childSpan);
	        }
	        childSpan.transaction = this.transaction;
	        return childSpan;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setTag = function (key, value) {
	        var _a;
	        this.tags = tslib_1.__assign(tslib_1.__assign({}, this.tags), (_a = {}, _a[key] = value, _a));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    Span.prototype.setData = function (key, value) {
	        var _a;
	        this.data = tslib_1.__assign(tslib_1.__assign({}, this.data), (_a = {}, _a[key] = value, _a));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setStatus = function (value) {
	        this.status = value;
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setHttpStatus = function (httpStatus) {
	        this.setTag('http.status_code', String(httpStatus));
	        var spanStatus = spanstatus_1.SpanStatus.fromHttpCode(httpStatus);
	        if (spanStatus !== spanstatus_1.SpanStatus.UnknownError) {
	            this.setStatus(spanStatus);
	        }
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.isSuccess = function () {
	        return this.status === spanstatus_1.SpanStatus.Ok;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.finish = function (endTimestamp) {
	        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : utils_1.timestampWithMs();
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toTraceparent = function () {
	        var sampledString = '';
	        if (this.sampled !== undefined) {
	            sampledString = this.sampled ? '-1' : '-0';
	        }
	        return this.traceId + "-" + this.spanId + sampledString;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.getTraceContext = function () {
	        return utils_1.dropUndefinedKeys({
	            data: Object.keys(this.data).length > 0 ? this.data : undefined,
	            description: this.description,
	            op: this.op,
	            parent_span_id: this.parentSpanId,
	            span_id: this.spanId,
	            status: this.status,
	            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
	            trace_id: this.traceId,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toJSON = function () {
	        return utils_1.dropUndefinedKeys({
	            data: Object.keys(this.data).length > 0 ? this.data : undefined,
	            description: this.description,
	            op: this.op,
	            parent_span_id: this.parentSpanId,
	            span_id: this.spanId,
	            start_timestamp: this.startTimestamp,
	            status: this.status,
	            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
	            timestamp: this.endTimestamp,
	            trace_id: this.traceId,
	        });
	    };
	    return Span;
	}());
	exports.Span = Span;
	//# sourceMappingURL=span.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var hub_1 = __webpack_require__(7);
	var utils_1 = __webpack_require__(1);
	var span_1 = __webpack_require__(39);
	/** JSDoc */
	var Transaction = /** @class */ (function (_super) {
	    tslib_1.__extends(Transaction, _super);
	    /**
	     * This constructor should never be called manually. Those instrumenting tracing should use
	     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
	     * @internal
	     * @hideconstructor
	     * @hidden
	     */
	    function Transaction(transactionContext, hub) {
	        var _this = _super.call(this, transactionContext) || this;
	        _this._measurements = {};
	        /**
	         * The reference to the current hub.
	         */
	        _this._hub = hub_1.getCurrentHub();
	        if (utils_1.isInstanceOf(hub, hub_1.Hub)) {
	            _this._hub = hub;
	        }
	        _this.name = transactionContext.name ? transactionContext.name : '';
	        _this._trimEnd = transactionContext.trimEnd;
	        // this is because transactions are also spans, and spans have a transaction pointer
	        _this.transaction = _this;
	        return _this;
	    }
	    /**
	     * JSDoc
	     */
	    Transaction.prototype.setName = function (name) {
	        this.name = name;
	    };
	    /**
	     * Attaches SpanRecorder to the span itself
	     * @param maxlen maximum number of spans that can be recorded
	     */
	    Transaction.prototype.initSpanRecorder = function (maxlen) {
	        if (maxlen === void 0) { maxlen = 1000; }
	        if (!this.spanRecorder) {
	            this.spanRecorder = new span_1.SpanRecorder(maxlen);
	        }
	        this.spanRecorder.add(this);
	    };
	    /**
	     * Set observed measurements for this transaction.
	     * @hidden
	     */
	    Transaction.prototype.setMeasurements = function (measurements) {
	        this._measurements = tslib_1.__assign({}, measurements);
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.finish = function (endTimestamp) {
	        var _this = this;
	        // This transaction is already finished, so we should not flush it again.
	        if (this.endTimestamp !== undefined) {
	            return undefined;
	        }
	        if (!this.name) {
	            utils_1.logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
	            this.name = '<unlabeled transaction>';
	        }
	        // just sets the end timestamp
	        _super.prototype.finish.call(this, endTimestamp);
	        if (this.sampled !== true) {
	            // At this point if `sampled !== true` we want to discard the transaction.
	            utils_1.logger.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
	            return undefined;
	        }
	        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) { return s !== _this && s.endTimestamp; }) : [];
	        if (this._trimEnd && finishedSpans.length > 0) {
	            this.endTimestamp = finishedSpans.reduce(function (prev, current) {
	                if (prev.endTimestamp && current.endTimestamp) {
	                    return prev.endTimestamp > current.endTimestamp ? prev : current;
	                }
	                return prev;
	            }).endTimestamp;
	        }
	        var transaction = {
	            contexts: {
	                trace: this.getTraceContext(),
	            },
	            spans: finishedSpans,
	            start_timestamp: this.startTimestamp,
	            tags: this.tags,
	            timestamp: this.endTimestamp,
	            transaction: this.name,
	            type: 'transaction',
	        };
	        var hasMeasurements = Object.keys(this._measurements).length > 0;
	        if (hasMeasurements) {
	            utils_1.logger.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
	            transaction.measurements = this._measurements;
	        }
	        return this._hub.captureEvent(transaction);
	    };
	    return Transaction;
	}(span_1.Span));
	exports.Transaction = Transaction;
	//# sourceMappingURL=transaction.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var polyfill_1 = __webpack_require__(141);
	/** An error emitted by Sentry SDKs and related utilities. */
	var SentryError = /** @class */ (function (_super) {
	    tslib_1.__extends(SentryError, _super);
	    function SentryError(message) {
	        var _newTarget = this.constructor;
	        var _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _newTarget.prototype.constructor.name;
	        polyfill_1.setPrototypeOf(_this, _newTarget.prototype);
	        return _this;
	    }
	    return SentryError;
	}(Error));
	exports.SentryError = SentryError;
	//# sourceMappingURL=error.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var misc_1 = __webpack_require__(18);
	// TODO: Implement different loggers for different environments
	var global = misc_1.getGlobalObject();
	/** Prefix for logging strings */
	var PREFIX = 'Sentry Logger ';
	/** JSDoc */
	var Logger = /** @class */ (function () {
	    /** JSDoc */
	    function Logger() {
	        this._enabled = false;
	    }
	    /** JSDoc */
	    Logger.prototype.disable = function () {
	        this._enabled = false;
	    };
	    /** JSDoc */
	    Logger.prototype.enable = function () {
	        this._enabled = true;
	    };
	    /** JSDoc */
	    Logger.prototype.log = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        misc_1.consoleSandbox(function () {
	            global.console.log(PREFIX + "[Log]: " + args.join(' '));
	        });
	    };
	    /** JSDoc */
	    Logger.prototype.warn = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        misc_1.consoleSandbox(function () {
	            global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
	        });
	    };
	    /** JSDoc */
	    Logger.prototype.error = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        misc_1.consoleSandbox(function () {
	            global.console.error(PREFIX + "[Error]: " + args.join(' '));
	        });
	    };
	    return Logger;
	}());
	// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
	global.__SENTRY__ = global.__SENTRY__ || {};
	var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());
	exports.logger = logger;
	//# sourceMappingURL=logger.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(11);
	var object_1 = __webpack_require__(44);
	/**
	 * Checks whether we're in the Node.js or Browser environment
	 *
	 * @returns Answer to given question
	 */
	function isNodeEnv() {
	    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
	}
	exports.isNodeEnv = isNodeEnv;
	/**
	 * Requires a module which is protected against bundler minification.
	 *
	 * @param request The module path to resolve
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function dynamicRequire(mod, request) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return mod.require(request);
	}
	exports.dynamicRequire = dynamicRequire;
	/** Default request keys that'll be used to extract data from the request */
	var DEFAULT_REQUEST_KEYS = ['cookies', 'data', 'headers', 'method', 'query_string', 'url'];
	/**
	 * Normalizes data from the request object, accounting for framework differences.
	 *
	 * @param req The request object from which to extract data
	 * @param keys An optional array of keys to include in the normalized data. Defaults to DEFAULT_REQUEST_KEYS if not
	 * provided.
	 * @returns An object containing normalized request data
	 */
	function extractNodeRequestData(req, keys) {
	    if (keys === void 0) { keys = DEFAULT_REQUEST_KEYS; }
	    // make sure we can safely use dynamicRequire below
	    if (!isNodeEnv()) {
	        throw new Error("Can't get node request data outside of a node environment");
	    }
	    var requestData = {};
	    // headers:
	    //   node, express: req.headers
	    //   koa: req.header
	    var headers = (req.headers || req.header || {});
	    // method:
	    //   node, express, koa: req.method
	    var method = req.method;
	    // host:
	    //   express: req.hostname in > 4 and req.host in < 4
	    //   koa: req.host
	    //   node: req.headers.host
	    var host = req.hostname || req.host || headers.host || '<no host>';
	    // protocol:
	    //   node: <n/a>
	    //   express, koa: req.protocol
	    var protocol = req.protocol === 'https' || req.secure || (req.socket || {}).encrypted
	        ? 'https'
	        : 'http';
	    // url (including path and query string):
	    //   node, express: req.originalUrl
	    //   koa: req.url
	    var originalUrl = (req.originalUrl || req.url || '');
	    // absolute url
	    var absoluteUrl = protocol + "://" + host + originalUrl;
	    keys.forEach(function (key) {
	        switch (key) {
	            case 'headers':
	                requestData.headers = headers;
	                break;
	            case 'method':
	                requestData.method = method;
	                break;
	            case 'url':
	                requestData.url = absoluteUrl;
	                break;
	            case 'cookies':
	                // cookies:
	                //   node, express, koa: req.headers.cookie
	                //   vercel, sails.js, express (w/ cookie middleware): req.cookies
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                requestData.cookies = req.cookies || dynamicRequire(module, 'cookie').parse(headers.cookie || '');
	                break;
	            case 'query_string':
	                // query string:
	                //   node: req.url (raw)
	                //   express, koa: req.query
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                requestData.query_string = dynamicRequire(module, 'url').parse(originalUrl || '', false).query;
	                break;
	            case 'data':
	                if (method === 'GET' || method === 'HEAD') {
	                    break;
	                }
	                // body data:
	                //   node, express, koa: req.body
	                if (req.body !== undefined) {
	                    requestData.data = is_1.isString(req.body) ? req.body : JSON.stringify(object_1.normalize(req.body));
	                }
	                break;
	            default:
	                if ({}.hasOwnProperty.call(req, key)) {
	                    requestData[key] = req[key];
	                }
	        }
	    });
	    return requestData;
	}
	exports.extractNodeRequestData = extractNodeRequestData;
	//# sourceMappingURL=node.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92), __webpack_require__(16)(module)))

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var browser_1 = __webpack_require__(66);
	var is_1 = __webpack_require__(11);
	var memo_1 = __webpack_require__(67);
	var stacktrace_1 = __webpack_require__(45);
	var string_1 = __webpack_require__(46);
	/**
	 * Wrap a given object method with a higher-order function
	 *
	 * @param source An object that contains a method to be wrapped.
	 * @param name A name of method to be wrapped.
	 * @param replacementFactory A function that should be used to wrap a given method, returning the wrapped method which
	 * will be substituted in for `source[name]`.
	 * @returns void
	 */
	function fill(source, name, replacementFactory) {
	    if (!(name in source)) {
	        return;
	    }
	    var original = source[name];
	    var wrapped = replacementFactory(original);
	    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
	    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
	    if (typeof wrapped === 'function') {
	        try {
	            wrapped.prototype = wrapped.prototype || {};
	            Object.defineProperties(wrapped, {
	                __sentry_original__: {
	                    enumerable: false,
	                    value: original,
	                },
	            });
	        }
	        catch (_Oo) {
	            // This can throw if multiple fill happens on a global object like XMLHttpRequest
	            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
	        }
	    }
	    source[name] = wrapped;
	}
	exports.fill = fill;
	/**
	 * Encodes given object into url-friendly format
	 *
	 * @param object An object that contains serializable values
	 * @returns string Encoded
	 */
	function urlEncode(object) {
	    return Object.keys(object)
	        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
	        .join('&');
	}
	exports.urlEncode = urlEncode;
	/**
	 * Transforms any object into an object literal with all its attributes
	 * attached to it.
	 *
	 * @param value Initial source that we have to transform in order for it to be usable by the serializer
	 */
	function getWalkSource(value) {
	    if (is_1.isError(value)) {
	        var error = value;
	        var err = {
	            message: error.message,
	            name: error.name,
	            stack: error.stack,
	        };
	        for (var i in error) {
	            if (Object.prototype.hasOwnProperty.call(error, i)) {
	                err[i] = error[i];
	            }
	        }
	        return err;
	    }
	    if (is_1.isEvent(value)) {
	        var event_1 = value;
	        var source = {};
	        source.type = event_1.type;
	        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
	        try {
	            source.target = is_1.isElement(event_1.target)
	                ? browser_1.htmlTreeAsString(event_1.target)
	                : Object.prototype.toString.call(event_1.target);
	        }
	        catch (_oO) {
	            source.target = '<unknown>';
	        }
	        try {
	            source.currentTarget = is_1.isElement(event_1.currentTarget)
	                ? browser_1.htmlTreeAsString(event_1.currentTarget)
	                : Object.prototype.toString.call(event_1.currentTarget);
	        }
	        catch (_oO) {
	            source.currentTarget = '<unknown>';
	        }
	        if (typeof CustomEvent !== 'undefined' && is_1.isInstanceOf(value, CustomEvent)) {
	            source.detail = event_1.detail;
	        }
	        for (var i in event_1) {
	            if (Object.prototype.hasOwnProperty.call(event_1, i)) {
	                source[i] = event_1;
	            }
	        }
	        return source;
	    }
	    return value;
	}
	/** Calculates bytes size of input string */
	function utf8Length(value) {
	    // eslint-disable-next-line no-bitwise
	    return ~-encodeURI(value).split(/%..|./).length;
	}
	/** Calculates bytes size of input object */
	function jsonSize(value) {
	    return utf8Length(JSON.stringify(value));
	}
	/** JSDoc */
	function normalizeToSize(object, 
	// Default Node.js REPL depth
	depth, 
	// 100kB, as 200kB is max payload size, so half sounds reasonable
	maxSize) {
	    if (depth === void 0) { depth = 3; }
	    if (maxSize === void 0) { maxSize = 100 * 1024; }
	    var serialized = normalize(object, depth);
	    if (jsonSize(serialized) > maxSize) {
	        return normalizeToSize(object, depth - 1, maxSize);
	    }
	    return serialized;
	}
	exports.normalizeToSize = normalizeToSize;
	/**
	 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
	 * booleans, null, and undefined.
	 *
	 * @param value The value to stringify
	 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
	 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
	 *  unchanged.
	 */
	function serializeValue(value) {
	    var type = Object.prototype.toString.call(value);
	    // Node.js REPL notation
	    if (typeof value === 'string') {
	        return value;
	    }
	    if (type === '[object Object]') {
	        return '[Object]';
	    }
	    if (type === '[object Array]') {
	        return '[Array]';
	    }
	    var normalized = normalizeValue(value);
	    return is_1.isPrimitive(normalized) ? normalized : type;
	}
	/**
	 * normalizeValue()
	 *
	 * Takes unserializable input and make it serializable friendly
	 *
	 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
	 * - serializes Error objects
	 * - filter global objects
	 */
	function normalizeValue(value, key) {
	    if (key === 'domain' && value && typeof value === 'object' && value._events) {
	        return '[Domain]';
	    }
	    if (key === 'domainEmitter') {
	        return '[DomainEmitter]';
	    }
	    if (typeof global !== 'undefined' && value === global) {
	        return '[Global]';
	    }
	    if (typeof window !== 'undefined' && value === window) {
	        return '[Window]';
	    }
	    if (typeof document !== 'undefined' && value === document) {
	        return '[Document]';
	    }
	    // React's SyntheticEvent thingy
	    if (is_1.isSyntheticEvent(value)) {
	        return '[SyntheticEvent]';
	    }
	    if (typeof value === 'number' && value !== value) {
	        return '[NaN]';
	    }
	    if (value === void 0) {
	        return '[undefined]';
	    }
	    if (typeof value === 'function') {
	        return "[Function: " + stacktrace_1.getFunctionName(value) + "]";
	    }
	    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
	    if (typeof value === 'symbol') {
	        return "[" + String(value) + "]";
	    }
	    if (typeof value === 'bigint') {
	        return "[BigInt: " + String(value) + "]";
	    }
	    return value;
	}
	/**
	 * Walks an object to perform a normalization on it
	 *
	 * @param key of object that's walked in current iteration
	 * @param value object to be walked
	 * @param depth Optional number indicating how deep should walking be performed
	 * @param memo Optional Memo class handling decycling
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function walk(key, value, depth, memo) {
	    if (depth === void 0) { depth = +Infinity; }
	    if (memo === void 0) { memo = new memo_1.Memo(); }
	    // If we reach the maximum depth, serialize whatever has left
	    if (depth === 0) {
	        return serializeValue(value);
	    }
	    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	    // If value implements `toJSON` method, call it and return early
	    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
	        return value.toJSON();
	    }
	    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
	    var normalized = normalizeValue(value, key);
	    if (is_1.isPrimitive(normalized)) {
	        return normalized;
	    }
	    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
	    var source = getWalkSource(value);
	    // Create an accumulator that will act as a parent for all future itterations of that branch
	    var acc = Array.isArray(value) ? [] : {};
	    // If we already walked that branch, bail out, as it's circular reference
	    if (memo.memoize(value)) {
	        return '[Circular ~]';
	    }
	    // Walk all keys of the source
	    for (var innerKey in source) {
	        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
	        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
	            continue;
	        }
	        // Recursively walk through all the child nodes
	        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
	    }
	    // Once walked through all the branches, remove the parent from memo storage
	    memo.unmemoize(value);
	    // Return accumulated values
	    return acc;
	}
	exports.walk = walk;
	/**
	 * normalize()
	 *
	 * - Creates a copy to prevent original input mutation
	 * - Skip non-enumerablers
	 * - Calls `toJSON` if implemented
	 * - Removes circular references
	 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
	 * - Translates known global objects/Classes to a string representations
	 * - Takes care of Error objects serialization
	 * - Optionally limit depth of final output
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function normalize(input, depth) {
	    try {
	        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
	    }
	    catch (_oO) {
	        return '**non-serializable**';
	    }
	}
	exports.normalize = normalize;
	/**
	 * Given any captured exception, extract its keys and create a sorted
	 * and truncated list that will be used inside the event message.
	 * eg. `Non-error exception captured with keys: foo, bar, baz`
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function extractExceptionKeysForMessage(exception, maxLength) {
	    if (maxLength === void 0) { maxLength = 40; }
	    var keys = Object.keys(getWalkSource(exception));
	    keys.sort();
	    if (!keys.length) {
	        return '[object has no keys]';
	    }
	    if (keys[0].length >= maxLength) {
	        return string_1.truncate(keys[0], maxLength);
	    }
	    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
	        var serialized = keys.slice(0, includedKeys).join(', ');
	        if (serialized.length > maxLength) {
	            continue;
	        }
	        if (includedKeys === keys.length) {
	            return serialized;
	        }
	        return string_1.truncate(serialized, maxLength);
	    }
	    return '';
	}
	exports.extractExceptionKeysForMessage = extractExceptionKeysForMessage;
	/**
	 * Given any object, return the new object with removed keys that value was `undefined`.
	 * Works recursively on objects and arrays.
	 */
	function dropUndefinedKeys(val) {
	    var e_1, _a;
	    if (is_1.isPlainObject(val)) {
	        var obj = val;
	        var rv = {};
	        try {
	            for (var _b = tslib_1.__values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var key = _c.value;
	                if (typeof obj[key] !== 'undefined') {
	                    rv[key] = dropUndefinedKeys(obj[key]);
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return rv;
	    }
	    if (Array.isArray(val)) {
	        return val.map(dropUndefinedKeys);
	    }
	    return val;
	}
	exports.dropUndefinedKeys = dropUndefinedKeys;
	//# sourceMappingURL=object.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var defaultFunctionName = '<anonymous>';
	/**
	 * Safely extract function name from itself
	 */
	function getFunctionName(fn) {
	    try {
	        if (!fn || typeof fn !== 'function') {
	            return defaultFunctionName;
	        }
	        return fn.name || defaultFunctionName;
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        return defaultFunctionName;
	    }
	}
	exports.getFunctionName = getFunctionName;
	//# sourceMappingURL=stacktrace.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(11);
	/**
	 * Truncates given string to the maximum characters count
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string (0 = unlimited)
	 * @returns string Encoded
	 */
	function truncate(str, max) {
	    if (max === void 0) { max = 0; }
	    if (typeof str !== 'string' || max === 0) {
	        return str;
	    }
	    return str.length <= max ? str : str.substr(0, max) + "...";
	}
	exports.truncate = truncate;
	/**
	 * This is basically just `trim_line` from
	 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string
	 * @returns string Encoded
	 */
	function snipLine(line, colno) {
	    var newLine = line;
	    var ll = newLine.length;
	    if (ll <= 150) {
	        return newLine;
	    }
	    if (colno > ll) {
	        // eslint-disable-next-line no-param-reassign
	        colno = ll;
	    }
	    var start = Math.max(colno - 60, 0);
	    if (start < 5) {
	        start = 0;
	    }
	    var end = Math.min(start + 140, ll);
	    if (end > ll - 5) {
	        end = ll;
	    }
	    if (end === ll) {
	        start = Math.max(end - 140, 0);
	    }
	    newLine = newLine.slice(start, end);
	    if (start > 0) {
	        newLine = "'{snip} " + newLine;
	    }
	    if (end < ll) {
	        newLine += ' {snip}';
	    }
	    return newLine;
	}
	exports.snipLine = snipLine;
	/**
	 * Join values in array
	 * @param input array of values to be joined together
	 * @param delimiter string to be placed in-between values
	 * @returns Joined values
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function safeJoin(input, delimiter) {
	    if (!Array.isArray(input)) {
	        return '';
	    }
	    var output = [];
	    // eslint-disable-next-line @typescript-eslint/prefer-for-of
	    for (var i = 0; i < input.length; i++) {
	        var value = input[i];
	        try {
	            output.push(String(value));
	        }
	        catch (e) {
	            output.push('[value cannot be serialized]');
	        }
	    }
	    return output.join(delimiter);
	}
	exports.safeJoin = safeJoin;
	/**
	 * Checks if the value matches a regex or includes the string
	 * @param value The string value to be checked against
	 * @param pattern Either a regex or a string that must be contained in value
	 */
	function isMatchingPattern(value, pattern) {
	    if (!is_1.isString(value)) {
	        return false;
	    }
	    if (is_1.isRegExp(pattern)) {
	        return pattern.test(value);
	    }
	    if (typeof pattern === 'string') {
	        return value.indexOf(pattern) !== -1;
	    }
	    return false;
	}
	exports.isMatchingPattern = isMatchingPattern;
	//# sourceMappingURL=string.js.map

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	var document = __webpack_require__(5).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(25);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(179);
	var enumBugKeys = __webpack_require__(79);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(21).f;
	var has = __webpack_require__(29);
	var TAG = __webpack_require__(6)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(87)('keys');
	var uid = __webpack_require__(91);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(81);
	var defined = __webpack_require__(47);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(47);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var core_1 = __webpack_require__(3);
	var utils_1 = __webpack_require__(1);
	var backend_1 = __webpack_require__(93);
	var helpers_1 = __webpack_require__(17);
	var integrations_1 = __webpack_require__(31);
	var version_1 = __webpack_require__(60);
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * @see BrowserOptions for documentation on configuration options.
	 * @see SentryClient for usage documentation.
	 */
	var BrowserClient = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserClient, _super);
	    /**
	     * Creates a new Browser SDK instance.
	     *
	     * @param options Configuration options for this SDK.
	     */
	    function BrowserClient(options) {
	        if (options === void 0) { options = {}; }
	        return _super.call(this, backend_1.BrowserBackend, options) || this;
	    }
	    /**
	     * Show a report dialog to the user to send feedback to a specific event.
	     *
	     * @param options Set individual options for the dialog
	     */
	    BrowserClient.prototype.showReportDialog = function (options) {
	        if (options === void 0) { options = {}; }
	        // doesn't work without a document (React Native)
	        var document = utils_1.getGlobalObject().document;
	        if (!document) {
	            return;
	        }
	        if (!this._isEnabled()) {
	            utils_1.logger.error('Trying to call showReportDialog with Sentry Client disabled');
	            return;
	        }
	        helpers_1.injectReportDialog(tslib_1.__assign(tslib_1.__assign({}, options), { dsn: options.dsn || this.getDsn() }));
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
	        event.platform = event.platform || 'javascript';
	        event.sdk = tslib_1.__assign(tslib_1.__assign({}, event.sdk), { name: version_1.SDK_NAME, packages: tslib_1.__spread(((event.sdk && event.sdk.packages) || []), [
	                {
	                    name: 'npm:@sentry/browser',
	                    version: version_1.SDK_VERSION,
	                },
	            ]), version: version_1.SDK_VERSION });
	        return _super.prototype._prepareEvent.call(this, event, scope, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._sendEvent = function (event) {
	        var integration = this.getIntegration(integrations_1.Breadcrumbs);
	        if (integration) {
	            integration.addSentryBreadcrumb(event);
	        }
	        _super.prototype._sendEvent.call(this, event);
	    };
	    return BrowserClient;
	}(core_1.BaseClient));
	exports.BrowserClient = BrowserClient;
	//# sourceMappingURL=client.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(1);
	var tracekit_1 = __webpack_require__(32);
	var STACKTRACE_LIMIT = 50;
	/**
	 * This function creates an exception from an TraceKitStackTrace
	 * @param stacktrace TraceKitStackTrace that will be converted to an exception
	 * @hidden
	 */
	function exceptionFromStacktrace(stacktrace) {
	    var frames = prepareFramesForEvent(stacktrace.stack);
	    var exception = {
	        type: stacktrace.name,
	        value: stacktrace.message,
	    };
	    if (frames && frames.length) {
	        exception.stacktrace = { frames: frames };
	    }
	    if (exception.type === undefined && exception.value === '') {
	        exception.value = 'Unrecoverable error caught';
	    }
	    return exception;
	}
	exports.exceptionFromStacktrace = exceptionFromStacktrace;
	/**
	 * @hidden
	 */
	function eventFromPlainObject(exception, syntheticException, rejection) {
	    var event = {
	        exception: {
	            values: [
	                {
	                    type: utils_1.isEvent(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
	                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + utils_1.extractExceptionKeysForMessage(exception),
	                },
	            ],
	        },
	        extra: {
	            __serialized__: utils_1.normalizeToSize(exception),
	        },
	    };
	    if (syntheticException) {
	        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
	        var frames_1 = prepareFramesForEvent(stacktrace.stack);
	        event.stacktrace = {
	            frames: frames_1,
	        };
	    }
	    return event;
	}
	exports.eventFromPlainObject = eventFromPlainObject;
	/**
	 * @hidden
	 */
	function eventFromStacktrace(stacktrace) {
	    var exception = exceptionFromStacktrace(stacktrace);
	    return {
	        exception: {
	            values: [exception],
	        },
	    };
	}
	exports.eventFromStacktrace = eventFromStacktrace;
	/**
	 * @hidden
	 */
	function prepareFramesForEvent(stack) {
	    if (!stack || !stack.length) {
	        return [];
	    }
	    var localStack = stack;
	    var firstFrameFunction = localStack[0].func || '';
	    var lastFrameFunction = localStack[localStack.length - 1].func || '';
	    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
	    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
	        localStack = localStack.slice(1);
	    }
	    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
	    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
	        localStack = localStack.slice(0, -1);
	    }
	    // The frame where the crash happened, should be the last entry in the array
	    return localStack
	        .slice(0, STACKTRACE_LIMIT)
	        .map(function (frame) { return ({
	        colno: frame.column === null ? undefined : frame.column,
	        filename: frame.url || localStack[0].url,
	        function: frame.func || '?',
	        in_app: true,
	        lineno: frame.line === null ? undefined : frame.line,
	    }); })
	        .reverse();
	}
	exports.prepareFramesForEvent = prepareFramesForEvent;
	//# sourceMappingURL=parsers.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var base_1 = __webpack_require__(33);
	exports.BaseTransport = base_1.BaseTransport;
	var fetch_1 = __webpack_require__(102);
	exports.FetchTransport = fetch_1.FetchTransport;
	var xhr_1 = __webpack_require__(103);
	exports.XHRTransport = xhr_1.XHRTransport;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SDK_NAME = 'sentry.javascript.browser';
	exports.SDK_VERSION = '5.30.0';
	//# sourceMappingURL=version.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(1);
	/** Noop transport */
	var NoopTransport = /** @class */ (function () {
	    function NoopTransport() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.sendEvent = function (_) {
	        return utils_1.SyncPromise.resolve({
	            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
	            status: types_1.Status.Skipped,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.close = function (_) {
	        return utils_1.SyncPromise.resolve(true);
	    };
	    return NoopTransport;
	}());
	exports.NoopTransport = NoopTransport;
	//# sourceMappingURL=noop.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var utils_1 = __webpack_require__(1);
	/**
	 * Holds additional event information. {@link Scope.applyToEvent} will be
	 * called by the client before an event will be sent.
	 */
	var Scope = /** @class */ (function () {
	    function Scope() {
	        /** Flag if notifiying is happening. */
	        this._notifyingListeners = false;
	        /** Callback for client to receive scope changes. */
	        this._scopeListeners = [];
	        /** Callback list that will be called after {@link applyToEvent}. */
	        this._eventProcessors = [];
	        /** Array of breadcrumbs. */
	        this._breadcrumbs = [];
	        /** User */
	        this._user = {};
	        /** Tags */
	        this._tags = {};
	        /** Extra */
	        this._extra = {};
	        /** Contexts */
	        this._contexts = {};
	    }
	    /**
	     * Inherit values from the parent scope.
	     * @param scope to clone.
	     */
	    Scope.clone = function (scope) {
	        var newScope = new Scope();
	        if (scope) {
	            newScope._breadcrumbs = tslib_1.__spread(scope._breadcrumbs);
	            newScope._tags = tslib_1.__assign({}, scope._tags);
	            newScope._extra = tslib_1.__assign({}, scope._extra);
	            newScope._contexts = tslib_1.__assign({}, scope._contexts);
	            newScope._user = scope._user;
	            newScope._level = scope._level;
	            newScope._span = scope._span;
	            newScope._session = scope._session;
	            newScope._transactionName = scope._transactionName;
	            newScope._fingerprint = scope._fingerprint;
	            newScope._eventProcessors = tslib_1.__spread(scope._eventProcessors);
	        }
	        return newScope;
	    };
	    /**
	     * Add internal on change listener. Used for sub SDKs that need to store the scope.
	     * @hidden
	     */
	    Scope.prototype.addScopeListener = function (callback) {
	        this._scopeListeners.push(callback);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addEventProcessor = function (callback) {
	        this._eventProcessors.push(callback);
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setUser = function (user) {
	        this._user = user || {};
	        if (this._session) {
	            this._session.update({ user: user });
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getUser = function () {
	        return this._user;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTags = function (tags) {
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), tags);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTag = function (key, value) {
	        var _a;
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), (_a = {}, _a[key] = value, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtras = function (extras) {
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), extras);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtra = function (key, extra) {
	        var _a;
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), (_a = {}, _a[key] = extra, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setFingerprint = function (fingerprint) {
	        this._fingerprint = fingerprint;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setLevel = function (level) {
	        this._level = level;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTransactionName = function (name) {
	        this._transactionName = name;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Can be removed in major version.
	     * @deprecated in favor of {@link this.setTransactionName}
	     */
	    Scope.prototype.setTransaction = function (name) {
	        return this.setTransactionName(name);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setContext = function (key, context) {
	        var _a;
	        if (context === null) {
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete this._contexts[key];
	        }
	        else {
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), (_a = {}, _a[key] = context, _a));
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSpan = function (span) {
	        this._span = span;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSpan = function () {
	        return this._span;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getTransaction = function () {
	        var _a, _b, _c, _d;
	        // often, this span will be a transaction, but it's not guaranteed to be
	        var span = this.getSpan();
	        // try it the new way first
	        if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) {
	            return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
	        }
	        // fallback to the old way (known bug: this only finds transactions with sampled = true)
	        if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) {
	            return span.spanRecorder.spans[0];
	        }
	        // neither way found a transaction
	        return undefined;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSession = function (session) {
	        if (!session) {
	            delete this._session;
	        }
	        else {
	            this._session = session;
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSession = function () {
	        return this._session;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.update = function (captureContext) {
	        if (!captureContext) {
	            return this;
	        }
	        if (typeof captureContext === 'function') {
	            var updatedScope = captureContext(this);
	            return updatedScope instanceof Scope ? updatedScope : this;
	        }
	        if (captureContext instanceof Scope) {
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext._tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext._extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext._contexts);
	            if (captureContext._user && Object.keys(captureContext._user).length) {
	                this._user = captureContext._user;
	            }
	            if (captureContext._level) {
	                this._level = captureContext._level;
	            }
	            if (captureContext._fingerprint) {
	                this._fingerprint = captureContext._fingerprint;
	            }
	        }
	        else if (utils_1.isPlainObject(captureContext)) {
	            // eslint-disable-next-line no-param-reassign
	            captureContext = captureContext;
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext.tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext.extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext.contexts);
	            if (captureContext.user) {
	                this._user = captureContext.user;
	            }
	            if (captureContext.level) {
	                this._level = captureContext.level;
	            }
	            if (captureContext.fingerprint) {
	                this._fingerprint = captureContext.fingerprint;
	            }
	        }
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clear = function () {
	        this._breadcrumbs = [];
	        this._tags = {};
	        this._extra = {};
	        this._user = {};
	        this._contexts = {};
	        this._level = undefined;
	        this._transactionName = undefined;
	        this._fingerprint = undefined;
	        this._span = undefined;
	        this._session = undefined;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: utils_1.dateTimestampInSeconds() }, breadcrumb);
	        this._breadcrumbs =
	            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
	                ? tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxBreadcrumbs)
	                : tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clearBreadcrumbs = function () {
	        this._breadcrumbs = [];
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Applies the current context and fingerprint to the event.
	     * Note that breadcrumbs will be added by the client.
	     * Also if the event has already breadcrumbs on it, we do not merge them.
	     * @param event Event
	     * @param hint May contain additional informartion about the original exception.
	     * @hidden
	     */
	    Scope.prototype.applyToEvent = function (event, hint) {
	        var _a;
	        if (this._extra && Object.keys(this._extra).length) {
	            event.extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), event.extra);
	        }
	        if (this._tags && Object.keys(this._tags).length) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), event.tags);
	        }
	        if (this._user && Object.keys(this._user).length) {
	            event.user = tslib_1.__assign(tslib_1.__assign({}, this._user), event.user);
	        }
	        if (this._contexts && Object.keys(this._contexts).length) {
	            event.contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), event.contexts);
	        }
	        if (this._level) {
	            event.level = this._level;
	        }
	        if (this._transactionName) {
	            event.transaction = this._transactionName;
	        }
	        // We want to set the trace context for normal events only if there isn't already
	        // a trace context on the event. There is a product feature in place where we link
	        // errors with transaction and it relys on that.
	        if (this._span) {
	            event.contexts = tslib_1.__assign({ trace: this._span.getTraceContext() }, event.contexts);
	            var transactionName = (_a = this._span.transaction) === null || _a === void 0 ? void 0 : _a.name;
	            if (transactionName) {
	                event.tags = tslib_1.__assign({ transaction: transactionName }, event.tags);
	            }
	        }
	        this._applyFingerprint(event);
	        event.breadcrumbs = tslib_1.__spread((event.breadcrumbs || []), this._breadcrumbs);
	        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
	        return this._notifyEventProcessors(tslib_1.__spread(getGlobalEventProcessors(), this._eventProcessors), event, hint);
	    };
	    /**
	     * This will be called after {@link applyToEvent} is finished.
	     */
	    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
	        var _this = this;
	        if (index === void 0) { index = 0; }
	        return new utils_1.SyncPromise(function (resolve, reject) {
	            var processor = processors[index];
	            if (event === null || typeof processor !== 'function') {
	                resolve(event);
	            }
	            else {
	                var result = processor(tslib_1.__assign({}, event), hint);
	                if (utils_1.isThenable(result)) {
	                    result
	                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
	                        .then(null, reject);
	                }
	                else {
	                    _this._notifyEventProcessors(processors, result, hint, index + 1)
	                        .then(resolve)
	                        .then(null, reject);
	                }
	            }
	        });
	    };
	    /**
	     * This will be called on every set call.
	     */
	    Scope.prototype._notifyScopeListeners = function () {
	        var _this = this;
	        // We need this check for this._notifyingListeners to be able to work on scope during updates
	        // If this check is not here we'll produce endless recursion when something is done with the scope
	        // during the callback.
	        if (!this._notifyingListeners) {
	            this._notifyingListeners = true;
	            this._scopeListeners.forEach(function (callback) {
	                callback(_this);
	            });
	            this._notifyingListeners = false;
	        }
	    };
	    /**
	     * Applies fingerprint from the scope to the event if there's one,
	     * uses message if there's one instead or get rid of empty fingerprint
	     */
	    Scope.prototype._applyFingerprint = function (event) {
	        // Make sure it's an array first and we actually have something in place
	        event.fingerprint = event.fingerprint
	            ? Array.isArray(event.fingerprint)
	                ? event.fingerprint
	                : [event.fingerprint]
	            : [];
	        // If we have something on the scope, then merge it with event
	        if (this._fingerprint) {
	            event.fingerprint = event.fingerprint.concat(this._fingerprint);
	        }
	        // If we have no data at all, remove empty array default
	        if (event.fingerprint && !event.fingerprint.length) {
	            delete event.fingerprint;
	        }
	    };
	    return Scope;
	}());
	exports.Scope = Scope;
	/**
	 * Retruns the global event processors.
	 */
	function getGlobalEventProcessors() {
	    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
	    var global = utils_1.getGlobalObject();
	    global.__SENTRY__ = global.__SENTRY__ || {};
	    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
	    return global.__SENTRY__.globalEventProcessors;
	    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
	}
	/**
	 * Add a EventProcessor to be kept globally.
	 * @param callback EventProcessor to add
	 */
	function addGlobalEventProcessor(callback) {
	    getGlobalEventProcessors().push(callback);
	}
	exports.addGlobalEventProcessor = addGlobalEventProcessor;
	//# sourceMappingURL=scope.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(1);
	/**
	 * @inheritdoc
	 */
	var Session = /** @class */ (function () {
	    function Session(context) {
	        this.errors = 0;
	        this.sid = utils_1.uuid4();
	        this.timestamp = Date.now();
	        this.started = Date.now();
	        this.duration = 0;
	        this.status = types_1.SessionStatus.Ok;
	        if (context) {
	            this.update(context);
	        }
	    }
	    /** JSDoc */
	    // eslint-disable-next-line complexity
	    Session.prototype.update = function (context) {
	        if (context === void 0) { context = {}; }
	        if (context.user) {
	            if (context.user.ip_address) {
	                this.ipAddress = context.user.ip_address;
	            }
	            if (!context.did) {
	                this.did = context.user.id || context.user.email || context.user.username;
	            }
	        }
	        this.timestamp = context.timestamp || Date.now();
	        if (context.sid) {
	            // Good enough uuid validation. — Kamil
	            this.sid = context.sid.length === 32 ? context.sid : utils_1.uuid4();
	        }
	        if (context.did) {
	            this.did = "" + context.did;
	        }
	        if (typeof context.started === 'number') {
	            this.started = context.started;
	        }
	        if (typeof context.duration === 'number') {
	            this.duration = context.duration;
	        }
	        else {
	            this.duration = this.timestamp - this.started;
	        }
	        if (context.release) {
	            this.release = context.release;
	        }
	        if (context.environment) {
	            this.environment = context.environment;
	        }
	        if (context.ipAddress) {
	            this.ipAddress = context.ipAddress;
	        }
	        if (context.userAgent) {
	            this.userAgent = context.userAgent;
	        }
	        if (typeof context.errors === 'number') {
	            this.errors = context.errors;
	        }
	        if (context.status) {
	            this.status = context.status;
	        }
	    };
	    /** JSDoc */
	    Session.prototype.close = function (status) {
	        if (status) {
	            this.update({ status: status });
	        }
	        else if (this.status === types_1.SessionStatus.Ok) {
	            this.update({ status: types_1.SessionStatus.Exited });
	        }
	        else {
	            this.update();
	        }
	    };
	    /** JSDoc */
	    Session.prototype.toJSON = function () {
	        return utils_1.dropUndefinedKeys({
	            sid: "" + this.sid,
	            init: true,
	            started: new Date(this.started).toISOString(),
	            timestamp: new Date(this.timestamp).toISOString(),
	            status: this.status,
	            errors: this.errors,
	            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
	            duration: this.duration,
	            attrs: utils_1.dropUndefinedKeys({
	                release: this.release,
	                environment: this.environment,
	                ip_address: this.ipAddress,
	                user_agent: this.userAgent,
	            }),
	        });
	    };
	    return Session;
	}());
	exports.Session = Session;
	//# sourceMappingURL=session.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var browsertracing_1 = __webpack_require__(116);
	exports.BrowserTracing = browsertracing_1.BrowserTracing;
	var request_1 = __webpack_require__(65);
	exports.registerRequestInstrumentation = request_1.registerRequestInstrumentation;
	exports.defaultRequestInstrumentationOptions = request_1.defaultRequestInstrumentationOptions;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var hub_1 = __webpack_require__(7);
	var utils_1 = __webpack_require__(1);
	var utils_2 = __webpack_require__(10);
	exports.DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
	exports.defaultRequestInstrumentationOptions = {
	    traceFetch: true,
	    traceXHR: true,
	    tracingOrigins: exports.DEFAULT_TRACING_ORIGINS,
	};
	/** Registers span creators for xhr and fetch requests  */
	function registerRequestInstrumentation(_options) {
	    // eslint-disable-next-line @typescript-eslint/unbound-method
	    var _a = tslib_1.__assign(tslib_1.__assign({}, exports.defaultRequestInstrumentationOptions), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
	    // We should cache url -> decision so that we don't have to compute
	    // regexp everytime we create a request.
	    var urlMap = {};
	    var defaultShouldCreateSpan = function (url) {
	        if (urlMap[url]) {
	            return urlMap[url];
	        }
	        var origins = tracingOrigins;
	        urlMap[url] =
	            origins.some(function (origin) { return utils_1.isMatchingPattern(url, origin); }) &&
	                !utils_1.isMatchingPattern(url, 'sentry_key');
	        return urlMap[url];
	    };
	    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
	    // That's why we filter out already unwanted Spans from tracingOrigins
	    var shouldCreateSpan = defaultShouldCreateSpan;
	    if (typeof shouldCreateSpanForRequest === 'function') {
	        shouldCreateSpan = function (url) {
	            return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
	        };
	    }
	    var spans = {};
	    if (traceFetch) {
	        utils_1.addInstrumentationHandler({
	            callback: function (handlerData) {
	                fetchCallback(handlerData, shouldCreateSpan, spans);
	            },
	            type: 'fetch',
	        });
	    }
	    if (traceXHR) {
	        utils_1.addInstrumentationHandler({
	            callback: function (handlerData) {
	                xhrCallback(handlerData, shouldCreateSpan, spans);
	            },
	            type: 'xhr',
	        });
	    }
	}
	exports.registerRequestInstrumentation = registerRequestInstrumentation;
	/**
	 * Create and track fetch request spans
	 */
	function fetchCallback(handlerData, shouldCreateSpan, spans) {
	    var _a;
	    var currentClientOptions = (_a = hub_1.getCurrentHub()
	        .getClient()) === null || _a === void 0 ? void 0 : _a.getOptions();
	    if (!(currentClientOptions && utils_2.hasTracingEnabled(currentClientOptions)) ||
	        !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
	        return;
	    }
	    if (handlerData.endTimestamp && handlerData.fetchData.__span) {
	        var span = spans[handlerData.fetchData.__span];
	        if (span) {
	            var response = handlerData.response;
	            if (response) {
	                // TODO (kmclb) remove this once types PR goes through
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                span.setHttpStatus(response.status);
	            }
	            span.finish();
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete spans[handlerData.fetchData.__span];
	        }
	        return;
	    }
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        var span = activeTransaction.startChild({
	            data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { type: 'fetch' }),
	            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
	            op: 'http',
	        });
	        handlerData.fetchData.__span = span.spanId;
	        spans[span.spanId] = span;
	        var request = (handlerData.args[0] = handlerData.args[0]);
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var options = (handlerData.args[1] = handlerData.args[1] || {});
	        var headers = options.headers;
	        if (utils_1.isInstanceOf(request, Request)) {
	            headers = request.headers;
	        }
	        if (headers) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            if (typeof headers.append === 'function') {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                headers.append('sentry-trace', span.toTraceparent());
	            }
	            else if (Array.isArray(headers)) {
	                headers = tslib_1.__spread(headers, [['sentry-trace', span.toTraceparent()]]);
	            }
	            else {
	                headers = tslib_1.__assign(tslib_1.__assign({}, headers), { 'sentry-trace': span.toTraceparent() });
	            }
	        }
	        else {
	            headers = { 'sentry-trace': span.toTraceparent() };
	        }
	        options.headers = headers;
	    }
	}
	exports.fetchCallback = fetchCallback;
	/**
	 * Create and track xhr request spans
	 */
	function xhrCallback(handlerData, shouldCreateSpan, spans) {
	    var _a;
	    var currentClientOptions = (_a = hub_1.getCurrentHub()
	        .getClient()) === null || _a === void 0 ? void 0 : _a.getOptions();
	    if (!(currentClientOptions && utils_2.hasTracingEnabled(currentClientOptions)) ||
	        !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url)) ||
	        handlerData.xhr.__sentry_own_request__) {
	        return;
	    }
	    var xhr = handlerData.xhr.__sentry_xhr__;
	    // check first if the request has finished and is tracked by an existing span which should now end
	    if (handlerData.endTimestamp && handlerData.xhr.__sentry_xhr_span_id__) {
	        var span = spans[handlerData.xhr.__sentry_xhr_span_id__];
	        if (span) {
	            span.setHttpStatus(xhr.status_code);
	            span.finish();
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete spans[handlerData.xhr.__sentry_xhr_span_id__];
	        }
	        return;
	    }
	    // if not, create a new span to track it
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        var span = activeTransaction.startChild({
	            data: tslib_1.__assign(tslib_1.__assign({}, xhr.data), { type: 'xhr', method: xhr.method, url: xhr.url }),
	            description: xhr.method + " " + xhr.url,
	            op: 'http',
	        });
	        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
	        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
	        if (handlerData.xhr.setRequestHeader) {
	            try {
	                handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
	            }
	            catch (_) {
	                // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
	            }
	        }
	    }
	}
	exports.xhrCallback = xhrCallback;
	//# sourceMappingURL=request.js.map

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(11);
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function htmlTreeAsString(elem) {
	    // try/catch both:
	    // - accessing event.target (see getsentry/raven-js#838, #768)
	    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	    // - can throw an exception in some circumstances.
	    try {
	        var currentElem = elem;
	        var MAX_TRAVERSE_HEIGHT = 5;
	        var MAX_OUTPUT_LEN = 80;
	        var out = [];
	        var height = 0;
	        var len = 0;
	        var separator = ' > ';
	        var sepLength = separator.length;
	        var nextStr = void 0;
	        // eslint-disable-next-line no-plusplus
	        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
	            nextStr = _htmlElementAsString(currentElem);
	            // bail out if
	            // - nextStr is the 'html' element
	            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	            //   (ignore this limit if we are on the first iteration)
	            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
	                break;
	            }
	            out.push(nextStr);
	            len += nextStr.length;
	            currentElem = currentElem.parentNode;
	        }
	        return out.reverse().join(separator);
	    }
	    catch (_oO) {
	        return '<unknown>';
	    }
	}
	exports.htmlTreeAsString = htmlTreeAsString;
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function _htmlElementAsString(el) {
	    var elem = el;
	    var out = [];
	    var className;
	    var classes;
	    var key;
	    var attr;
	    var i;
	    if (!elem || !elem.tagName) {
	        return '';
	    }
	    out.push(elem.tagName.toLowerCase());
	    if (elem.id) {
	        out.push("#" + elem.id);
	    }
	    // eslint-disable-next-line prefer-const
	    className = elem.className;
	    if (className && is_1.isString(className)) {
	        classes = className.split(/\s+/);
	        for (i = 0; i < classes.length; i++) {
	            out.push("." + classes[i]);
	        }
	    }
	    var allowedAttrs = ['type', 'name', 'title', 'alt'];
	    for (i = 0; i < allowedAttrs.length; i++) {
	        key = allowedAttrs[i];
	        attr = elem.getAttribute(key);
	        if (attr) {
	            out.push("[" + key + "=\"" + attr + "\"]");
	        }
	    }
	    return out.join('');
	}
	//# sourceMappingURL=browser.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/**
	 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
	 */
	var Memo = /** @class */ (function () {
	    function Memo() {
	        this._hasWeakSet = typeof WeakSet === 'function';
	        this._inner = this._hasWeakSet ? new WeakSet() : [];
	    }
	    /**
	     * Sets obj to remember.
	     * @param obj Object to remember
	     */
	    Memo.prototype.memoize = function (obj) {
	        if (this._hasWeakSet) {
	            if (this._inner.has(obj)) {
	                return true;
	            }
	            this._inner.add(obj);
	            return false;
	        }
	        // eslint-disable-next-line @typescript-eslint/prefer-for-of
	        for (var i = 0; i < this._inner.length; i++) {
	            var value = this._inner[i];
	            if (value === obj) {
	                return true;
	            }
	        }
	        this._inner.push(obj);
	        return false;
	    };
	    /**
	     * Removes object from internal storage.
	     * @param obj Object to forget
	     */
	    Memo.prototype.unmemoize = function (obj) {
	        if (this._hasWeakSet) {
	            this._inner.delete(obj);
	        }
	        else {
	            for (var i = 0; i < this._inner.length; i++) {
	                if (this._inner[i] === obj) {
	                    this._inner.splice(i, 1);
	                    break;
	                }
	            }
	        }
	    };
	    return Memo;
	}());
	exports.Memo = Memo;
	//# sourceMappingURL=memo.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var logger_1 = __webpack_require__(42);
	var misc_1 = __webpack_require__(18);
	/**
	 * Tells whether current environment supports ErrorEvent objects
	 * {@link supportsErrorEvent}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsErrorEvent() {
	    try {
	        new ErrorEvent('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsErrorEvent = supportsErrorEvent;
	/**
	 * Tells whether current environment supports DOMError objects
	 * {@link supportsDOMError}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMError() {
	    try {
	        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
	        // 1 argument required, but only 0 present.
	        // @ts-ignore It really needs 1 argument, not 0.
	        new DOMError('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMError = supportsDOMError;
	/**
	 * Tells whether current environment supports DOMException objects
	 * {@link supportsDOMException}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMException() {
	    try {
	        new DOMException('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMException = supportsDOMException;
	/**
	 * Tells whether current environment supports Fetch API
	 * {@link supportsFetch}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsFetch() {
	    if (!('fetch' in misc_1.getGlobalObject())) {
	        return false;
	    }
	    try {
	        new Headers();
	        new Request('');
	        new Response();
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsFetch = supportsFetch;
	/**
	 * isNativeFetch checks if the given function is a native implementation of fetch()
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function isNativeFetch(func) {
	    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
	}
	/**
	 * Tells whether current environment supports Fetch API natively
	 * {@link supportsNativeFetch}.
	 *
	 * @returns true if `window.fetch` is natively implemented, false otherwise
	 */
	function supportsNativeFetch() {
	    if (!supportsFetch()) {
	        return false;
	    }
	    var global = misc_1.getGlobalObject();
	    // Fast path to avoid DOM I/O
	    // eslint-disable-next-line @typescript-eslint/unbound-method
	    if (isNativeFetch(global.fetch)) {
	        return true;
	    }
	    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
	    // so create a "pure" iframe to see if that has native fetch
	    var result = false;
	    var doc = global.document;
	    // eslint-disable-next-line deprecation/deprecation
	    if (doc && typeof doc.createElement === "function") {
	        try {
	            var sandbox = doc.createElement('iframe');
	            sandbox.hidden = true;
	            doc.head.appendChild(sandbox);
	            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
	                // eslint-disable-next-line @typescript-eslint/unbound-method
	                result = isNativeFetch(sandbox.contentWindow.fetch);
	            }
	            doc.head.removeChild(sandbox);
	        }
	        catch (err) {
	            logger_1.logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
	        }
	    }
	    return result;
	}
	exports.supportsNativeFetch = supportsNativeFetch;
	/**
	 * Tells whether current environment supports ReportingObserver API
	 * {@link supportsReportingObserver}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReportingObserver() {
	    return 'ReportingObserver' in misc_1.getGlobalObject();
	}
	exports.supportsReportingObserver = supportsReportingObserver;
	/**
	 * Tells whether current environment supports Referrer Policy API
	 * {@link supportsReferrerPolicy}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReferrerPolicy() {
	    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	    // https://caniuse.com/#feat=referrer-policy
	    // It doesn't. And it throw exception instead of ignoring this parameter...
	    // REF: https://github.com/getsentry/raven-js/issues/1233
	    if (!supportsFetch()) {
	        return false;
	    }
	    try {
	        new Request('_', {
	            referrerPolicy: 'origin',
	        });
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsReferrerPolicy = supportsReferrerPolicy;
	/**
	 * Tells whether current environment supports History API
	 * {@link supportsHistory}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsHistory() {
	    // NOTE: in Chrome App environment, touching history.pushState, *even inside
	    //       a try/catch block*, will cause Chrome to output an error to console.error
	    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	    var global = misc_1.getGlobalObject();
	    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var chrome = global.chrome;
	    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
	    return !isChromePackagedApp && hasHistoryApi;
	}
	exports.supportsHistory = supportsHistory;
	//# sourceMappingURL=supports.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
	/* eslint-disable @typescript-eslint/typedef */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var is_1 = __webpack_require__(11);
	/** SyncPromise internal states */
	var States;
	(function (States) {
	    /** Pending */
	    States["PENDING"] = "PENDING";
	    /** Resolved / OK */
	    States["RESOLVED"] = "RESOLVED";
	    /** Rejected / Error */
	    States["REJECTED"] = "REJECTED";
	})(States || (States = {}));
	/**
	 * Thenable class that behaves like a Promise and follows it's interface
	 * but is not async internally
	 */
	var SyncPromise = /** @class */ (function () {
	    function SyncPromise(executor) {
	        var _this = this;
	        this._state = States.PENDING;
	        this._handlers = [];
	        /** JSDoc */
	        this._resolve = function (value) {
	            _this._setResult(States.RESOLVED, value);
	        };
	        /** JSDoc */
	        this._reject = function (reason) {
	            _this._setResult(States.REJECTED, reason);
	        };
	        /** JSDoc */
	        this._setResult = function (state, value) {
	            if (_this._state !== States.PENDING) {
	                return;
	            }
	            if (is_1.isThenable(value)) {
	                value.then(_this._resolve, _this._reject);
	                return;
	            }
	            _this._state = state;
	            _this._value = value;
	            _this._executeHandlers();
	        };
	        // TODO: FIXME
	        /** JSDoc */
	        this._attachHandler = function (handler) {
	            _this._handlers = _this._handlers.concat(handler);
	            _this._executeHandlers();
	        };
	        /** JSDoc */
	        this._executeHandlers = function () {
	            if (_this._state === States.PENDING) {
	                return;
	            }
	            var cachedHandlers = _this._handlers.slice();
	            _this._handlers = [];
	            cachedHandlers.forEach(function (handler) {
	                if (handler.done) {
	                    return;
	                }
	                if (_this._state === States.RESOLVED) {
	                    if (handler.onfulfilled) {
	                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	                        handler.onfulfilled(_this._value);
	                    }
	                }
	                if (_this._state === States.REJECTED) {
	                    if (handler.onrejected) {
	                        handler.onrejected(_this._value);
	                    }
	                }
	                handler.done = true;
	            });
	        };
	        try {
	            executor(this._resolve, this._reject);
	        }
	        catch (e) {
	            this._reject(e);
	        }
	    }
	    /** JSDoc */
	    SyncPromise.resolve = function (value) {
	        return new SyncPromise(function (resolve) {
	            resolve(value);
	        });
	    };
	    /** JSDoc */
	    SyncPromise.reject = function (reason) {
	        return new SyncPromise(function (_, reject) {
	            reject(reason);
	        });
	    };
	    /** JSDoc */
	    SyncPromise.all = function (collection) {
	        return new SyncPromise(function (resolve, reject) {
	            if (!Array.isArray(collection)) {
	                reject(new TypeError("Promise.all requires an array as input."));
	                return;
	            }
	            if (collection.length === 0) {
	                resolve([]);
	                return;
	            }
	            var counter = collection.length;
	            var resolvedCollection = [];
	            collection.forEach(function (item, index) {
	                SyncPromise.resolve(item)
	                    .then(function (value) {
	                    resolvedCollection[index] = value;
	                    counter -= 1;
	                    if (counter !== 0) {
	                        return;
	                    }
	                    resolve(resolvedCollection);
	                })
	                    .then(null, reject);
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            _this._attachHandler({
	                done: false,
	                onfulfilled: function (result) {
	                    if (!onfulfilled) {
	                        // TODO: ¯\_(ツ)_/¯
	                        // TODO: FIXME
	                        resolve(result);
	                        return;
	                    }
	                    try {
	                        resolve(onfulfilled(result));
	                        return;
	                    }
	                    catch (e) {
	                        reject(e);
	                        return;
	                    }
	                },
	                onrejected: function (reason) {
	                    if (!onrejected) {
	                        reject(reason);
	                        return;
	                    }
	                    try {
	                        resolve(onrejected(reason));
	                        return;
	                    }
	                    catch (e) {
	                        reject(e);
	                        return;
	                    }
	                },
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.catch = function (onrejected) {
	        return this.then(function (val) { return val; }, onrejected);
	    };
	    /** JSDoc */
	    SyncPromise.prototype.finally = function (onfinally) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            var val;
	            var isRejected;
	            return _this.then(function (value) {
	                isRejected = false;
	                val = value;
	                if (onfinally) {
	                    onfinally();
	                }
	            }, function (reason) {
	                isRejected = true;
	                val = reason;
	                if (onfinally) {
	                    onfinally();
	                }
	            }).then(function () {
	                if (isRejected) {
	                    reject(val);
	                    return;
	                }
	                resolve(val);
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.toString = function () {
	        return '[object SyncPromise]';
	    };
	    return SyncPromise;
	}());
	exports.SyncPromise = SyncPromise;
	//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,r){ true?module.exports=r():"function"==typeof define&&define.amd?define([],r):"object"==typeof exports?exports.SpeedTest=r():t.SpeedTest=r()}(this,(function(){return function(){var t={260:function(t,r,n){function e(t,r){var n=s();return(e=function(t,r){return n[t-=381]})(t,r)}t=n.nmd(t);var a=e;function s(){var t=["3627351tWRYNI","2314443bijRpF","2385585CJTGos","1977664EFYLyi","2ETEkyy","1488pOAKnl","Promise","7465CtDOZx","589480mSmWVr","exports","1479942bsfTpg"];return(s=function(){return t})()}(function(t,r){for(var n=e,a=t();;)try{if(410414==parseInt(n(381))/1*(-parseInt(n(385))/2)+parseInt(n(389))/3+-parseInt(n(382))/4*(parseInt(n(384))/5)+-parseInt(n(387))/6+parseInt(n(388))/7+parseInt(n(391))/8+parseInt(n(390))/9)break;a.push(a.shift())}catch(t){a.push(a.shift())}})(s),n(6201),n(252),n(5552),n(5795),t[a(386)]=n(4102)[a(383)]},6293:function(t,r,n){function e(t,r){var n=a();return(e=function(t,r){return n[t-=417]})(t,r)}function a(){var t=["628676KgdruH","958276zVxaIM","8jvOiEn","Array","303051oXeXDO","8858773ODyyWf","740WWBRid","fill","1973034wtRmkM","exports","90qtmWzt","293625oQnGGV","149049xlWpSE","12lJmvuN"];return(a=function(){return t})()}t=n.nmd(t);var s=e;(function(t,r){for(var n=e,a=t();;)try{if(910228==parseInt(n(419))/1+parseInt(n(427))/2+-parseInt(n(423))/3*(-parseInt(n(418))/4)+-parseInt(n(430))/5*(parseInt(n(429))/6)+-parseInt(n(424))/7*(parseInt(n(421))/8)+parseInt(n(417))/9*(parseInt(n(425))/10)+-parseInt(n(420))/11)break;a.push(a.shift())}catch(t){a.push(a.shift())}})(a),n(8194),t[s(428)]=n(4102)[s(422)][s(426)]},1970:function(t,r,n){t=n.nmd(t);var e=s;function a(){var t=["find","Array","44082pzazBJ","2739564moRuCH","976mDcmCd","22206zqlmwA","19384lcJzAK","776270pNCQWL","83grXEme","3927900VgcCcs","4QgnFxv","5661397Ivxioi","exports"];return(a=function(){return t})()}function s(t,r){var n=a();return(s=function(t,r){return n[t-=185]})(t,r)}(function(t,r){for(var n=s,e=t();;)try{if(548209==-parseInt(n(187))/1*(parseInt(n(185))/2)+parseInt(n(195))/3*(-parseInt(n(189))/4)+parseInt(n(188))/5+-parseInt(n(197))/6+parseInt(n(190))/7+parseInt(n(196))/8*(parseInt(n(194))/9)+parseInt(n(186))/10)break;e.push(e.shift())}catch(t){e.push(e.shift())}})(a),n(3828),t[e(191)]=n(4102)[e(193)][e(192)]},7355:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=s();return(a=function(t,r){return n[t-=279]})(t,r)}function s(){var t=["598622MJpJfs","exports","5283055ycMWPU","4568214iQsSLi","1313038aMrMOf","assign","Object","4436192PUQXOQ","9034422qrSqvi","58682544lSraBJ","7ttLrUC"];return(s=function(){return t})()}(function(t,r){for(var n=a,e=t();;)try{if(886043==-parseInt(n(282))/1+-parseInt(n(286))/2+-parseInt(n(285))/3+-parseInt(n(289))/4+-parseInt(n(284))/5+parseInt(n(279))/6*(-parseInt(n(281))/7)+parseInt(n(280))/8)break;e.push(e.shift())}catch(t){e.push(e.shift())}})(s),n(7350),t[e(283)]=n(4102)[e(288)][e(287)]},6709:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=s();return(a=function(t,r){return n[t-=454]})(t,r)}function s(){var t=["242908goLjEF","includes","5AnyeAU","33xNrGJd","418rlkjGa","437416caNSpp","exports","19070zItmwM","4522623lnckfV","1710606fSyyGI","1557dgZYvK","6792CcAbWK","710243wuVuiM"];return(s=function(){return t})()}(function(t,r){for(var n=a,e=t();;)try{if(446415==parseInt(n(466))/1+parseInt(n(459))/2+-parseInt(n(457))/3*(-parseInt(n(454))/4)+-parseInt(n(456))/5*(parseInt(n(463))/6)+-parseInt(n(462))/7+parseInt(n(465))/8*(-parseInt(n(464))/9)+parseInt(n(461))/10*(-parseInt(n(458))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}})(s),n(8027),t[e(460)]=n(4102).String[e(455)]},5321:function(t){function r(t,e){var a=n();return(r=function(t,r){return a[t-=148]})(t,e)}function n(){var t=[" is not a function!","941140ZSrHOp","3788336zUDUhS","1sluznY","9mIWLCd","377615NdaDkP","1167344EDTFrL","2628msBJlb","390zssvBB","2543739rLPzuO","function","49346BuFoLF","102615akPiMj","72lZzEeI"];return(n=function(){return t})()}(function(t,n){for(var e=r,a=t();;)try{if(713713==-parseInt(e(148))/1*(-parseInt(e(151))/2)+-parseInt(e(154))/3+-parseInt(e(161))/4+-parseInt(e(157))/5*(-parseInt(e(153))/6)+parseInt(e(150))/7*(-parseInt(e(158))/8)+parseInt(e(149))/9*(parseInt(e(160))/10)+-parseInt(e(156))/11*(-parseInt(e(152))/12))break;a.push(a.shift())}catch(t){a.push(a.shift())}})(n),t.exports=function(t){var n=r;if(typeof t!=n(155))throw TypeError(t+n(159));return t}},4416:function(t,r,n){t=n.nmd(t);var e=i;function a(){var t=["unscopables","44629871MJrRoB","51743YBdwak","2020qiZmNz","16PrrlFs","8914822gmXQbW","7989370SWtMlP","6SPLfTO","172968ndOUjW","6741jxyciL","549JZNGrV","exports","3623785Symcdw"];return(a=function(){return t})()}!function(t,r){for(var n=i,e=t();;)try{if(779651==parseInt(n(167))/1*(-parseInt(n(169))/2)+-parseInt(n(161))/3*(-parseInt(n(168))/4)+parseInt(n(164))/5+-parseInt(n(172))/6*(-parseInt(n(170))/7)+parseInt(n(160))/8*(parseInt(n(162))/9)+parseInt(n(171))/10+-parseInt(n(166))/11)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a);var s=n(2449)(e(165)),o=Array.prototype;function i(t,r){var n=a();return(i=function(t,r){return n[t-=160]})(t,r)}null==o[s]&&n(9842)(o,s,{}),t[e(163)]=function(t){o[s][t]=!0}},7416:function(t,r,n){function e(t,r){var n=a();return(e=function(t,r){return n[t-=427]})(t,r)}function a(){var t=["10128hNkLhh","10182948DPAZsN","11mdcrhA","78418QdWQHZ","1946FNkrax","75627LbdCTG","4aEqOCY","21377473LSphFH","215547ZAcUpE","8885JmWBna","17wjvzkF","570kBiYOt","3642drFRuB","exports"];return(a=function(){return t})()}t=n.nmd(t);var s=e;(function(t,r){for(var n=e,a=t();;)try{if(582628==-parseInt(n(432))/1*(-parseInt(n(439))/2)+-parseInt(n(430))/3*(-parseInt(n(428))/4)+parseInt(n(431))/5*(-parseInt(n(434))/6)+-parseInt(n(440))/7*(parseInt(n(436))/8)+-parseInt(n(427))/9*(-parseInt(n(433))/10)+-parseInt(n(438))/11*(parseInt(n(437))/12)+parseInt(n(429))/13)break;a.push(a.shift())}catch(t){a.push(a.shift())}})(a),t[s(435)]=function(t,r,n,e){if(!(t instanceof r)||void 0!==e&&e in t)throw TypeError(n+": incorrect invocation!");return t}},2136:function(t,r,n){function e(t,r){var n=a();return(e=function(t,r){return n[t-=457]})(t,r)}function a(){var t=["1932MgfhIq","2747756MKndYL","39408VNkAVO","3jWbLzH","2156650FzamlH","1TyNIzG","10iqiTID","35617092zOrWyS"," is not an object!","791598zrNSVt","10301373aFRJrK","6514254YVtwsW","11FQoiLZ"];return(a=function(){return t})()}!function(t,r){for(var n=e,a=t();;)try{if(761981==parseInt(n(468))/1*(parseInt(n(459))/2)+-parseInt(n(466))/3*(parseInt(n(464))/4)+parseInt(n(467))/5+parseInt(n(461))/6+-parseInt(n(463))/7*(-parseInt(n(465))/8)+parseInt(n(460))/9*(parseInt(n(469))/10)+parseInt(n(462))/11*(-parseInt(n(457))/12))break;a.push(a.shift())}catch(t){a.push(a.shift())}}(a);var s=n(1410);t.exports=function(t){var r=e;if(!s(t))throw TypeError(t+r(458));return t}},8986:function(t,r,n){"use strict";t=n.nmd(t);var e=i;!function(t,r){for(var n=i,e=t();;)try{if(132298==-parseInt(n(155))/1+parseInt(n(156))/2*(parseInt(n(153))/3)+-parseInt(n(158))/4+-parseInt(n(157))/5*(parseInt(n(161))/6)+parseInt(n(154))/7+-parseInt(n(151))/8+parseInt(n(160))/9)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(u);var a=n(147),s=n(501),o=n(5702);function i(t,r){var n=u();return(i=function(t,r){return n[t-=151]})(t,r)}function u(){var t=["652188sHRDaJ","length","2215233VQDsPR","6bVyOmz","1168760WRvBTP","exports","101865mfhjiu","1615621mdaGHD","19544duQMGZ","12zCqucS","1098430fbprhA"];return(u=function(){return t})()}t[e(152)]=function(t){for(var r=e,n=a(this),i=o(n[r(159)]),u=arguments[r(159)],c=s(u>1?arguments[1]:void 0,i),f=u>2?arguments[2]:void 0,p=void 0===f?i:s(f,i);p>c;)n[c++]=t;return n}},4391:function(t,r,n){function e(){var t=["171892bAcHpY","783545aKcBxI","2638230LkkfZg","2167851ccqnAp","3331248CBMJro","3281930yBDfBR","814884jnSxsw","7EOxltW"];return(e=function(){return t})()}function a(t,r){var n=e();return(a=function(t,r){return n[t-=422]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(422660==parseInt(n(422))/1+-parseInt(n(427))/2+parseInt(n(424))/3+-parseInt(n(429))/4+-parseInt(n(426))/5+parseInt(n(423))/6*(parseInt(n(428))/7)+-parseInt(n(425))/8)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(e);var s=n(5653),o=n(5702),i=n(501);t.exports=function(t){return function(r,n,e){var a,u=s(r),c=o(u.length),f=i(e,c);if(t&&n!=n){for(;c>f;)if((a=u[f++])!=a)return!0}else for(;c>f;f++)if((t||f in u)&&u[f]===n)return t||f||0;return!t&&-1}}},6474:function(t,r,n){function e(){var t=["1670nuBKzN","1080662iBGtRX","8598799cnjMTi","192335vlUtmI","204743ticmgy","1887884scuYEf","29790qbgOMe","push","5328JtNQMy","72HqrZnU","136ZVIhfo","3HNpoAM"];return(e=function(){return t})()}!function(t,r){for(var n=c,e=t();;)try{if(330861==-parseInt(n(449))/1+parseInt(n(447))/2*(parseInt(n(445))/3)+-parseInt(n(451))/4+parseInt(n(452))/5*(parseInt(n(455))/6)+-parseInt(n(450))/7*(parseInt(n(444))/8)+parseInt(n(454))/9*(parseInt(n(446))/10)+parseInt(n(448))/11)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(e);var a=n(4316),s=n(9037),o=n(147),i=n(5702),u=n(7772);function c(t,r){var n=e();return(c=function(t,r){return n[t-=444]})(t,r)}t.exports=function(t,r){var n=1==t,e=2==t,f=3==t,p=4==t,I=6==t,v=5==t||I,h=r||u;return function(r,u,l){for(var y,d,m=c,b=o(r),g=s(b),S=a(u,l,3),w=i(g.length),k=0,O=n?h(r,w):e?h(r,0):void 0;w>k;k++)if((v||k in g)&&(d=S(y=g[k],k,b),t))if(n)O[k]=d;else if(d)switch(t){case 3:return!0;case 5:return y;case 6:return k;case 2:O[m(453)](y)}else if(p)return!1;return I?-1:f||p?p:O}}},5162:function(t,r,n){var e=i;!function(t,r){for(var n=i,e=t();;)try{if(202784==-parseInt(n(340))/1+-parseInt(n(345))/2+parseInt(n(342))/3+parseInt(n(343))/4*(-parseInt(n(350))/5)+-parseInt(n(339))/6*(-parseInt(n(344))/7)+parseInt(n(349))/8+-parseInt(n(348))/9*(-parseInt(n(346))/10))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(u);var a=n(1410),s=n(2262),o=n(2449)(e(341));function i(t,r){var n=u();return(i=function(t,r){return n[t-=339]})(t,r)}function u(){var t=["111285UkcLCk","489808mtNXSu","621255fjWcmf","1078134PyrprD","357063XJnsRn","species","43725adAZFs","12kOzwtu","7lLoGPF","451070dlwvTC","730DlzvcA","function"];return(u=function(){return t})()}t.exports=function(t){var r,n=e;return s(t)&&(typeof(r=t.constructor)!=n(347)||r!==Array&&!s(r.prototype)||(r=void 0),a(r)&&null===(r=r[o])&&(r=void 0)),void 0===r?Array:r}},7772:function(t,r,n){function e(){var t=["60LHhnAB","670339RuOVui","7dufzQN","297bEibve","2829720ViVwVX","2091903oafJoF","253192uYwGVb","80YrATGA","2jrGLEI","328437IQtpBv","5320265XmXWGp","10421562opKQFW"];return(e=function(){return t})()}!function(t,r){for(var n=s,e=t();;)try{if(926873==parseInt(n(280))/1*(parseInt(n(275))/2)+parseInt(n(276))/3*(parseInt(n(279))/4)+parseInt(n(277))/5+-parseInt(n(278))/6*(parseInt(n(281))/7)+-parseInt(n(285))/8*(-parseInt(n(282))/9)+-parseInt(n(274))/10*(parseInt(n(284))/11)+-parseInt(n(283))/12)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(e);var a=n(5162);function s(t,r){var n=e();return(s=function(t,r){return n[t-=274]})(t,r)}t.exports=function(t,r){return new(a(t))(r)}},8716:function(t,r,n){t=n.nmd(t);var e=u;!function(t,r){for(var n=u,e=t();;)try{if(655991==-parseInt(n(492))/1*(-parseInt(n(491))/2)+-parseInt(n(504))/3+-parseInt(n(493))/4+parseInt(n(500))/5+-parseInt(n(499))/6*(parseInt(n(506))/7)+-parseInt(n(496))/8*(parseInt(n(497))/9)+parseInt(n(502))/10)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(i);var a=n(7729),s=n(2449)(e(508)),o="Arguments"==a(function(){return arguments}());function i(){var t=["4114530CrlbpS","Undefined","3279070ExDjnZ","callee","1235814WEHNDW","Object","5153883TsFGtR","string","toStringTag","30rWSXCY","59765XcnJgY","550648jrwSPg","exports","function","32jHqqSF","237213OlytQe","Null","6UVNOEe"];return(i=function(){return t})()}function u(t,r){var n=i();return(u=function(t,r){return n[t-=491]})(t,r)}t[e(494)]=function(t){var r,n,i,u=e;return void 0===t?u(501):null===t?u(498):typeof(n=function(t,r){try{return t[r]}catch(t){}}(r=Object(t),s))==u(507)?n:o?a(r):(i=a(r))==u(505)&&typeof r[u(503)]==u(495)?"Arguments":i}},7729:function(t,r,n){t=n.nmd(t);var e=s;!function(t,r){for(var n=s,e=t();;)try{if(217964==parseInt(n(303))/1+-parseInt(n(305))/2*(parseInt(n(309))/3)+-parseInt(n(304))/4+-parseInt(n(310))/5*(parseInt(n(301))/6)+-parseInt(n(311))/7+-parseInt(n(313))/8+-parseInt(n(308))/9*(-parseInt(n(300))/10))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(o);var a={}[e(312)];function s(t,r){var n=o();return(s=function(t,r){return n[t-=300]})(t,r)}function o(){var t=["20WsBnZT","call","exports","41661TfeVUc","56535JdcYxi","65845hYeMyY","33131PqchEi","toString","187328vjcBND","890XJUmnA","54VCWKki","slice","259349rNzvkt","472984raDoiY"];return(o=function(){return t})()}t[e(307)]=function(t){var r=e;return a[r(306)](t)[r(302)](8,-1)}},4102:function(t,r,n){t=n.nmd(t);var e=o;function a(){var t=["5464910QJKBWD","4335996TWgOlA","280526fLgrqr","exports","1851664FzdRLD","4033482MZMuVn","2.6.12","393456Ekrihm","2044584JprQgI","number"];return(a=function(){return t})()}!function(t,r){for(var n=o,e=t();;)try{if(687118==parseInt(n(353))/1+parseInt(n(345))/2+-parseInt(n(346))/3+parseInt(n(349))/4+parseInt(n(351))/5+-parseInt(n(352))/6+-parseInt(n(348))/7)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a);var s=t[e(344)]={version:e(347)};function o(t,r){var n=a();return(o=function(t,r){return n[t-=344]})(t,r)}typeof __e==e(350)&&(__e=s)},4316:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=o();return(a=function(t,r){return n[t-=202]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(635672==parseInt(n(207))/1*(parseInt(n(209))/2)+parseInt(n(208))/3+parseInt(n(211))/4+-parseInt(n(206))/5+-parseInt(n(212))/6+-parseInt(n(204))/7+-parseInt(n(210))/8)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(o);var s=n(5321);function o(){var t=["exports","apply","694750ftiRHl","call","265030ufyDTe","3YOjdIW","479142dGINre","413272HtKxNW","2362504GyOQbW","3242796sXaodw","3042480xPAfPl"];return(o=function(){return t})()}t[e(202)]=function(t,r,n){if(s(t),void 0===r)return t;switch(n){case 1:return function(n){return t.call(r,n)};case 2:return function(n,e){return t[a(205)](r,n,e)};case 3:return function(n,e,s){return t[a(205)](r,n,e,s)}}return function(){return t[a(203)](r,arguments)}}},8668:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=s();return(a=function(t,r){return n[t-=106]})(t,r)}function s(){var t=["4YfOSvA","2042838RsUQyL","2793264bMILIB","Can't call method on  ","1069110xTmbyF","2101700gJgzta","3919096rCpbLm","exports","606755fZDurg","438759gXKRzd"];return(s=function(){return t})()}(function(t,r){for(var n=a,e=t();;)try{if(875276==parseInt(n(108))/1+-parseInt(n(114))/2+parseInt(n(111))/3+parseInt(n(109))/4*(-parseInt(n(107))/5)+parseInt(n(110))/6+-parseInt(n(113))/7+parseInt(n(115))/8)break;e.push(e.shift())}catch(t){e.push(e.shift())}})(s),t[e(106)]=function(t){if(null==t)throw TypeError(e(112)+t);return t}},5286:function(t,r,n){function e(t,r){var n=a();return(e=function(t,r){return n[t-=105]})(t,r)}function a(){var t=["1303024WIfaJE","5340054aFpgVQ","10eFfDvj","1881234cawIVh","293036MOGrlf","5232598YxTCPA","207184htannR","1124862NAZQRt"];return(a=function(){return t})()}(function(t,r){for(var n=e,a=t();;)try{if(559464==parseInt(n(110))/1+-parseInt(n(105))/2+parseInt(n(109))/3+parseInt(n(112))/4*(-parseInt(n(108))/5)+parseInt(n(107))/6+-parseInt(n(111))/7+parseInt(n(106))/8)break;a.push(a.shift())}catch(t){a.push(a.shift())}})(a),t.exports=!n(6042)((function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}))},5996:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=u();return(a=function(t,r){return n[t-=180]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(260248==parseInt(n(188))/1*(-parseInt(n(187))/2)+-parseInt(n(191))/3+-parseInt(n(186))/4+-parseInt(n(182))/5+parseInt(n(181))/6*(parseInt(n(184))/7)+parseInt(n(189))/8*(-parseInt(n(190))/9)+-parseInt(n(180))/10*(-parseInt(n(185))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(u);var s=n(1410),o=n(9533).document,i=s(o)&&s(o.createElement);function u(){var t=["2642339Brbknh","55mBdejI","1593660WlbIfL","2qyrDAo","339279TluiQU","2047208FsfELW","18DnOMCn","1231089EpFPZY","3972260EDSAtC","6qOcWjJ","2217500jpURKx","exports"];return(u=function(){return t})()}t[e(183)]=function(t){return i?o.createElement(t):{}}},2621:function(t,r,n){function e(t,r){var n=a();return(e=function(t,r){return n[t-=500]})(t,r)}function a(){var t=["split","1038720UnirBk","905AtPOMJ","9203890hiQsKm","3544456xoFDkB","31161MIpJJS","exports","765651BuELBZ","4BAjdcT","7914SDJWWE","constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf","7SoGvzC","7326315VVdvpT"];return(a=function(){return t})()}t=n.nmd(t);var s=e;(function(t,r){for(var n=e,a=t();;)try{if(757324==-parseInt(n(503))/1+-parseInt(n(512))/2+parseInt(n(505))/3*(parseInt(n(506))/4)+-parseInt(n(500))/5*(parseInt(n(507))/6)+-parseInt(n(509))/7*(parseInt(n(502))/8)+parseInt(n(510))/9+parseInt(n(501))/10)break;a.push(a.shift())}catch(t){a.push(a.shift())}})(a),t[s(504)]=s(508)[s(511)](",")},2335:function(t,r,n){function e(t,r){var n=a();return(e=function(t,r){return n[t-=375]})(t,r)}function a(){var t=["1088225bGUDta","192392myFRWY","156BMcwOm","186tySMzx","63QwCDnm","1636YsoQsT","prototype","2699fcFcoc","exports","1759720LNpbbS","function","core","2254054AZRPut","96282KmwqWC","18TVvJxh"];return(a=function(){return t})()}t=n.nmd(t);var s=e;!function(t,r){for(var n=e,a=t();;)try{if(137361==parseInt(n(385))/1*(parseInt(n(381))/2)+parseInt(n(380))/3*(-parseInt(n(383))/4)+-parseInt(n(378))/5+parseInt(n(376))/6*(parseInt(n(382))/7)+-parseInt(n(379))/8*(parseInt(n(377))/9)+-parseInt(n(387))/10+parseInt(n(375))/11)break;a.push(a.shift())}catch(t){a.push(a.shift())}}(a);var o=n(9533),i=n(4102),u=n(9842),c=n(2541),f=n(4316),p=s(384),I=function t(r,n,e){var a,I,v,h,l=s,y=r&t.F,d=r&t.G,m=r&t.P,b=r&t.B,g=d?o:r&t.S?o[n]||(o[n]={}):(o[n]||{})[p],S=d?i:i[n]||(i[n]={}),w=S[p]||(S[p]={});for(a in d&&(e=n),e)v=((I=!y&&g&&void 0!==g[a])?g:e)[a],h=b&&I?f(v,o):m&&typeof v==l(388)?f(Function.call,v):v,g&&c(g,a,v,r&t.U),S[a]!=v&&u(S,a,h),m&&w[a]!=v&&(w[a]=v)};o[s(389)]=i,I.F=1,I.G=2,I.S=4,I.P=8,I.B=16,I.W=32,I.U=64,I.R=128,t[s(386)]=I},5625:function(t,r,n){function e(){var t=["1261168HoctiG","/./","6647850BkQkdM","12323088RdHPHx","469896qtbhSg","1351340IZJlJX","49WxGoHm","1BcrNpa","2758554sOBuyM","match","965828zGRQhE","10ZqlOeC","exports","286xSeCSX"];return(e=function(){return t})()}t=n.nmd(t);var a=o;!function(t,r){for(var n=o,e=t();;)try{if(985750==-parseInt(n(165))/1*(-parseInt(n(152))/2)+parseInt(n(162))/3+-parseInt(n(154))/4*(parseInt(n(155))/5)+-parseInt(n(160))/6+parseInt(n(164))/7*(-parseInt(n(158))/8)+-parseInt(n(161))/9+parseInt(n(163))/10*(parseInt(n(157))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(e);var s=n(2449)(a(153));function o(t,r){var n=e();return(o=function(t,r){return n[t-=152]})(t,r)}t[a(156)]=function(t){var r=a,n=/./;try{r(159)[t](n)}catch(r){try{return n[s]=!1,!"/./"[t](n)}catch(t){}}return!0}},6042:function(t,r,n){function e(t,r){var n=s();return(e=function(t,r){return n[t-=458]})(t,r)}t=n.nmd(t);var a=e;function s(){var t=["1604BfusTs","848945eeAVBv","300piWGRH","888CVxJbM","28OFFSwK","117yoAPth","exports","439688mNLPfm","3711IutIMN","17802560pGHMzo","609510vPfcxk","1458117icGGRd","50533jhjmqp"];return(s=function(){return t})()}(function(t,r){for(var n=e,a=t();;)try{if(905641==parseInt(n(461))/1+-parseInt(n(463))/2*(parseInt(n(458))/3)+-parseInt(n(467))/4*(-parseInt(n(464))/5)+parseInt(n(466))/6*(-parseInt(n(462))/7)+parseInt(n(470))/8*(parseInt(n(468))/9)+-parseInt(n(459))/10+-parseInt(n(460))/11*(-parseInt(n(465))/12))break;a.push(a.shift())}catch(t){a.push(a.shift())}})(s),t[a(469)]=function(t){try{return!!t()}catch(t){return!0}}},6220:function(t,r,n){t=n.nmd(t);var e=v;!function(t,r){for(var n=v,e=t();;)try{if(531197==parseInt(n(488))/1+-parseInt(n(486))/2+parseInt(n(489))/3*(parseInt(n(501))/4)+parseInt(n(491))/5+parseInt(n(495))/6+-parseInt(n(500))/7+-parseInt(n(497))/8)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(h);var a=n(4316),s=n(5596),o=n(5013),i=n(2136),u=n(5702),c=n(4028),f={},p={},I=t[e(499)]=function(t,r,n,I,v){var h,l,y,d,m=e,b=v?function(){return t}:c(t),g=a(n,I,r?2:1),S=0;if(typeof b!=m(493))throw TypeError(t+" is not iterable!");if(o(b)){for(h=u(t[m(498)]);h>S;S++)if((d=r?g(i(l=t[S])[0],l[1]):g(t[S]))===f||d===p)return d}else for(y=b[m(490)](t);!(l=y[m(487)]()).done;)if((d=s(y,g,l[m(494)],r))===f||d===p)return d};function v(t,r){var n=h();return(v=function(t,r){return n[t-=486]})(t,r)}function h(){var t=["next","991605bcOKUS","229527CucUSj","call","4241425ULGlfs","RETURN","function","value","5084496BIwXfd","BREAK","6846984yJWUkS","length","exports","5980303eNjEwe","20mRLXPp","1656904JIYKmT"];return(h=function(){return t})()}I[e(496)]=f,I[e(492)]=p},5911:function(t,r,n){function e(t,r){var n=s();return(e=function(t,r){return n[t-=346]})(t,r)}t=n.nmd(t);var a=e;function s(){var t=["232032lldnRS","toString","20554030yZAPaV","704440lXoPHP","39844vFLLKY","20bmQKPF","1074cBYyvo","1092664JsSFge","exports","1585275cMQUlx","18JYHufV","native-function-to-string","1705648PWQPTI"];return(s=function(){return t})()}(function(t,r){for(var n=e,a=t();;)try{if(812702==parseInt(n(355))/1+parseInt(n(351))/2+parseInt(n(352))/3+-parseInt(n(357))/4*(parseInt(n(348))/5)+parseInt(n(358))/6*(-parseInt(n(356))/7)+-parseInt(n(346))/8*(parseInt(n(349))/9)+parseInt(n(354))/10)break;a.push(a.shift())}catch(t){a.push(a.shift())}})(s),t[a(347)]=n(3763)(a(350),Function[a(353)])},9533:function(t,r,n){function e(t,r){var n=a();return(e=function(t,r){return n[t-=418]})(t,r)}function a(){var t=["Math","943677bWytfF","54667QVUIWm","89172TxnSjC","352115LgGreD","868088vBvyJs","14OmbxGa","2250PoCFlX","6360068DHoTtU","number","8873166IhoSwA","undefined","91uBykrj","exports"];return(a=function(){return t})()}t=n.nmd(t);var s=e;!function(t,r){for(var n=e,a=t();;)try{if(927500==parseInt(n(430))/1*(parseInt(n(420))/2)+-parseInt(n(429))/3+parseInt(n(422))/4+-parseInt(n(418))/5+-parseInt(n(424))/6+parseInt(n(426))/7*(-parseInt(n(419))/8)+-parseInt(n(431))/9*(-parseInt(n(421))/10))break;a.push(a.shift())}catch(t){a.push(a.shift())}}(a);var o=t[s(427)]=typeof window!=s(425)&&window[s(428)]==Math?window:typeof self!=s(425)&&self[s(428)]==Math?self:Function("return this")();typeof __g==s(423)&&(__g=o)},3961:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=s();return(a=function(t,r){return n[t-=224]})(t,r)}function s(){var t=["6259326wssMoJ","2570pTxEMr","6057Mlftnw","50130uADTem","10756KFlzHh","1654336SwBEBe","1792tMLmLC","2517501bAklkj","1082543sfqraK","call","2250PCWYdm","exports"];return(s=function(){return t})()}!function(t,r){for(var n=a,e=t();;)try{if(713846==-parseInt(n(226))/1+parseInt(n(224))/2*(-parseInt(n(228))/3)+-parseInt(n(234))/4*(parseInt(n(231))/5)+parseInt(n(230))/6+-parseInt(n(225))/7+-parseInt(n(235))/8+-parseInt(n(232))/9*(-parseInt(n(233))/10))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(s);var o={}.hasOwnProperty;t[e(229)]=function(t,r){return o[e(227)](t,r)}},9842:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=i();return(a=function(t,r){return n[t-=301]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(297721==parseInt(n(308))/1+parseInt(n(307))/2+parseInt(n(309))/3+parseInt(n(304))/4+parseInt(n(305))/5+-parseInt(n(302))/6*(parseInt(n(306))/7)+-parseInt(n(303))/8)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(i);var s=n(9426),o=n(6412);function i(){var t=["9166896QXLDLR","558760wGTXob","2148560enioug","7yhQgaM","825634XLUvSb","544466shqkOy","209991MsEXSj","exports","918594PbYbAe"];return(i=function(){return t})()}t[e(301)]=n(5286)?function(t,r,n){return s.f(t,r,o(1,n))}:function(t,r,n){return t[r]=n,t}},1362:function(t,r,n){function e(t,r){var n=a();return(e=function(t,r){return n[t-=478]})(t,r)}function a(){var t=["30hPfeOI","26762LjUtSJ","3290428ZaGSLm","3430737cbcAgI","exports","5888820GEYPXs","3exZLTw","1671678QxxeUz","2350315zlkNeo","document","7763944RlQXnZ","documentElement","54cqufmP","15AvaQHT"];return(a=function(){return t})()}t=n.nmd(t);var s=e;!function(t,r){for(var n=e,a=t();;)try{if(866375==-parseInt(n(488))/1*(-parseInt(n(491))/2)+parseInt(n(482))/3*(-parseInt(n(478))/4)+parseInt(n(489))/5*(parseInt(n(483))/6)+parseInt(n(481))/7+-parseInt(n(486))/8+-parseInt(n(479))/9+-parseInt(n(490))/10*(-parseInt(n(484))/11))break;a.push(a.shift())}catch(t){a.push(a.shift())}}(a);var o=n(9533)[s(485)];t[s(480)]=o&&o[s(487)]},5866:function(t,r,n){function e(t,r){var n=s();return(e=function(t,r){return n[t-=424]})(t,r)}t=n.nmd(t);var a=e;function s(){var t=["27VcDkkm","exports","284kFCokq","5513570lkXMCD","154026gItpah","20JVSmJi","285568dWLfbQ","28783117LBAQmo","976645VdSWtf","14IvaKAQ","37182ozTcya","3558576lMnzRu"];return(s=function(){return t})()}(function(t,r){for(var n=e,a=t();;)try{if(955503==-parseInt(n(433))/1+-parseInt(n(431))/2*(-parseInt(n(427))/3)+parseInt(n(434))/4*(parseInt(n(425))/5)+-parseInt(n(428))/6+-parseInt(n(426))/7*(parseInt(n(435))/8)+parseInt(n(429))/9*(parseInt(n(432))/10)+-parseInt(n(424))/11)break;a.push(a.shift())}catch(t){a.push(a.shift())}})(s),t[a(430)]=!n(5286)&&!n(6042)((function(){return 7!=Object.defineProperty(n(5996)("div"),"a",{get:function(){return 7}}).a}))},7450:function(t,r,n){function e(t,r){var n=a();return(e=function(t,r){return n[t-=190]})(t,r)}function a(){var t=["1298625DNrqwl","2321490nBztiY","15LOOZkB","539366jQWDuH","13868330SceAof","call","864nfnugu","length","1BPzMfd","173864pncwhK","23624ZPSzPZ","858109vvXnVZ","exports","apply"];return(a=function(){return t})()}t=n.nmd(t);var s=e;(function(t,r){for(var n=e,a=t();;)try{if(366555==-parseInt(n(195))/1*(parseInt(n(190))/2)+-parseInt(n(203))/3*(parseInt(n(196))/4)+parseInt(n(201))/5+-parseInt(n(202))/6+-parseInt(n(198))/7+-parseInt(n(197))/8*(parseInt(n(193))/9)+parseInt(n(191))/10)break;a.push(a.shift())}catch(t){a.push(a.shift())}})(a),t[s(199)]=function(t,r,n){var e=s,a=void 0===n;switch(r[e(194)]){case 0:return a?t():t[e(192)](n);case 1:return a?t(r[0]):t[e(192)](n,r[0]);case 2:return a?t(r[0],r[1]):t[e(192)](n,r[0],r[1]);case 3:return a?t(r[0],r[1],r[2]):t[e(192)](n,r[0],r[1],r[2]);case 4:return a?t(r[0],r[1],r[2],r[3]):t[e(192)](n,r[0],r[1],r[2],r[3])}return t[e(200)](n,r)}},9037:function(t,r,n){t=n.nmd(t);var e=s;!function(t,r){for(var n=s,e=t();;)try{if(976844==parseInt(n(310))/1*(parseInt(n(317))/2)+parseInt(n(307))/3+parseInt(n(311))/4*(parseInt(n(316))/5)+-parseInt(n(318))/6+-parseInt(n(308))/7*(-parseInt(n(312))/8)+-parseInt(n(309))/9+parseInt(n(313))/10*(-parseInt(n(315))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(o);var a=n(7729);function s(t,r){var n=o();return(s=function(t,r){return n[t-=307]})(t,r)}function o(){var t=["201377HkcBit","378960CpmTMt","606614BLTCVd","1056030mBCJXf","split","5196291WngKPZ","14krjFco","17235153GRadGb","4hkbKmg","12tMVShG","1264904CSmfAD","230kgVHVQ","exports"];return(o=function(){return t})()}t[e(314)]=Object("z").propertyIsEnumerable(0)?Object:function(t){var r=e;return"String"==a(t)?t[r(319)](""):Object(t)}},5013:function(t,r,n){t=n.nmd(t);var e=u;function a(){var t=["1576552xeKnHg","145510CWzjkp","22544469CiKWmM","iterator","Array","164ScCLRL","exports","3410496ZquBPD","3264208YBHDlA","18EUketF","426874QgMBRm","690852YABjOR"];return(a=function(){return t})()}!function(t,r){for(var n=u,e=t();;)try{if(868441==-parseInt(n(379))/1+-parseInt(n(387))/2+-parseInt(n(390))/3+-parseInt(n(384))/4*(-parseInt(n(380))/5)+-parseInt(n(388))/6*(-parseInt(n(389))/7)+parseInt(n(386))/8+parseInt(n(381))/9)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a);var s=n(9654),o=n(2449)(e(382)),i=Array.prototype;function u(t,r){var n=a();return(u=function(t,r){return n[t-=379]})(t,r)}t[e(385)]=function(t){return void 0!==t&&(s[e(383)]===t||i[o]===t)}},2262:function(t,r,n){var e=a;function a(t,r){var n=o();return(a=function(t,r){return n[t-=103]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(962812==parseInt(n(107))/1+-parseInt(n(113))/2+-parseInt(n(109))/3*(-parseInt(n(112))/4)+-parseInt(n(108))/5*(-parseInt(n(110))/6)+parseInt(n(103))/7+parseInt(n(105))/8+parseInt(n(104))/9*(-parseInt(n(111))/10))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(o);var s=n(7729);function o(){var t=["190690LBXptp","98524NuCcuc","3487448ipzNOZ","isArray","8206632Ueozif","198AEVNeu","2925096ZJqwYz","Array","1512481qtNOmx","8335GvCtUN","9dCplHq","6zOgSNa"];return(o=function(){return t})()}t.exports=Array[e(114)]||function(t){var r=e;return s(t)==r(106)}},1410:function(t,r,n){t=n.nmd(t);var e=s;function a(){var t=["38nyhCyD","441fCawZT","exports","4849968xUfswF","symbol","6554562UkGOfS","186033khpKKd","1010853gSrRDW","431170BdrssH","5kXuglE","6017744EEnciZ","453957oVvItT","constructor","function","prototype"];return(a=function(){return t})()}function s(t,r){var n=a();return(s=function(t,r){return n[t-=270]})(t,r)}function o(t){var r=s;return(o=r(282)==typeof Symbol&&r(273)==typeof Symbol.iterator?function(t){return typeof t}:function(t){var n=r;return t&&n(282)==typeof Symbol&&t[n(281)]===Symbol&&t!==Symbol[n(283)]?n(273):typeof t})(t)}!function(t,r){for(var n=s,e=t();;)try{if(620675==-parseInt(n(276))/1+parseInt(n(284))/2*(-parseInt(n(275))/3)+-parseInt(n(272))/4+parseInt(n(278))/5*(parseInt(n(274))/6)+parseInt(n(280))/7+parseInt(n(279))/8+-parseInt(n(270))/9*(-parseInt(n(277))/10))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a),t[e(271)]=function(t){var r=e;return"object"===o(t)?null!==t:typeof t===r(282)}},8922:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=u();return(a=function(t,r){return n[t-=155]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(971321==parseInt(n(162))/1+-parseInt(n(155))/2+-parseInt(n(161))/3+-parseInt(n(164))/4+parseInt(n(156))/5+parseInt(n(163))/6+parseInt(n(157))/7*(parseInt(n(160))/8))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(u);var s=n(1410),o=n(7729),i=n(2449)("match");function u(){var t=["6192184SaLAoC","840280dWwZcu","3105430AnasFw","17240293HQASqf","RegExp","exports","8yWhwts","5634057lyTFQm","342602HVfMCs","8345634TbAwYW"];return(u=function(){return t})()}t[e(159)]=function(t){var r,n=e;return s(t)&&(void 0!==(r=t[i])?!!r:o(t)==n(158))}},5596:function(t,r,n){function e(t,r){var n=o();return(e=function(t,r){return n[t-=354]})(t,r)}t=n.nmd(t);var a=e;!function(t,r){for(var n=e,a=t();;)try{if(511557==parseInt(n(358))/1+-parseInt(n(354))/2+-parseInt(n(365))/3*(-parseInt(n(362))/4)+parseInt(n(364))/5*(-parseInt(n(356))/6)+parseInt(n(357))/7+parseInt(n(355))/8*(-parseInt(n(361))/9)+-parseInt(n(359))/10)break;a.push(a.shift())}catch(t){a.push(a.shift())}}(o);var s=n(2136);function o(){var t=["call","353512MeKOoh","56yrqMtT","6cPfLpZ","6674752lUHwGt","932042EOLZoU","8760420WCwPfD","exports","506727kWjTwr","1156dsXmtu","return","3422855MIAIUM","7863UcfTwj"];return(o=function(){return t})()}t[a(360)]=function(t,r,n,e){var o=a;try{return e?r(s(n)[0],n[1]):r(n)}catch(r){var i=t[o(363)];throw void 0!==i&&s(i[o(366)](t)),r}}},5843:function(t,r,n){"use strict";t=n.nmd(t);var e=u;!function(t,r){for(var n=u,e=t();;)try{if(355800==-parseInt(n(148))/1+-parseInt(n(145))/2+parseInt(n(150))/3*(-parseInt(n(147))/4)+parseInt(n(146))/5+-parseInt(n(138))/6*(-parseInt(n(149))/7)+parseInt(n(140))/8*(parseInt(n(142))/9)+-parseInt(n(139))/10*(parseInt(n(144))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(c);var a=n(8871),s=n(6412),o=n(1773),i={};function u(t,r){var n=c();return(u=function(t,r){return n[t-=136]})(t,r)}function c(){var t=["328506Scjsrw","1651405cfSACF","12hPFfpF","462599ovjVao","658iebITf","337371WXXTWJ"," Iterator","iterator","42678wRicHI","25310VCeifl","16cFhMfL","exports","1650051hxJacX","prototype","198KoGahd"];return(c=function(){return t})()}n(9842)(i,n(2449)(e(137)),(function(){return this})),t[e(141)]=function(t,r,n){var u=e;t[u(143)]=a(i,{next:s(1,n)}),o(t,r+u(136))}},3587:function(t,r,n){"use strict";t=n.nmd(t);var e=m;function a(){var t=["153MxueYB","508677hAqiAz","56jBwXHz","183008MzMTAc","115GtFuNr","34384YwJBdA","entries","name","values","iterator","next","137700qRbRub","function","589548VNnbYw","430FfAaRV"," Iterator","prototype","call","54740tooOTK","exports","keys"];return(a=function(){return t})()}!function(t,r){for(var n=m,e=t();;)try{if(110644==parseInt(n(458))/1*(parseInt(n(468))/2)+parseInt(n(455))/3+parseInt(n(457))/4+parseInt(n(465))/5+-parseInt(n(467))/6+parseInt(n(456))/7*(parseInt(n(459))/8)+-parseInt(n(454))/9*(parseInt(n(451))/10))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a);var s=n(1196),o=n(2335),i=n(2541),u=n(9842),c=n(9654),f=n(5843),p=n(1773),I=n(9675),v=n(2449)(e(463)),h=!([].keys&&e(464)in[][e(453)]()),l="keys",y=e(462),d=function(){return this};function m(t,r){var n=a();return(m=function(t,r){return n[t-=449]})(t,r)}t[e(452)]=function(t,r,n,a,m,b,g){var S=e;f(n,r,a);var w,k,O,x=function(t){if(!h&&t in M)return M[t];switch(t){case l:case y:return function(){return new n(this,t)}}return function(){return new n(this,t)}},j=r+S(469),A=m==y,T=!1,M=t.prototype,P=M[v]||M["@@iterator"]||m&&M[m],E=P||x(m),L=m?A?x(S(460)):E:void 0,C="Array"==r&&M.entries||P;if(C&&(O=I(C[S(450)](new t)))!==Object[S(449)]&&O[S(464)]&&(p(O,j,!0),s||typeof O[v]==S(466)||u(O,v,d)),A&&P&&P[S(461)]!==y&&(T=!0,E=function(){return P[S(450)](this)}),(!s||g)&&(h||T||!M[v])&&u(M,v,E),c[r]=E,c[j]=d,m)if(w={values:A?E:x(y),keys:b?E:x(l),entries:L},g)for(k in w)k in M||i(M,k,w[k]);else o(o.P+o.F*(h||T),r,w);return w}},8350:function(t,r,n){var e=i;!function(t,r){for(var n=i,e=t();;)try{if(212425==parseInt(n(113))/1*(parseInt(n(105))/2)+-parseInt(n(116))/3+-parseInt(n(108))/4+parseInt(n(110))/5+parseInt(n(109))/6+-parseInt(n(106))/7*(-parseInt(n(107))/8)+parseInt(n(114))/9)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(u);var a=n(2449)("iterator"),s=!1;try{var o=[7][a]();o[e(115)]=function(){s=!0},Array[e(111)](o,(function(){throw 2}))}catch(t){}function i(t,r){var n=u();return(i=function(t,r){return n[t-=105]})(t,r)}function u(){var t=["7aBPJIP","367736nASopm","1669236EVxbCQ","1601730KMHSQA","1028255IBWXwO","from","next","32343TTSiEV","2263140VTJiRP","return","711984QGRZSk","6COrNRC"];return(u=function(){return t})()}t.exports=function(t,r){var n=e;if(!r&&!s)return!1;var o=!1;try{var i=[7],u=i[a]();u[n(112)]=function(){return{done:o=!0}},i[a]=function(){return u},t(i)}catch(t){}return o}},6801:function(t,r,n){function e(t,r){var n=s();return(e=function(t,r){return n[t-=371]})(t,r)}t=n.nmd(t);var a=e;function s(){var t=["21TiylOX","1831016ygbPdc","1692864BbHoXv","34605XRsooc","6zyhoee","1506885frSUoo","2200iLrpIa","exports","1053198ZUmPve","651649urPsNt","9914340FHOQOP"];return(s=function(){return t})()}(function(t,r){for(var n=e,a=t();;)try{if(741854==parseInt(n(375))/1+parseInt(n(379))/2+parseInt(n(381))/3*(-parseInt(n(378))/4)+-parseInt(n(371))/5+parseInt(n(374))/6*(parseInt(n(377))/7)+-parseInt(n(372))/8*(parseInt(n(380))/9)+parseInt(n(376))/10)break;a.push(a.shift())}catch(t){a.push(a.shift())}})(s),t[a(373)]=function(t,r){return{value:r,done:!!t}}},9654:function(t,r,n){t=n.nmd(t);var e=s;function a(){var t=["exports","605853XFiJtd","3088QuqvHH","2863IFmUmJ","1028144UoPexi","162207TrmfRf","31490YuEJfk","17025pklKYC","1748664vjdQSn","174sCJzHh"];return(a=function(){return t})()}function s(t,r){var n=a();return(s=function(t,r){return n[t-=446]})(t,r)}(function(t,r){for(var n=s,e=t();;)try{if(162048==-parseInt(n(449))/1+parseInt(n(450))/2+-parseInt(n(455))/3+parseInt(n(448))/4+parseInt(n(451))/5*(-parseInt(n(453))/6)+-parseInt(n(447))/7*(-parseInt(n(446))/8)+parseInt(n(452))/9)break;e.push(e.shift())}catch(t){e.push(e.shift())}})(a),t[e(454)]={}},1196:function(t){function r(){var t=["1484520ziivpl","1335320hiyVyq","17308eXeVFP","309DZzxCt","3027708jUenoI","10446728PxOEXl","487040zNAJVf","480988jZHSOL"];return(r=function(){return t})()}function n(t,e){var a=r();return(n=function(t,r){return a[t-=384]})(t,e)}(function(t,r){for(var e=n,a=t();;)try{if(262822==parseInt(e(384))/1+parseInt(e(391))/2+-parseInt(e(388))/3*(-parseInt(e(387))/4)+-parseInt(e(385))/5+parseInt(e(389))/6+parseInt(e(386))/7+-parseInt(e(390))/8)break;a.push(a.shift())}catch(t){a.push(a.shift())}})(r),t.exports=!1},8492:function(t,r,n){t=n.nmd(t);var e=p;function a(){var t=["8MHCzTI","133162yuCocj","domain","createTextNode","enter","1081050rRwARP","standalone","54RSBdkp","next","MutationObserver","1161170yuuLuu","observe","638460eVQjxg","44ohbEfV","9336072STTJzL","nextTick","navigator","then","set","622952guNEuD","resolve","process","7264287umfdHK","WebKitMutationObserver","exports","11qBiFkB","7twnnZB"];return(a=function(){return t})()}!function(t,r){for(var n=p,e=t();;)try{if(647719==parseInt(n(133))/1*(parseInt(n(136))/2)+parseInt(n(113))/3*(-parseInt(n(135))/4)+-parseInt(n(120))/5*(-parseInt(n(115))/6)+parseInt(n(134))/7*(-parseInt(n(127))/8)+parseInt(n(130))/9+parseInt(n(118))/10*(-parseInt(n(121))/11)+-parseInt(n(122))/12)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a);var s=n(9533),o=n(9789)[e(126)],i=s[e(117)]||s[e(131)],u=s[e(129)],c=s.Promise,f=n(7729)(u)==e(129);function p(t,r){var n=a();return(p=function(t,r){return n[t-=113]})(t,r)}t[e(132)]=function(){var t,r,n,a=e,I=function(){var e,a,s=p;for(f&&(e=u[s(137)])&&e.exit();t;){a=t.fn,t=t[s(116)];try{a()}catch(e){throw t?n():r=void 0,e}}r=void 0,e&&e[s(139)]()};if(f)n=function(){u[p(123)](I)};else if(!i||s[a(124)]&&s.navigator[a(114)])if(c&&c[a(128)]){var v=c.resolve(void 0);n=function(){v[a(125)](I)}}else n=function(){o.call(s,I)};else{var h=!0,l=document[a(138)]("");new i(I)[a(119)](l,{characterData:!0}),n=function(){l.data=h=!h}}return function(e){var s={fn:e,next:void 0};r&&(r[a(116)]=s),!t&&(t=s,n()),r=s}}},8091:function(t,r,n){"use strict";t=n.nmd(t);var e=a;function a(t,r){var n=i();return(a=function(t,r){return n[t-=165]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(269334==parseInt(n(178))/1+parseInt(n(176))/2*(parseInt(n(179))/3)+-parseInt(n(174))/4+-parseInt(n(175))/5*(parseInt(n(171))/6)+parseInt(n(166))/7*(-parseInt(n(169))/8)+parseInt(n(168))/9+-parseInt(n(173))/10*(parseInt(n(170))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(i);var s=n(5321);function o(t){var r,n,e=a;this[e(177)]=new t((function(t,e){if(void 0!==r||void 0!==n)throw TypeError("Bad Promise constructor");r=t,n=e})),this[e(172)]=s(r),this[e(167)]=s(n)}function i(){var t=["3690648BaZXud","515656qlglmf","69817UNmZQC","18KiMJRG","resolve","60KUcyDe","1651080ReyHsB","755560gcKeZy","34ghvcCg","promise","292458GujUXb","94491UcTjip","exports","7jaAUZN","reject"];return(i=function(){return t})()}t[e(165)].f=function(t){return new o(t)}},7051:function(t,r,n){"use strict";var e=a;function a(t,r){var n=I();return(a=function(t,r){return n[t-=221]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(315132==parseInt(n(230))/1+parseInt(n(232))/2*(parseInt(n(228))/3)+parseInt(n(235))/4+-parseInt(n(224))/5+parseInt(n(231))/6+-parseInt(n(225))/7*(parseInt(n(226))/8)+parseInt(n(223))/9*(-parseInt(n(234))/10))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(I);var s=n(5286),o=n(9124),i=n(6528),u=n(1204),c=n(147),f=n(9037),p=Object[e(227)];function I(){var t=["202998YckniV","forEach","442288axsWgE","3473586JtUaIl","6FkSolD","call","20zJCDkM","159152UNMptU","join","keys","length","2662326nPAwqX","1656555gQCYTE","14prJFTm","103736Joltyl","assign"];return(I=function(){return t})()}t.exports=!p||n(6042)((function(){var t=e,r={},n={},a=Symbol(),s="abcdefghijklmnopqrst";return r[a]=7,s.split("")[t(229)]((function(t){n[t]=t})),7!=p({},r)[a]||Object[t(221)](p({},n))[t(236)]("")!=s}))?function(t,r){for(var n=e,a=c(t),p=arguments[n(222)],I=1,v=i.f,h=u.f;p>I;)for(var l,y=f(arguments[I++]),d=v?o(y).concat(v(y)):o(y),m=d[n(222)],b=0;m>b;)l=d[b++],s&&!h[n(233)](y,l)||(a[l]=y[l]);return a}:p},8871:function(t,r,n){t=n.nmd(t);var e=p;!function(t,r){for(var n=p,e=t();;)try{if(742618==-parseInt(n(289))/1*(parseInt(n(293))/2)+-parseInt(n(272))/3+parseInt(n(288))/4*(-parseInt(n(280))/5)+parseInt(n(286))/6*(parseInt(n(279))/7)+-parseInt(n(292))/8*(-parseInt(n(274))/9)+parseInt(n(285))/10+parseInt(n(283))/11)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(I);var a=n(2136),s=n(7371),o=n(2621),i=n(6883)(e(276)),u=function(){},c=e(284),f=function(){var t,r=e,a=n(5996)(r(278)),s=o.length;for(a.style[r(291)]="none",n(1362)[r(271)](a),a[r(277)]=r(273),(t=a[r(269)][r(282)]).open(),t.write("<"+r(290)+">document.F=Object<"+r(270)+">"),t[r(287)](),f=t.F;s--;)delete f[c][o[s]];return f()};function p(t,r){var n=I();return(p=function(t,r){return n[t-=269]})(t,r)}function I(){var t=["iframe","42mouzAE","5790590XUgZkS","create","document","9593309wtItKn","prototype","13183150jLWhqW","180426pLBUty","close","4qoGIjz","941107zgyeRg","script","display","16yCZWeF","2PoUCUe","contentWindow","/script","appendChild","2014425bujxpi","javascript:","5141061mcdtuv","exports","IE_PROTO","src"];return(I=function(){return t})()}t[e(275)]=Object[e(281)]||function(t,r){var n;return null!==t?(u[c]=a(t),n=new u,u[c]=null,n[i]=t):n=f(),void 0===r?n:s(n,r)}},9426:function(t,r,n){function e(){var t=["8SCCysk","318882GTodsh","830lIEZyD","Accessors not supported!","33426SiRNUw","350451Hwywon","value","set","385015LpksxX","1434936cpCyMT","52374MmhSMw","4511177vdcnzJ","defineProperty","8iVYZrq","7KVWtQm"];return(e=function(){return t})()}function a(t,r){var n=e();return(a=function(t,r){return n[t-=485]})(t,r)}var s=a;!function(t,r){for(var n=a,e=t();;)try{if(219578==-parseInt(n(488))/1+parseInt(n(498))/2*(-parseInt(n(493))/3)+-parseInt(n(496))/4*(-parseInt(n(491))/5)+-parseInt(n(499))/6*(parseInt(n(497))/7)+-parseInt(n(492))/8+-parseInt(n(487))/9*(-parseInt(n(485))/10)+parseInt(n(494))/11)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(e);var o=n(2136),i=n(5866),u=n(4361),c=Object[s(495)];r.f=n(5286)?Object[s(495)]:function(t,r,n){var e=s;if(o(t),r=u(r,!0),o(n),i)try{return c(t,r,n)}catch(t){}if("get"in n||e(490)in n)throw TypeError(e(486));return e(489)in n&&(t[r]=n[e(489)]),t}},7371:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=u();return(a=function(t,r){return n[t-=146]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(576439==parseInt(n(156))/1+-parseInt(n(148))/2+parseInt(n(147))/3+parseInt(n(158))/4*(-parseInt(n(157))/5)+-parseInt(n(153))/6*(parseInt(n(146))/7)+parseInt(n(155))/8*(-parseInt(n(150))/9)+-parseInt(n(151))/10*(-parseInt(n(149))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(u);var s=n(9426),o=n(2136),i=n(9124);function u(){var t=["24daYqvg","552761ycDpbP","5uZToMG","851416fHIgUD","7EsPbYp","572784IEZdLm","1397558fZwvJW","11Pdbmpp","2200914cXPByR","18885550TzusGQ","defineProperties","2463204hECgom","exports"];return(u=function(){return t})()}t[e(154)]=n(5286)?Object[e(152)]:function(t,r){o(t);for(var n,e=i(r),a=e.length,u=0;a>u;)s.f(t,n=e[u++],r[n]);return t}},6528:function(t,r){var n=e;function e(t,r){var n=a();return(e=function(t,r){return n[t-=114]})(t,r)}function a(){var t=["3xvFOfF","24067152rSBSiE","1320HMelyH","1225845GCaqJb","24PJfHha","468092atjFBV","717dvTYen","getOwnPropertySymbols","25660FCKHxQ","10692aiRFtB","69810oDljbz","3209215VpTKNP","77NsnIJR"];return(a=function(){return t})()}(function(t,r){for(var n=e,a=t();;)try{if(455942==-parseInt(n(114))/1*(parseInt(n(119))/2)+parseInt(n(120))/3*(parseInt(n(123))/4)+-parseInt(n(125))/5+parseInt(n(124))/6*(-parseInt(n(126))/7)+parseInt(n(118))/8*(-parseInt(n(117))/9)+-parseInt(n(122))/10*(parseInt(n(116))/11)+parseInt(n(115))/12)break;a.push(a.shift())}catch(t){a.push(a.shift())}})(a),r.f=Object[n(121)]},9675:function(t,r,n){function e(){var t=["6479433xSFlBH","function","20DOGGJs","3246728DVXTDG","908928SCDUMK","8028795toeeKN","56ijtAlc","855048cRjAgJ","7110528HwDOUW","932424vukBds","constructor","prototype","3FAZGFG"];return(e=function(){return t})()}function a(t,r){var n=e();return(a=function(t,r){return n[t-=152]})(t,r)}var s=a;!function(t,r){for(var n=a,e=t();;)try{if(951623==-parseInt(n(162))/1+parseInt(n(154))/2*(parseInt(n(157))/3)+-parseInt(n(161))/4+parseInt(n(163))/5+parseInt(n(153))/6+-parseInt(n(164))/7*(-parseInt(n(152))/8)+-parseInt(n(158))/9*(parseInt(n(160))/10))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(e);var o=n(3961),i=n(147),u=n(6883)("IE_PROTO"),c=Object[s(156)];t.exports=Object.getPrototypeOf||function(t){var r=s;return t=i(t),o(t,u)?t[u]:typeof t[r(155)]==r(159)&&t instanceof t[r(155)]?t[r(155)][r(156)]:t instanceof Object?c:null}},3990:function(t,r,n){function e(t,r){var n=a();return(e=function(t,r){return n[t-=275]})(t,r)}function a(){var t=["4275YDOccp","24504Dyblxz","exports","12878646riehqR","2172879SvohOA","1059335LwBopK","4dFfxgY","1779526eklUCi","16046BujEEY","20GzjsuA","2660286sGEozS","87UYsnpV","length","push"];return(a=function(){return t})()}t=n.nmd(t);var s=e;!function(t,r){for(var n=e,a=t();;)try{if(935643==-parseInt(n(276))/1*(parseInt(n(287))/2)+parseInt(n(283))/3+-parseInt(n(285))/4*(-parseInt(n(284))/5)+-parseInt(n(275))/6+parseInt(n(286))/7+-parseInt(n(280))/8*(parseInt(n(279))/9)+parseInt(n(288))/10*(parseInt(n(282))/11))break;a.push(a.shift())}catch(t){a.push(a.shift())}}(a);var o=n(3961),i=n(5653),u=n(4391)(!1),c=n(6883)("IE_PROTO");t[s(281)]=function(t,r){var n,e=s,a=i(t),f=0,p=[];for(n in a)n!=c&&o(a,n)&&p.push(n);for(;r[e(277)]>f;)o(a,n=r[f++])&&(~u(p,n)||p[e(278)](n));return p}},9124:function(t,r,n){function e(t,r){var n=s();return(e=function(t,r){return n[t-=126]})(t,r)}t=n.nmd(t);var a=e;function s(){var t=["32144BHDNxE","33GQUZiZ","2711676iPQGjv","302vKXICc","277590NtfSNt","1498Cwfmvl","580071xGptVY","3338256rwqvym","2403DRjHWH","1105FZQyhq","9750afpPCr","18OweUCA","exports"];return(s=function(){return t})()}!function(t,r){for(var n=e,a=t();;)try{if(543394==-parseInt(n(128))/1*(parseInt(n(136))/2)+parseInt(n(126))/3+-parseInt(n(135))/4+parseInt(n(129))/5*(-parseInt(n(130))/6)+-parseInt(n(138))/7*(-parseInt(n(133))/8)+parseInt(n(131))/9*(parseInt(n(137))/10)+parseInt(n(134))/11*(parseInt(n(127))/12))break;a.push(a.shift())}catch(t){a.push(a.shift())}}(s);var o=n(3990),i=n(2621);t[a(132)]=Object.keys||function(t){return o(t,i)}},1204:function(t,r){function n(t,r){var a=e();return(n=function(t,r){return a[t-=315]})(t,r)}function e(){var t=["7059848vTITuZ","8kWwnbx","535988FlZVrJ","222811YDHKjV","3903144hxXNob","12574188CtGqJy","23556ANlffL","6LgXPTI","200NVTqSt","10276580xGmJZo"];return(e=function(){return t})()}(function(t,r){for(var e=n,a=t();;)try{if(735705==parseInt(e(316))/1*(parseInt(e(324))/2)+-parseInt(e(320))/3*(parseInt(e(315))/4)+-parseInt(e(321))/5*(-parseInt(e(319))/6)+-parseInt(e(317))/7+parseInt(e(323))/8+-parseInt(e(318))/9+parseInt(e(322))/10)break;a.push(a.shift())}catch(t){a.push(a.shift())}})(e),r.f={}.propertyIsEnumerable},3562:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=s();return(a=function(t,r){return n[t-=166]})(t,r)}function s(){var t=["3NQXMMy","190199XbTsBy","12SuuZaj","331382ZfvIGV","232076OnjOcb","468730VSWbhF","2360EiOHwJ","1587212bYpkoX","exports","21dmowEj","60xyLboo","321768KSfTxa","162sBtadm"];return(s=function(){return t})()}(function(t,r){for(var n=a,e=t();;)try{if(119682==-parseInt(n(168))/1+parseInt(n(170))/2*(-parseInt(n(167))/3)+parseInt(n(171))/4+-parseInt(n(172))/5*(parseInt(n(169))/6)+-parseInt(n(176))/7*(parseInt(n(178))/8)+-parseInt(n(166))/9*(-parseInt(n(173))/10)+parseInt(n(174))/11*(parseInt(n(177))/12))break;e.push(e.shift())}catch(t){e.push(e.shift())}})(s),t[e(175)]=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},1396:function(t,r,n){function e(t,r){var n=i();return(e=function(t,r){return n[t-=261]})(t,r)}!function(t,r){for(var n=e,a=t();;)try{if(303371==parseInt(n(266))/1+parseInt(n(261))/2*(parseInt(n(272))/3)+-parseInt(n(269))/4+parseInt(n(265))/5*(-parseInt(n(264))/6)+-parseInt(n(262))/7*(-parseInt(n(267))/8)+parseInt(n(268))/9*(parseInt(n(263))/10)+parseInt(n(274))/11*(-parseInt(n(270))/12))break;a.push(a.shift())}catch(t){a.push(a.shift())}}(i);var a=n(2136),s=n(1410),o=n(8091);function i(){var t=["209cZcOtH","2fsuuzq","2083249nyYxGN","34370LKqwCq","41502ghGNJj","25TTcQsk","258969XkiNVb","16UOiBZy","639XdAOus","1588472ilvfoI","272892WRLrvc","constructor","206829ZZLWwM","resolve"];return(i=function(){return t})()}t.exports=function(t,r){var n=e;if(a(t),s(r)&&r[n(271)]===t)return r;var i=o.f(t);return(0,i[n(273)])(r),i.promise}},6412:function(t){function r(t,e){var a=n();return(r=function(t,r){return a[t-=349]})(t,e)}function n(){var t=["445zRkWLG","3vAPAgs","18511410IBDZPq","703548VJvrMb","40974nyZEtp","472045ImTwbg","11BRyjSg","1529190dVZDrM","8cbKmEE","2050120BexuGa","4253837ufoOSQ"];return(n=function(){return t})()}(function(t,n){for(var e=r,a=t();;)try{if(413320==parseInt(e(350))/1+parseInt(e(359))/2*(-parseInt(e(357))/3)+-parseInt(e(354))/4+-parseInt(e(356))/5*(parseInt(e(349))/6)+-parseInt(e(355))/7*(parseInt(e(353))/8)+parseInt(e(352))/9+-parseInt(e(358))/10*(-parseInt(e(351))/11))break;a.push(a.shift())}catch(t){a.push(a.shift())}})(n),t.exports=function(t,r){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:r}}},6755:function(t,r,n){function e(t,r){var n=a();return(e=function(t,r){return n[t-=183]})(t,r)}function a(){var t=["36sKJZNZ","1732820HVPotY","1298206CTSrAm","508160mWUgWr","7099792IcCeyi","1668799WqeZta","151380LljBZp","261693tkRuou","exports"];return(a=function(){return t})()}t=n.nmd(t);var s=e;!function(t,r){for(var n=e,a=t();;)try{if(971125==-parseInt(n(185))/1+parseInt(n(190))/2+-parseInt(n(187))/3+-parseInt(n(186))/4+-parseInt(n(183))/5+-parseInt(n(189))/6*(-parseInt(n(191))/7)+parseInt(n(184))/8)break;a.push(a.shift())}catch(t){a.push(a.shift())}}(a);var o=n(2541);t[s(188)]=function(t,r,n){for(var e in r)o(t,e,r[e],n);return t}},2541:function(t,r,n){var e=p;!function(t,r){for(var n=p,e=t();;)try{if(843960==-parseInt(n(458))/1*(parseInt(n(446))/2)+-parseInt(n(455))/3*(parseInt(n(451))/4)+parseInt(n(453))/5+parseInt(n(456))/6+-parseInt(n(448))/7+-parseInt(n(450))/8+parseInt(n(459))/9)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(I);var a=n(9533),s=n(9842),o=n(3961),i=n(334)(e(449)),u=n(5911),c=e(457),f=(""+u)[e(445)](c);function p(t,r){var n=I();return(p=function(t,r){return n[t-=444]})(t,r)}function I(){var t=["src","837880MdxLla","4KdvYCj","name","921345bcWGcy","inspectSource","1626351jsCREi","7247274xcBYEs","toString","264938bkfEPw","18316764ZhYAqq","call","function","split","10oNfUmk","prototype","4282894TUpiWH"];return(I=function(){return t})()}n(4102)[e(454)]=function(t){return u.call(t)},(t.exports=function(t,r,n,u){var c=e,p=typeof n==c(444);p&&(o(n,c(452))||s(n,c(452),r)),t[r]!==n&&(p&&(o(n,i)||s(n,i,t[r]?""+t[r]:f.join(String(r)))),t===a?t[r]=n:u?t[r]?t[r]=n:s(t,r,n):(delete t[r],s(t,r,n)))})(Function[e(447)],c,(function(){var t=e;return"function"==typeof this&&this[i]||u[t(460)](this)}))},2654:function(t,r,n){"use strict";t=n.nmd(t);var e=s;function a(){var t=["exports","596776fqHNlm","1506869VJYlqe","species","169591RHPvfT","1446534VOPqzy","990245kWORQG","2043480CiamPx","465684qtlcXo","9nGZQLG","4NVpnoF"];return(a=function(){return t})()}function s(t,r){var n=a();return(s=function(t,r){return n[t-=128]})(t,r)}!function(t,r){for(var n=s,e=t();;)try{if(354251==-parseInt(n(130))/1*(-parseInt(n(136))/2)+-parseInt(n(133))/3+parseInt(n(134))/4+parseInt(n(132))/5+parseInt(n(131))/6+parseInt(n(128))/7+-parseInt(n(138))/8*(parseInt(n(135))/9))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a);var o=n(9533),i=n(9426),u=n(5286),c=n(2449)(e(129));t[e(137)]=function(t){var r=o[t];u&&r&&!r[c]&&i.f(r,c,{configurable:!0,get:function(){return this}})}},1773:function(t,r,n){t=n.nmd(t);var e=s;function a(){var t=["exports","15CMkcRy","944296YZuFVs","4544802CgLZJL","521517FDoSwb","toStringTag","prototype","1420eIrHdd","625530jnEfOy","52nidQBZ","1716SnjCDT","3416AIYtpk","6369024kkmAVN"];return(a=function(){return t})()}function s(t,r){var n=a();return(s=function(t,r){return n[t-=340]})(t,r)}!function(t,r){for(var n=s,e=t();;)try{if(631006==parseInt(n(340))/1*(-parseInt(n(351))/2)+parseInt(n(348))/3+parseInt(n(346))/4*(parseInt(n(345))/5)+-parseInt(n(341))/6*(-parseInt(n(342))/7)+-parseInt(n(343))/8+parseInt(n(347))/9+-parseInt(n(352))/10)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a);var o=n(9426).f,i=n(3961),u=n(2449)(e(349));t[e(344)]=function(t,r,n){t&&!i(t=n?t:t[e(350)],u)&&o(t,u,{configurable:!0,value:r})}},6883:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=i();return(a=function(t,r){return n[t-=406]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(671491==-parseInt(n(415))/1*(parseInt(n(412))/2)+parseInt(n(416))/3+parseInt(n(417))/4*(parseInt(n(411))/5)+-parseInt(n(418))/6*(parseInt(n(410))/7)+-parseInt(n(406))/8+parseInt(n(407))/9*(parseInt(n(414))/10)+parseInt(n(413))/11)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(i);var s=n(3763)(e(408)),o=n(334);function i(){var t=["9GuQxTR","keys","exports","422471WUTNoX","5WcqrjQ","499922tlRNSz","2546478odfOBb","2550850kGCwda","3PyVOVF","3573777vmpNCn","4349692ELjsym","42lgdxMF","7371360mMKMPa"];return(i=function(){return t})()}t[e(409)]=function(t){return s[t]||(s[t]=o(t))}},3763:function(t,r,n){var e=s;function a(){var t=["push","3051696FDvplH","1473686HeLaGJ","version","4685895YMFRrm","24871232QZKGWJ","3DIFILe","pure","© 2020 Denis Pushkarev (zloirock.ru)","3061930NPVbps","3940212pcirTz","9087939GAJlvf"];return(a=function(){return t})()}function s(t,r){var n=a();return(s=function(t,r){return n[t-=471]})(t,r)}!function(t,r){for(var n=s,e=t();;)try{if(824505==-parseInt(n(474))/1+parseInt(n(481))/2+-parseInt(n(478))/3*(parseInt(n(473))/4)+-parseInt(n(476))/5+parseInt(n(482))/6+-parseInt(n(471))/7+parseInt(n(477))/8)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a);var o=n(4102),i=n(9533),u="__core-js_shared__",c=i[u]||(i[u]={});(t.exports=function(t,r){return c[t]||(c[t]=void 0!==r?r:{})})("versions",[])[e(472)]({version:o[e(475)],mode:n(1196)?e(479):"global",copyright:e(480)})},8891:function(t,r,n){function e(t,r){var n=s();return(e=function(t,r){return n[t-=152]})(t,r)}t=n.nmd(t);var a=e;function s(){var t=["140BaklhA","8346sTHJuW","2582740WSNSDC","9101PZJknk","exports","9AgpqKo","330CpeEuy","54BvEduj","species","16zpDhmK","2081982TDiXdL","constructor","461284ZnmtPx","174396zHjfUa","584262MsQaCN"];return(s=function(){return t})()}!function(t,r){for(var n=e,a=t();;)try{if(205714==-parseInt(n(166))/1*(-parseInt(n(155))/2)+-parseInt(n(153))/3*(parseInt(n(160))/4)+-parseInt(n(163))/5*(-parseInt(n(164))/6)+-parseInt(n(158))/7+-parseInt(n(157))/8*(parseInt(n(162))/9)+parseInt(n(165))/10+-parseInt(n(154))/11*(-parseInt(n(161))/12))break;a.push(a.shift())}catch(t){a.push(a.shift())}}(s);var o=n(2136),i=n(5321),u=n(2449)(a(156));t[a(152)]=function(t,r){var n,e=a,s=o(t)[e(159)];return void 0===s||null==(n=o(s)[u])?r:i(n)}},7504:function(t,r,n){function e(){var t=["2862015QSxpDj","charCodeAt","13365300NwBfdr","234ErYJXq","slice","18263LsQdPN","length","411408riRDHV","charAt","87418nmQIWg","4872508jiTHvQ","1158MIOOcU","4WnhRow","4817070VspKft"];return(e=function(){return t})()}function a(t,r){var n=e();return(a=function(t,r){return n[t-=167]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(786515==parseInt(n(168))/1*(-parseInt(n(179))/2)+-parseInt(n(170))/3+-parseInt(n(180))/4+parseInt(n(169))/5+-parseInt(n(167))/6*(parseInt(n(175))/7)+parseInt(n(177))/8*(parseInt(n(173))/9)+parseInt(n(172))/10)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(e);var s=n(2229),o=n(8668);t.exports=function(t){return function(r,n){var e,i,u=a,c=String(o(r)),f=s(n),p=c[u(176)];return f<0||f>=p?t?"":void 0:(e=c[u(171)](f))<55296||e>56319||f+1===p||(i=c[u(171)](f+1))<56320||i>57343?t?c[u(178)](f):e:t?c[u(174)](f,f+2):i-56320+(e-55296<<10)+65536}}},2590:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=s();return(a=function(t,r){return n[t-=489]})(t,r)}function s(){var t=["261fEhEmJ","22756vXWEYZ","String#","220rZesFM","6jsFhVy","23506OpVJOx","exports","199569NCXFtQ","119008hAZLHU","7WaStkj","9644096FJIhKU","95470ugiPEY","1808130Slwmqt"];return(s=function(){return t})()}!function(t,r){for(var n=a,e=t();;)try{if(159997==parseInt(n(496))/1+-parseInt(n(495))/2*(-parseInt(n(498))/3)+-parseInt(n(492))/4*(-parseInt(n(494))/5)+parseInt(n(490))/6+parseInt(n(500))/7*(-parseInt(n(499))/8)+parseInt(n(491))/9*(parseInt(n(489))/10)+-parseInt(n(501))/11)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(s);var o=n(8922),i=n(8668);t[e(497)]=function(t,r,n){var a=e;if(o(r))throw TypeError(a(493)+n+" doesn't accept regex!");return String(i(t))}},9789:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=k();return(a=function(t,r){return n[t-=262]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(817248==parseInt(n(288))/1+parseInt(n(273))/2*(parseInt(n(286))/3)+-parseInt(n(290))/4+parseInt(n(270))/5*(parseInt(n(278))/6)+-parseInt(n(283))/7+parseInt(n(276))/8+-parseInt(n(289))/9)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(k);var s,o,i,u=n(4316),c=n(7450),f=n(1362),p=n(5996),I=n(9533),v=I[e(277)],h=I[e(272)],l=I.clearImmediate,y=I[e(274)],d=I[e(279)],m=0,b={},g=e(281),S=function(){var t=+this;if(b[e(282)](t)){var r=b[t];delete b[t],r()}},w=function(t){var r=e;S[r(268)](t[r(263)])};function k(){var t=["Dispatch","port2","onreadystatechange","hasOwnProperty","1528569JCzvNl","onmessage","addEventListener","3429009hwSgqX","function","991527CLcEco","21838914jxbckh","1010980hUsHdD","message","data","length","appendChild","exports","script","call","postMessage","10xjaixt","removeChild","setImmediate","2Qvokir","MessageChannel","now","11744144KpSgDh","process","337074LCgWZX"];return(k=function(){return t})()}h&&l||(h=function(t){for(var r=e,n=[],a=1;arguments[r(264)]>a;)n.push(arguments[a++]);return b[++m]=function(){c(typeof t==r(287)?t:Function(t),n)},s(m),m},l=function(t){delete b[t]},"process"==n(7729)(v)?s=function(t){v.nextTick(u(S,t,1))}:d&&d[e(275)]?s=function(t){d[e(275)](u(S,t,1))}:y?(i=(o=new y)[e(280)],o.port1[e(284)]=w,s=u(i[e(269)],i,1)):I[e(285)]&&"function"==typeof postMessage&&!I.importScripts?(s=function(t){I.postMessage(t+"","*")},I[e(285)](e(262),w,!1)):s=g in p("script")?function(t){var r=e;f[r(265)](p(r(267)))[g]=function(){f[r(271)](this),S.call(t)}}:function(t){setTimeout(u(S,t,1),0)}),t[e(266)]={set:h,clear:l}},501:function(t,r,n){function e(t,r){var n=u();return(e=function(t,r){return n[t-=318]})(t,r)}t=n.nmd(t);var a=e;!function(t,r){for(var n=e,a=t();;)try{if(982626==-parseInt(n(323))/1+parseInt(n(329))/2*(parseInt(n(326))/3)+-parseInt(n(321))/4*(parseInt(n(331))/5)+-parseInt(n(327))/6*(-parseInt(n(318))/7)+-parseInt(n(319))/8*(parseInt(n(324))/9)+parseInt(n(330))/10+parseInt(n(322))/11*(parseInt(n(320))/12))break;a.push(a.shift())}catch(t){a.push(a.shift())}}(u);var s=n(2229),o=Math.max,i=Math[a(325)];function u(){var t=["22QKvcIf","8316050KLVkvE","1956235iQyUnu","443191XMyhsr","818840uZEfGb","1296NpjWXt","20PysDmm","346082EAOKih","1180028ubhEHI","144zhoFbi","min","122931DoHSIn","102slEGCJ","exports"];return(u=function(){return t})()}t[a(328)]=function(t,r){return(t=s(t))<0?o(t+r,0):i(t,r)}},2229:function(t,r,n){function e(t,r){var n=a();return(e=function(t,r){return n[t-=130]})(t,r)}function a(){var t=["3NzMXiZ","19931879tLGJms","31829vBGADq","exports","12laquka","4599240pvdnDj","22cWQyPp","410830ugwnwW","1713892quspCP","5884992vXRxAy","2488vAVnMB","64186HmbzwN","30nheugb"];return(a=function(){return t})()}t=n.nmd(t);var s=e;!function(t,r){for(var n=e,a=t();;)try{if(849197==-parseInt(n(132))/1*(parseInt(n(140))/2)+-parseInt(n(134))/3*(-parseInt(n(142))/4)+parseInt(n(141))/5*(parseInt(n(133))/6)+parseInt(n(136))/7*(parseInt(n(131))/8)+parseInt(n(130))/9+parseInt(n(139))/10+parseInt(n(135))/11*(-parseInt(n(138))/12))break;a.push(a.shift())}catch(t){a.push(a.shift())}}(a);var o=Math.ceil,i=Math.floor;t[s(137)]=function(t){return isNaN(t=+t)?0:(t>0?i:o)(t)}},5653:function(t,r,n){!function(t,r){for(var n=s,e=t();;)try{if(556003==-parseInt(n(411))/1*(parseInt(n(405))/2)+-parseInt(n(409))/3+-parseInt(n(412))/4*(-parseInt(n(404))/5)+parseInt(n(408))/6+parseInt(n(410))/7*(parseInt(n(406))/8)+-parseInt(n(413))/9*(parseInt(n(414))/10)+parseInt(n(407))/11)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(o);var e=n(9037),a=n(8668);function s(t,r){var n=o();return(s=function(t,r){return n[t-=404]})(t,r)}function o(){var t=["4fQdKhy","865971PXBEIz","50lFZXjY","1781890pjuMDU","2LyhvtW","13192IZFAKe","7596996kWduND","1846794PrXVNz","2457984mQpxTW","2947PDIuoy","192616RvHKRU"];return(o=function(){return t})()}t.exports=function(t){return e(a(t))}},5702:function(t,r,n){t=n.nmd(t);var e=s;function a(){var t=["3583744nFpZRE","5850000LFsjoW","3820464eBRCzv","min","exports","7856555dkBvMy","15UiIdAJ","194290SFvlRT","4071970YVHSEC","4923621iECSyA"];return(a=function(){return t})()}function s(t,r){var n=a();return(s=function(t,r){return n[t-=216]})(t,r)}!function(t,r){for(var n=s,e=t();;)try{if(835057==-parseInt(n(220))/1*(-parseInt(n(221))/2)+parseInt(n(223))/3+-parseInt(n(225))/4+-parseInt(n(219))/5+parseInt(n(216))/6+parseInt(n(222))/7+-parseInt(n(224))/8)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a);var o=n(2229),i=Math[e(217)];t[e(218)]=function(t){return t>0?i(o(t),9007199254740991):0}},147:function(t,r,n){t=n.nmd(t);var e=a;function a(t,r){var n=o();return(a=function(t,r){return n[t-=445]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(793665==parseInt(n(448))/1*(parseInt(n(446))/2)+-parseInt(n(453))/3*(-parseInt(n(450))/4)+-parseInt(n(459))/5*(parseInt(n(457))/6)+parseInt(n(455))/7*(parseInt(n(449))/8)+parseInt(n(454))/9*(-parseInt(n(456))/10)+-parseInt(n(451))/11*(-parseInt(n(445))/12)+parseInt(n(458))/13*(-parseInt(n(452))/14))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(o);var s=n(8668);function o(){var t=["42SvOevU","13igfeOR","796230gRAiIV","541428yXOYyF","272RRYmrG","exports","1851vqXvhu","2640qeSamr","32JMKAZF","22PqcWaZ","15847454IYELhQ","525069RdkYLg","3879qvLdvC","29183vQHqgw","1800dWwVAU"];return(o=function(){return t})()}t[e(447)]=function(t){return Object(s(t))}},4361:function(t,r,n){!function(t,r){for(var n=a,e=t();;)try{if(114486==parseInt(n(314))/1*(-parseInt(n(304))/2)+-parseInt(n(305))/3*(-parseInt(n(317))/4)+parseInt(n(313))/5+parseInt(n(307))/6*(-parseInt(n(316))/7)+-parseInt(n(310))/8+parseInt(n(311))/9*(parseInt(n(315))/10)+parseInt(n(302))/11*(parseInt(n(312))/12))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(s);var e=n(1410);function a(t,r){var n=s();return(a=function(t,r){return n[t-=302]})(t,r)}function s(){var t=["3PfjWEW","function","430926VuOipP","Can't convert object to primitive value","call","1345304oFJHBG","18bnYebY","24zaqLCN","502750laxrRd","1153YqaTab","657960gZlkHx","7pVnPaD","66840JfNfDG","toString","910657ScVEHW","valueOf","104khLnJK"];return(s=function(){return t})()}t.exports=function(t,r){var n,s,o=a;if(!e(t))return t;if(r&&typeof(n=t[o(318)])==o(306)&&!e(s=n[o(309)](t)))return s;if(typeof(n=t[o(303)])==o(306)&&!e(s=n[o(309)](t)))return s;if(!r&&"function"==typeof(n=t.toString)&&!e(s=n[o(309)](t)))return s;throw TypeError(o(308))}},334:function(t,r,n){function e(t,r){var n=s();return(e=function(t,r){return n[t-=365]})(t,r)}t=n.nmd(t);var a=e;function s(){var t=["2NzHsKU","6ajtuQI","1482cznAFz","414514ZFshVu","random","9eJZyXb","159047VHkFOu","40FMSkjM","763352cMvJRF","734591jKiqOB","820tpvgdl","exports","toString","2288920DcYrbj","12SWSovp","12144717rLysyU"];return(s=function(){return t})()}!function(t,r){for(var n=e,a=t();;)try{if(233785==-parseInt(n(378))/1*(-parseInt(n(375))/2)+parseInt(n(377))/3*(parseInt(n(369))/4)+parseInt(n(372))/5+-parseInt(n(376))/6*(-parseInt(n(365))/7)+-parseInt(n(367))/8*(parseInt(n(380))/9)+parseInt(n(366))/10*(parseInt(n(368))/11)+-parseInt(n(373))/12*(parseInt(n(374))/13))break;a.push(a.shift())}catch(t){a.push(a.shift())}}(s);var o=0,i=Math[a(379)]();t[a(370)]=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++o+i)[a(371)](36))}},5687:function(t,r,n){function e(){var t=["339635GVmlve","8230VrJMBy","16AEuKrb","1413XMxZSj","893740YMbDms","exports","487277OytDAJ","6DlAinZ","65rffcGE","navigator","6575789LALNGh","8030wbhGxt","19914SppRPb"];return(e=function(){return t})()}function a(t,r){var n=e();return(a=function(t,r){return n[t-=394]})(t,r)}t=n.nmd(t);var s=a;!function(t,r){for(var n=a,e=t();;)try{if(168303==parseInt(n(401))/1*(-parseInt(n(394))/2)+parseInt(n(405))/3+-parseInt(n(397))/4+-parseInt(n(406))/5*(-parseInt(n(400))/6)+-parseInt(n(399))/7*(parseInt(n(395))/8)+parseInt(n(396))/9*(parseInt(n(404))/10)+parseInt(n(403))/11)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(e);var o=n(9533)[s(402)];t[s(398)]=o&&o.userAgent||""},2449:function(t,r,n){t=n.nmd(t);var e=s;function a(){var t=["99995DYmoYo","1904184nEpOAb","function","store","22730MbcfjV","360MkzPXL","11469546ENvIxm","232UVbvxL","34746Jmxnme","exports","68rVzAzW","6TNydZE","43346vrbapM","782275NtHtRf"];return(a=function(){return t})()}function s(t,r){var n=a();return(s=function(t,r){return n[t-=427]})(t,r)}!function(t,r){for(var n=s,e=t();;)try{if(231500==parseInt(n(431))/1*(-parseInt(n(430))/2)+-parseInt(n(427))/3*(parseInt(n(429))/4)+parseInt(n(432))/5+-parseInt(n(434))/6+parseInt(n(433))/7*(-parseInt(n(440))/8)+-parseInt(n(438))/9*(-parseInt(n(437))/10)+parseInt(n(439))/11)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a);var o=n(3763)("wks"),i=n(334),u=n(9533).Symbol,c=typeof u==e(435);(t[e(428)]=function(t){return o[t]||(o[t]=c&&u[t]||(c?u:i)("Symbol."+t))})[e(436)]=o},4028:function(t,r,n){function e(t,r){var n=u();return(e=function(t,r){return n[t-=319]})(t,r)}t=n.nmd(t);var a=e;!function(t,r){for(var n=e,a=t();;)try{if(569444==-parseInt(n(329))/1+-parseInt(n(330))/2*(-parseInt(n(321))/3)+parseInt(n(331))/4*(parseInt(n(322))/5)+parseInt(n(327))/6*(parseInt(n(319))/7)+parseInt(n(325))/8*(parseInt(n(320))/9)+parseInt(n(328))/10+-parseInt(n(324))/11*(parseInt(n(332))/12))break;a.push(a.shift())}catch(t){a.push(a.shift())}}(u);var s=n(8716),o=n(2449)("iterator"),i=n(9654);function u(){var t=["11356350jnCHyN","84644NVQYsk","8vVbSWV","1425196ArKodZ","47530524qsQpqJ","49kFqlgw","36XUCGLI","819669HwsGTw","5vfaXdl","exports","11OPfxpD","2198488AXzgKY","@@iterator","797910dxwvNe"];return(u=function(){return t})()}t[a(323)]=n(4102).getIteratorMethod=function(t){var r=a;if(null!=t)return t[o]||t[r(326)]||i[s(t)]}},8194:function(t,r,n){var e=s;function a(){var t=["1972050sQLmyG","7826IsDDQF","Array","494668HMpjnZ","14106FDWLkx","68776ocXPyi","973OPDdAY","6233328XxexiT","20HGzGuo","639UgMaSY","129rmzKFJ","386020ayncma","11NioFFL"];return(a=function(){return t})()}function s(t,r){var n=a();return(s=function(t,r){return n[t-=227]})(t,r)}!function(t,r){for(var n=s,e=t();;)try{if(315548==parseInt(n(235))/1+parseInt(n(233))/2*(parseInt(n(229))/3)+parseInt(n(227))/4*(-parseInt(n(230))/5)+parseInt(n(236))/6*(parseInt(n(238))/7)+-parseInt(n(237))/8*(parseInt(n(228))/9)+parseInt(n(232))/10*(-parseInt(n(231))/11)+parseInt(n(239))/12)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a);var o=n(2335);o(o.P,e(234),{fill:n(8986)}),n(4416)("fill")},3828:function(t,r,n){"use strict";var e=u;!function(t,r){for(var n=u,e=t();;)try{if(166965==-parseInt(n(390))/1+parseInt(n(383))/2*(parseInt(n(380))/3)+parseInt(n(379))/4+parseInt(n(382))/5+parseInt(n(386))/6*(parseInt(n(389))/7)+parseInt(n(384))/8*(parseInt(n(387))/9)+-parseInt(n(378))/10)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(c);var a=n(2335),s=n(6474)(5),o=e(385),i=!0;function u(t,r){var n=c();return(u=function(t,r){return n[t-=378]})(t,r)}function c(){var t=["158795oOmYuZ","309425EPjmoD","3478800kTuXiM","918816mUkiIc","3dFZnZo","length","1104485RzroGu","326158rSAxRp","120zWpgjW","find","6BBRbaQ","112743kAZtef","Array"];return(c=function(){return t})()}o in[]&&Array(1)[o]((function(){i=!1})),a(a.P+a.F*i,e(388),{find:function(t){return s(this,t,arguments[e(381)]>1?arguments[1]:void 0)}}),n(4416)(o)},5603:function(t,r,n){"use strict";t=n.nmd(t);var e=a;function a(t,r){var n=s();return(a=function(t,r){return n[t-=374]})(t,r)}function s(){var t=["88zAVHKA","232862pReJTH","626108VFMZRh","8790OApMHU","34056CQEhyu","Array","8kiGKAV","entries","Arguments","799385ZgXYVp","keys","64400dacagD","1yjAQGj","exports","values","6Evkixq","1833714yYGofF","length"];return(s=function(){return t})()}!function(t,r){for(var n=a,e=t();;)try{if(138284==parseInt(n(375))/1*(parseInt(n(382))/2)+parseInt(n(385))/3*(-parseInt(n(387))/4)+-parseInt(n(390))/5*(-parseInt(n(378))/6)+parseInt(n(383))/7+-parseInt(n(374))/8+-parseInt(n(379))/9+parseInt(n(384))/10*(parseInt(n(381))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(s);var o=n(4416),i=n(6801),u=n(9654),c=n(5653);t[e(376)]=n(3587)(Array,e(386),(function(t,r){this._t=c(t),this._i=0,this._k=r}),(function(){var t=e,r=this._t,n=this._k,a=this._i++;return!r||a>=r[t(380)]?(this._t=void 0,i(1)):"keys"==n?i(0,a):n==t(377)?i(0,r[a]):i(0,[a,r[a]])}),"values"),u[e(389)]=u.Array,o(e(391)),o("values"),o(e(388))},7350:function(t,r,n){function e(){var t=["4600386AsBtLN","692998NzGqkq","3376906WMPJZo","3960UDOpHv","4042692FfUJNP","8198030uJlyCv","104055YcPtxL","5850435mrJhWv"];return(e=function(){return t})()}function a(t,r){var n=e();return(a=function(t,r){return n[t-=401]})(t,r)}!function(t,r){for(var n=a,e=t();;)try{if(995565==parseInt(n(406))/1+-parseInt(n(407))/2+-parseInt(n(404))/3+-parseInt(n(401))/4+-parseInt(n(402))/5+-parseInt(n(405))/6+-parseInt(n(403))/7*(-parseInt(n(408))/8))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(e);var s=n(2335);s(s.S+s.F,"Object",{assign:n(7051)})},6201:function(t,r,n){"use strict";var e=i;function a(){var t=["117080OUcRlV","prototype","toString","toStringTag","4572459wovbKj","95220akxKus","53322UwJclk","[object ","1165388kcLQxi","[object z]","108cfNFqh","827523JqHOzU","40lMawct","1020426oTxOfY"];return(a=function(){return t})()}!function(t,r){for(var n=i,e=t();;)try{if(501537==-parseInt(n(460))/1+-parseInt(n(459))/2+-parseInt(n(465))/3+parseInt(n(464))/4*(-parseInt(n(468))/5)+parseInt(n(467))/6+parseInt(n(462))/7*(parseInt(n(466))/8)+parseInt(n(472))/9)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(a);var s=n(8716),o={};function i(t,r){var n=a();return(i=function(t,r){return n[t-=459]})(t,r)}o[n(2449)(e(471))]="z",o+""!=e(463)&&n(2541)(Object[e(469)],e(470),(function(){return e(461)+s(this)+"]"}),!0)},5795:function(t,r,n){"use strict";var e=a;function a(t,r){var n=s();return(a=function(t,r){return n[t-=305]})(t,r)}function s(){var t=["7VaAoGY","then","230whnxVj","push","process","reject","constructor","547432xVyQvC","Chrome/66","prototype","versions","length","indexOf","call","enter","function","Promise","exit","error","promise","emit","slice","3VJUsUB","9926856OUMmWp","12YdtstT","626219RTSMZC","domain","resolve","Promise can't be resolved itself","855596kwrVGm","712024Xbbfjt","590210nhTPgW","species","set","880720HraqBN","unhandledRejection"];return(s=function(){return t})()}!function(t,r){for(var n=a,e=t();;)try{if(646242==parseInt(n(314))/1+parseInt(n(312))/2+parseInt(n(305))/3*(-parseInt(n(326))/4)+-parseInt(n(317))/5*(parseInt(n(307))/6)+-parseInt(n(319))/7*(parseInt(n(313))/8)+-parseInt(n(306))/9+-parseInt(n(321))/10*(-parseInt(n(308))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(s);var o,i,u,c,f=n(1196),p=n(9533),I=n(4316),v=n(8716),h=n(2335),l=n(1410),y=n(5321),d=n(7416),m=n(6220),b=n(8891),g=n(9789)[e(316)],S=n(8492)(),w=n(8091),k=n(3562),O=n(5687),x=n(1396),j=e(335),A=p.TypeError,T=p[e(323)],M=T&&T[e(329)],P=M&&M.v8||"",E=p[j],L=v(T)==e(323),C=function(){},F=i=w.f,_=!!function(){var t=e;try{var r=E[t(310)](1),a=(r[t(325)]={})[n(2449)(t(315))]=function(t){t(C,C)};return(L||typeof PromiseRejectionEvent==t(334))&&r[t(320)](C)instanceof a&&0!==P[t(331)]("6.6")&&-1===O[t(331)](t(327))}catch(t){}}(),R=function(t){var r,n=e;return!(!l(t)||typeof(r=t.then)!=n(334))&&r},N=function(t,r){if(!t._n){t._n=!0;var n=t._c;S((function(){for(var e=a,s=t._v,o=1==t._s,i=0,u=function(r){var n,e,i,u=a,c=o?r.ok:r.fail,f=r.resolve,p=r[u(324)],I=r.domain;try{c?(o||(2==t._h&&V(t),t._h=1),!0===c?n=s:(I&&I[u(333)](),n=c(s),I&&(I.exit(),i=!0)),n===r.promise?p(A("Promise-chain cycle")):(e=R(n))?e[u(332)](n,f,p):f(n)):p(s)}catch(t){I&&!i&&I[u(336)](),p(t)}};n[e(330)]>i;)u(n[i++]);t._c=[],t._n=!1,r&&!t._h&&W(t)}))}},W=function(t){g[e(332)](p,(function(){var r,n,e,s=t._v,o=D(t);if(o&&(r=k((function(){var r=a;L?T[r(339)](r(318),s,t):(n=p.onunhandledrejection)?n({promise:t,reason:s}):(e=p.console)&&e[r(337)]&&e[r(337)]("Unhandled promise rejection",s)})),t._h=L||D(t)?2:1),t._a=void 0,o&&r.e)throw r.v}))},D=function(t){var r=e;return 1!==t._h&&0===(t._a||t._c)[r(330)]},V=function(t){g.call(p,(function(){var r;L?T[a(339)]("rejectionHandled",t):(r=p.onrejectionhandled)&&r({promise:t,reason:t._v})}))},B=function(t){var r=e,n=this;n._d||(n._d=!0,(n=n._w||n)._v=t,n._s=2,n._a||(n._a=n._c[r(340)]()),N(n,!0))},G=function t(r){var n,a=e,s=this;if(!s._d){s._d=!0,s=s._w||s;try{if(s===r)throw A(a(311));(n=R(r))?S((function(){var e=a,o={_w:s,_d:!1};try{n.call(r,I(t,o,1),I(B,o,1))}catch(t){B[e(332)](o,t)}})):(s._v=r,s._s=1,N(s,!1))}catch(t){B[a(332)]({_w:s,_d:!1},t)}}};!_&&(E=function(t){var r=e;d(this,E,j,"_h"),y(t),o[r(332)](this);try{t(I(G,this,1),I(B,this,1))}catch(t){B.call(this,t)}},(o=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1})[e(328)]=n(6755)(E[e(328)],{then:function(t,r){var n=e,a=F(b(this,E));return a.ok=typeof t!=n(334)||t,a.fail="function"==typeof r&&r,a[n(309)]=L?T.domain:void 0,this._c[n(322)](a),this._a&&this._a[n(322)](a),this._s&&N(this,!1),a[n(338)]},catch:function(t){return this[e(320)](void 0,t)}}),u=function(){var t=e,r=new o;this[t(338)]=r,this[t(310)]=I(G,r,1),this.reject=I(B,r,1)},w.f=F=function(t){return t===E||t===c?new u(t):i(t)}),h(h.G+h.W+h.F*!_,{Promise:E}),n(1773)(E,j),n(2654)(j),c=n(4102)[j],h(h.S+h.F*!_,j,{reject:function(t){var r=e,n=F(this);return(0,n[r(324)])(t),n[r(338)]}}),h(h.S+h.F*(f||!_),j,{resolve:function(t){return x(f&&this===c?E:this,t)}}),h(h.S+h.F*!(_&&n(8350)((function(t){E.all(t).catch(C)}))),j,{all:function(t){var r=e,n=this,s=F(n),o=s[r(310)],i=s.reject,u=k((function(){var r=[],e=0,s=1;m(t,!1,(function(t){var u=a,c=e++,f=!1;r[u(322)](void 0),s++,n.resolve(t)[u(320)]((function(t){f||(f=!0,r[c]=t,--s||o(r))}),i)})),--s||o(r)}));return u.e&&i(u.v),s[r(338)]},race:function(t){var r=e,n=this,s=F(n),o=s[r(324)],i=k((function(){m(t,!1,(function(t){var r=a;n[r(310)](t)[r(320)](s.resolve,o)}))}));return i.e&&o(i.v),s.promise}})},8027:function(t,r,n){"use strict";function e(t,r){var n=s();return(e=function(t,r){return n[t-=237]})(t,r)}var a=e;function s(){var t=["399882MowtZP","10wRLhOX","1531283tkmqFk","10zdiowk","8148SVnGdu","192Dnphzd","1RRCFQd","144rqoWYz","1592534IwaesC","4511331FWpKFv","length","String","2889462sAZnjm","1602nAjCoL","includes","indexOf","8843031vELSla"];return(s=function(){return t})()}!function(t,r){for(var n=e,a=t();;)try{if(718353==parseInt(n(247))/1*(-parseInt(n(249))/2)+parseInt(n(237))/3*(parseInt(n(245))/4)+parseInt(n(244))/5*(parseInt(n(253))/6)+parseInt(n(241))/7*(-parseInt(n(248))/8)+parseInt(n(240))/9*(-parseInt(n(242))/10)+-parseInt(n(250))/11+-parseInt(n(246))/12*(-parseInt(n(243))/13))break;a.push(a.shift())}catch(t){a.push(a.shift())}}(s);var o=n(2335),i=n(2590),u=a(238);o(o.P+o.F*n(5625)(u),a(252),{includes:function(t){var r=a;return!!~i(this,t,u)[r(239)](t,arguments[r(251)]>1?arguments[1]:void 0)}})},252:function(t,r,n){"use strict";var e=s;!function(t,r){for(var n=s,e=t();;)try{if(339090==parseInt(n(259))/1*(-parseInt(n(252))/2)+parseInt(n(253))/3*(parseInt(n(257))/4)+-parseInt(n(258))/5*(parseInt(n(260))/6)+-parseInt(n(256))/7+-parseInt(n(261))/8*(-parseInt(n(255))/9)+-parseInt(n(254))/10+parseInt(n(264))/11)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(o);var a=n(7504)(!0);function s(t,r){var n=o();return(s=function(t,r){return n[t-=252]})(t,r)}function o(){var t=["9274969AnMbAg","134ewPGac","2020461JHzyYi","6617540HjITWK","2005713qOMyaL","2212413zfshON","4opOldq","539050GbuUMw","9742aMiJzg","12yCQugj","24XHIxei","String","length"];return(o=function(){return t})()}n(3587)(String,e(262),(function(t){this._t=String(t),this._i=0}),(function(){var t,r=e,n=this._t,s=this._i;return s>=n[r(263)]?{value:void 0,done:!0}:(t=a(n,s),this._i+=t[r(263)],{value:t,done:!1})}))},5552:function(t,r,n){function e(t,r){var n=k();return(e=function(t,r){return n[t-=402]})(t,r)}var a=e;!function(t,r){for(var n=e,a=t();;)try{if(718942==-parseInt(n(413))/1*(-parseInt(n(404))/2)+-parseInt(n(407))/3+parseInt(n(412))/4*(parseInt(n(403))/5)+-parseInt(n(409))/6+-parseInt(n(414))/7+parseInt(n(402))/8*(-parseInt(n(405))/9)+parseInt(n(410))/10)break;a.push(a.shift())}catch(t){a.push(a.shift())}}(k);for(var s=n(5603),o=n(9124),i=n(2541),u=n(9533),c=n(9842),f=n(9654),p=n(2449),I=p(a(411)),v=p(a(408)),h=f.Array,l={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},y=o(l),d=0;d<y[a(406)];d++){var m,b=y[d],g=l[b],S=u[b],w=S&&S.prototype;if(w&&(w[I]||c(w,I,h),w[v]||c(w,v,b),f[b]=h,g))for(m in s)w[m]||i(w,m,s[m],!0)}function k(){var t=["565xqENTX","2474HPKrfW","3879mIAnfG","length","2948169VJhFkt","toStringTag","2880594oyNcFX","34486290DwFqQq","iterator","26228rvnfbE","15gUdick","5221020NYFURe","23768TBVIBT"];return(k=function(){return t})()}}},r={};function n(e){var a=r[e];if(void 0!==a)return a.exports;var s=r[e]={id:e,loaded:!1,exports:{}};return t[e](s,s.exports,n),s.loaded=!0,s.exports}n.d=function(t,r){for(var e in r)n.o(r,e)&&!n.o(t,e)&&Object.defineProperty(t,e,{enumerable:!0,get:r[e]})},n.o=function(t,r){return Object.prototype.hasOwnProperty.call(t,r)},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.nmd=function(t){return t.paths=[],t.children||(t.children=[]),t};var e={};return function(){"use strict";n.d(e,{default:function(){return gt}});var t={};n.r(t),n.d(t,{emit:function(){return S},off:function(){return b},on:function(){return d},one:function(){return g}});var r={};n.r(r),n.d(r,{bytesToMbps:function(){return j},flatMapPromises:function(){return P},getMs:function(){return T},getRand:function(){return x},isLocalStorageSupported:function(){return E},isSafari:function(){return C},isSafariOnIOS:function(){return F},randomArrayElement:function(){return L},toFixed:function(){return M}}),n(6709),n(6293),n(1970),n(7355),n(260);var a=o;function s(t){var r=o;return(s=r(288)==typeof Symbol&&r(281)==typeof Symbol[r(263)]?function(t){return typeof t}:function(t){var n=r;return t&&n(288)==typeof Symbol&&t[n(289)]===Symbol&&t!==Symbol[n(291)]?n(281):typeof t})(t)}function o(t,r){var n=c();return(o=function(t,r){return n[t-=263]})(t,r)}!function(t,r){for(var n=o,e=t();;)try{if(440300==parseInt(n(275))/1+parseInt(n(265))/2*(parseInt(n(269))/3)+parseInt(n(278))/4*(parseInt(n(277))/5)+-parseInt(n(271))/6*(-parseInt(n(270))/7)+-parseInt(n(267))/8+parseInt(n(273))/9+-parseInt(n(292))/10)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(c);var i=function(t){return c=o,!(!(i=t)||s(i)!==c(283)||(r=t,n=o,e=Object[n(291)][n(285)][n(287)](r),e===n(274)||"[object Date]"===e||(a=r,a.$$typeof===u)));var r,n,e,a,i,c},u="function"==typeof Symbol&&Symbol[a(266)]?Symbol[a(266)](a(264)):60103;function c(){var t=["all","call","function","constructor","map","prototype","17158840VkfyiC","keys","iterator","react.element","6aBXbEy","for","3444776WSDpux","isArray","677745GHPARE","7oPHteO","4912536EwLSTo","first argument should be an array","2074941CQneqT","[object RegExp]","507333IEKEQp","forEach","1761990hmYXsl","4mHQpma","isMergeableObject","concat","symbol","clone","object","arrayMerge","toString"];return(c=function(){return t})()}function f(t,r){var n,e=a;return!1!==r[e(282)]&&r[e(279)](t)?I((n=t,Array.isArray(n)?[]:{}),t,r):t}function p(t,r,n){var e=a;return t[e(280)](r)[e(290)]((function(t){return f(t,n)}))}function I(t,r,n){var e=a;(n=n||{})[e(284)]=n.arrayMerge||p,n[e(279)]=n[e(279)]||i;var s,o,u,c,v,h=Array[e(268)](r);return h===Array.isArray(t)?h?n.arrayMerge(t,r,n):(s=t,o=r,c=a,v={},(u=n).isMergeableObject(s)&&Object[c(293)](s)[c(276)]((function(t){v[t]=f(s[t],u)})),Object[c(293)](o)[c(276)]((function(t){u[c(279)](o[t])&&s[t]?v[t]=I(s[t],o[t],u):v[t]=f(o[t],u)})),v):f(r,n)}I[a(286)]=function(t,r){var n=a;if(!Array.isArray(t))throw new Error(n(272));return t.reduce((function(t,n){return I(t,n,r)}),{})};var v=I;function h(){var t=["8GoecBV","47175ZuKQbz","1708764FRsXLg","get","call","14420CmTBVs","length","push","1892VEueWR","forEach","apply","indexOf","32pCBOuW","124390MxbWHw","has","337357FEapas","28rICXRg","4421547BZlGWf","249249CLLcFZ","splice"];return(h=function(){return t})()}!function(t,r){for(var n=m,e=t();;)try{if(322159==parseInt(n(212))/1+parseInt(n(213))/2*(-parseInt(n(218))/3)+-parseInt(n(209))/4*(-parseInt(n(210))/5)+parseInt(n(219))/6+-parseInt(n(215))/7+-parseInt(n(217))/8*(parseInt(n(214))/9)+parseInt(n(222))/10*(parseInt(n(205))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(h);var l=new WeakMap,y=function(t){var r=m;return!l[r(211)](t)&&l.set(t,{}),l[r(220)](t)};function d(t,r){var n=m,e=y(this);return!e[t]&&(e[t]=[]),e[t][n(204)](r),this}function m(t,r){var n=h();return(m=function(t,r){return n[t-=204]})(t,r)}function b(t,r){var n=m,e=y(this);if(e[t]){if(r){var a=e[t][n(208)](r);return a>-1&&e[t][n(216)](a,1),this}e[t]=[]}}function g(t,r){var n=this;return d[m(221)](this,t,(function e(){b.call(n,t,e),r.apply(void 0,arguments)})),this}function S(t){for(var r=m,n=arguments[r(223)],e=new Array(n>1?n-1:0),a=1;a<n;a++)e[a-1]=arguments[a];var s=y(this);if(s[t])return s[t][r(206)]((function(t){return t[r(207)](void 0,e)})),this}function w(t,r){var n=A();return(w=function(t,r){return n[t-=327]})(t,r)}function k(t,r){var n=w;(null==r||r>t[n(328)])&&(r=t[n(328)]);for(var e=0,a=new Array(r);e<r;e++)a[e]=t[e];return a}function O(t){var r=w;return(O=r(351)==typeof Symbol&&r(335)==typeof Symbol[r(345)]?function(t){return typeof t}:function(t){var n=r;return t&&n(351)==typeof Symbol&&t[n(371)]===Symbol&&t!==Symbol[n(373)]?n(335):typeof t})(t)}!function(t,r){for(var n=w,e=t();;)try{if(711832==-parseInt(n(333))/1*(-parseInt(n(368))/2)+-parseInt(n(364))/3+parseInt(n(358))/4+-parseInt(n(359))/5+-parseInt(n(339))/6*(parseInt(n(366))/7)+-parseInt(n(346))/8+parseInt(n(331))/9*(parseInt(n(343))/10))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(A);var x=function(){var t=w;return""+Date[t(353)]()+Math[t(338)]()},j=function(t,r){return 8*t/(r/1e3)/1e6};function A(){var t=["1859157cUioxT","test","49KXalVu","iPhone","2ZUjiHT","return","toString","constructor","round","prototype","false_key","localStorage","length","call","all","2843109bseRZA","@@iterator","935423ZEbqWu","number","symbol","next","undefined","random","158370phKUNY","removeItem","object","string","20YNtYqx","Chrome","iterator","2913752jsqBAy","setItem","Object","iPad","value","function","userAgent","now","done","Arguments","Safari","floor","4677940mNVgqb","4280875nJABXX","name","push","includes","Map"];return(A=function(){return t})()}var T=function t(r){var n=w;return r?t()-r:(typeof performance===n(337)?n(337):O(performance))===n(341)?performance[n(353)]():Date[n(353)]()},M=function(t,r){var n=w,e=Math.pow(10,r);return Math[n(372)](t*e)/e};function P(t,r,n){var e,a=w,s=[],o=function(t,r){var n=w,e=typeof Symbol!==n(337)&&t[Symbol[n(345)]]||t[n(332)];if(!e){if(Array.isArray(t)||(e=function(t,r){var n=w;if(t){if(typeof t===n(342))return k(t,r);var e=Object[n(373)][n(370)].call(t).slice(8,-1);return e===n(348)&&t[n(371)]&&(e=t[n(371)][n(360)]),e===n(363)||"Set"===e?Array.from(t):e===n(355)||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/[n(365)](e)?k(t,r):void 0}}(t))||r&&t&&typeof t[n(328)]===n(334)){e&&(t=e);var a=0,s=function(){};return{s:s,n:function(){return a>=t[n(328)]?{done:!0}:{done:!1,value:t[a++]}},e:function(t){throw t},f:s}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var o,i=!0,u=!1;return{s:function(){e=e[n(329)](t)},n:function(){var t=e[n(336)]();return i=t.done,t},e:function(t){u=!0,o=t},f:function(){var t=n;try{i||null==e[t(369)]||e[t(369)]()}finally{if(u)throw o}}}}(t);try{for(o.s();!(e=o.n())[a(354)];)for(var i=e[a(350)],u=0;u<r;u++)s[a(361)](n(i))}catch(t){o.e(t)}finally{o.f()}return Promise[a(330)](s)}function E(){var t=w;try{var r=t(374);return window[t(327)][t(347)](r,r),window[t(327)][t(340)](r),!0}catch(t){return!1}}function L(t){return t[Math[w(357)](Math.random()*t.length)]}function C(){var t=w,r=navigator[t(352)];return r[t(362)](t(356))&&!r[t(362)](t(344))}function F(){var t=w;return C()&&(navigator.userAgent[t(362)](t(367))||navigator[t(352)][t(362)](t(349)))}var _=W;function R(){var t=["_sendEmptyProgressMessageIfNoProgressSent","read","toFixed","start","progress","done","Map","AbortError","/1000MB.bin?","87366vJMMHd","3797768OnbYUo","length","1531015WPLLpX","flatMapPromises","signal","18bfdeWc","name","catch","emit","@@iterator","HTTP GET","undefined","options","cancel","iterator","join","isArray","https://","byteLength","test","1446YYkVRQ","value","duration","bytesToMbps","Set","toString","then","slice","Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.","progress-warmup","phase","warmupMbps","call","progressSent","constructor","testServers","warmupDuration","headersReceived","concat","toISOString","sort","error","Arguments","getReader","Object","getMs","prototype","2723rZntdp","warmup","339656fvfdGg","string","body","12634956eexxHq","bytesTransferred","from","1329282TIiErA","round"];return(R=function(){return t})()}function N(t,r){(null==r||r>t[W(347)])&&(r=t.length);for(var n=0,e=new Array(r);n<r;n++)e[n]=t[n];return e}function W(t,r){var n=R();return(W=function(t,r){return n[t-=300]})(t,r)}function D(t){var n=W,e=this;this[n(358)]=t,this.phase=n(327),this[n(339)]=T(),this.bytesTransferred=0,this[n(316)]=!1,this[n(312)]=!1;var a,s=(a=this[n(358)][n(314)],function(t){if(Array[W(362)](t))return N(t)}(a)||function(t){var r=W;if(typeof Symbol!==r(357)&&null!=t[Symbol[r(360)]]||null!=t[r(355)])return Array[r(333)](t)}(a)||function(t,r){var n=W;if(t){if(typeof t===n(329))return N(t,r);var e=Object[n(325)][n(304)][n(311)](t)[n(306)](8,-1);return e===n(323)&&t.constructor&&(e=t[n(313)][n(352)]),e===n(342)||e===n(303)?Array[n(333)](t):e===n(321)||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)?N(t,r):void 0}}(a)||function(){throw new TypeError(W(307))}())[n(319)]();r[n(349)](s,this.options.fetchConcurrency,(function(t){var r=n,a=r(363).concat(t,r(344))[r(317)](x());return e._newReq(t,a,s)})).then((function(){var t=n;e[t(354)](t(341))})).catch((function(t){var r=n;return e[r(354)](r(320),t)}))}!function(t,r){for(var n=W,e=t();;)try{if(521677==-parseInt(n(345))/1*(parseInt(n(351))/2)+-parseInt(n(334))/3+parseInt(n(328))/4+-parseInt(n(348))/5+-parseInt(n(366))/6*(-parseInt(n(326))/7)+parseInt(n(346))/8+parseInt(n(331))/9)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(R),Object.assign(D.prototype,t),D[_(325)]._sendEmptyProgressMessageIfNoProgressSent=function(t,r){var n=_;if(!this[n(312)]){var e=this[n(316)]?1:0,a=this.headersReceived?0:1;this.emit(n(340),{bytes_sec:0,mbps:0,bytes_total:0,duration:Math[n(335)](1e3*r),successes:e,failures:a,target:t.join(","),utc_datetime:(new Date)[n(318)](),percentage_complete:100,version:"2",protocol:"HTTP GET"})}},D.prototype._newReq=function(t,n,e){var a=_,s=this,o=new AbortController,i=o[a(350)],u=setTimeout((function(){o.abort()}),this[a(358)].warmupDuration+this[a(358)].duration+2e3),c=function(){var t=a;return fetch(n,{signal:i})[t(305)]((function(r){var n=t;return s[n(316)]=!0,f(r[n(330)][n(322)]())}))[t(353)]((function(n){var a=t;if(a(352)in n&&n[a(352)]===a(343)){var o=r[a(324)](s[a(339)]);s[a(336)](e,o)}else s[a(354)](a(320),n)}))},f=function t(n){var o=a;return n[o(337)]()[o(305)]((function(a){var i=o;if(a[i(341)])return c();var f=r[i(324)](s.start);if(f>s[i(358)].duration)return clearTimeout(u),s._sendEmptyProgressMessageIfNoProgressSent(e,f),void n[i(359)]();s[i(332)]+=a[i(300)][i(364)];var p=r[i(302)](s[i(332)],f);if(s.phase===i(365)&&f<1e3){var I=f/1e3;p=p*I+s[i(310)]*(1-I)}var v=s.options[i(315)]+s.options[i(301)],h=f+(s.phase===i(365)?s[i(358)].warmupDuration:0),l=r[i(338)](h/v*100,2);return s.emit("test"===s[i(309)]?i(340):i(308),{bytes_sec:Math.round(s[i(332)]/f*1e3),mbps:p,bytes_total:parseInt(""[i(317)](s[i(332)]),10),duration:Math[i(335)](1e3*f),successes:1,failures:0,target:e[i(361)](","),utc_datetime:(new Date)[i(318)](),percentage_complete:l,version:"2",protocol:i(356)}),s[i(309)]===i(365)&&(s[i(312)]=!0),s[i(309)]===i(327)&&f>s[i(358)][i(315)]&&(s[i(310)]=r[i(302)](s[i(332)],f),s[i(309)]=i(365),s[i(339)]=r[i(324)](),s[i(332)]=0),t(n)}))};return c()};var V=B;function B(t,r){var n=G();return(B=function(t,r){return n[t-=169]})(t,r)}function G(){var t=["POST","name","aborted","onreadystatechange","warmupMbps","Cannot run with concurrency == 0","isSafariOnIOS","undefined","open","getMs","827184ujMzIZ","emit","Set","string","push","handleTest","loadstart","progress","readyState","929583FhiHiO","1021538Ptqhtx","isArray","40MIIZhM","5zcYrbt","slice","random","2499WzNhnB","target","HTTP POST","length","warmupBytes","duration","call","testServers","Cannot run with no targets","abort","join","timeStamp","Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.","set","warmupDuration","12sKIKGS","https://","1366IhWrYj","isSafari","fetchConcurrency","bytesToMbps","addEventListener","round","upload","Object","error","send","@@iterator","warmup","toFixed","completed","constructor","blob","bestServer","timeout","concat","assign","/?rand=","application/octet-stream","performTesting","options","442714zSeMqe","phase","17802279kNVnhU","idle","handleWarmup","from","loaded","warmupEndTime","size","test","495428pqDgAO"];return(G=function(){return t})()}function H(t,r){var n=B;(null==r||r>t[n(235)])&&(r=t[n(235)]);for(var e=0,a=new Array(r);e<r;e++)a[e]=t[e];return a}!function(t,r){for(var n=B,e=t();;)try{if(325535==parseInt(n(195))/1+-parseInt(n(171))/2*(-parseInt(n(232))/3)+parseInt(n(205))/4*(parseInt(n(229))/5)+parseInt(n(169))/6*(parseInt(n(226))/7)+parseInt(n(216))/8+-parseInt(n(225))/9*(-parseInt(n(228))/10)+-parseInt(n(197))/11)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(G);var U=2e3,Z=[],z=[],J=52428800;function q(){for(var t=B,r=0,n=0;n<z[t(235)];n++)r+=z[n]*J;for(var e=0;e<Z[t(235)];e++)r+=Z[e];return r}function X(t){for(var r=B,n=new Uint8Array(t),e=t;e>0;){var a=e%65536;a=a>0?a:65536;var s=new Uint8Array(a);self.crypto.getRandomValues(s),e-=a,n[r(245)](s,e)}return n}function Y(t,n,e){var a=B,s=this;this[a(194)]=t,this.direction=n,this[a(196)]=a(182),this[a(184)]=!1,Z=[],z=[];var o,i,u,c,f,p,I,v=r[a(215)](),h=(I=this[a(194)][a(239)],function(t){if(Array[B(227)](t))return H(t)}(I)||function(t){var r=B;if(typeof Symbol!==r(213)&&null!=t[Symbol.iterator]||null!=t[r(181)])return Array[r(200)](t)}(I)||function(t,r){var n=B;if(t){if(typeof t===n(219))return H(t,r);var e=Object.prototype.toString[n(238)](t)[n(230)](8,-1);return e===n(178)&&t[n(185)]&&(e=t[n(185)][n(207)]),"Map"===e||e===n(218)?Array[n(200)](t):"Arguments"===e||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/[n(204)](e)?H(t,r):void 0}}(I)||function(){throw new TypeError(B(244))}()).sort();this.blob=new Blob([X(J)],{type:a(192)}),this[a(187)]=e,!this[a(187)]&&(this[a(187)]=h[0]),this[a(199)]=function(t,n){var e=a;t>s[e(194)][e(246)]&&(s[e(246)]=t,s[e(210)]=r[e(174)](n,t),s[e(236)]=n,s[e(202)]=r[e(215)](),s.phase=e(204));var o=r[e(174)](n,t),i=r[e(183)](100*t/(s.options[e(237)]+s[e(194)].warmupDuration),2);s[e(217)](e(223),{bytes_sec:Math[e(176)](n/t*1e3),mbps:o,bytes_total:parseInt(""[e(189)](n),10),duration:Math[e(176)](1e3*t),successes:1,failures:0,target:h[e(242)](","),utc_datetime:(new Date).toISOString(),percentage_complete:i,version:"2",protocol:"HTTP POST"})},this.handleTest=function(t,n,e){var o=a,i=r[o(215)](s[o(202)]),u=n-s[o(236)];if(i>s[o(194)][o(237)])return s[o(217)]("done"),s.phase=o(198),!1;var c=r[o(174)](u,i),f=r[o(183)](100*t/(s[o(194)][o(237)]+s[o(194)].warmupDuration),2),p=c;if(i<1e3){var I=i/1e3;p=c*I+s[o(210)]*(1-I)}return s[o(217)](o(223),{bytes_sec:Math.round(1e3*u/i),mbps:p,bytes_total:parseInt("".concat(u),10),duration:Math[o(176)](1e3*i),successes:1,failures:0,target:h[o(242)](","),utc_datetime:(new Date).toISOString(),percentage_complete:f,version:"2",protocol:o(234),estimated_speed_mbps:e,estimate_size:J,probe_server:s.bestServer,connections:s[o(194)].fetchConcurrency}),!0},this[a(193)]=function(n){var e=a;n<200&&(s.options.fetchConcurrency=1,h=[s.bestServer]);var o=s[e(194)][e(173)];if(o>4&&r[e(172)]()&&(o=4),r[e(212)]()&&(h=[s.bestServer]),0===o)s[e(217)]("error",e(211));else if(0===h.length)s[e(217)](e(179),e(240));else for(var i=0,u=0;u<h[e(235)];u++)for(var c=0;c<o;c++)Q(t,h[u],i,(function(){var t=e,a=r[t(215)](v),o=q();return s[t(196)]===t(182)?(s[t(199)](a,o),!0):s[t(196)]===t(204)?s[t(221)](a,o,n):(s[t(196)],!1)}),(function(){var t=e;s.emit(t(179),"Upload error")}),s[e(186)]),i++,Z[e(220)](0),z[e(220)](0)},o=this.bestServer,i=this.blob,u=function(t){return s[a(193)](t)},c=B,f=new XMLHttpRequest,p=-1,f.upload[c(175)](c(222),(function(t){p=t[c(243)]})),f[c(209)]=function(t){var n=c;if(4===t.target[n(224)]){if(-1===p)return void u(0);var e=t[n(243)]-p,a=r[n(174)](i[n(203)],e);u(a)}},f[c(188)]=1e3,f[c(214)](c(206),c(170)+o+c(191)+Math[c(231)](),!0),f[c(180)](i)}function Q(t,r,n,e,a,s){var o=V,i=new XMLHttpRequest;function u(){i[o(208)]=!0,a()}i[o(188)]=t[o(237)]+t[o(246)]+U,i[o(177)][o(175)]("loadstart",(function(){!e()&&i.abort()})),i[o(177)][o(175)](o(223),(function(t){var r=o;Z[n]=t[r(201)],e()||i[r(241)]()})),i[o(209)]=function(u){var c=o;if(4===u[c(233)][c(224)]){if(i[c(208)])return;z[n]++,Z[n]=0,e()&&Q(t,r,n,e,a,s)}},i[o(177)][o(175)](o(179),u),i[o(177)].addEventListener(o(241),u),i[o(177)][o(175)]("timeout",u);var c=r;i.open(o(206),o(170)+c+o(191)+Math[o(231)](),!0),i[o(208)]=!1,i[o(180)](s)}function K(t,r){var n=$;(null==r||r>t.length)&&(r=t[n(256)]);for(var e=0,a=new Array(r);e<r;e++)a[e]=t[e];return a}function $(t,r){var n=rt();return($=function(t,r){return n[t-=204]})(t,r)}function tt(t){var n,e=$,a=this;if(null!==(n=t[e(207)])&&void 0!==n&&n[e(256)]){var s,o=t[e(241)],i=r[e(251)](t.testServers),u=new WebSocket(e(226)[e(229)](i,":")[e(229)](t.wsTestServerPort,"/ws/0.05")),c=new ArrayBuffer(.125),f=T(),p=[];setTimeout((function(){var t=e;!p[t(256)]&&(console[t(248)]("Connection to "[t(229)](i,t(258))),a.emit("error"),u[t(233)]())}),t[e(236)]),u[e(225)]=function(){s=r[e(230)](),u.send(c)},u[e(238)]=function(t){var n=e;"U0"===t[n(239)]&&(p[n(247)](r[n(230)](s)),--o>0?(s=r[n(230)](),u[n(227)](c)):u.close())},u[e(211)]=function(){var n=e;if(p[n(256)]){var s=p.reduce((function(t,r){return t+r}))/p.length,o=Math[n(210)][n(257)](Math,p),u=p[n(249)]((function(t){return t-o})),c=u[n(237)]((function(t,r){return t+r}))/u.length,I=function(t,r){var n=$;if(0===t.length)return 0;var e,a=0,s=function(t,r){var n=$,e=typeof Symbol!==n(228)&&t[Symbol[n(206)]]||t[n(224)];if(!e){if(Array.isArray(t)||(e=function(t,r){var n=$;if(t){if(typeof t===n(244))return K(t,r);var e=Object.prototype[n(252)][n(208)](t)[n(212)](8,-1);return e===n(246)&&t[n(215)]&&(e=t[n(215)].name),e===n(204)||e===n(250)?Array.from(t):e===n(253)||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/[n(231)](e)?K(t,r):void 0}}(t))||r&&t&&typeof t.length===n(213)){e&&(t=e);var a=0,s=function(){};return{s:s,n:function(){return a>=t.length?{done:!0}:{done:!1,value:t[a++]}},e:function(t){throw t},f:s}}throw new TypeError(n(222))}var o,i=!0,u=!1;return{s:function(){e=e.call(t)},n:function(){var t=n,r=e.next();return i=r[t(242)],r},e:function(t){u=!0,o=t},f:function(){var t=n;try{i||null==e[t(223)]||e[t(223)]()}finally{if(u)throw o}}}}(t);try{for(s.s();!(e=s.n())[n(242)];){var o=e.value;a+=Math[n(217)](o-r)}}catch(t){s.e(t)}finally{s.f()}return a/t.length}(p,s);a[n(232)](n(242),{round_trip_time:Math[n(234)](1e3*s),jitter:Math[n(234)](1e3*I),jitterLegacy:Math[n(234)](1e3*c),minLatency:o,duration:Math[n(234)](1e3*r[n(230)](f)),successes:t.packets,failures:0,target:i,utc_datetime:(new Date)[n(240)](),percentage_complete:100,version:"2"})}},u[e(243)]=function(t){var r=e;return a[r(232)](r(248),t)}}else this[e(232)](e(248),e(214))}function rt(){var t=["packets","done","onerror","string","114075xojXoM","Object","push","error","map","Set","randomArrayElement","toString","Arguments","2229DCydMI","7sFVLzp","length","apply"," timed out","Map","634JPSNDv","iterator","testServers","call","44avsnxO","min","onclose","slice","number","Latency: no server","constructor","1958104NiMdpX","abs","73649ckgqOL","5021224gTLvCo","102BmPDUO","4713543YoksXO","Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.","return","@@iterator","onopen","wss://","send","undefined","concat","getMs","test","emit","close","round","1302970Kycxtz","timeout","reduce","onmessage","data","toISOString"];return(rt=function(){return t})()}function nt(t){var r=ot;return(nt=r(432)==typeof Symbol&&"symbol"==typeof Symbol[r(492)]?function(t){return typeof t}:function(t){var n=r;return t&&"function"==typeof Symbol&&t[n(486)]===Symbol&&t!==Symbol[n(488)]?n(472):typeof t})(t)}function et(t,r){var n=ot,e=Object[n(437)](t);if(Object[n(463)]){var a=Object[n(463)](t);r&&(a=a.filter((function(r){return Object[n(487)](t,r).enumerable}))),e.push[n(452)](e,a)}return e}function at(t){for(var r=ot,n=1;n<arguments[r(450)];n++){var e=null!=arguments[n]?arguments[n]:{};n%2?et(Object(e),!0)[r(434)]((function(r){var n,a,s,o,i,u;s=t,o=r,i=e[r],u=ot,n=ot,a=function(t,r){var n=ot;if(nt(t)!==n(451)||null===t)return t;var e=t[Symbol[n(439)]];if(void 0!==e){var a=e[n(449)](t,r||n(471));if(nt(a)!==n(451))return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return(r===n(464)?String:Number)(t)}(o,"string"),(o=nt(a)===n(472)?a:String(a))in s?Object[u(484)](s,o,{value:i,enumerable:!0,configurable:!0,writable:!0}):s[o]=i})):Object[r(475)]?Object[r(465)](t,Object[r(475)](e)):et(Object(e))[r(434)]((function(n){var a=r;Object[a(484)](t,n,Object[a(487)](e,n))}))}return t}function st(){var t=["then","1255671ayPUti","random","setRequestHeader","ingestionApi","75Pnxwyp","55zJpPfr","call","length","object","apply","isMobileDevice","agentId","78972bIQVoU","getItem","emit","responseText","6flFHui","userAgent","localStorage","Content-type","getOwnPropertySymbols","string","defineProperties","application/json","device","381829PgTEMt","/register/web","stringify","default","symbol","model","ingestion","getOwnPropertyDescriptors","readyState","/ingest/web","9656yHoYUX","POST","open","16OzCugp","parse","toString","defineProperty","status","constructor","getOwnPropertyDescriptor","prototype","manufacturer","test-id","setItem","iterator","panelId","concat","getTimezoneOffset","176588XOmszq","send","function","276970xvmBTO","forEach","onreadystatechange","isLocalStorageSupported","keys","12778dBMoyU","toPrimitive","sk-agent-id","test_id"];return(st=function(){return t})()}function ot(t,r){var n=st();return(ot=function(t,r){return n[t-=430]})(t,r)}function it(t,r){var n=ut();return(it=function(t,r){return n[t-=290]})(t,r)}function ut(){var t=["2035935CsRSCR","364015EGtJmC","userAgent","12zwNmmm"," Edge/","698570OAeKWd","AppleWebKit","Safari","193730BsPfkS","includes","166416kmCxKn","2801640mBFOlg","13003353CUAnlB","Firefox","252BEBvAh"];return(ut=function(){return t})()}Object[V(190)](Y.prototype,t),function(t,r){for(var n=$,e=t();;)try{if(357051==parseInt(n(218))/1+parseInt(n(205))/2*(-parseInt(n(254))/3)+parseInt(n(216))/4+parseInt(n(245))/5*(-parseInt(n(220))/6)+-parseInt(n(255))/7*(parseInt(n(219))/8)+parseInt(n(221))/9+parseInt(n(235))/10*(parseInt(n(209))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(rt),Object.assign(tt.prototype,t),function(t,r){for(var n=ot,e=t();;)try{if(104641==parseInt(n(478))/1+-parseInt(n(438))/2+parseInt(n(459))/3*(-parseInt(n(430))/4)+parseInt(n(447))/5*(-parseInt(n(455))/6)+-parseInt(n(468))/7*(-parseInt(n(481))/8)+parseInt(n(443))/9+-parseInt(n(433))/10*(-parseInt(n(448))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(st),function(t,r){for(var n=it,e=t();;)try{if(442502==-parseInt(n(298))/1+-parseInt(n(290))/2+-parseInt(n(297))/3+parseInt(n(300))/4*(parseInt(n(302))/5)+parseInt(n(293))/6+-parseInt(n(296))/7*(parseInt(n(292))/8)+parseInt(n(294))/9)break;e.push(e.shift())}catch(t){e.push(e.shift())}}(ut);var ct,ft,pt,It=bt;function vt(t){var r=bt;return(vt=r(433)==typeof Symbol&&r(368)==typeof Symbol[r(363)]?function(t){return typeof t}:function(t){var n=r;return t&&n(433)==typeof Symbol&&t[n(440)]===Symbol&&t!==Symbol[n(345)]?n(368):typeof t})(t)}function ht(){var t=bt;ht=function(){return n};var r,n={},e=Object[t(345)],a=e[t(390)],s=Object[t(378)]||function(r,n,e){var a=t;r[n]=e[a(330)]},o=t(433)==typeof Symbol?Symbol:{},i=o.iterator||t(418),u=o[t(432)]||t(449),c=o[t(331)]||t(427);function f(r,n,e){return Object[t(378)](r,n,{value:e,enumerable:!0,configurable:!0,writable:!0}),r[n]}try{f({},"")}catch(t){f=function(t,r,n){return t[r]=n}}function p(n,e,a,o){var i,u,c,f,p=e&&e[t(345)]instanceof m?e:m,b=Object.create(p.prototype),g=new P(o||[]);return s(b,"_invoke",{value:(i=n,u=a,c=g,f=v,function(t,n){var e=bt;if(f===l)throw new Error("Generator is already running");if(f===y){if(e(463)===t)throw n;return{value:r,done:!0}}for(c[e(384)]=t,c.arg=n;;){var a=c[e(451)];if(a){var s=A(a,c);if(s){if(s===d)continue;return s}}if(e(460)===c[e(384)])c[e(446)]=c._sent=c[e(367)];else if(e(463)===c.method){if(f===v)throw f=y,c[e(367)];c[e(401)](c[e(367)])}else"return"===c[e(384)]&&c.abrupt("return",c[e(367)]);f=l;var o=I(i,u,c);if(e(438)===o[e(388)]){if(f=c[e(389)]?y:h,o[e(367)]===d)continue;return{value:o[e(367)],done:c[e(389)]}}e(463)===o[e(388)]&&(f=y,c.method=e(463),c.arg=o[e(367)])}})}),b}function I(r,n,e){var a=t;try{return{type:a(438),arg:r[a(426)](n,e)}}catch(t){return{type:a(463),arg:t}}}n.wrap=p;var v=t(358),h="suspendedYield",l=t(348),y=t(347),d={};function m(){}function b(){}function g(){}var S={};f(S,i,(function(){return this}));var w=Object[t(442)],k=w&&w(w(E([])));k&&k!==e&&a[t(426)](k,i)&&(S=k);var O=g[t(345)]=m[t(345)]=Object[t(362)](S);function x(r){var n=t;[n(460),n(463),n(351)][n(407)]((function(t){f(r,t,(function(r){return this._invoke(t,r)}))}))}function j(r,n){var e,o=t;function i(t,e,s,o){var u=bt,c=I(r[t],r,e);if("throw"!==c[u(388)]){var f=c[u(367)],p=f[u(330)];return p&&"object"==vt(p)&&a[u(426)](p,u(415))?n[u(370)](p[u(415)]).then((function(t){i(u(460),t,s,o)}),(function(t){i("throw",t,s,o)})):n[u(370)](p)[u(344)]((function(t){f[u(330)]=t,s(f)}),(function(t){return i(u(463),t,s,o)}))}o(c[u(367)])}s(this,o(421),{value:function(t,r){function a(){return new n((function(n,e){i(t,r,n,e)}))}return e=e?e[o(344)](a,a):a()}})}function A(n,e){var a=t,s=e[a(384)],o=n[a(363)][s];if(o===r)return e.delegate=null,a(463)===s&&n[a(363)][a(351)]&&(e[a(384)]="return",e.arg=r,A(n,e),a(463)===e[a(384)])||a(351)!==s&&(e[a(384)]=a(463),e[a(367)]=new TypeError(a(436)+s+"' method")),d;var i=I(o,n.iterator,e.arg);if(a(463)===i.type)return e[a(384)]=a(463),e[a(367)]=i.arg,e[a(451)]=null,d;var u=i.arg;return u?u[a(389)]?(e[n[a(366)]]=u[a(330)],e.next=n[a(425)],a(351)!==e.method&&(e[a(384)]=a(460),e.arg=r),e[a(451)]=null,d):u:(e[a(384)]=a(463),e.arg=new TypeError("iterator result is not an object"),e.delegate=null,d)}function T(r){var n=t,e={tryLoc:r[0]};1 in r&&(e[n(417)]=r[1]),2 in r&&(e[n(374)]=r[2],e.afterLoc=r[3]),this.tryEntries[n(429)](e)}function M(r){var n=t,e=r[n(380)]||{};e.type=n(438),delete e[n(367)],r[n(380)]=e}function P(r){var n=t;this[n(338)]=[{tryLoc:n(471)}],r[n(407)](T,this),this[n(352)](!0)}function E(n){var e=t;if(n||""===n){var s=n[i];if(s)return s[e(426)](n);if("function"==typeof n[e(460)])return n;if(!isNaN(n[e(385)])){var o=-1,u=function t(){for(var s=e;++o<n[s(385)];)if(a[s(426)](n,o))return t[s(330)]=n[o],t.done=!1,t;return t[s(330)]=r,t[s(389)]=!0,t};return u[e(460)]=u}}throw new TypeError(vt(n)+e(399))}return b[t(345)]=g,s(O,t(440),{value:g,configurable:!0}),s(g,"constructor",{value:b,configurable:!0}),b[t(409)]=f(g,c,t(381)),n[t(430)]=function(r){var n=t,e=n(433)==typeof r&&r[n(440)];return!!e&&(e===b||n(381)===(e[n(409)]||e[n(372)]))},n[t(458)]=function(r){var n=t;return Object[n(369)]?Object[n(369)](r,g):(r[n(391)]=g,f(r,c,n(381))),r[n(345)]=Object[n(362)](O),r},n[t(376)]=function(t){return{__await:t}},x(j[t(345)]),f(j[t(345)],u,(function(){return this})),n.AsyncIterator=j,n[t(455)]=function(r,e,a,s,o){var i=t;void 0===o&&(o=Promise);var u=new j(p(r,e,a,s),o);return n[i(430)](e)?u:u[i(460)]().then((function(t){var r=i;return t.done?t[r(330)]:u[r(460)]()}))},x(O),f(O,c,t(346)),f(O,i,(function(){return this})),f(O,t(423),(function(){return t(435)})),n[t(360)]=function(r){var n=t,e=Object(r),a=[];for(var s in e)a[n(429)](s);return a.reverse(),function t(){for(var r=n;a[r(385)];){var s=a[r(403)]();if(s in e)return t.value=s,t[r(389)]=!1,t}return t[r(389)]=!0,t}},n.values=E,P.prototype={constructor:P,reset:function(n){var e=t;if(this[e(472)]=0,this.next=0,this[e(446)]=this[e(395)]=r,this[e(389)]=!1,this.delegate=null,this[e(384)]=e(460),this[e(367)]=r,this[e(338)][e(407)](M),!n)for(var s in this)"t"===s[e(454)](0)&&a[e(426)](this,s)&&!isNaN(+s.slice(1))&&(this[s]=r)},stop:function(){var r=t;this[r(389)]=!0;var n=this.tryEntries[0][r(380)];if(r(463)===n[r(388)])throw n[r(367)];return this[r(412)]},dispatchException:function(n){var e=t;if(this[e(389)])throw n;var s=this;function o(t,a){var o=e;return c[o(388)]=o(463),c[o(367)]=n,s[o(460)]=t,a&&(s[o(384)]="next",s[o(367)]=r),!!a}for(var i=this[e(338)][e(385)]-1;i>=0;--i){var u=this.tryEntries[i],c=u.completion;if(e(471)===u[e(457)])return o("end");if(u[e(457)]<=this[e(472)]){var f=a[e(426)](u,e(417)),p=a.call(u,e(374));if(f&&p){if(this[e(472)]<u[e(417)])return o(u.catchLoc,!0);if(this[e(472)]<u[e(374)])return o(u.finallyLoc)}else if(f){if(this[e(472)]<u.catchLoc)return o(u[e(417)],!0)}else{if(!p)throw new Error("try statement without catch or finally");if(this.prev<u.finallyLoc)return o(u[e(374)])}}}},abrupt:function(r,n){for(var e=t,s=this.tryEntries[e(385)]-1;s>=0;--s){var o=this[e(338)][s];if(o.tryLoc<=this[e(472)]&&a[e(426)](o,e(374))&&this[e(472)]<o[e(374)]){var i=o;break}}i&&(e(465)===r||e(473)===r)&&i[e(457)]<=n&&n<=i[e(374)]&&(i=null);var u=i?i[e(380)]:{};return u[e(388)]=r,u[e(367)]=n,i?(this.method=e(460),this[e(460)]=i[e(374)],d):this.complete(u)},complete:function(r,n){var e=t;if("throw"===r[e(388)])throw r[e(367)];return e(465)===r[e(388)]||e(473)===r[e(388)]?this[e(460)]=r.arg:"return"===r[e(388)]?(this[e(412)]=this.arg=r[e(367)],this[e(384)]=e(351),this[e(460)]=e(404)):e(438)===r[e(388)]&&n&&(this.next=n),d},finish:function(r){for(var n=t,e=this.tryEntries[n(385)]-1;e>=0;--e){var a=this[n(338)][e];if(a.finallyLoc===r)return this[n(462)](a[n(380)],a.afterLoc),M(a),d}},catch:function(r){for(var n=t,e=this.tryEntries[n(385)]-1;e>=0;--e){var a=this[n(338)][e];if(a.tryLoc===r){var s=a[n(380)];if(n(463)===s[n(388)]){var o=s[n(367)];M(a)}return o}}throw new Error(n(469))},delegateYield:function(n,e,a){var s=t;return this[s(451)]={iterator:E(n),resultName:e,nextLoc:a},s(460)===this[s(384)]&&(this[s(367)]=r),d}},n}function lt(){var t=["DURATION_TOO_SHORT","tryEntries","_runDownload","minLatency","error","hostname","https://ingestion-api.samknows.com","then","prototype","Generator","completed","executing","982053qtvMEp","_getTargets","return","reset","abrupt","wrap","inProgress","catch","map","suspendedStart","946752mQiHhX","keys","filter","create","iterator","min","run","resultName","arg","symbol","setPrototypeOf","resolve","Arguments","name","_findTestServer","finallyLoc","320134oSkFuj","awrap","6944110ACLVzG","defineProperty",'Test "',"completion","GeneratorFunction","from","assign","method","length","targetsApi","duration","type","done","hasOwnProperty","__proto__","Map","warning","sort","_sent","emit","NO_TEST_SERVER","runSpeedTest"," is not iterable","json","dispatchException","apply","pop","end","string","DISTANCE_LARGE","forEach","concat","displayName","test","_optionsFor","rval","slice","_findFastestServer","__await","_runUpload","catchLoc","@@iterator","testServers","Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.","_invoke","test-done","toString","download","nextLoc","call","@@toStringTag","target","push","isGeneratorFunction","stop","asyncIterator","function","options","[object Generator]","The iterator does not provide a '","6MozSfO","normal","_runLatency","constructor",'" is not supported. We only support these tests: ',"getPrototypeOf","bestServer","percentage_complete","global","sent","NO_TEST_SERVERS","_setupSpeedTest","@@asyncIterator","fastestServer","delegate","DOWNLOAD_INACCURATE","isArray","charAt","async","results","tryLoc","mark","1336671EAbmRD","next","https://speedtest-api.samknows.com/targets","complete","throw","166vLNAfF","break","progress","8UxiRTg","progress-warmup","illegal catch attempt","upload","root","prev","continue","5493aVQtWN","value","toStringTag","latency","mbps","11rdeejl","1050815zFTseu","distance"];return(lt=function(){return t})()}function yt(t,r){var n=bt;(null==r||r>t[n(385)])&&(r=t[n(385)]);for(var e=0,a=new Array(r);e<r;e++)a[e]=t[e];return a}function dt(t,r,n,e,a,s,o){var i=bt;try{var u=t[s](o),c=u[i(330)]}catch(t){return void n(t)}u[i(389)]?r(c):Promise[i(370)](c)[i(344)](e,a)}function mt(t){return function(){var r=this,n=arguments;return new Promise((function(e,a){var s=bt,o=t[s(402)](r,n);function i(t){dt(o,e,a,i,u,s(460),t)}function u(t){dt(o,e,a,i,u,"throw",t)}i(void 0)}))}}function bt(t,r){var n=lt();return(bt=function(t,r){return n[t-=330]})(t,r)}function gt(){var t=arguments[It(385)]>0&&void 0!==arguments[0]?arguments[0]:{};this._setupSpeedTest(t)}!function(t,r){for(var n=bt,e=t();;)try{if(161235==-parseInt(n(375))/1+-parseInt(n(464))/2*(-parseInt(n(474))/3)+-parseInt(n(359))/4+-parseInt(n(335))/5+parseInt(n(437))/6*(parseInt(n(459))/7)+parseInt(n(467))/8*(-parseInt(n(349))/9)+-parseInt(n(377))/10*(-parseInt(n(334))/11))break;e.push(e.shift())}catch(t){e.push(e.shift())}}(lt),gt[It(345)][It(448)]=function(){var t=It,r=arguments[t(385)]>0&&void 0!==arguments[0]?arguments[0]:{};this.options=v({global:{targetsApi:t(461),targetSet:void 0,wsTestServerPort:443,fetchConcurrency:6,warmupDuration:4e3,useTestServersInParallel:!1},latency:{packets:10,timeout:5e3},download:{duration:1e4},upload:{duration:1e4},ingestion:{ingestionApi:t(343),panelId:void 0}},r),this[t(456)]={inProgress:void 0,latency:void 0,download:void 0,upload:void 0}},gt[It(345)][It(373)]=function(){var t=It,r=this,n=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=this[t(434)][t(445)].useTestServersInParallel;return this._getTargets()[t(344)]((function(){return r[t(414)](e,n)}))},gt[It(345)][It(414)]=function(t,r){var n=It,e=this;return r&&(this[n(456)].inProgress=n(332),this[n(456)][n(332)]={inProgress:!0}),this[n(411)](n(332))[n(419)].reduce((function(t,r){return t[n(344)]((function(t){return new Promise((function(n){var a,s=bt;null!==(a=r)&&void 0!==a&&a[s(342)]&&(r=r.hostname),new tt(e._optionsFor(s(332),{testServers:[r]})).on(s(389),(function(r){return n(t[s(408)](r))})).on(s(341),(function(){return n(t[s(408)]({target:r,successes:0,failures:1}))}))}))}))}),Promise.resolve([]))[n(344)]((function(a){var s,o=n,i=a[o(361)]((function(t){return t.successes}))[o(394)]((function(t,r){var n=o;return t.minLatency-r[n(340)]}))[0];if(!i)throw new Error(o(397));t?e.bestServer=i[o(428)]:e[o(434)].global[o(419)]=[i[o(428)]],null!==(s=e.testServers)&&void 0!==s&&s[o(385)]&&(e.results[o(450)]=e[o(419)].find((function(t){return t[o(342)]===i.target}))),r&&(e[o(456)][o(332)]=i,e[o(396)]("progress",e.results),e[o(396)](o(422),o(332),e[o(456)]))}))},gt[It(345)][It(350)]=(ft=It,pt=mt(ht()[ft(458)]((function t(){var r,n,e,a,s,o,i=ft;return ht()[i(354)]((function(t){for(var u=i;;)switch(t[u(472)]=t.next){case 0:if(null===(r=this.options[u(445)][u(419)])||void 0===r||!r[u(385)]){t[u(460)]=2;break}return t[u(353)](u(351),Promise[u(370)]());case 2:return n=this[u(434)][u(445)].targetSet,e=n?"?target_set="[u(408)](n):"",a=""[u(408)](this[u(434)][u(445)][u(386)])[u(408)](e),t.next=7,fetch(a);case 7:return s=t[u(446)],t[u(460)]=10,s[u(400)]();case 10:if(0!==(o=t[u(446)]).length){t[u(460)]=15;break}throw new Error(u(447));case 15:Math[u(364)][u(402)](Math,function(t){if(Array[bt(453)](t))return yt(t)}(c=o[u(357)]((function(t){return t[u(336)]})))||function(t){var r=bt;if("undefined"!=typeof Symbol&&null!=t[Symbol[r(363)]]||null!=t[r(418)])return Array.from(t)}(c)||function(t,r){var n=bt;if(t){if(typeof t===n(405))return yt(t,r);var e=Object[n(345)][n(423)][n(426)](t)[n(413)](8,-1);return"Object"===e&&t[n(440)]&&(e=t.constructor[n(372)]),e===n(392)||"Set"===e?Array[n(382)](t):e===n(371)||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/[n(410)](e)?yt(t,r):void 0}}(c)||function(){throw new TypeError(bt(420))}())>1500&&this[u(396)](u(393),u(406));case 17:this.options.global.testServers=o[u(357)]((function(t){return t[u(342)]}));case 18:case u(404):return t[u(431)]()}var c}),t,this)}))),function(){return pt[ft(402)](this,arguments)}),gt[It(345)][It(439)]=function(){var t=this;return new Promise((function(r,n){var e=bt;t[e(456)].inProgress=e(332),t[e(456)].latency={inProgress:!0};var a=t._optionsFor(e(332));new tt(t._optionsFor(e(332),a)).on(e(389),(function(n){var a=e;t[a(456)][a(332)]=n,t[a(396)]("progress",t[a(456)]),t.emit("test-done","latency",t[a(456)]),r()})).on(e(341),(function(){return n()}))}))},gt[It(345)][It(339)]=function(){var t=It,r=this,n=arguments[t(385)]>0&&void 0!==arguments[0]?arguments[0]:{};return new Promise((function(e,a){var s=t;r[s(456)][s(355)]="download",r.results[s(424)]={},new D(n=r[s(411)](s(424),n),s(424)).on(s(466),(function(t){var n=s;r[n(456)][n(424)]=t,r.emit(n(466),r[n(456)])})).on(s(468),(function(t){var n=s,e=Object[n(383)]({},r[n(456)],{download:t});r[n(396)]("progress-warmup",e)})).on(s(389),(function(){var t,o,i,u,c=s;r[c(456)][c(424)][c(387)]<n.duration/2?a(new Error(c(337))):(r[c(456)][c(424)][c(444)]=100,r.emit("test-done",c(424),r[c(456)]),t=r[c(456)][c(424)][c(333)],o=it,u=(i=navigator[o(299)])[o(291)]("Windows NT"),(i.includes(o(303))?u?i.includes(o(301))?t>800:t>400:i.includes(o(304))?t>300:t>800:(i.includes(o(295)),t>800))&&r[c(396)]("warning",c(452)),e())})).on(s(341),a)}))},gt[It(345)][It(416)]=function(){var t=It,r=this,n=arguments[t(385)]>0&&void 0!==arguments[0]?arguments[0]:{};return new Promise((function(e,a){var s=t;r[s(456)][s(355)]=s(470),r[s(456)][s(470)]={},new Y(n=r[s(411)](s(470),n),s(470),r[s(443)]).on(s(466),(function(t){var n=s;r[n(456)][n(470)]=t,r[n(396)](n(466),r[n(456)])})).on(s(468),(function(t){var n=s,e=Object[n(383)]({},r.results,{upload:t});r.emit(n(468),e)})).on("done",(function(){var t=s;r.results[t(470)][t(387)]<n[t(387)]/2?a(new Error(t(337))):(r.results.upload.percentage_complete=100,r[t(396)](t(422),"upload",r[t(456)]),e())})).on(s(341),a)}))},gt[It(345)][It(411)]=function(t,r){var n=It;return Object[n(383)]({},this[n(434)][n(445)],this[n(434)][t],r)},gt[It(345)][It(365)]=(ct=mt(ht().mark((function t(r){var n,e,a,s,o=bt,i=this,u=arguments;return ht()[o(354)]((function(t){for(var c=o;;)switch(t[c(472)]=t[c(460)]){case 0:if(e=u.length>1&&void 0!==u[1]?u[1]:{},-1===(a=[c(332),"download",c(470)]).indexOf(r)&&this.emit("error",new Error(c(379).concat(r,c(441)).concat(a.join()))),s={download:this[c(339)],upload:this[c(416)],latency:this._runLatency},null!==(n=this[c(434)][c(445)][c(419)])&&void 0!==n&&n[c(385)]){t[c(460)]=7;break}return t[c(460)]=7,this[c(373)]();case 7:return t[c(353)]("return",s[r].call(this,e)[c(344)]((function(){var t=c;delete i[t(456)][t(355)]}))[c(356)]((function(t){var r=c;console[r(341)](t),i[r(396)]("error",t)})));case 8:case"end":return t.stop()}}),t,this)}))),function(t){return ct[bt(402)](this,arguments)}),gt[It(345)][It(398)]=function(){var t=It,n=this;return this._findTestServer(!0)[t(344)]((function(){return n[t(339)]()}))[t(344)]((function(){return n[t(416)]()}))[t(344)]((function(){var e,a,s,o,i,u,c,f=t;return delete n[f(456)][f(355)],n[f(396)](f(389),n[f(456)]),e=n[f(456)],u=ot,c=(a=n)._optionsFor(u(474)),(s=c,o=ot,i=void 0,E()&&(i=window[o(461)][o(456)](o(440))),i?Promise.resolve(i):new Promise((function(t){var n,e=o,a=new XMLHttpRequest;a[e(480)](e(479),""[e(494)](s[e(446)],e(469))),a[e(445)](e(462),e(466)),a.onreadystatechange=function(){var n=e;if(4===a.readyState&&200===a[n(485)]){var s=JSON[n(482)](a[n(458)]);r[n(436)]()&&window[n(461)][n(491)](n(440),s[n(454)]),t(s[n(454)])}},a[e(431)](JSON[e(470)]({panelId:s[e(493)],browserId:(n=ot,Math.round(1e16*Math[n(444)]())[n(483)](16)),userAgent:navigator[e(460)]}))})))[u(442)]((function(t){return function(t,r,n){var e=ot,a={};n[e(467)]&&n[e(467)][e(453)]&&(a={device_model:n.device[e(473)],device_name:n.device.name,device_manufacturer:n.device[e(489)]});var s={device_environment:at({user_agent:navigator[e(460)],timezone_offset:-1*(new Date)[e(495)]()},a),tests:r};return new Promise((function(r,a){var o=e,i=new XMLHttpRequest;i.open("POST",""[o(494)](n.ingestionApi,o(477)),!0),i[o(445)](o(462),o(466)),i[o(435)]=function(){var t=o;if(4===i[t(476)]&&200===i.status){var n=JSON[t(482)](i[t(458)]);n.success?r(n[t(441)]):a()}},i[o(431)](JSON[o(470)]({version:1,agentId:t,data:s}))}))}(t,e,c)}))[u(442)]((function(t){var r=u;return a[r(457)](r(490),t),t}))}))[t(356)]((function(r){var e=t;console[e(341)](r),n.emit(e(341),r)}))},Object.assign(gt[It(345)],t)}(),e.default}()}));

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getResult;
	function formatNumber(number) {
	  if (number > 1e3) {
	    return Math.round(number);
	  }
	
	  if (number > 1) {
	    return number.toPrecision(3);
	  }
	
	  return number.toFixed(2);
	}
	
	function getResult(results) {
	  var test = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : results.inProgress;
	
	  if (!test) {
	    return { val: undefined, unit: undefined };
	  }
	
	  if (test === 'jitter') {
	    if (results.latency.jitter >= 1e6) {
	      return {
	        val: formatNumber(results.latency.jitter / 1e6),
	        unit: 's'
	      };
	    }
	    return {
	      val: formatNumber(results.latency.jitter / 1e3),
	      unit: 'ms'
	    };
	  }
	
	  if (test === 'latency') {
	    if (results.latency.round_trip_time >= 1e6) {
	      return {
	        val: formatNumber(results.latency.round_trip_time / 1e6),
	        unit: 's'
	      };
	    }
	    return {
	      val: formatNumber(results.latency.round_trip_time / 1e3),
	      unit: 'ms'
	    };
	  }
	
	  var val = results[test].mbps || 0;
	  var unit = 'mbps';
	
	  if (val < 1) {
	    val *= 1024;
	    unit = 'kbps';
	  }
	
	  return { val: formatNumber(val), unit: unit };
	}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _qs = __webpack_require__(24);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var langs = void 0;
	
	if (navigator.languages) {
	  langs = navigator.languages.slice();
	} else {
	  langs = [navigator.language || navigator.userLanguage];
	}
	
	if ((0, _qs2.default)('lang')) {
	  langs.unshift((0, _qs2.default)('lang'));
	}
	
	var langFiles = {
	  'en-GB': __webpack_require__(204),
	  'ar-SA': __webpack_require__(203),
	  'zh-CN': __webpack_require__(205),
	  'zh-HK': __webpack_require__(206)
	};
	
	var langFile = langs.map(function (lang) {
	  return langFiles[lang];
	}).filter(function (file) {
	  return file;
	})[0];
	
	var i18n = langFile || langFiles['en-GB'];
	exports.default = i18n;
	
	[].slice.call(document.querySelectorAll('[data-i18n]')).forEach(function (el) {
	  el.textContent = i18n[el.dataset.i18n];
	});

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(162), __esModule: true };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(73);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(154);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(152);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(207);


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(26);
	var TAG = __webpack_require__(6)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(5).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(26);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(49);
	var $export = __webpack_require__(9);
	var redefine = __webpack_require__(183);
	var hide = __webpack_require__(15);
	var Iterators = __webpack_require__(20);
	var $iterCreate = __webpack_require__(171);
	var setToStringTag = __webpack_require__(52);
	var getPrototypeOf = __webpack_require__(178);
	var ITERATOR = __webpack_require__(6)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(12);
	var dPs = __webpack_require__(176);
	var enumBugKeys = __webpack_require__(79);
	var IE_PROTO = __webpack_require__(53)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(48)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(80).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(19);
	var newPromiseCapability = __webpack_require__(50);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(4);
	var global = __webpack_require__(5);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(49) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(12);
	var aFunction = __webpack_require__(25);
	var SPECIES = __webpack_require__(6)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(27);
	var invoke = __webpack_require__(168);
	var html = __webpack_require__(80);
	var cel = __webpack_require__(48);
	var global = __webpack_require__(5);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(26)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(54);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var core_1 = __webpack_require__(3);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(1);
	var eventbuilder_1 = __webpack_require__(30);
	var transports_1 = __webpack_require__(59);
	/**
	 * The Sentry Browser SDK Backend.
	 * @hidden
	 */
	var BrowserBackend = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserBackend, _super);
	    function BrowserBackend() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromException = function (exception, hint) {
	        return eventbuilder_1.eventFromException(this._options, exception, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
	        if (level === void 0) { level = types_1.Severity.Info; }
	        return eventbuilder_1.eventFromMessage(this._options, message, level, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype._setupTransport = function () {
	        if (!this._options.dsn) {
	            // We return the noop transport here in case there is no Dsn.
	            return _super.prototype._setupTransport.call(this);
	        }
	        var transportOptions = tslib_1.__assign(tslib_1.__assign({}, this._options.transportOptions), { dsn: this._options.dsn });
	        if (this._options.transport) {
	            return new this._options.transport(transportOptions);
	        }
	        if (utils_1.supportsFetch()) {
	            return new transports_1.FetchTransport(transportOptions);
	        }
	        return new transports_1.XHRTransport(transportOptions);
	    };
	    return BrowserBackend;
	}(core_1.BaseBackend));
	exports.BrowserBackend = BrowserBackend;
	//# sourceMappingURL=backend.js.map

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(8);
	exports.Severity = types_1.Severity;
	exports.Status = types_1.Status;
	var core_1 = __webpack_require__(3);
	exports.addGlobalEventProcessor = core_1.addGlobalEventProcessor;
	exports.addBreadcrumb = core_1.addBreadcrumb;
	exports.captureException = core_1.captureException;
	exports.captureEvent = core_1.captureEvent;
	exports.captureMessage = core_1.captureMessage;
	exports.configureScope = core_1.configureScope;
	exports.getHubFromCarrier = core_1.getHubFromCarrier;
	exports.getCurrentHub = core_1.getCurrentHub;
	exports.Hub = core_1.Hub;
	exports.makeMain = core_1.makeMain;
	exports.Scope = core_1.Scope;
	exports.startTransaction = core_1.startTransaction;
	exports.setContext = core_1.setContext;
	exports.setExtra = core_1.setExtra;
	exports.setExtras = core_1.setExtras;
	exports.setTag = core_1.setTag;
	exports.setTags = core_1.setTags;
	exports.setUser = core_1.setUser;
	exports.withScope = core_1.withScope;
	var client_1 = __webpack_require__(57);
	exports.BrowserClient = client_1.BrowserClient;
	var helpers_1 = __webpack_require__(17);
	exports.injectReportDialog = helpers_1.injectReportDialog;
	var eventbuilder_1 = __webpack_require__(30);
	exports.eventFromException = eventbuilder_1.eventFromException;
	exports.eventFromMessage = eventbuilder_1.eventFromMessage;
	var sdk_1 = __webpack_require__(101);
	exports.defaultIntegrations = sdk_1.defaultIntegrations;
	exports.forceLoad = sdk_1.forceLoad;
	exports.init = sdk_1.init;
	exports.lastEventId = sdk_1.lastEventId;
	exports.onLoad = sdk_1.onLoad;
	exports.showReportDialog = sdk_1.showReportDialog;
	exports.flush = sdk_1.flush;
	exports.close = sdk_1.close;
	exports.wrap = sdk_1.wrap;
	var version_1 = __webpack_require__(60);
	exports.SDK_NAME = version_1.SDK_NAME;
	exports.SDK_VERSION = version_1.SDK_VERSION;
	//# sourceMappingURL=exports.js.map

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	tslib_1.__exportStar(__webpack_require__(94), exports);
	var core_1 = __webpack_require__(3);
	var utils_1 = __webpack_require__(1);
	var BrowserIntegrations = __webpack_require__(31);
	var Transports = __webpack_require__(59);
	exports.Transports = Transports;
	var windowIntegrations = {};
	// This block is needed to add compatibility with the integrations packages when used with a CDN
	var _window = utils_1.getGlobalObject();
	if (_window.Sentry && _window.Sentry.Integrations) {
	    windowIntegrations = _window.Sentry.Integrations;
	}
	var INTEGRATIONS = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, windowIntegrations), core_1.Integrations), BrowserIntegrations);
	exports.Integrations = INTEGRATIONS;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable max-lines */
	var core_1 = __webpack_require__(3);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(1);
	/**
	 * Default Breadcrumbs instrumentations
	 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
	 */
	var Breadcrumbs = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Breadcrumbs(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = Breadcrumbs.id;
	        this._options = tslib_1.__assign({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
	    }
	    /**
	     * Create a breadcrumb of `sentry` from the events themselves
	     */
	    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
	        if (!this._options.sentry) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
	            event_id: event.event_id,
	            level: event.level,
	            message: utils_1.getEventDescription(event),
	        }, {
	            event: event,
	        });
	    };
	    /**
	     * Instrument browser built-ins w/ breadcrumb capturing
	     *  - Console API
	     *  - DOM API (click/typing)
	     *  - XMLHttpRequest API
	     *  - Fetch API
	     *  - History API
	     */
	    Breadcrumbs.prototype.setupOnce = function () {
	        var _this = this;
	        if (this._options.console) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._consoleBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'console',
	            });
	        }
	        if (this._options.dom) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._domBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'dom',
	            });
	        }
	        if (this._options.xhr) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._xhrBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'xhr',
	            });
	        }
	        if (this._options.fetch) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._fetchBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'fetch',
	            });
	        }
	        if (this._options.history) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._historyBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'history',
	            });
	        }
	    };
	    /**
	     * Creates breadcrumbs from console API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
	        var breadcrumb = {
	            category: 'console',
	            data: {
	                arguments: handlerData.args,
	                logger: 'console',
	            },
	            level: types_1.Severity.fromString(handlerData.level),
	            message: utils_1.safeJoin(handlerData.args, ' '),
	        };
	        if (handlerData.level === 'assert') {
	            if (handlerData.args[0] === false) {
	                breadcrumb.message = "Assertion failed: " + (utils_1.safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
	                breadcrumb.data.arguments = handlerData.args.slice(1);
	            }
	            else {
	                // Don't capture a breadcrumb for passed assertions
	                return;
	            }
	        }
	        core_1.getCurrentHub().addBreadcrumb(breadcrumb, {
	            input: handlerData.args,
	            level: handlerData.level,
	        });
	    };
	    /**
	     * Creates breadcrumbs from DOM API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
	        var target;
	        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
	        try {
	            target = handlerData.event.target
	                ? utils_1.htmlTreeAsString(handlerData.event.target)
	                : utils_1.htmlTreeAsString(handlerData.event);
	        }
	        catch (e) {
	            target = '<unknown>';
	        }
	        if (target.length === 0) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "ui." + handlerData.name,
	            message: target,
	        }, {
	            event: handlerData.event,
	            name: handlerData.name,
	        });
	    };
	    /**
	     * Creates breadcrumbs from XHR API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
	        if (handlerData.endTimestamp) {
	            // We only capture complete, non-sentry requests
	            if (handlerData.xhr.__sentry_own_request__) {
	                return;
	            }
	            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'xhr',
	                data: {
	                    method: method,
	                    url: url,
	                    status_code: status_code,
	                },
	                type: 'http',
	            }, {
	                xhr: handlerData.xhr,
	                input: body,
	            });
	            return;
	        }
	    };
	    /**
	     * Creates breadcrumbs from fetch API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
	        // We only capture complete fetch requests
	        if (!handlerData.endTimestamp) {
	            return;
	        }
	        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
	            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
	            return;
	        }
	        if (handlerData.error) {
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'fetch',
	                data: handlerData.fetchData,
	                level: types_1.Severity.Error,
	                type: 'http',
	            }, {
	                data: handlerData.error,
	                input: handlerData.args,
	            });
	        }
	        else {
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'fetch',
	                data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { status_code: handlerData.response.status }),
	                type: 'http',
	            }, {
	                input: handlerData.args,
	                response: handlerData.response,
	            });
	        }
	    };
	    /**
	     * Creates breadcrumbs from history API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
	        var global = utils_1.getGlobalObject();
	        var from = handlerData.from;
	        var to = handlerData.to;
	        var parsedLoc = utils_1.parseUrl(global.location.href);
	        var parsedFrom = utils_1.parseUrl(from);
	        var parsedTo = utils_1.parseUrl(to);
	        // Initial pushState doesn't provide `from` information
	        if (!parsedFrom.path) {
	            parsedFrom = parsedLoc;
	        }
	        // Use only the path component of the URL if the URL matches the current
	        // document (almost all the time when using pushState)
	        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
	            to = parsedTo.relative;
	        }
	        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
	            from = parsedFrom.relative;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: 'navigation',
	            data: {
	                from: from,
	                to: to,
	            },
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Breadcrumbs.id = 'Breadcrumbs';
	    return Breadcrumbs;
	}());
	exports.Breadcrumbs = Breadcrumbs;
	//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	var core_1 = __webpack_require__(3);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(1);
	var eventbuilder_1 = __webpack_require__(30);
	var helpers_1 = __webpack_require__(17);
	/** Global handlers */
	var GlobalHandlers = /** @class */ (function () {
	    /** JSDoc */
	    function GlobalHandlers(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = GlobalHandlers.id;
	        /** JSDoc */
	        this._onErrorHandlerInstalled = false;
	        /** JSDoc */
	        this._onUnhandledRejectionHandlerInstalled = false;
	        this._options = tslib_1.__assign({ onerror: true, onunhandledrejection: true }, options);
	    }
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.prototype.setupOnce = function () {
	        Error.stackTraceLimit = 50;
	        if (this._options.onerror) {
	            utils_1.logger.log('Global Handler attached: onerror');
	            this._installGlobalOnErrorHandler();
	        }
	        if (this._options.onunhandledrejection) {
	            utils_1.logger.log('Global Handler attached: onunhandledrejection');
	            this._installGlobalOnUnhandledRejectionHandler();
	        }
	    };
	    /** JSDoc */
	    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
	        var _this = this;
	        if (this._onErrorHandlerInstalled) {
	            return;
	        }
	        utils_1.addInstrumentationHandler({
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            callback: function (data) {
	                var error = data.error;
	                var currentHub = core_1.getCurrentHub();
	                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
	                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
	                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
	                    return;
	                }
	                var client = currentHub.getClient();
	                var event = utils_1.isPrimitive(error)
	                    ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column)
	                    : _this._enhanceEventWithInitialFrame(eventbuilder_1.eventFromUnknownInput(error, undefined, {
	                        attachStacktrace: client && client.getOptions().attachStacktrace,
	                        rejection: false,
	                    }), data.url, data.line, data.column);
	                utils_1.addExceptionMechanism(event, {
	                    handled: false,
	                    type: 'onerror',
	                });
	                currentHub.captureEvent(event, {
	                    originalException: error,
	                });
	            },
	            type: 'error',
	        });
	        this._onErrorHandlerInstalled = true;
	    };
	    /** JSDoc */
	    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
	        var _this = this;
	        if (this._onUnhandledRejectionHandlerInstalled) {
	            return;
	        }
	        utils_1.addInstrumentationHandler({
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            callback: function (e) {
	                var error = e;
	                // dig the object of the rejection out of known event types
	                try {
	                    // PromiseRejectionEvents store the object of the rejection under 'reason'
	                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
	                    if ('reason' in e) {
	                        error = e.reason;
	                    }
	                    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
	                    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
	                    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
	                    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
	                    // https://github.com/getsentry/sentry-javascript/issues/2380
	                    else if ('detail' in e && 'reason' in e.detail) {
	                        error = e.detail.reason;
	                    }
	                }
	                catch (_oO) {
	                    // no-empty
	                }
	                var currentHub = core_1.getCurrentHub();
	                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
	                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
	                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
	                    return true;
	                }
	                var client = currentHub.getClient();
	                var event = utils_1.isPrimitive(error)
	                    ? _this._eventFromRejectionWithPrimitive(error)
	                    : eventbuilder_1.eventFromUnknownInput(error, undefined, {
	                        attachStacktrace: client && client.getOptions().attachStacktrace,
	                        rejection: true,
	                    });
	                event.level = types_1.Severity.Error;
	                utils_1.addExceptionMechanism(event, {
	                    handled: false,
	                    type: 'onunhandledrejection',
	                });
	                currentHub.captureEvent(event, {
	                    originalException: error,
	                });
	                return;
	            },
	            type: 'unhandledrejection',
	        });
	        this._onUnhandledRejectionHandlerInstalled = true;
	    };
	    /**
	     * This function creates a stack from an old, error-less onerror handler.
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
	        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
	        // If 'message' is ErrorEvent, get real message from inside
	        var message = utils_1.isErrorEvent(msg) ? msg.message : msg;
	        var name;
	        if (utils_1.isString(message)) {
	            var groups = message.match(ERROR_TYPES_RE);
	            if (groups) {
	                name = groups[1];
	                message = groups[2];
	            }
	        }
	        var event = {
	            exception: {
	                values: [
	                    {
	                        type: name || 'Error',
	                        value: message,
	                    },
	                ],
	            },
	        };
	        return this._enhanceEventWithInitialFrame(event, url, line, column);
	    };
	    /**
	     * Create an event from a promise rejection where the `reason` is a primitive.
	     *
	     * @param reason: The `reason` property of the promise rejection
	     * @returns An Event object with an appropriate `exception` value
	     */
	    GlobalHandlers.prototype._eventFromRejectionWithPrimitive = function (reason) {
	        return {
	            exception: {
	                values: [
	                    {
	                        type: 'UnhandledRejection',
	                        // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
	                        value: "Non-Error promise rejection captured with value: " + String(reason),
	                    },
	                ],
	            },
	        };
	    };
	    /** JSDoc */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
	        event.exception = event.exception || {};
	        event.exception.values = event.exception.values || [];
	        event.exception.values[0] = event.exception.values[0] || {};
	        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
	        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
	        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
	        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
	        var filename = utils_1.isString(url) && url.length > 0 ? url : utils_1.getLocationHref();
	        if (event.exception.values[0].stacktrace.frames.length === 0) {
	            event.exception.values[0].stacktrace.frames.push({
	                colno: colno,
	                filename: filename,
	                function: '?',
	                in_app: true,
	                lineno: lineno,
	            });
	        }
	        return event;
	    };
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.id = 'GlobalHandlers';
	    return GlobalHandlers;
	}());
	exports.GlobalHandlers = GlobalHandlers;
	//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var core_1 = __webpack_require__(3);
	var utils_1 = __webpack_require__(1);
	var parsers_1 = __webpack_require__(58);
	var tracekit_1 = __webpack_require__(32);
	var DEFAULT_KEY = 'cause';
	var DEFAULT_LIMIT = 5;
	/** Adds SDK info to an event. */
	var LinkedErrors = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function LinkedErrors(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = LinkedErrors.id;
	        this._key = options.key || DEFAULT_KEY;
	        this._limit = options.limit || DEFAULT_LIMIT;
	    }
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event, hint) {
	            var self = core_1.getCurrentHub().getIntegration(LinkedErrors);
	            if (self) {
	                return self._handler(event, hint);
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype._handler = function (event, hint) {
	        if (!event.exception || !event.exception.values || !hint || !utils_1.isInstanceOf(hint.originalException, Error)) {
	            return event;
	        }
	        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
	        event.exception.values = tslib_1.__spread(linkedErrors, event.exception.values);
	        return event;
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
	        if (stack === void 0) { stack = []; }
	        if (!utils_1.isInstanceOf(error[key], Error) || stack.length + 1 >= this._limit) {
	            return stack;
	        }
	        var stacktrace = tracekit_1.computeStackTrace(error[key]);
	        var exception = parsers_1.exceptionFromStacktrace(stacktrace);
	        return this._walkErrorTree(error[key], key, tslib_1.__spread([exception], stack));
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.id = 'LinkedErrors';
	    return LinkedErrors;
	}());
	exports.LinkedErrors = LinkedErrors;
	//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var utils_1 = __webpack_require__(1);
	var helpers_1 = __webpack_require__(17);
	var DEFAULT_EVENT_TARGET = [
	    'EventTarget',
	    'Window',
	    'Node',
	    'ApplicationCache',
	    'AudioTrackList',
	    'ChannelMergerNode',
	    'CryptoOperation',
	    'EventSource',
	    'FileReader',
	    'HTMLUnknownElement',
	    'IDBDatabase',
	    'IDBRequest',
	    'IDBTransaction',
	    'KeyOperation',
	    'MediaController',
	    'MessagePort',
	    'ModalWindow',
	    'Notification',
	    'SVGElementInstance',
	    'Screen',
	    'TextTrack',
	    'TextTrackCue',
	    'TextTrackList',
	    'WebSocket',
	    'WebSocketWorker',
	    'Worker',
	    'XMLHttpRequest',
	    'XMLHttpRequestEventTarget',
	    'XMLHttpRequestUpload',
	];
	/** Wrap timer functions and event targets to catch errors and provide better meta data */
	var TryCatch = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function TryCatch(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = TryCatch.id;
	        this._options = tslib_1.__assign({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
	    }
	    /**
	     * Wrap timer functions and event targets to catch errors
	     * and provide better metadata.
	     */
	    TryCatch.prototype.setupOnce = function () {
	        var global = utils_1.getGlobalObject();
	        if (this._options.setTimeout) {
	            utils_1.fill(global, 'setTimeout', this._wrapTimeFunction.bind(this));
	        }
	        if (this._options.setInterval) {
	            utils_1.fill(global, 'setInterval', this._wrapTimeFunction.bind(this));
	        }
	        if (this._options.requestAnimationFrame) {
	            utils_1.fill(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
	        }
	        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
	            utils_1.fill(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
	        }
	        if (this._options.eventTarget) {
	            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
	            eventTarget.forEach(this._wrapEventTarget.bind(this));
	        }
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapTimeFunction = function (original) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var originalCallback = args[0];
	            args[0] = helpers_1.wrap(originalCallback, {
	                mechanism: {
	                    data: { function: utils_1.getFunctionName(original) },
	                    handled: true,
	                    type: 'instrument',
	                },
	            });
	            return original.apply(this, args);
	        };
	    };
	    /** JSDoc */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    TryCatch.prototype._wrapRAF = function (original) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function (callback) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            return original.call(this, helpers_1.wrap(callback, {
	                mechanism: {
	                    data: {
	                        function: 'requestAnimationFrame',
	                        handler: utils_1.getFunctionName(original),
	                    },
	                    handled: true,
	                    type: 'instrument',
	                },
	            }));
	        };
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapEventTarget = function (target) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var global = utils_1.getGlobalObject();
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        var proto = global[target] && global[target].prototype;
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	            return;
	        }
	        utils_1.fill(proto, 'addEventListener', function (original) {
	            return function (eventName, fn, options) {
	                try {
	                    if (typeof fn.handleEvent === 'function') {
	                        fn.handleEvent = helpers_1.wrap(fn.handleEvent.bind(fn), {
	                            mechanism: {
	                                data: {
	                                    function: 'handleEvent',
	                                    handler: utils_1.getFunctionName(fn),
	                                    target: target,
	                                },
	                                handled: true,
	                                type: 'instrument',
	                            },
	                        });
	                    }
	                }
	                catch (err) {
	                    // can sometimes get 'Permission denied to access property "handle Event'
	                }
	                return original.call(this, eventName, 
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                helpers_1.wrap(fn, {
	                    mechanism: {
	                        data: {
	                            function: 'addEventListener',
	                            handler: utils_1.getFunctionName(fn),
	                            target: target,
	                        },
	                        handled: true,
	                        type: 'instrument',
	                    },
	                }), options);
	            };
	        });
	        utils_1.fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
	            return function (eventName, fn, options) {
	                var _a;
	                /**
	                 * There are 2 possible scenarios here:
	                 *
	                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
	                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
	                 * as a pass-through, and call original `removeEventListener` with it.
	                 *
	                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
	                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
	                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
	                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
	                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
	                 *
	                 * When someone adds a handler prior to initialization, and then do it again, but after,
	                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
	                 * to get rid of the initial handler and it'd stick there forever.
	                 */
	                var wrappedEventHandler = fn;
	                try {
	                    var originalEventHandler = (_a = wrappedEventHandler) === null || _a === void 0 ? void 0 : _a.__sentry_wrapped__;
	                    if (originalEventHandler) {
	                        originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
	                    }
	                }
	                catch (e) {
	                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
	                }
	                return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
	            };
	        });
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapXHR = function (originalSend) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line @typescript-eslint/no-this-alias
	            var xhr = this;
	            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
	            xmlHttpRequestProps.forEach(function (prop) {
	                if (prop in xhr && typeof xhr[prop] === 'function') {
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    utils_1.fill(xhr, prop, function (original) {
	                        var wrapOptions = {
	                            mechanism: {
	                                data: {
	                                    function: prop,
	                                    handler: utils_1.getFunctionName(original),
	                                },
	                                handled: true,
	                                type: 'instrument',
	                            },
	                        };
	                        // If Instrument integration has been called before TryCatch, get the name of original function
	                        if (original.__sentry_original__) {
	                            wrapOptions.mechanism.data.handler = utils_1.getFunctionName(original.__sentry_original__);
	                        }
	                        // Otherwise wrap directly
	                        return helpers_1.wrap(original, wrapOptions);
	                    });
	                }
	            });
	            return originalSend.apply(this, args);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    TryCatch.id = 'TryCatch';
	    return TryCatch;
	}());
	exports.TryCatch = TryCatch;
	//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var core_1 = __webpack_require__(3);
	var utils_1 = __webpack_require__(1);
	var global = utils_1.getGlobalObject();
	/** UserAgent */
	var UserAgent = /** @class */ (function () {
	    function UserAgent() {
	        /**
	         * @inheritDoc
	         */
	        this.name = UserAgent.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    UserAgent.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event) {
	            var _a, _b, _c;
	            if (core_1.getCurrentHub().getIntegration(UserAgent)) {
	                // if none of the information we want exists, don't bother
	                if (!global.navigator && !global.location && !global.document) {
	                    return event;
	                }
	                // grab as much info as exists and add it to the event
	                var url = ((_a = event.request) === null || _a === void 0 ? void 0 : _a.url) || ((_b = global.location) === null || _b === void 0 ? void 0 : _b.href);
	                var referrer = (global.document || {}).referrer;
	                var userAgent = (global.navigator || {}).userAgent;
	                var headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (_c = event.request) === null || _c === void 0 ? void 0 : _c.headers), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
	                var request = tslib_1.__assign(tslib_1.__assign({}, (url && { url: url })), { headers: headers });
	                return tslib_1.__assign(tslib_1.__assign({}, event), { request: request });
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    UserAgent.id = 'UserAgent';
	    return UserAgent;
	}());
	exports.UserAgent = UserAgent;
	//# sourceMappingURL=useragent.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var utils_1 = __webpack_require__(1);
	var client_1 = __webpack_require__(57);
	var helpers_1 = __webpack_require__(17);
	var integrations_1 = __webpack_require__(31);
	exports.defaultIntegrations = [
	    new core_1.Integrations.InboundFilters(),
	    new core_1.Integrations.FunctionToString(),
	    new integrations_1.TryCatch(),
	    new integrations_1.Breadcrumbs(),
	    new integrations_1.GlobalHandlers(),
	    new integrations_1.LinkedErrors(),
	    new integrations_1.UserAgent(),
	];
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * To use this SDK, call the {@link init} function as early as possible when
	 * loading the web page. To set context information or send manual events, use
	 * the provided methods.
	 *
	 * @example
	 *
	 * ```
	 *
	 * import { init } from '@sentry/browser';
	 *
	 * init({
	 *   dsn: '__DSN__',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { configureScope } from '@sentry/browser';
	 * configureScope((scope: Scope) => {
	 *   scope.setExtra({ battery: 0.7 });
	 *   scope.setTag({ user_mode: 'admin' });
	 *   scope.setUser({ id: '4711' });
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { addBreadcrumb } from '@sentry/browser';
	 * addBreadcrumb({
	 *   message: 'My Breadcrumb',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 *
	 * ```
	 *
	 * import * as Sentry from '@sentry/browser';
	 * Sentry.captureMessage('Hello, world!');
	 * Sentry.captureException(new Error('Good bye'));
	 * Sentry.captureEvent({
	 *   message: 'Manual',
	 *   stacktrace: [
	 *     // ...
	 *   ],
	 * });
	 * ```
	 *
	 * @see {@link BrowserOptions} for documentation on configuration options.
	 */
	function init(options) {
	    if (options === void 0) { options = {}; }
	    if (options.defaultIntegrations === undefined) {
	        options.defaultIntegrations = exports.defaultIntegrations;
	    }
	    if (options.release === undefined) {
	        var window_1 = utils_1.getGlobalObject();
	        // This supports the variable that sentry-webpack-plugin injects
	        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
	            options.release = window_1.SENTRY_RELEASE.id;
	        }
	    }
	    if (options.autoSessionTracking === undefined) {
	        options.autoSessionTracking = false;
	    }
	    core_1.initAndBind(client_1.BrowserClient, options);
	    if (options.autoSessionTracking) {
	        startSessionTracking();
	    }
	}
	exports.init = init;
	/**
	 * Present the user with a report dialog.
	 *
	 * @param options Everything is optional, we try to fetch all info need from the global scope.
	 */
	function showReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    if (!options.eventId) {
	        options.eventId = core_1.getCurrentHub().lastEventId();
	    }
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        client.showReportDialog(options);
	    }
	}
	exports.showReportDialog = showReportDialog;
	/**
	 * This is the getter for lastEventId.
	 *
	 * @returns The last event id of a captured event.
	 */
	function lastEventId() {
	    return core_1.getCurrentHub().lastEventId();
	}
	exports.lastEventId = lastEventId;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function forceLoad() {
	    // Noop
	}
	exports.forceLoad = forceLoad;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function onLoad(callback) {
	    callback();
	}
	exports.onLoad = onLoad;
	/**
	 * A promise that resolves when all current events have been sent.
	 * If you provide a timeout and the queue takes longer to drain the promise returns false.
	 *
	 * @param timeout Maximum time in ms the client should wait.
	 */
	function flush(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.flush(timeout);
	    }
	    return utils_1.SyncPromise.reject(false);
	}
	exports.flush = flush;
	/**
	 * A promise that resolves when all current events have been sent.
	 * If you provide a timeout and the queue takes longer to drain the promise returns false.
	 *
	 * @param timeout Maximum time in ms the client should wait.
	 */
	function close(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.close(timeout);
	    }
	    return utils_1.SyncPromise.reject(false);
	}
	exports.close = close;
	/**
	 * Wrap code within a try/catch block so the SDK is able to capture errors.
	 *
	 * @param fn A function to wrap.
	 *
	 * @returns The result of wrapped function call.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function wrap(fn) {
	    return helpers_1.wrap(fn)();
	}
	exports.wrap = wrap;
	/**
	 * Enable automatic Session Tracking for the initial page load.
	 */
	function startSessionTracking() {
	    var window = utils_1.getGlobalObject();
	    var hub = core_1.getCurrentHub();
	    /**
	     * We should be using `Promise.all([windowLoaded, firstContentfulPaint])` here,
	     * but, as always, it's not available in the IE10-11. Thanks IE.
	     */
	    var loadResolved = document.readyState === 'complete';
	    var fcpResolved = false;
	    var possiblyEndSession = function () {
	        if (fcpResolved && loadResolved) {
	            hub.endSession();
	        }
	    };
	    var resolveWindowLoaded = function () {
	        loadResolved = true;
	        possiblyEndSession();
	        window.removeEventListener('load', resolveWindowLoaded);
	    };
	    hub.startSession();
	    if (!loadResolved) {
	        // IE doesn't support `{ once: true }` for event listeners, so we have to manually
	        // attach and then detach it once completed.
	        window.addEventListener('load', resolveWindowLoaded);
	    }
	    try {
	        var po = new PerformanceObserver(function (entryList, po) {
	            entryList.getEntries().forEach(function (entry) {
	                if (entry.name === 'first-contentful-paint' && entry.startTime < firstHiddenTime_1) {
	                    po.disconnect();
	                    fcpResolved = true;
	                    possiblyEndSession();
	                }
	            });
	        });
	        // There's no need to even attach this listener if `PerformanceObserver` constructor will fail,
	        // so we do it below here.
	        var firstHiddenTime_1 = document.visibilityState === 'hidden' ? 0 : Infinity;
	        document.addEventListener('visibilitychange', function (event) {
	            firstHiddenTime_1 = Math.min(firstHiddenTime_1, event.timeStamp);
	        }, { once: true });
	        po.observe({
	            type: 'paint',
	            buffered: true,
	        });
	    }
	    catch (e) {
	        fcpResolved = true;
	        possiblyEndSession();
	    }
	}
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var core_1 = __webpack_require__(3);
	var utils_1 = __webpack_require__(1);
	var base_1 = __webpack_require__(33);
	var global = utils_1.getGlobalObject();
	/** `fetch` based transport */
	var FetchTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(FetchTransport, _super);
	    function FetchTransport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    FetchTransport.prototype.sendEvent = function (event) {
	        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
	    };
	    /**
	     * @inheritDoc
	     */
	    FetchTransport.prototype.sendSession = function (session) {
	        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
	    };
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        if (this._isRateLimited(sentryRequest.type)) {
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        var options = {
	            body: sentryRequest.body,
	            method: 'POST',
	            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	            // https://caniuse.com/#feat=referrer-policy
	            // It doesn't. And it throw exception instead of ignoring this parameter...
	            // REF: https://github.com/getsentry/raven-js/issues/1233
	            referrerPolicy: (utils_1.supportsReferrerPolicy() ? 'origin' : ''),
	        };
	        if (this.options.fetchParameters !== undefined) {
	            Object.assign(options, this.options.fetchParameters);
	        }
	        if (this.options.headers !== undefined) {
	            options.headers = this.options.headers;
	        }
	        return this._buffer.add(new utils_1.SyncPromise(function (resolve, reject) {
	            global
	                .fetch(sentryRequest.url, options)
	                .then(function (response) {
	                var headers = {
	                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
	                    'retry-after': response.headers.get('Retry-After'),
	                };
	                _this._handleResponse({
	                    requestType: sentryRequest.type,
	                    response: response,
	                    headers: headers,
	                    resolve: resolve,
	                    reject: reject,
	                });
	            })
	                .catch(reject);
	        }));
	    };
	    return FetchTransport;
	}(base_1.BaseTransport));
	exports.FetchTransport = FetchTransport;
	//# sourceMappingURL=fetch.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var core_1 = __webpack_require__(3);
	var utils_1 = __webpack_require__(1);
	var base_1 = __webpack_require__(33);
	/** `XHR` based transport */
	var XHRTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(XHRTransport, _super);
	    function XHRTransport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    XHRTransport.prototype.sendEvent = function (event) {
	        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
	    };
	    /**
	     * @inheritDoc
	     */
	    XHRTransport.prototype.sendSession = function (session) {
	        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
	    };
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        if (this._isRateLimited(sentryRequest.type)) {
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        return this._buffer.add(new utils_1.SyncPromise(function (resolve, reject) {
	            var request = new XMLHttpRequest();
	            request.onreadystatechange = function () {
	                if (request.readyState === 4) {
	                    var headers = {
	                        'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
	                        'retry-after': request.getResponseHeader('Retry-After'),
	                    };
	                    _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
	                }
	            };
	            request.open('POST', sentryRequest.url);
	            for (var header in _this.options.headers) {
	                if (_this.options.headers.hasOwnProperty(header)) {
	                    request.setRequestHeader(header, _this.options.headers[header]);
	                }
	            }
	            request.send(sentryRequest.body);
	        }));
	    };
	    return XHRTransport;
	}(base_1.BaseTransport));
	exports.XHRTransport = XHRTransport;
	//# sourceMappingURL=xhr.js.map

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(1);
	var SENTRY_API_VERSION = '7';
	/** Helper class to provide urls to different Sentry endpoints. */
	var API = /** @class */ (function () {
	    /** Create a new instance of API */
	    function API(dsn) {
	        this.dsn = dsn;
	        this._dsnObject = new utils_1.Dsn(dsn);
	    }
	    /** Returns the Dsn object. */
	    API.prototype.getDsn = function () {
	        return this._dsnObject;
	    };
	    /** Returns the prefix to construct Sentry ingestion API endpoints. */
	    API.prototype.getBaseApiEndpoint = function () {
	        var dsn = this._dsnObject;
	        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
	        var port = dsn.port ? ":" + dsn.port : '';
	        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
	    };
	    /** Returns the store endpoint URL. */
	    API.prototype.getStoreEndpoint = function () {
	        return this._getIngestEndpoint('store');
	    };
	    /**
	     * Returns the store endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
	        return this.getStoreEndpoint() + "?" + this._encodedAuth();
	    };
	    /**
	     * Returns the envelope endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
	        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
	    };
	    /** Returns only the path component for the store endpoint. */
	    API.prototype.getStoreEndpointPath = function () {
	        var dsn = this._dsnObject;
	        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
	    };
	    /**
	     * Returns an object that can be used in request headers.
	     * This is needed for node and the old /store endpoint in sentry
	     */
	    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
	        var dsn = this._dsnObject;
	        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
	        header.push("sentry_client=" + clientName + "/" + clientVersion);
	        header.push("sentry_key=" + dsn.user);
	        if (dsn.pass) {
	            header.push("sentry_secret=" + dsn.pass);
	        }
	        return {
	            'Content-Type': 'application/json',
	            'X-Sentry-Auth': header.join(', '),
	        };
	    };
	    /** Returns the url to the report dialog endpoint. */
	    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
	        if (dialogOptions === void 0) { dialogOptions = {}; }
	        var dsn = this._dsnObject;
	        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
	        var encodedOptions = [];
	        encodedOptions.push("dsn=" + dsn.toString());
	        for (var key in dialogOptions) {
	            if (key === 'dsn') {
	                continue;
	            }
	            if (key === 'user') {
	                if (!dialogOptions.user) {
	                    continue;
	                }
	                if (dialogOptions.user.name) {
	                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
	                }
	                if (dialogOptions.user.email) {
	                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
	                }
	            }
	            else {
	                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
	            }
	        }
	        if (encodedOptions.length) {
	            return endpoint + "?" + encodedOptions.join('&');
	        }
	        return endpoint;
	    };
	    /** Returns the envelope endpoint URL. */
	    API.prototype._getEnvelopeEndpoint = function () {
	        return this._getIngestEndpoint('envelope');
	    };
	    /** Returns the ingest API endpoint for target. */
	    API.prototype._getIngestEndpoint = function (target) {
	        var base = this.getBaseApiEndpoint();
	        var dsn = this._dsnObject;
	        return "" + base + dsn.projectId + "/" + target + "/";
	    };
	    /** Returns a URL-encoded string with auth config suitable for a query string. */
	    API.prototype._encodedAuth = function () {
	        var dsn = this._dsnObject;
	        var auth = {
	            // We send only the minimum set of required information. See
	            // https://github.com/getsentry/sentry-javascript/issues/2572.
	            sentry_key: dsn.user,
	            sentry_version: SENTRY_API_VERSION,
	        };
	        return utils_1.urlEncode(auth);
	    };
	    return API;
	}());
	exports.API = API;
	//# sourceMappingURL=api.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(1);
	var noop_1 = __webpack_require__(61);
	/**
	 * This is the base implemention of a Backend.
	 * @hidden
	 */
	var BaseBackend = /** @class */ (function () {
	    /** Creates a new backend instance. */
	    function BaseBackend(options) {
	        this._options = options;
	        if (!this._options.dsn) {
	            utils_1.logger.warn('No DSN provided, backend will not do anything.');
	        }
	        this._transport = this._setupTransport();
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromException` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromMessage` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendEvent = function (event) {
	        this._transport.sendEvent(event).then(null, function (reason) {
	            utils_1.logger.error("Error while sending event: " + reason);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendSession = function (session) {
	        if (!this._transport.sendSession) {
	            utils_1.logger.warn("Dropping session because custom transport doesn't implement sendSession");
	            return;
	        }
	        this._transport.sendSession(session).then(null, function (reason) {
	            utils_1.logger.error("Error while sending session: " + reason);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.getTransport = function () {
	        return this._transport;
	    };
	    /**
	     * Sets up the transport so it can be used later to send requests.
	     */
	    BaseBackend.prototype._setupTransport = function () {
	        return new noop_1.NoopTransport();
	    };
	    return BaseBackend;
	}());
	exports.BaseBackend = BaseBackend;
	//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	/* eslint-disable max-lines */
	var hub_1 = __webpack_require__(7);
	var types_1 = __webpack_require__(8);
	var utils_1 = __webpack_require__(1);
	var integration_1 = __webpack_require__(107);
	/**
	 * Base implementation for all JavaScript SDK clients.
	 *
	 * Call the constructor with the corresponding backend constructor and options
	 * specific to the client subclass. To access these options later, use
	 * {@link Client.getOptions}. Also, the Backend instance is available via
	 * {@link Client.getBackend}.
	 *
	 * If a Dsn is specified in the options, it will be parsed and stored. Use
	 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
	 * invalid, the constructor will throw a {@link SentryException}. Note that
	 * without a valid Dsn, the SDK will not send any events to Sentry.
	 *
	 * Before sending an event via the backend, it is passed through
	 * {@link BaseClient.prepareEvent} to add SDK information and scope data
	 * (breadcrumbs and context). To add more custom information, override this
	 * method and extend the resulting prepared event.
	 *
	 * To issue automatically created events (e.g. via instrumentation), use
	 * {@link Client.captureEvent}. It will prepare the event and pass it through
	 * the callback lifecycle. To issue auto-breadcrumbs, use
	 * {@link Client.addBreadcrumb}.
	 *
	 * @example
	 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
	 *   public constructor(options: NodeOptions) {
	 *     super(NodeBackend, options);
	 *   }
	 *
	 *   // ...
	 * }
	 */
	var BaseClient = /** @class */ (function () {
	    /**
	     * Initializes this client instance.
	     *
	     * @param backendClass A constructor function to create the backend.
	     * @param options Options for the client.
	     */
	    function BaseClient(backendClass, options) {
	        /** Array of used integrations. */
	        this._integrations = {};
	        /** Number of call being processed */
	        this._processing = 0;
	        this._backend = new backendClass(options);
	        this._options = options;
	        if (options.dsn) {
	            this._dsn = new utils_1.Dsn(options.dsn);
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseClient.prototype.captureException = function (exception, hint, scope) {
	        var _this = this;
	        var eventId = hint && hint.event_id;
	        this._process(this._getBackend()
	            .eventFromException(exception, hint)
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
	        var _this = this;
	        var eventId = hint && hint.event_id;
	        var promisedEvent = utils_1.isPrimitive(message)
	            ? this._getBackend().eventFromMessage(String(message), level, hint)
	            : this._getBackend().eventFromException(message, hint);
	        this._process(promisedEvent
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureEvent = function (event, hint, scope) {
	        var eventId = hint && hint.event_id;
	        this._process(this._captureEvent(event, hint, scope).then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureSession = function (session) {
	        if (!session.release) {
	            utils_1.logger.warn('Discarded session because of missing release');
	        }
	        else {
	            this._sendSession(session);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getDsn = function () {
	        return this._dsn;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getOptions = function () {
	        return this._options;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.flush = function (timeout) {
	        var _this = this;
	        return this._isClientProcessing(timeout).then(function (ready) {
	            return _this._getBackend()
	                .getTransport()
	                .close(timeout)
	                .then(function (transportFlushed) { return ready && transportFlushed; });
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.close = function (timeout) {
	        var _this = this;
	        return this.flush(timeout).then(function (result) {
	            _this.getOptions().enabled = false;
	            return result;
	        });
	    };
	    /**
	     * Sets up the integrations
	     */
	    BaseClient.prototype.setupIntegrations = function () {
	        if (this._isEnabled()) {
	            this._integrations = integration_1.setupIntegrations(this._options);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getIntegration = function (integration) {
	        try {
	            return this._integrations[integration.id] || null;
	        }
	        catch (_oO) {
	            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
	            return null;
	        }
	    };
	    /** Updates existing session based on the provided event */
	    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
	        var e_1, _a;
	        var crashed = false;
	        var errored = false;
	        var userAgent;
	        var exceptions = event.exception && event.exception.values;
	        if (exceptions) {
	            errored = true;
	            try {
	                for (var exceptions_1 = tslib_1.__values(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
	                    var ex = exceptions_1_1.value;
	                    var mechanism = ex.mechanism;
	                    if (mechanism && mechanism.handled === false) {
	                        crashed = true;
	                        break;
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	        var user = event.user;
	        if (!session.userAgent) {
	            var headers = event.request ? event.request.headers : {};
	            for (var key in headers) {
	                if (key.toLowerCase() === 'user-agent') {
	                    userAgent = headers[key];
	                    break;
	                }
	            }
	        }
	        session.update(tslib_1.__assign(tslib_1.__assign({}, (crashed && { status: types_1.SessionStatus.Crashed })), { user: user,
	            userAgent: userAgent, errors: session.errors + Number(errored || crashed) }));
	    };
	    /** Deliver captured session to Sentry */
	    BaseClient.prototype._sendSession = function (session) {
	        this._getBackend().sendSession(session);
	    };
	    /** Waits for the client to be done with processing. */
	    BaseClient.prototype._isClientProcessing = function (timeout) {
	        var _this = this;
	        return new utils_1.SyncPromise(function (resolve) {
	            var ticked = 0;
	            var tick = 1;
	            var interval = setInterval(function () {
	                if (_this._processing == 0) {
	                    clearInterval(interval);
	                    resolve(true);
	                }
	                else {
	                    ticked += tick;
	                    if (timeout && ticked >= timeout) {
	                        clearInterval(interval);
	                        resolve(false);
	                    }
	                }
	            }, tick);
	        });
	    };
	    /** Returns the current backend. */
	    BaseClient.prototype._getBackend = function () {
	        return this._backend;
	    };
	    /** Determines whether this SDK is enabled and a valid Dsn is present. */
	    BaseClient.prototype._isEnabled = function () {
	        return this.getOptions().enabled !== false && this._dsn !== undefined;
	    };
	    /**
	     * Adds common information to events.
	     *
	     * The information includes release and environment from `options`,
	     * breadcrumbs and context (extra, tags and user) from the scope.
	     *
	     * Information that is already present in the event is never overwritten. For
	     * nested objects, such as the context, keys are merged.
	     *
	     * @param event The original event.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A new event with more information.
	     */
	    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
	        var _this = this;
	        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
	        var prepared = tslib_1.__assign(tslib_1.__assign({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : utils_1.uuid4()), timestamp: event.timestamp || utils_1.dateTimestampInSeconds() });
	        this._applyClientOptions(prepared);
	        this._applyIntegrationsMetadata(prepared);
	        // If we have scope given to us, use it as the base for further modifications.
	        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
	        var finalScope = scope;
	        if (hint && hint.captureContext) {
	            finalScope = hub_1.Scope.clone(finalScope).update(hint.captureContext);
	        }
	        // We prepare the result here with a resolved Event.
	        var result = utils_1.SyncPromise.resolve(prepared);
	        // This should be the last thing called, since we want that
	        // {@link Hub.addEventProcessor} gets the finished prepared event.
	        if (finalScope) {
	            // In case we have a hub we reassign it.
	            result = finalScope.applyToEvent(prepared, hint);
	        }
	        return result.then(function (evt) {
	            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
	                return _this._normalizeEvent(evt, normalizeDepth);
	            }
	            return evt;
	        });
	    };
	    /**
	     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
	     * Normalized keys:
	     * - `breadcrumbs.data`
	     * - `user`
	     * - `contexts`
	     * - `extra`
	     * @param event Event
	     * @returns Normalized event
	     */
	    BaseClient.prototype._normalizeEvent = function (event, depth) {
	        if (!event) {
	            return null;
	        }
	        var normalized = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, event), (event.breadcrumbs && {
	            breadcrumbs: event.breadcrumbs.map(function (b) { return (tslib_1.__assign(tslib_1.__assign({}, b), (b.data && {
	                data: utils_1.normalize(b.data, depth),
	            }))); }),
	        })), (event.user && {
	            user: utils_1.normalize(event.user, depth),
	        })), (event.contexts && {
	            contexts: utils_1.normalize(event.contexts, depth),
	        })), (event.extra && {
	            extra: utils_1.normalize(event.extra, depth),
	        }));
	        // event.contexts.trace stores information about a Transaction. Similarly,
	        // event.spans[] stores information about child Spans. Given that a
	        // Transaction is conceptually a Span, normalization should apply to both
	        // Transactions and Spans consistently.
	        // For now the decision is to skip normalization of Transactions and Spans,
	        // so this block overwrites the normalized event to add back the original
	        // Transaction information prior to normalization.
	        if (event.contexts && event.contexts.trace) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            normalized.contexts.trace = event.contexts.trace;
	        }
	        return normalized;
	    };
	    /**
	     *  Enhances event using the client configuration.
	     *  It takes care of all "static" values like environment, release and `dist`,
	     *  as well as truncating overly long values.
	     * @param event event instance to be enhanced
	     */
	    BaseClient.prototype._applyClientOptions = function (event) {
	        var options = this.getOptions();
	        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
	        if (!('environment' in event)) {
	            event.environment = 'environment' in options ? environment : 'production';
	        }
	        if (event.release === undefined && release !== undefined) {
	            event.release = release;
	        }
	        if (event.dist === undefined && dist !== undefined) {
	            event.dist = dist;
	        }
	        if (event.message) {
	            event.message = utils_1.truncate(event.message, maxValueLength);
	        }
	        var exception = event.exception && event.exception.values && event.exception.values[0];
	        if (exception && exception.value) {
	            exception.value = utils_1.truncate(exception.value, maxValueLength);
	        }
	        var request = event.request;
	        if (request && request.url) {
	            request.url = utils_1.truncate(request.url, maxValueLength);
	        }
	    };
	    /**
	     * This function adds all used integrations to the SDK info in the event.
	     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
	     */
	    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
	        var sdkInfo = event.sdk;
	        var integrationsArray = Object.keys(this._integrations);
	        if (sdkInfo && integrationsArray.length > 0) {
	            sdkInfo.integrations = integrationsArray;
	        }
	    };
	    /**
	     * Tells the backend to send this event
	     * @param event The Sentry event to send
	     */
	    BaseClient.prototype._sendEvent = function (event) {
	        this._getBackend().sendEvent(event);
	    };
	    /**
	     * Processes the event and logs an error in case of rejection
	     * @param event
	     * @param hint
	     * @param scope
	     */
	    BaseClient.prototype._captureEvent = function (event, hint, scope) {
	        return this._processEvent(event, hint, scope).then(function (finalEvent) {
	            return finalEvent.event_id;
	        }, function (reason) {
	            utils_1.logger.error(reason);
	            return undefined;
	        });
	    };
	    /**
	     * Processes an event (either error or message) and sends it to Sentry.
	     *
	     * This also adds breadcrumbs and context information to the event. However,
	     * platform specific meta data (such as the User's IP address) must be added
	     * by the SDK implementor.
	     *
	     *
	     * @param event The event to send to Sentry.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
	     */
	    BaseClient.prototype._processEvent = function (event, hint, scope) {
	        var _this = this;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
	        if (!this._isEnabled()) {
	            return utils_1.SyncPromise.reject(new utils_1.SentryError('SDK not enabled, will not send event.'));
	        }
	        var isTransaction = event.type === 'transaction';
	        // 1.0 === 100% events are sent
	        // 0.0 === 0% events are sent
	        // Sampling for transaction happens somewhere else
	        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
	            return utils_1.SyncPromise.reject(new utils_1.SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
	        }
	        return this._prepareEvent(event, scope, hint)
	            .then(function (prepared) {
	            if (prepared === null) {
	                throw new utils_1.SentryError('An event processor returned null, will not send event.');
	            }
	            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
	            if (isInternalException || isTransaction || !beforeSend) {
	                return prepared;
	            }
	            var beforeSendResult = beforeSend(prepared, hint);
	            if (typeof beforeSendResult === 'undefined') {
	                throw new utils_1.SentryError('`beforeSend` method has to return `null` or a valid event.');
	            }
	            else if (utils_1.isThenable(beforeSendResult)) {
	                return beforeSendResult.then(function (event) { return event; }, function (e) {
	                    throw new utils_1.SentryError("beforeSend rejected with " + e);
	                });
	            }
	            return beforeSendResult;
	        })
	            .then(function (processedEvent) {
	            if (processedEvent === null) {
	                throw new utils_1.SentryError('`beforeSend` returned `null`, will not send event.');
	            }
	            var session = scope && scope.getSession && scope.getSession();
	            if (!isTransaction && session) {
	                _this._updateSessionFromEvent(session, processedEvent);
	            }
	            _this._sendEvent(processedEvent);
	            return processedEvent;
	        })
	            .then(null, function (reason) {
	            if (reason instanceof utils_1.SentryError) {
	                throw reason;
	            }
	            _this.captureException(reason, {
	                data: {
	                    __sentry__: true,
	                },
	                originalException: reason,
	            });
	            throw new utils_1.SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
	        });
	    };
	    /**
	     * Occupies the client with processing and event
	     */
	    BaseClient.prototype._process = function (promise) {
	        var _this = this;
	        this._processing += 1;
	        promise.then(function (value) {
	            _this._processing -= 1;
	            return value;
	        }, function (reason) {
	            _this._processing -= 1;
	            return reason;
	        });
	    };
	    return BaseClient;
	}());
	exports.BaseClient = BaseClient;
	//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var hub_1 = __webpack_require__(7);
	var utils_1 = __webpack_require__(1);
	exports.installedIntegrations = [];
	/** Gets integration to install */
	function getIntegrationsToSetup(options) {
	    var defaultIntegrations = (options.defaultIntegrations && tslib_1.__spread(options.defaultIntegrations)) || [];
	    var userIntegrations = options.integrations;
	    var integrations = [];
	    if (Array.isArray(userIntegrations)) {
	        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
	        var pickedIntegrationsNames_1 = [];
	        // Leave only unique default integrations, that were not overridden with provided user integrations
	        defaultIntegrations.forEach(function (defaultIntegration) {
	            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
	                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
	                integrations.push(defaultIntegration);
	                pickedIntegrationsNames_1.push(defaultIntegration.name);
	            }
	        });
	        // Don't add same user integration twice
	        userIntegrations.forEach(function (userIntegration) {
	            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
	                integrations.push(userIntegration);
	                pickedIntegrationsNames_1.push(userIntegration.name);
	            }
	        });
	    }
	    else if (typeof userIntegrations === 'function') {
	        integrations = userIntegrations(defaultIntegrations);
	        integrations = Array.isArray(integrations) ? integrations : [integrations];
	    }
	    else {
	        integrations = tslib_1.__spread(defaultIntegrations);
	    }
	    // Make sure that if present, `Debug` integration will always run last
	    var integrationsNames = integrations.map(function (i) { return i.name; });
	    var alwaysLastToRun = 'Debug';
	    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
	        integrations.push.apply(integrations, tslib_1.__spread(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
	    }
	    return integrations;
	}
	exports.getIntegrationsToSetup = getIntegrationsToSetup;
	/** Setup given integration */
	function setupIntegration(integration) {
	    if (exports.installedIntegrations.indexOf(integration.name) !== -1) {
	        return;
	    }
	    integration.setupOnce(hub_1.addGlobalEventProcessor, hub_1.getCurrentHub);
	    exports.installedIntegrations.push(integration.name);
	    utils_1.logger.log("Integration installed: " + integration.name);
	}
	exports.setupIntegration = setupIntegration;
	/**
	 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
	 * integrations are added unless they were already provided before.
	 * @param integrations array of integration instances
	 * @param withDefault should enable default integrations
	 */
	function setupIntegrations(options) {
	    var integrations = {};
	    getIntegrationsToSetup(options).forEach(function (integration) {
	        integrations[integration.name] = integration;
	        setupIntegration(integration);
	    });
	    return integrations;
	}
	exports.setupIntegrations = setupIntegrations;
	//# sourceMappingURL=integration.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var originalFunctionToString;
	/** Patch toString calls to return proper name for wrapped functions */
	var FunctionToString = /** @class */ (function () {
	    function FunctionToString() {
	        /**
	         * @inheritDoc
	         */
	        this.name = FunctionToString.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.prototype.setupOnce = function () {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        originalFunctionToString = Function.prototype.toString;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Function.prototype.toString = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var context = this.__sentry_original__ || this;
	            return originalFunctionToString.apply(context, args);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.id = 'FunctionToString';
	    return FunctionToString;
	}());
	exports.FunctionToString = FunctionToString;
	//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var hub_1 = __webpack_require__(7);
	var utils_1 = __webpack_require__(1);
	// "Script error." is hard coded into browsers for errors that it can't read.
	// this is the result of a script being pulled in from an external domain and CORS.
	var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
	/** Inbound filters configurable by the user */
	var InboundFilters = /** @class */ (function () {
	    function InboundFilters(_options) {
	        if (_options === void 0) { _options = {}; }
	        this._options = _options;
	        /**
	         * @inheritDoc
	         */
	        this.name = InboundFilters.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.prototype.setupOnce = function () {
	        hub_1.addGlobalEventProcessor(function (event) {
	            var hub = hub_1.getCurrentHub();
	            if (!hub) {
	                return event;
	            }
	            var self = hub.getIntegration(InboundFilters);
	            if (self) {
	                var client = hub.getClient();
	                var clientOptions = client ? client.getOptions() : {};
	                var options = self._mergeOptions(clientOptions);
	                if (self._shouldDropEvent(event, options)) {
	                    return null;
	                }
	            }
	            return event;
	        });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._shouldDropEvent = function (event, options) {
	        if (this._isSentryError(event, options)) {
	            utils_1.logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + utils_1.getEventDescription(event));
	            return true;
	        }
	        if (this._isIgnoredError(event, options)) {
	            utils_1.logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + utils_1.getEventDescription(event));
	            return true;
	        }
	        if (this._isDeniedUrl(event, options)) {
	            utils_1.logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
	            return true;
	        }
	        if (!this._isAllowedUrl(event, options)) {
	            utils_1.logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
	            return true;
	        }
	        return false;
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isSentryError = function (event, options) {
	        if (!options.ignoreInternal) {
	            return false;
	        }
	        try {
	            return ((event &&
	                event.exception &&
	                event.exception.values &&
	                event.exception.values[0] &&
	                event.exception.values[0].type === 'SentryError') ||
	                false);
	        }
	        catch (_oO) {
	            return false;
	        }
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isIgnoredError = function (event, options) {
	        if (!options.ignoreErrors || !options.ignoreErrors.length) {
	            return false;
	        }
	        return this._getPossibleEventMessages(event).some(function (message) {
	            // Not sure why TypeScript complains here...
	            return options.ignoreErrors.some(function (pattern) { return utils_1.isMatchingPattern(message, pattern); });
	        });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isDeniedUrl = function (event, options) {
	        // TODO: Use Glob instead?
	        if (!options.denyUrls || !options.denyUrls.length) {
	            return false;
	        }
	        var url = this._getEventFilterUrl(event);
	        return !url ? false : options.denyUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isAllowedUrl = function (event, options) {
	        // TODO: Use Glob instead?
	        if (!options.allowUrls || !options.allowUrls.length) {
	            return true;
	        }
	        var url = this._getEventFilterUrl(event);
	        return !url ? true : options.allowUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._mergeOptions = function (clientOptions) {
	        if (clientOptions === void 0) { clientOptions = {}; }
	        return {
	            allowUrls: tslib_1.__spread((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
	            denyUrls: tslib_1.__spread((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
	            ignoreErrors: tslib_1.__spread((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
	            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
	        };
	    };
	    /** JSDoc */
	    InboundFilters.prototype._getPossibleEventMessages = function (event) {
	        if (event.message) {
	            return [event.message];
	        }
	        if (event.exception) {
	            try {
	                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
	                return ["" + value, type + ": " + value];
	            }
	            catch (oO) {
	                utils_1.logger.error("Cannot extract message for event " + utils_1.getEventDescription(event));
	                return [];
	            }
	        }
	        return [];
	    };
	    /** JSDoc */
	    InboundFilters.prototype._getEventFilterUrl = function (event) {
	        try {
	            if (event.stacktrace) {
	                var frames_1 = event.stacktrace.frames;
	                return (frames_1 && frames_1[frames_1.length - 1].filename) || null;
	            }
	            if (event.exception) {
	                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
	                return (frames_2 && frames_2[frames_2.length - 1].filename) || null;
	            }
	            return null;
	        }
	        catch (oO) {
	            utils_1.logger.error("Cannot extract url for event " + utils_1.getEventDescription(event));
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.id = 'InboundFilters';
	    return InboundFilters;
	}());
	exports.InboundFilters = InboundFilters;
	//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var functiontostring_1 = __webpack_require__(108);
	exports.FunctionToString = functiontostring_1.FunctionToString;
	var inboundfilters_1 = __webpack_require__(109);
	exports.InboundFilters = inboundfilters_1.InboundFilters;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	/** Creates a SentryRequest from an event. */
	function sessionToSentryRequest(session, api) {
	    var envelopeHeaders = JSON.stringify({
	        sent_at: new Date().toISOString(),
	    });
	    var itemHeaders = JSON.stringify({
	        type: 'session',
	    });
	    return {
	        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
	        type: 'session',
	        url: api.getEnvelopeEndpointWithUrlEncodedAuth(),
	    };
	}
	exports.sessionToSentryRequest = sessionToSentryRequest;
	/** Creates a SentryRequest from an event. */
	function eventToSentryRequest(event, api) {
	    // since JS has no Object.prototype.pop()
	    var _a = event.tags || {}, samplingMethod = _a.__sentry_samplingMethod, sampleRate = _a.__sentry_sampleRate, otherTags = tslib_1.__rest(_a, ["__sentry_samplingMethod", "__sentry_sampleRate"]);
	    event.tags = otherTags;
	    var useEnvelope = event.type === 'transaction';
	    var req = {
	        body: JSON.stringify(event),
	        type: event.type || 'event',
	        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth(),
	    };
	    // https://develop.sentry.dev/sdk/envelopes/
	    // Since we don't need to manipulate envelopes nor store them, there is no
	    // exported concept of an Envelope with operations including serialization and
	    // deserialization. Instead, we only implement a minimal subset of the spec to
	    // serialize events inline here.
	    if (useEnvelope) {
	        var envelopeHeaders = JSON.stringify({
	            event_id: event.event_id,
	            sent_at: new Date().toISOString(),
	        });
	        var itemHeaders = JSON.stringify({
	            type: event.type,
	            // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
	            // explicitly-set sampling decisions). Are we good with that?
	            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
	        });
	        // The trailing newline is optional. We intentionally don't send it to avoid
	        // sending unnecessary bytes.
	        //
	        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
	        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
	        req.body = envelope;
	    }
	    return req;
	}
	exports.eventToSentryRequest = eventToSentryRequest;
	//# sourceMappingURL=request.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hub_1 = __webpack_require__(7);
	var utils_1 = __webpack_require__(1);
	/**
	 * Internal function to create a new SDK client instance. The client is
	 * installed and then bound to the current scope.
	 *
	 * @param clientClass The client class to instantiate.
	 * @param options Options to pass to the client.
	 */
	function initAndBind(clientClass, options) {
	    if (options.debug === true) {
	        utils_1.logger.enable();
	    }
	    var hub = hub_1.getCurrentHub();
	    var client = new clientClass(options);
	    hub.bindClient(client);
	}
	exports.initAndBind = initAndBind;
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var utils_1 = __webpack_require__(1);
	var scope_1 = __webpack_require__(62);
	var session_1 = __webpack_require__(63);
	/**
	 * API compatibility version of this hub.
	 *
	 * WARNING: This number should only be increased when the global interface
	 * changes and new methods are introduced.
	 *
	 * @hidden
	 */
	exports.API_VERSION = 3;
	/**
	 * Default maximum number of breadcrumbs added to an event. Can be overwritten
	 * with {@link Options.maxBreadcrumbs}.
	 */
	var DEFAULT_BREADCRUMBS = 100;
	/**
	 * Absolute maximum number of breadcrumbs added to an event. The
	 * `maxBreadcrumbs` option cannot be higher than this value.
	 */
	var MAX_BREADCRUMBS = 100;
	/**
	 * @inheritDoc
	 */
	var Hub = /** @class */ (function () {
	    /**
	     * Creates a new instance of the hub, will push one {@link Layer} into the
	     * internal stack on creation.
	     *
	     * @param client bound to the hub.
	     * @param scope bound to the hub.
	     * @param version number, higher number means higher priority.
	     */
	    function Hub(client, scope, _version) {
	        if (scope === void 0) { scope = new scope_1.Scope(); }
	        if (_version === void 0) { _version = exports.API_VERSION; }
	        this._version = _version;
	        /** Is a {@link Layer}[] containing the client and scope */
	        this._stack = [{}];
	        this.getStackTop().scope = scope;
	        this.bindClient(client);
	    }
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.isOlderThan = function (version) {
	        return this._version < version;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.bindClient = function (client) {
	        var top = this.getStackTop();
	        top.client = client;
	        if (client && client.setupIntegrations) {
	            client.setupIntegrations();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.pushScope = function () {
	        // We want to clone the content of prev scope
	        var scope = scope_1.Scope.clone(this.getScope());
	        this.getStack().push({
	            client: this.getClient(),
	            scope: scope,
	        });
	        return scope;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.popScope = function () {
	        if (this.getStack().length <= 1)
	            return false;
	        return !!this.getStack().pop();
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.withScope = function (callback) {
	        var scope = this.pushScope();
	        try {
	            callback(scope);
	        }
	        finally {
	            this.popScope();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getClient = function () {
	        return this.getStackTop().client;
	    };
	    /** Returns the scope of the top stack. */
	    Hub.prototype.getScope = function () {
	        return this.getStackTop().scope;
	    };
	    /** Returns the scope stack for domains or the process. */
	    Hub.prototype.getStack = function () {
	        return this._stack;
	    };
	    /** Returns the topmost scope layer in the order domain > local > process. */
	    Hub.prototype.getStackTop = function () {
	        return this._stack[this._stack.length - 1];
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    Hub.prototype.captureException = function (exception, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimick the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error('Sentry syntheticException');
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: exception,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureException', exception, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureMessage = function (message, level, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimick the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error(message);
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: message,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureMessage', message, level, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureEvent = function (event, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        this._invokeClient('captureEvent', event, tslib_1.__assign(tslib_1.__assign({}, hint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.lastEventId = function () {
	        return this._lastEventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope || !client)
	            return;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
	        if (maxBreadcrumbs <= 0)
	            return;
	        var timestamp = utils_1.dateTimestampInSeconds();
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: timestamp }, breadcrumb);
	        var finalBreadcrumb = beforeBreadcrumb
	            ? utils_1.consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
	            : mergedBreadcrumb;
	        if (finalBreadcrumb === null)
	            return;
	        scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setUser = function (user) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setUser(user);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTags = function (tags) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTags(tags);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtras = function (extras) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtras(extras);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTag = function (key, value) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTag(key, value);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtra = function (key, extra) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtra(key, extra);
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype.setContext = function (name, context) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setContext(name, context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.configureScope = function (callback) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (scope && client) {
	            callback(scope);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.run = function (callback) {
	        var oldHub = makeMain(this);
	        try {
	            callback(this);
	        }
	        finally {
	            makeMain(oldHub);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getIntegration = function (integration) {
	        var client = this.getClient();
	        if (!client)
	            return null;
	        try {
	            return client.getIntegration(integration);
	        }
	        catch (_oO) {
	            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSpan = function (context) {
	        return this._callExtensionMethod('startSpan', context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startTransaction = function (context, customSamplingContext) {
	        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.traceHeaders = function () {
	        return this._callExtensionMethod('traceHeaders');
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSession = function (context) {
	        // End existing session if there's one
	        this.endSession();
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
	        var session = new session_1.Session(tslib_1.__assign(tslib_1.__assign({ release: release,
	            environment: environment }, (scope && { user: scope.getUser() })), context));
	        if (scope) {
	            scope.setSession(session);
	        }
	        return session;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.endSession = function () {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope)
	            return;
	        var session = scope.getSession && scope.getSession();
	        if (session) {
	            session.close();
	            if (client && client.captureSession) {
	                client.captureSession(session);
	            }
	            scope.setSession();
	        }
	    };
	    /**
	     * Internal helper function to call a method on the top client if it exists.
	     *
	     * @param method The method to call on the client.
	     * @param args Arguments to pass to the client function.
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._invokeClient = function (method) {
	        var _a;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
	        if (client && client[method]) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	            (_a = client)[method].apply(_a, tslib_1.__spread(args, [scope]));
	        }
	    };
	    /**
	     * Calls global extension method and binding current instance to the function call
	     */
	    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._callExtensionMethod = function (method) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var carrier = getMainCarrier();
	        var sentry = carrier.__SENTRY__;
	        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
	            return sentry.extensions[method].apply(this, args);
	        }
	        utils_1.logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
	    };
	    return Hub;
	}());
	exports.Hub = Hub;
	/** Returns the global shim registry. */
	function getMainCarrier() {
	    var carrier = utils_1.getGlobalObject();
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {
	        extensions: {},
	        hub: undefined,
	    };
	    return carrier;
	}
	exports.getMainCarrier = getMainCarrier;
	/**
	 * Replaces the current main hub with the passed one on the global object
	 *
	 * @returns The old replaced hub
	 */
	function makeMain(hub) {
	    var registry = getMainCarrier();
	    var oldHub = getHubFromCarrier(registry);
	    setHubOnCarrier(registry, hub);
	    return oldHub;
	}
	exports.makeMain = makeMain;
	/**
	 * Returns the default hub instance.
	 *
	 * If a hub is already registered in the global carrier but this module
	 * contains a more recent version, it replaces the registered version.
	 * Otherwise, the currently registered hub will be returned.
	 */
	function getCurrentHub() {
	    // Get main carrier (global for every environment)
	    var registry = getMainCarrier();
	    // If there's no hub, or its an old API, assign a new one
	    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(exports.API_VERSION)) {
	        setHubOnCarrier(registry, new Hub());
	    }
	    // Prefer domains over global if they are there (applicable only to Node environment)
	    if (utils_1.isNodeEnv()) {
	        return getHubFromActiveDomain(registry);
	    }
	    // Return hub that lives on a global object
	    return getHubFromCarrier(registry);
	}
	exports.getCurrentHub = getCurrentHub;
	/**
	 * Returns the active domain, if one exists
	 *
	 * @returns The domain, or undefined if there is no active domain
	 */
	function getActiveDomain() {
	    var sentry = getMainCarrier().__SENTRY__;
	    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
	}
	exports.getActiveDomain = getActiveDomain;
	/**
	 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
	 * @returns discovered hub
	 */
	function getHubFromActiveDomain(registry) {
	    try {
	        var activeDomain = getActiveDomain();
	        // If there's no active domain, just return global hub
	        if (!activeDomain) {
	            return getHubFromCarrier(registry);
	        }
	        // If there's no hub on current domain, or it's an old API, assign a new one
	        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(exports.API_VERSION)) {
	            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
	            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, scope_1.Scope.clone(registryHubTopStack.scope)));
	        }
	        // Return hub that lives on a domain
	        return getHubFromCarrier(activeDomain);
	    }
	    catch (_Oo) {
	        // Return hub that lives on a global object
	        return getHubFromCarrier(registry);
	    }
	}
	/**
	 * This will tell whether a carrier has a hub on it or not
	 * @param carrier object
	 */
	function hasHubOnCarrier(carrier) {
	    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
	}
	/**
	 * This will create a new {@link Hub} and add to the passed object on
	 * __SENTRY__.hub.
	 * @param carrier object
	 * @hidden
	 */
	function getHubFromCarrier(carrier) {
	    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
	        return carrier.__SENTRY__.hub;
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
	    carrier.__SENTRY__.hub = new Hub();
	    return carrier.__SENTRY__.hub;
	}
	exports.getHubFromCarrier = getHubFromCarrier;
	/**
	 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
	 * @param carrier object
	 * @param hub Hub
	 */
	function setHubOnCarrier(carrier, hub) {
	    if (!carrier)
	        return false;
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
	    carrier.__SENTRY__.hub = hub;
	    return true;
	}
	exports.setHubOnCarrier = setHubOnCarrier;
	//# sourceMappingURL=hub.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var hub_1 = __webpack_require__(7);
	/**
	 * This calls a function on the current hub.
	 * @param method function to call on hub.
	 * @param args to pass to function.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function callOnHub(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    var hub = hub_1.getCurrentHub();
	    if (hub && hub[method]) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return hub[method].apply(hub, tslib_1.__spread(args));
	    }
	    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
	}
	/**
	 * Captures an exception event and sends it to Sentry.
	 *
	 * @param exception An exception-like object.
	 * @returns The generated eventId.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	function captureException(exception, captureContext) {
	    var syntheticException;
	    try {
	        throw new Error('Sentry syntheticException');
	    }
	    catch (exception) {
	        syntheticException = exception;
	    }
	    return callOnHub('captureException', exception, {
	        captureContext: captureContext,
	        originalException: exception,
	        syntheticException: syntheticException,
	    });
	}
	exports.captureException = captureException;
	/**
	 * Captures a message event and sends it to Sentry.
	 *
	 * @param message The message to send to Sentry.
	 * @param level Define the level of the message.
	 * @returns The generated eventId.
	 */
	function captureMessage(message, captureContext) {
	    var syntheticException;
	    try {
	        throw new Error(message);
	    }
	    catch (exception) {
	        syntheticException = exception;
	    }
	    // This is necessary to provide explicit scopes upgrade, without changing the original
	    // arity of the `captureMessage(message, level)` method.
	    var level = typeof captureContext === 'string' ? captureContext : undefined;
	    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
	    return callOnHub('captureMessage', message, level, tslib_1.__assign({ originalException: message, syntheticException: syntheticException }, context));
	}
	exports.captureMessage = captureMessage;
	/**
	 * Captures a manually created event and sends it to Sentry.
	 *
	 * @param event The event to send to Sentry.
	 * @returns The generated eventId.
	 */
	function captureEvent(event) {
	    return callOnHub('captureEvent', event);
	}
	exports.captureEvent = captureEvent;
	/**
	 * Callback to set context information onto the scope.
	 * @param callback Callback function that receives Scope.
	 */
	function configureScope(callback) {
	    callOnHub('configureScope', callback);
	}
	exports.configureScope = configureScope;
	/**
	 * Records a new breadcrumb which will be attached to future events.
	 *
	 * Breadcrumbs will be added to subsequent events to provide more context on
	 * user's actions prior to an error or crash.
	 *
	 * @param breadcrumb The breadcrumb to record.
	 */
	function addBreadcrumb(breadcrumb) {
	    callOnHub('addBreadcrumb', breadcrumb);
	}
	exports.addBreadcrumb = addBreadcrumb;
	/**
	 * Sets context data with the given name.
	 * @param name of the context
	 * @param context Any kind of data. This data will be normalized.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function setContext(name, context) {
	    callOnHub('setContext', name, context);
	}
	exports.setContext = setContext;
	/**
	 * Set an object that will be merged sent as extra data with the event.
	 * @param extras Extras object to merge into current context.
	 */
	function setExtras(extras) {
	    callOnHub('setExtras', extras);
	}
	exports.setExtras = setExtras;
	/**
	 * Set an object that will be merged sent as tags data with the event.
	 * @param tags Tags context object to merge into current context.
	 */
	function setTags(tags) {
	    callOnHub('setTags', tags);
	}
	exports.setTags = setTags;
	/**
	 * Set key:value that will be sent as extra data with the event.
	 * @param key String of extra
	 * @param extra Any kind of data. This data will be normalized.
	 */
	function setExtra(key, extra) {
	    callOnHub('setExtra', key, extra);
	}
	exports.setExtra = setExtra;
	/**
	 * Set key:value that will be sent as tags data with the event.
	 *
	 * Can also be used to unset a tag, by passing `undefined`.
	 *
	 * @param key String key of tag
	 * @param value Value of tag
	 */
	function setTag(key, value) {
	    callOnHub('setTag', key, value);
	}
	exports.setTag = setTag;
	/**
	 * Updates user context information for future events.
	 *
	 * @param user User context object to be set in the current context. Pass `null` to unset the user.
	 */
	function setUser(user) {
	    callOnHub('setUser', user);
	}
	exports.setUser = setUser;
	/**
	 * Creates a new scope with and executes the given operation within.
	 * The scope is automatically removed once the operation
	 * finishes or throws.
	 *
	 * This is essentially a convenience function for:
	 *
	 *     pushScope();
	 *     callback();
	 *     popScope();
	 *
	 * @param callback that will be enclosed into push/popScope.
	 */
	function withScope(callback) {
	    callOnHub('withScope', callback);
	}
	exports.withScope = withScope;
	/**
	 * Calls a function on the latest client. Use this with caution, it's meant as
	 * in "internal" helper so we don't need to expose every possible function in
	 * the shim. It is not guaranteed that the client actually implements the
	 * function.
	 *
	 * @param method The method to call on the client/client.
	 * @param args Arguments to pass to the client/fontend.
	 * @hidden
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _callOnClient(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    callOnHub.apply(void 0, tslib_1.__spread(['_invokeClient', method], args));
	}
	exports._callOnClient = _callOnClient;
	/**
	 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
	 *
	 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
	 * new child span within the transaction or any span, call the respective `.startChild()` method.
	 *
	 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
	 *
	 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
	 * finished child spans will be sent to Sentry.
	 *
	 * @param context Properties of the new `Transaction`.
	 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
	 * default values). See {@link Options.tracesSampler}.
	 *
	 * @returns The transaction which was just started
	 */
	function startTransaction(context, customSamplingContext) {
	    return callOnHub('startTransaction', tslib_1.__assign({}, context), customSamplingContext);
	}
	exports.startTransaction = startTransaction;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(1);
	var spanstatus_1 = __webpack_require__(14);
	var utils_2 = __webpack_require__(10);
	var global = utils_1.getGlobalObject();
	/**
	 * Add a listener that cancels and finishes a transaction when the global
	 * document is hidden.
	 */
	function registerBackgroundTabDetection() {
	    if (global && global.document) {
	        global.document.addEventListener('visibilitychange', function () {
	            var activeTransaction = utils_2.getActiveTransaction();
	            if (global.document.hidden && activeTransaction) {
	                utils_1.logger.log("[Tracing] Transaction: " + spanstatus_1.SpanStatus.Cancelled + " -> since tab moved to the background, op: " + activeTransaction.op);
	                // We should not set status if it is already set, this prevent important statuses like
	                // error or data loss from being overwritten on transaction.
	                if (!activeTransaction.status) {
	                    activeTransaction.setStatus(spanstatus_1.SpanStatus.Cancelled);
	                }
	                activeTransaction.setTag('visibilitychange', 'document.hidden');
	                activeTransaction.finish();
	            }
	        });
	    }
	    else {
	        utils_1.logger.warn('[Tracing] Could not set up background tab detection due to lack of global document');
	    }
	}
	exports.registerBackgroundTabDetection = registerBackgroundTabDetection;
	//# sourceMappingURL=backgroundtab.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var utils_1 = __webpack_require__(1);
	var hubextensions_1 = __webpack_require__(37);
	var idletransaction_1 = __webpack_require__(38);
	var spanstatus_1 = __webpack_require__(14);
	var utils_2 = __webpack_require__(10);
	var backgroundtab_1 = __webpack_require__(115);
	var metrics_1 = __webpack_require__(117);
	var request_1 = __webpack_require__(65);
	var router_1 = __webpack_require__(118);
	exports.DEFAULT_MAX_TRANSACTION_DURATION_SECONDS = 600;
	var DEFAULT_BROWSER_TRACING_OPTIONS = tslib_1.__assign({ idleTimeout: idletransaction_1.DEFAULT_IDLE_TIMEOUT, markBackgroundTransactions: true, maxTransactionDuration: exports.DEFAULT_MAX_TRANSACTION_DURATION_SECONDS, routingInstrumentation: router_1.defaultRoutingInstrumentation, startTransactionOnLocationChange: true, startTransactionOnPageLoad: true }, request_1.defaultRequestInstrumentationOptions);
	/**
	 * The Browser Tracing integration automatically instruments browser pageload/navigation
	 * actions as transactions, and captures requests, metrics and errors as spans.
	 *
	 * The integration can be configured with a variety of options, and can be extended to use
	 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
	 */
	var BrowserTracing = /** @class */ (function () {
	    function BrowserTracing(_options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = BrowserTracing.id;
	        this._metrics = new metrics_1.MetricsInstrumentation();
	        this._emitOptionsWarning = false;
	        var tracingOrigins = request_1.defaultRequestInstrumentationOptions.tracingOrigins;
	        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
	        if (_options &&
	            _options.tracingOrigins &&
	            Array.isArray(_options.tracingOrigins) &&
	            _options.tracingOrigins.length !== 0) {
	            tracingOrigins = _options.tracingOrigins;
	        }
	        else {
	            this._emitOptionsWarning = true;
	        }
	        this.options = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options), { tracingOrigins: tracingOrigins });
	    }
	    /**
	     * @inheritDoc
	     */
	    BrowserTracing.prototype.setupOnce = function (_, getCurrentHub) {
	        var _this = this;
	        this._getCurrentHub = getCurrentHub;
	        if (this._emitOptionsWarning) {
	            utils_1.logger.warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
	            utils_1.logger.warn("[Tracing] We added a reasonable default for you: " + request_1.defaultRequestInstrumentationOptions.tracingOrigins);
	        }
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.options, routingInstrumentation = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
	        routingInstrumentation(function (context) { return _this._createRouteTransaction(context); }, startTransactionOnPageLoad, startTransactionOnLocationChange);
	        if (markBackgroundTransactions) {
	            backgroundtab_1.registerBackgroundTabDetection();
	        }
	        request_1.registerRequestInstrumentation({ traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest });
	    };
	    /** Create routing idle transaction. */
	    BrowserTracing.prototype._createRouteTransaction = function (context) {
	        var _this = this;
	        if (!this._getCurrentHub) {
	            utils_1.logger.warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
	            return undefined;
	        }
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
	        var parentContextFromHeader = context.op === 'pageload' ? getHeaderContext() : undefined;
	        var expandedContext = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, context), parentContextFromHeader), { trimEnd: true });
	        var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
	        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
	        // from being sent to Sentry).
	        var finalContext = modifiedContext === undefined ? tslib_1.__assign(tslib_1.__assign({}, expandedContext), { sampled: false }) : modifiedContext;
	        if (finalContext.sampled === false) {
	            utils_1.logger.log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
	        }
	        var hub = this._getCurrentHub();
	        var idleTransaction = hubextensions_1.startIdleTransaction(hub, finalContext, idleTimeout, true);
	        utils_1.logger.log("[Tracing] Starting " + finalContext.op + " transaction on scope");
	        idleTransaction.registerBeforeFinishCallback(function (transaction, endTimestamp) {
	            _this._metrics.addPerformanceEntries(transaction);
	            adjustTransactionDuration(utils_2.secToMs(maxTransactionDuration), transaction, endTimestamp);
	        });
	        return idleTransaction;
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserTracing.id = 'BrowserTracing';
	    return BrowserTracing;
	}());
	exports.BrowserTracing = BrowserTracing;
	/**
	 * Gets transaction context from a sentry-trace meta.
	 *
	 * @returns Transaction context data from the header or undefined if there's no header or the header is malformed
	 */
	function getHeaderContext() {
	    var header = getMetaContent('sentry-trace');
	    if (header) {
	        return utils_2.extractTraceparentData(header);
	    }
	    return undefined;
	}
	exports.getHeaderContext = getHeaderContext;
	/** Returns the value of a meta tag */
	function getMetaContent(metaName) {
	    var el = document.querySelector("meta[name=" + metaName + "]");
	    return el ? el.getAttribute('content') : null;
	}
	exports.getMetaContent = getMetaContent;
	/** Adjusts transaction value based on max transaction duration */
	function adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
	    var diff = endTimestamp - transaction.startTimestamp;
	    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
	    if (isOutdatedTransaction) {
	        transaction.setStatus(spanstatus_1.SpanStatus.DeadlineExceeded);
	        transaction.setTag('maxTransactionDurationExceeded', 'true');
	    }
	}
	//# sourceMappingURL=browsertracing.js.map

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var utils_1 = __webpack_require__(1);
	var utils_2 = __webpack_require__(10);
	var getCLS_1 = __webpack_require__(119);
	var getFID_1 = __webpack_require__(120);
	var getLCP_1 = __webpack_require__(121);
	var getTTFB_1 = __webpack_require__(122);
	var getFirstHidden_1 = __webpack_require__(35);
	var global = utils_1.getGlobalObject();
	/** Class tracking metrics  */
	var MetricsInstrumentation = /** @class */ (function () {
	    function MetricsInstrumentation() {
	        this._measurements = {};
	        this._performanceCursor = 0;
	        if (global && global.performance) {
	            if (global.performance.mark) {
	                global.performance.mark('sentry-tracing-init');
	            }
	            this._trackCLS();
	            this._trackLCP();
	            this._trackFID();
	            this._trackTTFB();
	        }
	    }
	    /** Add performance related spans to a transaction */
	    MetricsInstrumentation.prototype.addPerformanceEntries = function (transaction) {
	        var _this = this;
	        if (!global || !global.performance || !global.performance.getEntries || !utils_1.browserPerformanceTimeOrigin) {
	            // Gatekeeper if performance API not available
	            return;
	        }
	        utils_1.logger.log('[Tracing] Adding & adjusting spans using Performance API');
	        var timeOrigin = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	        var entryScriptSrc;
	        if (global.document) {
	            // eslint-disable-next-line @typescript-eslint/prefer-for-of
	            for (var i = 0; i < document.scripts.length; i++) {
	                // We go through all scripts on the page and look for 'data-entry'
	                // We remember the name and measure the time between this script finished loading and
	                // our mark 'sentry-tracing-init'
	                if (document.scripts[i].dataset.entry === 'true') {
	                    entryScriptSrc = document.scripts[i].src;
	                    break;
	                }
	            }
	        }
	        var entryScriptStartTimestamp;
	        var tracingInitMarkStartTime;
	        global.performance
	            .getEntries()
	            .slice(this._performanceCursor)
	            .forEach(function (entry) {
	            var startTime = utils_2.msToSec(entry.startTime);
	            var duration = utils_2.msToSec(entry.duration);
	            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
	                return;
	            }
	            switch (entry.entryType) {
	                case 'navigation':
	                    addNavigationSpans(transaction, entry, timeOrigin);
	                    break;
	                case 'mark':
	                case 'paint':
	                case 'measure': {
	                    var startTimestamp = addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
	                    if (tracingInitMarkStartTime === undefined && entry.name === 'sentry-tracing-init') {
	                        tracingInitMarkStartTime = startTimestamp;
	                    }
	                    // capture web vitals
	                    var firstHidden = getFirstHidden_1.getFirstHidden();
	                    // Only report if the page wasn't hidden prior to the web vital.
	                    var shouldRecord = entry.startTime < firstHidden.timeStamp;
	                    if (entry.name === 'first-paint' && shouldRecord) {
	                        utils_1.logger.log('[Measurements] Adding FP');
	                        _this._measurements['fp'] = { value: entry.startTime };
	                        _this._measurements['mark.fp'] = { value: startTimestamp };
	                    }
	                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
	                        utils_1.logger.log('[Measurements] Adding FCP');
	                        _this._measurements['fcp'] = { value: entry.startTime };
	                        _this._measurements['mark.fcp'] = { value: startTimestamp };
	                    }
	                    break;
	                }
	                case 'resource': {
	                    var resourceName = entry.name.replace(window.location.origin, '');
	                    var endTimestamp = addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
	                    // We remember the entry script end time to calculate the difference to the first init mark
	                    if (entryScriptStartTimestamp === undefined && (entryScriptSrc || '').indexOf(resourceName) > -1) {
	                        entryScriptStartTimestamp = endTimestamp;
	                    }
	                    break;
	                }
	                default:
	                // Ignore other entry types.
	            }
	        });
	        if (entryScriptStartTimestamp !== undefined && tracingInitMarkStartTime !== undefined) {
	            _startChild(transaction, {
	                description: 'evaluation',
	                endTimestamp: tracingInitMarkStartTime,
	                op: 'script',
	                startTimestamp: entryScriptStartTimestamp,
	            });
	        }
	        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
	        this._trackNavigator(transaction);
	        // Measurements are only available for pageload transactions
	        if (transaction.op === 'pageload') {
	            // normalize applicable web vital values to be relative to transaction.startTimestamp
	            var timeOrigin_1 = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	            ['fcp', 'fp', 'lcp', 'ttfb'].forEach(function (name) {
	                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) {
	                    return;
	                }
	                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
	                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
	                // to be adjusted to be relative to transaction.startTimestamp.
	                var oldValue = _this._measurements[name].value;
	                var measurementTimestamp = timeOrigin_1 + utils_2.msToSec(oldValue);
	                // normalizedValue should be in milliseconds
	                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
	                var delta = normalizedValue - oldValue;
	                utils_1.logger.log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
	                _this._measurements[name].value = normalizedValue;
	            });
	            if (this._measurements['mark.fid'] && this._measurements['fid']) {
	                // create span for FID
	                _startChild(transaction, {
	                    description: 'first input delay',
	                    endTimestamp: this._measurements['mark.fid'].value + utils_2.msToSec(this._measurements['fid'].value),
	                    op: 'web.vitals',
	                    startTimestamp: this._measurements['mark.fid'].value,
	                });
	            }
	            transaction.setMeasurements(this._measurements);
	        }
	    };
	    /** Starts tracking the Cumulative Layout Shift on the current page. */
	    MetricsInstrumentation.prototype._trackCLS = function () {
	        var _this = this;
	        getCLS_1.getCLS(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            utils_1.logger.log('[Measurements] Adding CLS');
	            _this._measurements['cls'] = { value: metric.value };
	        });
	    };
	    /**
	     * Capture the information of the user agent.
	     */
	    MetricsInstrumentation.prototype._trackNavigator = function (transaction) {
	        var navigator = global.navigator;
	        if (!navigator) {
	            return;
	        }
	        // track network connectivity
	        var connection = navigator.connection;
	        if (connection) {
	            if (connection.effectiveType) {
	                transaction.setTag('effectiveConnectionType', connection.effectiveType);
	            }
	            if (connection.type) {
	                transaction.setTag('connectionType', connection.type);
	            }
	            if (isMeasurementValue(connection.rtt)) {
	                this._measurements['connection.rtt'] = { value: connection.rtt };
	            }
	            if (isMeasurementValue(connection.downlink)) {
	                this._measurements['connection.downlink'] = { value: connection.downlink };
	            }
	        }
	        if (isMeasurementValue(navigator.deviceMemory)) {
	            transaction.setTag('deviceMemory', String(navigator.deviceMemory));
	        }
	        if (isMeasurementValue(navigator.hardwareConcurrency)) {
	            transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
	        }
	    };
	    /** Starts tracking the Largest Contentful Paint on the current page. */
	    MetricsInstrumentation.prototype._trackLCP = function () {
	        var _this = this;
	        getLCP_1.getLCP(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            var timeOrigin = utils_2.msToSec(performance.timeOrigin);
	            var startTime = utils_2.msToSec(entry.startTime);
	            utils_1.logger.log('[Measurements] Adding LCP');
	            _this._measurements['lcp'] = { value: metric.value };
	            _this._measurements['mark.lcp'] = { value: timeOrigin + startTime };
	        });
	    };
	    /** Starts tracking the First Input Delay on the current page. */
	    MetricsInstrumentation.prototype._trackFID = function () {
	        var _this = this;
	        getFID_1.getFID(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            var timeOrigin = utils_2.msToSec(performance.timeOrigin);
	            var startTime = utils_2.msToSec(entry.startTime);
	            utils_1.logger.log('[Measurements] Adding FID');
	            _this._measurements['fid'] = { value: metric.value };
	            _this._measurements['mark.fid'] = { value: timeOrigin + startTime };
	        });
	    };
	    /** Starts tracking the Time to First Byte on the current page. */
	    MetricsInstrumentation.prototype._trackTTFB = function () {
	        var _this = this;
	        getTTFB_1.getTTFB(function (metric) {
	            var _a;
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            utils_1.logger.log('[Measurements] Adding TTFB');
	            _this._measurements['ttfb'] = { value: metric.value };
	            // Capture the time spent making the request and receiving the first byte of the response
	            var requestTime = metric.value - (_a = metric.entries[0], (_a !== null && _a !== void 0 ? _a : entry)).requestStart;
	            _this._measurements['ttfb.requestTime'] = { value: requestTime };
	        });
	    };
	    return MetricsInstrumentation;
	}());
	exports.MetricsInstrumentation = MetricsInstrumentation;
	/** Instrument navigation entries */
	function addNavigationSpans(transaction, entry, timeOrigin) {
	    addPerformanceNavigationTiming(transaction, entry, 'unloadEvent', timeOrigin);
	    addPerformanceNavigationTiming(transaction, entry, 'redirect', timeOrigin);
	    addPerformanceNavigationTiming(transaction, entry, 'domContentLoadedEvent', timeOrigin);
	    addPerformanceNavigationTiming(transaction, entry, 'loadEvent', timeOrigin);
	    addPerformanceNavigationTiming(transaction, entry, 'connect', timeOrigin);
	    addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'connectEnd');
	    addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'domainLookupStart');
	    addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin);
	    addRequest(transaction, entry, timeOrigin);
	}
	/** Create measure related spans */
	function addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
	    var measureStartTimestamp = timeOrigin + startTime;
	    var measureEndTimestamp = measureStartTimestamp + duration;
	    _startChild(transaction, {
	        description: entry.name,
	        endTimestamp: measureEndTimestamp,
	        op: entry.entryType,
	        startTimestamp: measureStartTimestamp,
	    });
	    return measureStartTimestamp;
	}
	/** Create resource-related spans */
	function addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin) {
	    // we already instrument based on fetch and xhr, so we don't need to
	    // duplicate spans here.
	    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
	        return undefined;
	    }
	    var data = {};
	    if ('transferSize' in entry) {
	        data['Transfer Size'] = entry.transferSize;
	    }
	    if ('encodedBodySize' in entry) {
	        data['Encoded Body Size'] = entry.encodedBodySize;
	    }
	    if ('decodedBodySize' in entry) {
	        data['Decoded Body Size'] = entry.decodedBodySize;
	    }
	    var startTimestamp = timeOrigin + startTime;
	    var endTimestamp = startTimestamp + duration;
	    _startChild(transaction, {
	        description: resourceName,
	        endTimestamp: endTimestamp,
	        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
	        startTimestamp: startTimestamp,
	        data: data,
	    });
	    return endTimestamp;
	}
	exports.addResourceSpans = addResourceSpans;
	/** Create performance navigation related spans */
	function addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, eventEnd) {
	    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
	    var start = entry[event + "Start"];
	    if (!start || !end) {
	        return;
	    }
	    _startChild(transaction, {
	        op: 'browser',
	        description: event,
	        startTimestamp: timeOrigin + utils_2.msToSec(start),
	        endTimestamp: timeOrigin + utils_2.msToSec(end),
	    });
	}
	/** Create request and response related spans */
	function addRequest(transaction, entry, timeOrigin) {
	    _startChild(transaction, {
	        op: 'browser',
	        description: 'request',
	        startTimestamp: timeOrigin + utils_2.msToSec(entry.requestStart),
	        endTimestamp: timeOrigin + utils_2.msToSec(entry.responseEnd),
	    });
	    _startChild(transaction, {
	        op: 'browser',
	        description: 'response',
	        startTimestamp: timeOrigin + utils_2.msToSec(entry.responseStart),
	        endTimestamp: timeOrigin + utils_2.msToSec(entry.responseEnd),
	    });
	}
	/**
	 * Helper function to start child on transactions. This function will make sure that the transaction will
	 * use the start timestamp of the created child span if it is earlier than the transactions actual
	 * start timestamp.
	 */
	function _startChild(transaction, _a) {
	    var startTimestamp = _a.startTimestamp, ctx = tslib_1.__rest(_a, ["startTimestamp"]);
	    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
	        transaction.startTimestamp = startTimestamp;
	    }
	    return transaction.startChild(tslib_1.__assign({ startTimestamp: startTimestamp }, ctx));
	}
	exports._startChild = _startChild;
	/**
	 * Checks if a given value is a valid measurement value.
	 */
	function isMeasurementValue(value) {
	    return typeof value === 'number' && isFinite(value);
	}
	//# sourceMappingURL=metrics.js.map

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(1);
	var global = utils_1.getGlobalObject();
	/**
	 * Default function implementing pageload and navigation transactions
	 */
	function defaultRoutingInstrumentation(startTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
	    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
	    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
	    if (!global || !global.location) {
	        utils_1.logger.warn('Could not initialize routing instrumentation due to invalid location');
	        return;
	    }
	    var startingUrl = global.location.href;
	    var activeTransaction;
	    if (startTransactionOnPageLoad) {
	        activeTransaction = startTransaction({ name: global.location.pathname, op: 'pageload' });
	    }
	    if (startTransactionOnLocationChange) {
	        utils_1.addInstrumentationHandler({
	            callback: function (_a) {
	                var to = _a.to, from = _a.from;
	                /**
	                 * This early return is there to account for some cases where a navigation transaction starts right after
	                 * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
	                 * create an uneccessary navigation transaction.
	                 *
	                 * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
	                 * only be caused in certain development environments where the usage of a hot module reloader is causing
	                 * errors.
	                 */
	                if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
	                    startingUrl = undefined;
	                    return;
	                }
	                if (from !== to) {
	                    startingUrl = undefined;
	                    if (activeTransaction) {
	                        utils_1.logger.log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
	                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
	                        activeTransaction.finish();
	                    }
	                    activeTransaction = startTransaction({ name: global.location.pathname, op: 'navigation' });
	                }
	            },
	            type: 'history',
	        });
	    }
	}
	exports.defaultRoutingInstrumentation = defaultRoutingInstrumentation;
	//# sourceMappingURL=router.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(34);
	var initMetric_1 = __webpack_require__(22);
	var observe_1 = __webpack_require__(36);
	var onHidden_1 = __webpack_require__(23);
	exports.getCLS = function (onReport, reportAllChanges) {
	    if (reportAllChanges === void 0) { reportAllChanges = false; }
	    var metric = initMetric_1.initMetric('CLS', 0);
	    var report;
	    var entryHandler = function (entry) {
	        // Only count layout shifts without recent user input.
	        if (!entry.hadRecentInput) {
	            metric.value += entry.value;
	            metric.entries.push(entry);
	            report();
	        }
	    };
	    var po = observe_1.observe('layout-shift', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, po, reportAllChanges);
	        onHidden_1.onHidden(function (_a) {
	            var isUnloading = _a.isUnloading;
	            po.takeRecords().map(entryHandler);
	            if (isUnloading) {
	                metric.isFinal = true;
	            }
	            report();
	        });
	    }
	};
	//# sourceMappingURL=getCLS.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(34);
	var getFirstHidden_1 = __webpack_require__(35);
	var initMetric_1 = __webpack_require__(22);
	var observe_1 = __webpack_require__(36);
	var onHidden_1 = __webpack_require__(23);
	exports.getFID = function (onReport) {
	    var metric = initMetric_1.initMetric('FID');
	    var firstHidden = getFirstHidden_1.getFirstHidden();
	    var entryHandler = function (entry) {
	        // Only report if the page wasn't hidden prior to the first input.
	        if (entry.startTime < firstHidden.timeStamp) {
	            metric.value = entry.processingStart - entry.startTime;
	            metric.entries.push(entry);
	            metric.isFinal = true;
	            report();
	        }
	    };
	    var po = observe_1.observe('first-input', entryHandler);
	    var report = bindReporter_1.bindReporter(onReport, metric, po);
	    if (po) {
	        onHidden_1.onHidden(function () {
	            po.takeRecords().map(entryHandler);
	            po.disconnect();
	        }, true);
	    }
	    else {
	        if (window.perfMetrics && window.perfMetrics.onFirstInputDelay) {
	            window.perfMetrics.onFirstInputDelay(function (value, event) {
	                // Only report if the page wasn't hidden prior to the first input.
	                if (event.timeStamp < firstHidden.timeStamp) {
	                    metric.value = value;
	                    metric.isFinal = true;
	                    metric.entries = [
	                        {
	                            entryType: 'first-input',
	                            name: event.type,
	                            target: event.target,
	                            cancelable: event.cancelable,
	                            startTime: event.timeStamp,
	                            processingStart: event.timeStamp + value,
	                        },
	                    ];
	                    report();
	                }
	            });
	        }
	    }
	};
	//# sourceMappingURL=getFID.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(34);
	var getFirstHidden_1 = __webpack_require__(35);
	var initMetric_1 = __webpack_require__(22);
	var observe_1 = __webpack_require__(36);
	var onHidden_1 = __webpack_require__(23);
	var whenInput_1 = __webpack_require__(124);
	exports.getLCP = function (onReport, reportAllChanges) {
	    if (reportAllChanges === void 0) { reportAllChanges = false; }
	    var metric = initMetric_1.initMetric('LCP');
	    var firstHidden = getFirstHidden_1.getFirstHidden();
	    var report;
	    var entryHandler = function (entry) {
	        // The startTime attribute returns the value of the renderTime if it is not 0,
	        // and the value of the loadTime otherwise.
	        var value = entry.startTime;
	        // If the page was hidden prior to paint time of the entry,
	        // ignore it and mark the metric as final, otherwise add the entry.
	        if (value < firstHidden.timeStamp) {
	            metric.value = value;
	            metric.entries.push(entry);
	        }
	        else {
	            metric.isFinal = true;
	        }
	        report();
	    };
	    var po = observe_1.observe('largest-contentful-paint', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, po, reportAllChanges);
	        var onFinal = function () {
	            if (!metric.isFinal) {
	                po.takeRecords().map(entryHandler);
	                metric.isFinal = true;
	                report();
	            }
	        };
	        void whenInput_1.whenInput().then(onFinal);
	        onHidden_1.onHidden(onFinal, true);
	    }
	};
	//# sourceMappingURL=getLCP.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(1);
	var initMetric_1 = __webpack_require__(22);
	var global = utils_1.getGlobalObject();
	var afterLoad = function (callback) {
	    if (document.readyState === 'complete') {
	        // Queue a task so the callback runs after `loadEventEnd`.
	        setTimeout(callback, 0);
	    }
	    else {
	        // Use `pageshow` so the callback runs after `loadEventEnd`.
	        addEventListener('pageshow', callback);
	    }
	};
	var getNavigationEntryFromPerformanceTiming = function () {
	    // Really annoying that TypeScript errors when using `PerformanceTiming`.
	    // eslint-disable-next-line deprecation/deprecation
	    var timing = global.performance.timing;
	    var navigationEntry = {
	        entryType: 'navigation',
	        startTime: 0,
	    };
	    for (var key in timing) {
	        if (key !== 'navigationStart' && key !== 'toJSON') {
	            navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
	        }
	    }
	    return navigationEntry;
	};
	exports.getTTFB = function (onReport) {
	    var metric = initMetric_1.initMetric('TTFB');
	    afterLoad(function () {
	        try {
	            // Use the NavigationTiming L2 entry if available.
	            var navigationEntry = global.performance.getEntriesByType('navigation')[0] || getNavigationEntryFromPerformanceTiming();
	            metric.value = metric.delta = navigationEntry.responseStart;
	            metric.entries = [navigationEntry];
	            onReport(metric);
	        }
	        catch (error) {
	            // Do nothing.
	        }
	    });
	};
	//# sourceMappingURL=getTTFB.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Performantly generate a unique, 27-char string by combining the current
	 * timestamp with a 13-digit random number.
	 * @return {string}
	 */
	exports.generateUniqueID = function () {
	    return Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
	};
	//# sourceMappingURL=generateUniqueID.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var inputPromise;
	exports.whenInput = function () {
	    if (!inputPromise) {
	        inputPromise = new Promise(function (r) {
	            return ['scroll', 'keydown', 'pointerdown'].map(function (type) {
	                addEventListener(type, r, {
	                    once: true,
	                    passive: true,
	                    capture: true,
	                });
	            });
	        });
	    }
	    return inputPromise;
	};
	//# sourceMappingURL=whenInput.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(1);
	var spanstatus_1 = __webpack_require__(14);
	var utils_2 = __webpack_require__(10);
	/**
	 * Configures global error listeners
	 */
	function registerErrorInstrumentation() {
	    utils_1.addInstrumentationHandler({
	        callback: errorCallback,
	        type: 'error',
	    });
	    utils_1.addInstrumentationHandler({
	        callback: errorCallback,
	        type: 'unhandledrejection',
	    });
	}
	exports.registerErrorInstrumentation = registerErrorInstrumentation;
	/**
	 * If an error or unhandled promise occurs, we mark the active transaction as failed
	 */
	function errorCallback() {
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        utils_1.logger.log("[Tracing] Transaction: " + spanstatus_1.SpanStatus.InternalError + " -> Global error occured");
	        activeTransaction.setStatus(spanstatus_1.SpanStatus.InternalError);
	    }
	}
	//# sourceMappingURL=errors.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var browser_1 = __webpack_require__(64);
	var hubextensions_1 = __webpack_require__(37);
	exports.addExtensionMethods = hubextensions_1.addExtensionMethods;
	var TracingIntegrations = __webpack_require__(128);
	var Integrations = tslib_1.__assign(tslib_1.__assign({}, TracingIntegrations), { BrowserTracing: browser_1.BrowserTracing });
	exports.Integrations = Integrations;
	var span_1 = __webpack_require__(39);
	exports.Span = span_1.Span;
	var transaction_1 = __webpack_require__(40);
	exports.Transaction = transaction_1.Transaction;
	var browser_2 = __webpack_require__(64);
	exports.registerRequestInstrumentation = browser_2.registerRequestInstrumentation;
	exports.defaultRequestInstrumentationOptions = browser_2.defaultRequestInstrumentationOptions;
	var spanstatus_1 = __webpack_require__(14);
	exports.SpanStatus = spanstatus_1.SpanStatus;
	var idletransaction_1 = __webpack_require__(38);
	exports.IdleTransaction = idletransaction_1.IdleTransaction;
	var hubextensions_2 = __webpack_require__(37);
	exports.startIdleTransaction = hubextensions_2.startIdleTransaction;
	// We are patching the global object with our hub extension methods
	hubextensions_1.addExtensionMethods();
	var utils_1 = __webpack_require__(10);
	exports.extractTraceparentData = utils_1.extractTraceparentData;
	exports.getActiveTransaction = utils_1.getActiveTransaction;
	exports.hasTracingEnabled = utils_1.hasTracingEnabled;
	exports.stripUrlQueryAndFragment = utils_1.stripUrlQueryAndFragment;
	exports.TRACEPARENT_REGEXP = utils_1.TRACEPARENT_REGEXP;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var utils_1 = __webpack_require__(1);
	/**
	 * Express integration
	 *
	 * Provides an request and error handler for Express framework as well as tracing capabilities
	 */
	var Express = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Express(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Express.id;
	        this._router = options.router || options.app;
	        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
	    }
	    /**
	     * @inheritDoc
	     */
	    Express.prototype.setupOnce = function () {
	        if (!this._router) {
	            utils_1.logger.error('ExpressIntegration is missing an Express instance');
	            return;
	        }
	        instrumentMiddlewares(this._router, this._methods);
	    };
	    /**
	     * @inheritDoc
	     */
	    Express.id = 'Express';
	    return Express;
	}());
	exports.Express = Express;
	/**
	 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
	 * and finishes it once the middleware is done invoking.
	 *
	 * Express middlewares have 3 various forms, thus we have to take care of all of them:
	 * // sync
	 * app.use(function (req, res) { ... })
	 * // async
	 * app.use(function (req, res, next) { ... })
	 * // error handler
	 * app.use(function (err, req, res, next) { ... })
	 *
	 * They all internally delegate to the `router[method]` of the given application instance.
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
	function wrap(fn, method) {
	    var arity = fn.length;
	    switch (arity) {
	        case 2: {
	            return function (req, res) {
	                var transaction = res.__sentry_transaction;
	                if (transaction) {
	                    var span_1 = transaction.startChild({
	                        description: fn.name,
	                        op: "middleware." + method,
	                    });
	                    res.once('finish', function () {
	                        span_1.finish();
	                    });
	                }
	                return fn.call(this, req, res);
	            };
	        }
	        case 3: {
	            return function (req, res, next) {
	                var _a;
	                var transaction = res.__sentry_transaction;
	                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
	                    description: fn.name,
	                    op: "middleware." + method,
	                });
	                fn.call(this, req, res, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var _a;
	                    (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                    next.call.apply(next, tslib_1.__spread([this], args));
	                });
	            };
	        }
	        case 4: {
	            return function (err, req, res, next) {
	                var _a;
	                var transaction = res.__sentry_transaction;
	                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
	                    description: fn.name,
	                    op: "middleware." + method,
	                });
	                fn.call(this, err, req, res, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var _a;
	                    (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                    next.call.apply(next, tslib_1.__spread([this], args));
	                });
	            };
	        }
	        default: {
	            throw new Error("Express middleware takes 2-4 arguments. Got: " + arity);
	        }
	    }
	}
	/**
	 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
	 * and wraps every function, as well as array of functions with a call to our `wrap` method.
	 * We have to take care of the arrays as well as iterate over all of the arguments,
	 * as `app.use` can accept middlewares in few various forms.
	 *
	 * app.use([<path>], <fn>)
	 * app.use([<path>], <fn>, ...<fn>)
	 * app.use([<path>], ...<fn>[])
	 */
	function wrapMiddlewareArgs(args, method) {
	    return args.map(function (arg) {
	        if (typeof arg === 'function') {
	            return wrap(arg, method);
	        }
	        if (Array.isArray(arg)) {
	            return arg.map(function (a) {
	                if (typeof a === 'function') {
	                    return wrap(a, method);
	                }
	                return a;
	            });
	        }
	        return arg;
	    });
	}
	/**
	 * Patches original router to utilize our tracing functionality
	 */
	function patchMiddleware(router, method) {
	    var originalCallback = router[method];
	    router[method] = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return originalCallback.call.apply(originalCallback, tslib_1.__spread([this], wrapMiddlewareArgs(args, method)));
	    };
	    return router;
	}
	/**
	 * Patches original router methods
	 */
	function instrumentMiddlewares(router, methods) {
	    if (methods === void 0) { methods = []; }
	    methods.forEach(function (method) { return patchMiddleware(router, method); });
	}
	//# sourceMappingURL=express.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var express_1 = __webpack_require__(127);
	exports.Express = express_1.Express;
	var postgres_1 = __webpack_require__(131);
	exports.Postgres = postgres_1.Postgres;
	var mysql_1 = __webpack_require__(130);
	exports.Mysql = mysql_1.Mysql;
	var mongo_1 = __webpack_require__(129);
	exports.Mongo = mongo_1.Mongo;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var utils_1 = __webpack_require__(1);
	var OPERATIONS = [
	    'aggregate',
	    'bulkWrite',
	    'countDocuments',
	    'createIndex',
	    'createIndexes',
	    'deleteMany',
	    'deleteOne',
	    'distinct',
	    'drop',
	    'dropIndex',
	    'dropIndexes',
	    'estimatedDocumentCount',
	    'findOne',
	    'findOneAndDelete',
	    'findOneAndReplace',
	    'findOneAndUpdate',
	    'indexes',
	    'indexExists',
	    'indexInformation',
	    'initializeOrderedBulkOp',
	    'insertMany',
	    'insertOne',
	    'isCapped',
	    'mapReduce',
	    'options',
	    'parallelCollectionScan',
	    'rename',
	    'replaceOne',
	    'stats',
	    'updateMany',
	    'updateOne',
	];
	// All of the operations above take `options` and `callback` as their final parameters, but some of them
	// take additional parameters as well. For those operations, this is a map of
	// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
	// positional arguments when we add them to the span's `data` object later
	var OPERATION_SIGNATURES = {
	    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
	    // see https://github.com/getsentry/sentry-javascript/pull/3102
	    bulkWrite: ['operations'],
	    countDocuments: ['query'],
	    createIndex: ['fieldOrSpec'],
	    createIndexes: ['indexSpecs'],
	    deleteMany: ['filter'],
	    deleteOne: ['filter'],
	    distinct: ['key', 'query'],
	    dropIndex: ['indexName'],
	    findOne: ['query'],
	    findOneAndDelete: ['filter'],
	    findOneAndReplace: ['filter', 'replacement'],
	    findOneAndUpdate: ['filter', 'update'],
	    indexExists: ['indexes'],
	    insertMany: ['docs'],
	    insertOne: ['doc'],
	    mapReduce: ['map', 'reduce'],
	    rename: ['newName'],
	    replaceOne: ['filter', 'doc'],
	    updateMany: ['filter', 'update'],
	    updateOne: ['filter', 'update'],
	};
	/** Tracing integration for mongo package */
	var Mongo = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Mongo(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Mongo.id;
	        this._operations = Array.isArray(options.operations)
	            ? options.operations
	            : OPERATIONS;
	        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
	    }
	    /**
	     * @inheritDoc
	     */
	    Mongo.prototype.setupOnce = function (_, getCurrentHub) {
	        var collection;
	        try {
	            var mongodbModule = utils_1.dynamicRequire(module, 'mongodb');
	            collection = mongodbModule.Collection;
	        }
	        catch (e) {
	            utils_1.logger.error('Mongo Integration was unable to require `mongodb` package.');
	            return;
	        }
	        this._instrumentOperations(collection, this._operations, getCurrentHub);
	    };
	    /**
	     * Patches original collection methods
	     */
	    Mongo.prototype._instrumentOperations = function (collection, operations, getCurrentHub) {
	        var _this = this;
	        operations.forEach(function (operation) { return _this._patchOperation(collection, operation, getCurrentHub); });
	    };
	    /**
	     * Patches original collection to utilize our tracing functionality
	     */
	    Mongo.prototype._patchOperation = function (collection, operation, getCurrentHub) {
	        if (!(operation in collection.prototype))
	            return;
	        var getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
	        utils_1.fill(collection.prototype, operation, function (orig) {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var _a, _b, _c;
	                var lastArg = args[args.length - 1];
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                // Check if the operation was passed a callback. (mapReduce requires a different check, as
	                // its (non-callback) arguments can also be functions.)
	                if (typeof lastArg !== 'function' || (operation === 'mapReduce' && args.length === 2)) {
	                    var span_1 = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild(getSpanContext(this, operation, args));
	                    return orig.call.apply(orig, tslib_1.__spread([this], args)).then(function (res) {
	                        var _a;
	                        (_a = span_1) === null || _a === void 0 ? void 0 : _a.finish();
	                        return res;
	                    });
	                }
	                var span = (_c = parentSpan) === null || _c === void 0 ? void 0 : _c.startChild(getSpanContext(this, operation, args.slice(0, -1)));
	                return orig.call.apply(orig, tslib_1.__spread([this], args.slice(0, -1), [function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        lastArg(err, result);
	                    }]));
	            };
	        });
	    };
	    /**
	     * Form a SpanContext based on the user input to a given operation.
	     */
	    Mongo.prototype._getSpanContextFromOperationArguments = function (collection, operation, args) {
	        var data = {
	            collectionName: collection.collectionName,
	            dbName: collection.dbName,
	            namespace: collection.namespace,
	        };
	        var spanContext = {
	            op: "db",
	            description: operation,
	            data: data,
	        };
	        // If the operation takes no arguments besides `options` and `callback`, or if argument
	        // collection is disabled for this operation, just return early.
	        var signature = OPERATION_SIGNATURES[operation];
	        var shouldDescribe = Array.isArray(this._describeOperations)
	            ? this._describeOperations.includes(operation)
	            : this._describeOperations;
	        if (!signature || !shouldDescribe) {
	            return spanContext;
	        }
	        try {
	            // Special case for `mapReduce`, as the only one accepting functions as arguments.
	            if (operation === 'mapReduce') {
	                var _a = tslib_1.__read(args, 2), map = _a[0], reduce = _a[1];
	                data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
	                data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
	            }
	            else {
	                for (var i = 0; i < signature.length; i++) {
	                    data[signature[i]] = JSON.stringify(args[i]);
	                }
	            }
	        }
	        catch (_oO) {
	            // no-empty
	        }
	        return spanContext;
	    };
	    /**
	     * @inheritDoc
	     */
	    Mongo.id = 'Mongo';
	    return Mongo;
	}());
	exports.Mongo = Mongo;
	//# sourceMappingURL=mongo.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(1);
	/** Tracing integration for node-mysql package */
	var Mysql = /** @class */ (function () {
	    function Mysql() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Mysql.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Mysql.prototype.setupOnce = function (_, getCurrentHub) {
	        var connection;
	        try {
	            // Unfortunatelly mysql is using some custom loading system and `Connection` is not exported directly.
	            connection = utils_1.dynamicRequire(module, 'mysql/lib/Connection.js');
	        }
	        catch (e) {
	            utils_1.logger.error('Mysql Integration was unable to require `mysql` package.');
	            return;
	        }
	        // The original function will have one of these signatures:
	        //    function (callback) => void
	        //    function (options, callback) => void
	        //    function (options, values, callback) => void
	        utils_1.fill(connection.prototype, 'query', function (orig) {
	            return function (options, values, callback) {
	                var _a, _b;
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
	                    description: typeof options === 'string' ? options : options.sql,
	                    op: "db",
	                });
	                if (typeof callback === 'function') {
	                    return orig.call(this, options, values, function (err, result, fields) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        callback(err, result, fields);
	                    });
	                }
	                if (typeof values === 'function') {
	                    return orig.call(this, options, function (err, result, fields) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        values(err, result, fields);
	                    });
	                }
	                return orig.call(this, options, values, callback);
	            };
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Mysql.id = 'Mysql';
	    return Mysql;
	}());
	exports.Mysql = Mysql;
	//# sourceMappingURL=mysql.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(1);
	/** Tracing integration for node-postgres package */
	var Postgres = /** @class */ (function () {
	    function Postgres() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Postgres.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Postgres.prototype.setupOnce = function (_, getCurrentHub) {
	        var client;
	        try {
	            var pgModule = utils_1.dynamicRequire(module, 'pg');
	            client = pgModule.Client;
	        }
	        catch (e) {
	            utils_1.logger.error('Postgres Integration was unable to require `pg` package.');
	            return;
	        }
	        /**
	         * function (query, callback) => void
	         * function (query, params, callback) => void
	         * function (query) => Promise
	         * function (query, params) => Promise
	         */
	        utils_1.fill(client.prototype, 'query', function (orig) {
	            return function (config, values, callback) {
	                var _a, _b;
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
	                    description: typeof config === 'string' ? config : config.text,
	                    op: "db",
	                });
	                if (typeof callback === 'function') {
	                    return orig.call(this, config, values, function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        callback(err, result);
	                    });
	                }
	                if (typeof values === 'function') {
	                    return orig.call(this, config, function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        values(err, result);
	                    });
	                }
	                return orig.call(this, config, values).then(function (res) {
	                    var _a;
	                    (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                    return res;
	                });
	            };
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Postgres.id = 'Postgres';
	    return Postgres;
	}());
	exports.Postgres = Postgres;
	//# sourceMappingURL=postgres.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** Console logging verbosity for the SDK. */
	var LogLevel;
	(function (LogLevel) {
	    /** No logs will be generated. */
	    LogLevel[LogLevel["None"] = 0] = "None";
	    /** Only SDK internal errors will be logged. */
	    LogLevel[LogLevel["Error"] = 1] = "Error";
	    /** Information useful for debugging the SDK will be logged. */
	    LogLevel[LogLevel["Debug"] = 2] = "Debug";
	    /** All SDK actions will be logged. */
	    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
	})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
	//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Session Status
	 */
	var SessionStatus;
	(function (SessionStatus) {
	    /** JSDoc */
	    SessionStatus["Ok"] = "ok";
	    /** JSDoc */
	    SessionStatus["Exited"] = "exited";
	    /** JSDoc */
	    SessionStatus["Crashed"] = "crashed";
	    /** JSDoc */
	    SessionStatus["Abnormal"] = "abnormal";
	})(SessionStatus = exports.SessionStatus || (exports.SessionStatus = {}));
	//# sourceMappingURL=session.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** JSDoc */
	// eslint-disable-next-line import/export
	var Severity;
	(function (Severity) {
	    /** JSDoc */
	    Severity["Fatal"] = "fatal";
	    /** JSDoc */
	    Severity["Error"] = "error";
	    /** JSDoc */
	    Severity["Warning"] = "warning";
	    /** JSDoc */
	    Severity["Log"] = "log";
	    /** JSDoc */
	    Severity["Info"] = "info";
	    /** JSDoc */
	    Severity["Debug"] = "debug";
	    /** JSDoc */
	    Severity["Critical"] = "critical";
	})(Severity = exports.Severity || (exports.Severity = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (Severity) {
	    /**
	     * Converts a string-based level into a {@link Severity}.
	     *
	     * @param level string representation of Severity
	     * @returns Severity
	     */
	    function fromString(level) {
	        switch (level) {
	            case 'debug':
	                return Severity.Debug;
	            case 'info':
	                return Severity.Info;
	            case 'warn':
	            case 'warning':
	                return Severity.Warning;
	            case 'error':
	                return Severity.Error;
	            case 'fatal':
	                return Severity.Fatal;
	            case 'critical':
	                return Severity.Critical;
	            case 'log':
	            default:
	                return Severity.Log;
	        }
	    }
	    Severity.fromString = fromString;
	})(Severity = exports.Severity || (exports.Severity = {}));
	//# sourceMappingURL=severity.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** The status of an event. */
	// eslint-disable-next-line import/export
	var Status;
	(function (Status) {
	    /** The status could not be determined. */
	    Status["Unknown"] = "unknown";
	    /** The event was skipped due to configuration or callbacks. */
	    Status["Skipped"] = "skipped";
	    /** The event was sent to Sentry successfully. */
	    Status["Success"] = "success";
	    /** The client is currently rate limited and will try again later. */
	    Status["RateLimit"] = "rate_limit";
	    /** The event could not be processed. */
	    Status["Invalid"] = "invalid";
	    /** A server-side error ocurred during submission. */
	    Status["Failed"] = "failed";
	})(Status = exports.Status || (exports.Status = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (Status) {
	    /**
	     * Converts a HTTP status code into a {@link Status}.
	     *
	     * @param code The HTTP response status code.
	     * @returns The send status or {@link Status.Unknown}.
	     */
	    function fromHttpCode(code) {
	        if (code >= 200 && code < 300) {
	            return Status.Success;
	        }
	        if (code === 429) {
	            return Status.RateLimit;
	        }
	        if (code >= 400 && code < 500) {
	            return Status.Invalid;
	        }
	        if (code >= 500) {
	            return Status.Failed;
	        }
	        return Status.Unknown;
	    }
	    Status.fromHttpCode = fromHttpCode;
	})(Status = exports.Status || (exports.Status = {}));
	//# sourceMappingURL=status.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var TransactionSamplingMethod;
	(function (TransactionSamplingMethod) {
	    TransactionSamplingMethod["Explicit"] = "explicitly_set";
	    TransactionSamplingMethod["Sampler"] = "client_sampler";
	    TransactionSamplingMethod["Rate"] = "client_rate";
	    TransactionSamplingMethod["Inheritance"] = "inheritance";
	})(TransactionSamplingMethod = exports.TransactionSamplingMethod || (exports.TransactionSamplingMethod = {}));
	//# sourceMappingURL=transaction.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Consumes the promise and logs the error when it rejects.
	 * @param promise A promise to forget.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function forget(promise) {
	    promise.then(null, function (e) {
	        // TODO: Use a better logging mechanism
	        // eslint-disable-next-line no-console
	        console.error(e);
	    });
	}
	exports.forget = forget;
	//# sourceMappingURL=async.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var error_1 = __webpack_require__(41);
	/** Regular expression used to parse a Dsn. */
	var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
	/** Error message */
	var ERROR_MESSAGE = 'Invalid Dsn';
	/** The Sentry Dsn, identifying a Sentry instance and project. */
	var Dsn = /** @class */ (function () {
	    /** Creates a new Dsn component */
	    function Dsn(from) {
	        if (typeof from === 'string') {
	            this._fromString(from);
	        }
	        else {
	            this._fromComponents(from);
	        }
	        this._validate();
	    }
	    /**
	     * Renders the string representation of this Dsn.
	     *
	     * By default, this will render the public representation without the password
	     * component. To get the deprecated private representation, set `withPassword`
	     * to true.
	     *
	     * @param withPassword When set to true, the password will be included.
	     */
	    Dsn.prototype.toString = function (withPassword) {
	        if (withPassword === void 0) { withPassword = false; }
	        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
	        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
	            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
	    };
	    /** Parses a string into this Dsn. */
	    Dsn.prototype._fromString = function (str) {
	        var match = DSN_REGEX.exec(str);
	        if (!match) {
	            throw new error_1.SentryError(ERROR_MESSAGE);
	        }
	        var _a = tslib_1.__read(match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
	        var path = '';
	        var projectId = lastPath;
	        var split = projectId.split('/');
	        if (split.length > 1) {
	            path = split.slice(0, -1).join('/');
	            projectId = split.pop();
	        }
	        if (projectId) {
	            var projectMatch = projectId.match(/^\d+/);
	            if (projectMatch) {
	                projectId = projectMatch[0];
	            }
	        }
	        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
	    };
	    /** Maps Dsn components into this instance. */
	    Dsn.prototype._fromComponents = function (components) {
	        this.protocol = components.protocol;
	        this.user = components.user;
	        this.pass = components.pass || '';
	        this.host = components.host;
	        this.port = components.port || '';
	        this.path = components.path || '';
	        this.projectId = components.projectId;
	    };
	    /** Validates this Dsn and throws on error. */
	    Dsn.prototype._validate = function () {
	        var _this = this;
	        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
	            if (!_this[component]) {
	                throw new error_1.SentryError(ERROR_MESSAGE + ": " + component + " missing");
	            }
	        });
	        if (!this.projectId.match(/^\d+$/)) {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
	        }
	        if (this.protocol !== 'http' && this.protocol !== 'https') {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
	        }
	        if (this.port && isNaN(parseInt(this.port, 10))) {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid port " + this.port);
	        }
	    };
	    return Dsn;
	}());
	exports.Dsn = Dsn;
	//# sourceMappingURL=dsn.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(2);
	var is_1 = __webpack_require__(11);
	var logger_1 = __webpack_require__(42);
	var misc_1 = __webpack_require__(18);
	var object_1 = __webpack_require__(44);
	var stacktrace_1 = __webpack_require__(45);
	var supports_1 = __webpack_require__(68);
	var global = misc_1.getGlobalObject();
	/**
	 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
	 *  - Console API
	 *  - Fetch API
	 *  - XHR API
	 *  - History API
	 *  - DOM API (click/typing)
	 *  - Error API
	 *  - UnhandledRejection API
	 */
	var handlers = {};
	var instrumented = {};
	/** Instruments given API */
	function instrument(type) {
	    if (instrumented[type]) {
	        return;
	    }
	    instrumented[type] = true;
	    switch (type) {
	        case 'console':
	            instrumentConsole();
	            break;
	        case 'dom':
	            instrumentDOM();
	            break;
	        case 'xhr':
	            instrumentXHR();
	            break;
	        case 'fetch':
	            instrumentFetch();
	            break;
	        case 'history':
	            instrumentHistory();
	            break;
	        case 'error':
	            instrumentError();
	            break;
	        case 'unhandledrejection':
	            instrumentUnhandledRejection();
	            break;
	        default:
	            logger_1.logger.warn('unknown instrumentation type:', type);
	    }
	}
	/**
	 * Add handler that will be called when given type of instrumentation triggers.
	 * Use at your own risk, this might break without changelog notice, only used internally.
	 * @hidden
	 */
	function addInstrumentationHandler(handler) {
	    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
	        return;
	    }
	    handlers[handler.type] = handlers[handler.type] || [];
	    handlers[handler.type].push(handler.callback);
	    instrument(handler.type);
	}
	exports.addInstrumentationHandler = addInstrumentationHandler;
	/** JSDoc */
	function triggerHandlers(type, data) {
	    var e_1, _a;
	    if (!type || !handlers[type]) {
	        return;
	    }
	    try {
	        for (var _b = tslib_1.__values(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var handler = _c.value;
	            try {
	                handler(data);
	            }
	            catch (e) {
	                logger_1.logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + stacktrace_1.getFunctionName(handler) + "\nError: " + e);
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	}
	/** JSDoc */
	function instrumentConsole() {
	    if (!('console' in global)) {
	        return;
	    }
	    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
	        if (!(level in global.console)) {
	            return;
	        }
	        object_1.fill(global.console, level, function (originalConsoleLevel) {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                triggerHandlers('console', { args: args, level: level });
	                // this fails for some browsers. :(
	                if (originalConsoleLevel) {
	                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
	                }
	            };
	        });
	    });
	}
	/** JSDoc */
	function instrumentFetch() {
	    if (!supports_1.supportsNativeFetch()) {
	        return;
	    }
	    object_1.fill(global, 'fetch', function (originalFetch) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var handlerData = {
	                args: args,
	                fetchData: {
	                    method: getFetchMethod(args),
	                    url: getFetchUrl(args),
	                },
	                startTimestamp: Date.now(),
	            };
	            triggerHandlers('fetch', tslib_1.__assign({}, handlerData));
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            return originalFetch.apply(global, args).then(function (response) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), response: response }));
	                return response;
	            }, function (error) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), error: error }));
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
	                //       it means the sentry.javascript SDK caught an error invoking your application code.
	                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
	                throw error;
	            });
	        };
	    });
	}
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/** Extract `method` from fetch call arguments */
	function getFetchMethod(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
	        return String(fetchArgs[0].method).toUpperCase();
	    }
	    if (fetchArgs[1] && fetchArgs[1].method) {
	        return String(fetchArgs[1].method).toUpperCase();
	    }
	    return 'GET';
	}
	/** Extract `url` from fetch call arguments */
	function getFetchUrl(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if (typeof fetchArgs[0] === 'string') {
	        return fetchArgs[0];
	    }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request)) {
	        return fetchArgs[0].url;
	    }
	    return String(fetchArgs[0]);
	}
	/* eslint-enable @typescript-eslint/no-unsafe-member-access */
	/** JSDoc */
	function instrumentXHR() {
	    if (!('XMLHttpRequest' in global)) {
	        return;
	    }
	    // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.
	    var requestKeys = [];
	    var requestValues = [];
	    var xhrproto = XMLHttpRequest.prototype;
	    object_1.fill(xhrproto, 'open', function (originalOpen) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line @typescript-eslint/no-this-alias
	            var xhr = this;
	            var url = args[1];
	            xhr.__sentry_xhr__ = {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                method: is_1.isString(args[0]) ? args[0].toUpperCase() : args[0],
	                url: args[1],
	            };
	            // if Sentry key appears in URL, don't capture it as a request
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            if (is_1.isString(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
	                xhr.__sentry_own_request__ = true;
	            }
	            var onreadystatechangeHandler = function () {
	                if (xhr.readyState === 4) {
	                    try {
	                        // touching statusCode in some platforms throws
	                        // an exception
	                        if (xhr.__sentry_xhr__) {
	                            xhr.__sentry_xhr__.status_code = xhr.status;
	                        }
	                    }
	                    catch (e) {
	                        /* do nothing */
	                    }
	                    try {
	                        var requestPos = requestKeys.indexOf(xhr);
	                        if (requestPos !== -1) {
	                            // Make sure to pop both key and value to keep it in sync.
	                            requestKeys.splice(requestPos);
	                            var args_1 = requestValues.splice(requestPos)[0];
	                            if (xhr.__sentry_xhr__ && args_1[0] !== undefined) {
	                                xhr.__sentry_xhr__.body = args_1[0];
	                            }
	                        }
	                    }
	                    catch (e) {
	                        /* do nothing */
	                    }
	                    triggerHandlers('xhr', {
	                        args: args,
	                        endTimestamp: Date.now(),
	                        startTimestamp: Date.now(),
	                        xhr: xhr,
	                    });
	                }
	            };
	            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
	                object_1.fill(xhr, 'onreadystatechange', function (original) {
	                    return function () {
	                        var readyStateArgs = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            readyStateArgs[_i] = arguments[_i];
	                        }
	                        onreadystatechangeHandler();
	                        return original.apply(xhr, readyStateArgs);
	                    };
	                });
	            }
	            else {
	                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
	            }
	            return originalOpen.apply(xhr, args);
	        };
	    });
	    object_1.fill(xhrproto, 'send', function (originalSend) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            requestKeys.push(this);
	            requestValues.push(args);
	            triggerHandlers('xhr', {
	                args: args,
	                startTimestamp: Date.now(),
	                xhr: this,
	            });
	            return originalSend.apply(this, args);
	        };
	    });
	}
	var lastHref;
	/** JSDoc */
	function instrumentHistory() {
	    if (!supports_1.supportsHistory()) {
	        return;
	    }
	    var oldOnPopState = global.onpopstate;
	    global.onpopstate = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var to = global.location.href;
	        // keep track of the current URL state, as we always receive only the updated state
	        var from = lastHref;
	        lastHref = to;
	        triggerHandlers('history', {
	            from: from,
	            to: to,
	        });
	        if (oldOnPopState) {
	            return oldOnPopState.apply(this, args);
	        }
	    };
	    /** @hidden */
	    function historyReplacementFunction(originalHistoryFunction) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var url = args.length > 2 ? args[2] : undefined;
	            if (url) {
	                // coerce to string (this is what pushState does)
	                var from = lastHref;
	                var to = String(url);
	                // keep track of the current URL state, as we always receive only the updated state
	                lastHref = to;
	                triggerHandlers('history', {
	                    from: from,
	                    to: to,
	                });
	            }
	            return originalHistoryFunction.apply(this, args);
	        };
	    }
	    object_1.fill(global.history, 'pushState', historyReplacementFunction);
	    object_1.fill(global.history, 'replaceState', historyReplacementFunction);
	}
	/** JSDoc */
	function instrumentDOM() {
	    if (!('document' in global)) {
	        return;
	    }
	    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	    // to the document. Do this before we instrument addEventListener.
	    global.document.addEventListener('click', domEventHandler('click', triggerHandlers.bind(null, 'dom')), false);
	    global.document.addEventListener('keypress', keypressEventHandler(triggerHandlers.bind(null, 'dom')), false);
	    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
	    ['EventTarget', 'Node'].forEach(function (target) {
	        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	        var proto = global[target] && global[target].prototype;
	        // eslint-disable-next-line no-prototype-builtins
	        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	            return;
	        }
	        /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	        object_1.fill(proto, 'addEventListener', function (original) {
	            return function (eventName, fn, options) {
	                if (fn && fn.handleEvent) {
	                    if (eventName === 'click') {
	                        object_1.fill(fn, 'handleEvent', function (innerOriginal) {
	                            return function (event) {
	                                domEventHandler('click', triggerHandlers.bind(null, 'dom'))(event);
	                                return innerOriginal.call(this, event);
	                            };
	                        });
	                    }
	                    if (eventName === 'keypress') {
	                        object_1.fill(fn, 'handleEvent', function (innerOriginal) {
	                            return function (event) {
	                                keypressEventHandler(triggerHandlers.bind(null, 'dom'))(event);
	                                return innerOriginal.call(this, event);
	                            };
	                        });
	                    }
	                }
	                else {
	                    if (eventName === 'click') {
	                        domEventHandler('click', triggerHandlers.bind(null, 'dom'), true)(this);
	                    }
	                    if (eventName === 'keypress') {
	                        keypressEventHandler(triggerHandlers.bind(null, 'dom'))(this);
	                    }
	                }
	                return original.call(this, eventName, fn, options);
	            };
	        });
	        object_1.fill(proto, 'removeEventListener', function (original) {
	            return function (eventName, fn, options) {
	                try {
	                    original.call(this, eventName, fn.__sentry_wrapped__, options);
	                }
	                catch (e) {
	                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
	                }
	                return original.call(this, eventName, fn, options);
	            };
	        });
	    });
	}
	var debounceDuration = 1000;
	var debounceTimer = 0;
	var keypressTimeout;
	var lastCapturedEvent;
	/**
	 * Wraps addEventListener to capture UI breadcrumbs
	 * @param name the event name (e.g. "click")
	 * @param handler function that will be triggered
	 * @param debounce decides whether it should wait till another event loop
	 * @returns wrapped breadcrumb events handler
	 * @hidden
	 */
	function domEventHandler(name, handler, debounce) {
	    if (debounce === void 0) { debounce = false; }
	    return function (event) {
	        // reset keypress timeout; e.g. triggering a 'click' after
	        // a 'keypress' will reset the keypress debounce so that a new
	        // set of keypresses can be recorded
	        keypressTimeout = undefined;
	        // It's possible this handler might trigger multiple times for the same
	        // event (e.g. event propagation through node ancestors). Ignore if we've
	        // already captured the event.
	        if (!event || lastCapturedEvent === event) {
	            return;
	        }
	        lastCapturedEvent = event;
	        if (debounceTimer) {
	            clearTimeout(debounceTimer);
	        }
	        if (debounce) {
	            debounceTimer = setTimeout(function () {
	                handler({ event: event, name: name });
	            });
	        }
	        else {
	            handler({ event: event, name: name });
	        }
	    };
	}
	/**
	 * Wraps addEventListener to capture keypress UI events
	 * @param handler function that will be triggered
	 * @returns wrapped keypress events handler
	 * @hidden
	 */
	function keypressEventHandler(handler) {
	    // TODO: if somehow user switches keypress target before
	    //       debounce timeout is triggered, we will only capture
	    //       a single breadcrumb from the FIRST target (acceptable?)
	    return function (event) {
	        var target;
	        try {
	            target = event.target;
	        }
	        catch (e) {
	            // just accessing event properties can throw an exception in some rare circumstances
	            // see: https://github.com/getsentry/raven-js/issues/838
	            return;
	        }
	        var tagName = target && target.tagName;
	        // only consider keypress events on actual input elements
	        // this will disregard keypresses targeting body (e.g. tabbing
	        // through elements, hotkeys, etc)
	        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
	            return;
	        }
	        // record first keypress in a series, but ignore subsequent
	        // keypresses until debounce clears
	        if (!keypressTimeout) {
	            domEventHandler('input', handler)(event);
	        }
	        clearTimeout(keypressTimeout);
	        keypressTimeout = setTimeout(function () {
	            keypressTimeout = undefined;
	        }, debounceDuration);
	    };
	}
	var _oldOnErrorHandler = null;
	/** JSDoc */
	function instrumentError() {
	    _oldOnErrorHandler = global.onerror;
	    global.onerror = function (msg, url, line, column, error) {
	        triggerHandlers('error', {
	            column: column,
	            error: error,
	            line: line,
	            msg: msg,
	            url: url,
	        });
	        if (_oldOnErrorHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnErrorHandler.apply(this, arguments);
	        }
	        return false;
	    };
	}
	var _oldOnUnhandledRejectionHandler = null;
	/** JSDoc */
	function instrumentUnhandledRejection() {
	    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
	    global.onunhandledrejection = function (e) {
	        triggerHandlers('unhandledrejection', e);
	        if (_oldOnUnhandledRejectionHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
	        }
	        return true;
	    };
	}
	//# sourceMappingURL=instrument.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
	// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
	Object.defineProperty(exports, "__esModule", { value: true });
	/** JSDoc */
	function normalizeArray(parts, allowAboveRoot) {
	    // if the path tries to go above the root, `up` ends up > 0
	    var up = 0;
	    for (var i = parts.length - 1; i >= 0; i--) {
	        var last = parts[i];
	        if (last === '.') {
	            parts.splice(i, 1);
	        }
	        else if (last === '..') {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up++;
	        }
	        else if (up) {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up--;
	        }
	    }
	    // if the path is allowed to go above the root, restore leading ..s
	    if (allowAboveRoot) {
	        // eslint-disable-next-line no-plusplus
	        for (; up--; up) {
	            parts.unshift('..');
	        }
	    }
	    return parts;
	}
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
	/** JSDoc */
	function splitPath(filename) {
	    var parts = splitPathRe.exec(filename);
	    return parts ? parts.slice(1) : [];
	}
	// path.resolve([from ...], to)
	// posix version
	/** JSDoc */
	function resolve() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resolvedPath = '';
	    var resolvedAbsolute = false;
	    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	        var path = i >= 0 ? args[i] : '/';
	        // Skip empty entries
	        if (!path) {
	            continue;
	        }
	        resolvedPath = path + "/" + resolvedPath;
	        resolvedAbsolute = path.charAt(0) === '/';
	    }
	    // At this point the path should be resolved to a full absolute path, but
	    // handle relative paths to be safe (might happen when process.cwd() fails)
	    // Normalize the path
	    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
	    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
	}
	exports.resolve = resolve;
	/** JSDoc */
	function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	        if (arr[start] !== '') {
	            break;
	        }
	    }
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	        if (arr[end] !== '') {
	            break;
	        }
	    }
	    if (start > end) {
	        return [];
	    }
	    return arr.slice(start, end - start + 1);
	}
	// path.relative(from, to)
	// posix version
	/** JSDoc */
	function relative(from, to) {
	    /* eslint-disable no-param-reassign */
	    from = resolve(from).substr(1);
	    to = resolve(to).substr(1);
	    /* eslint-enable no-param-reassign */
	    var fromParts = trim(from.split('/'));
	    var toParts = trim(to.split('/'));
	    var length = Math.min(fromParts.length, toParts.length);
	    var samePartsLength = length;
	    for (var i = 0; i < length; i++) {
	        if (fromParts[i] !== toParts[i]) {
	            samePartsLength = i;
	            break;
	        }
	    }
	    var outputParts = [];
	    for (var i = samePartsLength; i < fromParts.length; i++) {
	        outputParts.push('..');
	    }
	    outputParts = outputParts.concat(toParts.slice(samePartsLength));
	    return outputParts.join('/');
	}
	exports.relative = relative;
	// path.normalize(path)
	// posix version
	/** JSDoc */
	function normalizePath(path) {
	    var isPathAbsolute = isAbsolute(path);
	    var trailingSlash = path.substr(-1) === '/';
	    // Normalize the path
	    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
	    if (!normalizedPath && !isPathAbsolute) {
	        normalizedPath = '.';
	    }
	    if (normalizedPath && trailingSlash) {
	        normalizedPath += '/';
	    }
	    return (isPathAbsolute ? '/' : '') + normalizedPath;
	}
	exports.normalizePath = normalizePath;
	// posix version
	/** JSDoc */
	function isAbsolute(path) {
	    return path.charAt(0) === '/';
	}
	exports.isAbsolute = isAbsolute;
	// posix version
	/** JSDoc */
	function join() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return normalizePath(args.join('/'));
	}
	exports.join = join;
	/** JSDoc */
	function dirname(path) {
	    var result = splitPath(path);
	    var root = result[0];
	    var dir = result[1];
	    if (!root && !dir) {
	        // No dirname whatsoever
	        return '.';
	    }
	    if (dir) {
	        // It has a dirname, strip trailing slash
	        dir = dir.substr(0, dir.length - 1);
	    }
	    return root + dir;
	}
	exports.dirname = dirname;
	/** JSDoc */
	function basename(path, ext) {
	    var f = splitPath(path)[2];
	    if (ext && f.substr(ext.length * -1) === ext) {
	        f = f.substr(0, f.length - ext.length);
	    }
	    return f;
	}
	exports.basename = basename;
	//# sourceMappingURL=path.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
	/**
	 * setPrototypeOf polyfill using __proto__
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function setProtoOf(obj, proto) {
	    // @ts-ignore __proto__ does not exist on obj
	    obj.__proto__ = proto;
	    return obj;
	}
	/**
	 * setPrototypeOf polyfill using mixin
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function mixinProperties(obj, proto) {
	    for (var prop in proto) {
	        // eslint-disable-next-line no-prototype-builtins
	        if (!obj.hasOwnProperty(prop)) {
	            // @ts-ignore typescript complains about indexing so we remove
	            obj[prop] = proto[prop];
	        }
	    }
	    return obj;
	}
	//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var error_1 = __webpack_require__(41);
	var syncpromise_1 = __webpack_require__(69);
	/** A simple queue that holds promises. */
	var PromiseBuffer = /** @class */ (function () {
	    function PromiseBuffer(_limit) {
	        this._limit = _limit;
	        /** Internal set of queued Promises */
	        this._buffer = [];
	    }
	    /**
	     * Says if the buffer is ready to take more requests
	     */
	    PromiseBuffer.prototype.isReady = function () {
	        return this._limit === undefined || this.length() < this._limit;
	    };
	    /**
	     * Add a promise to the queue.
	     *
	     * @param task Can be any PromiseLike<T>
	     * @returns The original promise.
	     */
	    PromiseBuffer.prototype.add = function (task) {
	        var _this = this;
	        if (!this.isReady()) {
	            return syncpromise_1.SyncPromise.reject(new error_1.SentryError('Not adding Promise due to buffer limit reached.'));
	        }
	        if (this._buffer.indexOf(task) === -1) {
	            this._buffer.push(task);
	        }
	        task
	            .then(function () { return _this.remove(task); })
	            .then(null, function () {
	            return _this.remove(task).then(null, function () {
	                // We have to add this catch here otherwise we have an unhandledPromiseRejection
	                // because it's a new Promise chain.
	            });
	        });
	        return task;
	    };
	    /**
	     * Remove a promise to the queue.
	     *
	     * @param task Can be any PromiseLike<T>
	     * @returns Removed promise.
	     */
	    PromiseBuffer.prototype.remove = function (task) {
	        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
	        return removedTask;
	    };
	    /**
	     * This function returns the number of unresolved promises in the queue.
	     */
	    PromiseBuffer.prototype.length = function () {
	        return this._buffer.length;
	    };
	    /**
	     * This will drain the whole queue, returns true if queue is empty or drained.
	     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
	     *
	     * @param timeout Number in ms to wait until it resolves with false.
	     */
	    PromiseBuffer.prototype.drain = function (timeout) {
	        var _this = this;
	        return new syncpromise_1.SyncPromise(function (resolve) {
	            var capturedSetTimeout = setTimeout(function () {
	                if (timeout && timeout > 0) {
	                    resolve(false);
	                }
	            }, timeout);
	            syncpromise_1.SyncPromise.all(_this._buffer)
	                .then(function () {
	                clearTimeout(capturedSetTimeout);
	                resolve(true);
	            })
	                .then(null, function () {
	                resolve(true);
	            });
	        });
	    };
	    return PromiseBuffer;
	}());
	exports.PromiseBuffer = PromiseBuffer;
	//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var misc_1 = __webpack_require__(18);
	var node_1 = __webpack_require__(43);
	/**
	 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
	 *
	 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
	 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
	 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
	 */
	var dateTimestampSource = {
	    nowSeconds: function () { return Date.now() / 1000; },
	};
	/**
	 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
	 * support the API.
	 *
	 * Wrapping the native API works around differences in behavior from different browsers.
	 */
	function getBrowserPerformance() {
	    var performance = misc_1.getGlobalObject().performance;
	    if (!performance || !performance.now) {
	        return undefined;
	    }
	    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
	    //
	    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
	    // performance.now() gives a date arbitrarily in the past.
	    //
	    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
	    // undefined.
	    //
	    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
	    // interact with data coming out of performance entries.
	    //
	    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
	    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
	    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
	    // observed skews that can be as long as days, weeks or months.
	    //
	    // See https://github.com/getsentry/sentry-javascript/issues/2590.
	    //
	    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
	    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
	    // transactions of long-lived web pages.
	    var timeOrigin = Date.now() - performance.now();
	    return {
	        now: function () { return performance.now(); },
	        timeOrigin: timeOrigin,
	    };
	}
	/**
	 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
	 * implement the API.
	 */
	function getNodePerformance() {
	    try {
	        var perfHooks = node_1.dynamicRequire(module, 'perf_hooks');
	        return perfHooks.performance;
	    }
	    catch (_) {
	        return undefined;
	    }
	}
	/**
	 * The Performance API implementation for the current platform, if available.
	 */
	var platformPerformance = node_1.isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
	var timestampSource = platformPerformance === undefined
	    ? dateTimestampSource
	    : {
	        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
	    };
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
	 */
	exports.dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
	 * availability of the Performance API.
	 *
	 * See `usingPerformanceAPI` to test whether the Performance API is used.
	 *
	 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
	 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
	 * skew can grow to arbitrary amounts like days, weeks or months.
	 * See https://github.com/getsentry/sentry-javascript/issues/2590.
	 */
	exports.timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
	// Re-exported with an old name for backwards-compatibility.
	exports.timestampWithMs = exports.timestampInSeconds;
	/**
	 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
	 */
	exports.usingPerformanceAPI = platformPerformance !== undefined;
	/**
	 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
	 * performance API is available.
	 */
	exports.browserPerformanceTimeOrigin = (function () {
	    var performance = misc_1.getGlobalObject().performance;
	    if (!performance) {
	        return undefined;
	    }
	    if (performance.timeOrigin) {
	        return performance.timeOrigin;
	    }
	    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
	    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
	    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
	    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
	    // Date API.
	    // eslint-disable-next-line deprecation/deprecation
	    return (performance.timing && performance.timing.navigationStart) || Date.now();
	})();
	//# sourceMappingURL=time.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)(module)))

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _create = __webpack_require__(153);
	
	var _create2 = _interopRequireDefault(_create);
	
	exports.default = AnimatedNumber;
	
	var _events = __webpack_require__(201);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AnimatedNumber() {
	  var _this = this;
	
	  var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.01;
	
	  this.tendTo = initial;
	  this.initialValue = initial;
	
	  var lastValue = initial;
	
	  var animate = function animate() {
	    var nextValue = lastValue * 0.9 + _this.tendTo * 0.1;
	
	    if (nextValue < resolution * 20) {
	      nextValue = lastValue * 0.8 + _this.tendTo * 0.2;
	    }
	
	    if (nextValue < resolution) {
	      _this.emit('change', _this.initialValue);
	      lastValue = _this.initialValue;
	    } else if (Math.abs(nextValue - lastValue) > resolution || nextValue < resolution * 10) {
	      _this.emit('change', Math.round(nextValue / resolution) * resolution);
	      lastValue = nextValue;
	    }
	
	    requestAnimationFrame(animate);
	  };
	
	  requestAnimationFrame(animate);
	}
	
	AnimatedNumber.prototype = (0, _create2.default)(_events2.default.prototype);
	
	AnimatedNumber.prototype.set = function setNumber(newNumber) {
	  this.tendTo = newNumber;
	};
	
	AnimatedNumber.prototype.reset = function resetNumber() {
	  this.tendTo = this.initialValue;
	};

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calcDeg;
	function calcDeg(s) {
	  var deg = void 0;
	
	  if (s < 5) {
	    deg = s * (31 / 5);
	  } else if (s < 10) {
	    deg = 31;
	    deg += (s - 5) * ((61 - 31) / (10 - 5));
	  } else if (s < 15) {
	    deg = 61;
	    deg += (s - 10) * ((91 - 61) / (15 - 10));
	  } else if (s < 25) {
	    deg = 91;
	    deg += (s - 15) * ((121 - 91) / (25 - 15));
	  } else if (s < 50) {
	    deg = 121;
	    deg += (s - 25) * ((151 - 121) / (50 - 25));
	  } else if (s < 100) {
	    deg = 151;
	    deg += (s - 50) * ((179 - 151) / (100 - 50));
	  } else if (s < 300) {
	    deg = 179;
	    deg += (s - 100) * ((210 - 179) / (300 - 100));
	  } else if (s < 500) {
	    deg = 210;
	    deg += (s - 300) * ((240 - 210) / (500 - 300));
	  } else if (s < 1000) {
	    deg = 240;
	    deg += (s - 500) * ((266 - 240) / (1000 - 500));
	  } else {
	    deg = 266;
	  }
	
	  return Math.round(deg);
	}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = changeStyles;
	
	var _qs = __webpack_require__(24);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function changeColor() {
	  var testType = (0, _qs2.default)('test');
	
	  var primary = (0, _qs2.default)('primary');
	  var secondary = (0, _qs2.default)('secondary');
	
	  var latencyColor = (0, _qs2.default)('latency');
	  var jitterColor = (0, _qs2.default)('jitter');
	  var downloadColor = (0, _qs2.default)('download');
	  var uploadColor = (0, _qs2.default)('upload');
	
	  if (testType === 'animated') {
	    var jitterCss = '';
	
	    if (jitterColor === 'hidden') {
	      jitterCss = '.box--jitter { display: none; }';
	    } else if (jitterColor) {
	      jitterCss = '\n        .test-animated-el .box--jitter {\n          color: ' + jitterColor + ';\n          background: ' + jitterColor + ';\n        }\n      ';
	    }
	
	    if (!latencyColor || !downloadColor || !uploadColor || !primary) {
	      return jitterCss;
	    }
	
	    return '\n    .test-animated-el .box--upload {\n      color: ' + uploadColor + ';\n      background: ' + uploadColor + ';\n    }\n    .test-animated-el .box--download {\n      color: ' + downloadColor + ';\n      background: ' + downloadColor + ';\n    }\n    .test-animated-el .box--latency {\n      color: ' + latencyColor + ';\n      background: ' + latencyColor + ';\n    }\n    ' + jitterCss + '\n    .test-animated-el .test-info {\n      color: ' + primary + ';\n    }';
	  }
	
	  if (!primary || !secondary) {
	    return '';
	  }
	
	  return '\n  .test-default-el .gauge__face .gauge__arc--active {\n    stroke: ' + secondary + ';\n  }\n\n  .test-default-el .gauge__needle .gauge__needle--part1 {\n    fill: ' + primary + ';\n    stroke: ' + primary + ';\n  }\n\n  .test-default-el .gauge__needle .gauge__needle--part2 {\n    fill: ' + primary + ';\n  }\n\n  .test-default-el .gauge__needle circle {\n    fill: ' + primary + ';\n  }\n\n  .test-default-el .start-button {\n    background-color: ' + secondary + ';\n  }\n\n  .test-default-el .status-bar {\n    color: ' + secondary + ';\n  }';
	}
	
	function changeResultsVisibility() {
	  if ((0, _qs2.default)('show-results') === 'false') {
	    return '.results { display: none !important }';
	  }
	
	  return '';
	}
	
	function changeBrandingVisibility() {
	  if ((0, _qs2.default)('show-branding') === 'false') {
	    return '.byline { display: none }';
	  }
	
	  return '';
	}
	
	function changeStatusSize() {
	  if ((0, _qs2.default)('status') === 'result') {
	    return '.status-bar { font-size: 1.5em; padding-top: 0; }';
	  }
	
	  return '';
	}
	
	function changeStyles() {
	  var colorCss = changeColor();
	  var resultsCss = changeResultsVisibility();
	  var brandingCss = changeBrandingVisibility();
	  var statusCss = changeStatusSize();
	
	  if (colorCss || resultsCss || brandingCss || statusCss) {
	    var styleEl = document.createElement('style');
	    styleEl.type = 'text/css';
	    styleEl.innerHTML = colorCss + resultsCss + brandingCss + statusCss;
	
	    document.head.appendChild(styleEl);
	  }
	
	  var className = (0, _qs2.default)('test') || 'default';
	
	  document.body.classList.add('test-' + className);
	}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(77);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _stringify = __webpack_require__(151);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _asyncToGenerator2 = __webpack_require__(74);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(73);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(76);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(75);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _DEVICE_NAME_MAP;
	
	var _bowser = __webpack_require__(156);
	
	var Bowser = _interopRequireWildcard(_bowser);
	
	var _uaParserJs = __webpack_require__(209);
	
	var _http = __webpack_require__(148);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var USER_DEVICE_TYPE = {
	  PHONE: 'smartphone',
	  TABLET: 'tablet',
	  COMPUTER: 'desktop'
	};
	
	var DEVICE_NAME_MAP = (_DEVICE_NAME_MAP = {}, (0, _defineProperty3.default)(_DEVICE_NAME_MAP, USER_DEVICE_TYPE.PHONE, 'phone'), (0, _defineProperty3.default)(_DEVICE_NAME_MAP, USER_DEVICE_TYPE.TABLET, 'tablet'), (0, _defineProperty3.default)(_DEVICE_NAME_MAP, USER_DEVICE_TYPE.COMPUTER, 'computer'), _DEVICE_NAME_MAP);
	
	var DEVICE_TYPE_MAP = {
	  mobile: USER_DEVICE_TYPE.PHONE,
	  tablet: USER_DEVICE_TYPE.TABLET,
	  desktop: USER_DEVICE_TYPE.COMPUTER
	};
	
	var deviceNameMap = {
	  smartphone: 'phone',
	  tablet: 'tablet',
	  desktop: 'computer'
	};
	var DEFAULT_GENERIC_NAME = 'device';
	var ZEUS_API = ("https://zeus-api.samknows.one");
	var LS_KEY_DEVICE = 'samknows-iframe-detected-device';
	var DEVICE_DETECTION_VERSION = '2';
	
	exports.default = {
	  getDeviceFromUserAgent: function getDeviceFromUserAgent() {
	    var parser = new _uaParserJs.UAParser();
	    var device = parser.getDevice();
	
	    var browser = Bowser.parse(window.navigator.userAgent);
	    var deviceTypeKey = device.type || browser.platform.type;
	
	    var platformType = DEVICE_TYPE_MAP[deviceTypeKey];
	
	    return (0, _extends3.default)({}, device, {
	      manufacturer: device.vendor,
	      name: DEVICE_NAME_MAP[device.type],
	      type: platformType,
	      isMobileDevice: [USER_DEVICE_TYPE.PHONE, USER_DEVICE_TYPE.TABLET].indexOf(platformType) > -1,
	      genericName: deviceNameMap[device.type] || DEFAULT_GENERIC_NAME
	    });
	  },
	  waitForDeviceAtlasCookie: function waitForDeviceAtlasCookie() {
	    var intervalId = null;
	
	    return new _promise2.default(function (resolve) {
	      setTimeout(function () {
	        clearInterval(intervalId);
	        resolve('');
	      }, 3000);
	
	      intervalId = setInterval(function () {
	        var cookieName = 'DAPROPS';
	        var deviceAtlasCookie = document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)');
	
	        if (!deviceAtlasCookie) {
	          return;
	        }
	        resolve(deviceAtlasCookie[2]);
	        clearInterval(intervalId);
	      }, 100);
	    });
	  },
	  getDeviceFromApi: function getDeviceFromApi() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var cookie, _ref, data, properties, type, device;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.waitForDeviceAtlasCookie();
	
	            case 2:
	              cookie = _context.sent;
	              _context.next = 5;
	              return _http2.default.request(ZEUS_API + '/device-detect', {
	                method: 'POST',
	                body: (0, _stringify2.default)({
	                  device_cookie_data: cookie
	                })
	              });
	
	            case 5:
	              _ref = _context.sent;
	              data = _ref.data;
	              properties = data.properties;
	              type = properties.primary_hardware_type.toLowerCase().replace(' ', '_');
	
	              if (type === 'mobile_phone') {
	                type = USER_DEVICE_TYPE.PHONE;
	              }
	              device = {
	                type: type,
	                isMobileDevice: properties.is_mobile_phone || properties.is_tablet,
	                model: properties.model,
	                name: properties.marketing_name,
	                vendor: properties.vendor,
	                manufacturer: properties.manufacturer,
	                genericName: ''
	              };
	
	              device.genericName = deviceNameMap[device.type] || DEFAULT_GENERIC_NAME;
	
	              return _context.abrupt('return', device);
	
	            case 13:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  isLocalStorageSupported: function isLocalStorageSupported() {
	    try {
	      var testKey = 'false_key';
	      window.localStorage.setItem(testKey, testKey);
	      window.localStorage.removeItem(testKey);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  },
	  getSavedDevice: function getSavedDevice() {
	    var savedDeviceString = localStorage.getItem(LS_KEY_DEVICE);
	
	    if (!savedDeviceString) {
	      return undefined;
	    }
	
	    var savedDevice = JSON.parse(savedDeviceString);
	
	    var isOutdatedVersion = savedDevice.version !== DEVICE_DETECTION_VERSION;
	    var hasExpired = Date.now() > savedDevice.expiry;
	
	    if (isOutdatedVersion || hasExpired) {
	      localStorage.removeItem(LS_KEY_DEVICE);
	      return undefined;
	    }
	
	    return savedDevice.value;
	  },
	  getDevice: function getDevice() {
	    var _this2 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	      var device, ttl, deviceToSave;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              device = _this2.isLocalStorageSupported() ? _this2.getSavedDevice() : undefined;
	
	              if (!device) {
	                _context2.next = 3;
	                break;
	              }
	
	              return _context2.abrupt('return', device);
	
	            case 3:
	              _context2.prev = 3;
	              _context2.next = 6;
	              return _this2.getDeviceFromApi();
	
	            case 6:
	              device = _context2.sent;
	              ttl = 30 * 24 * 60 * 60 * 1000;
	              deviceToSave = {
	                value: device,
	                expiry: Date.now() + ttl,
	                version: DEVICE_DETECTION_VERSION
	              };
	
	
	              if (_this2.isLocalStorageSupported()) {
	                localStorage.setItem(LS_KEY_DEVICE, (0, _stringify2.default)(deviceToSave));
	              }
	              _context2.next = 15;
	              break;
	
	            case 12:
	              _context2.prev = 12;
	              _context2.t0 = _context2['catch'](3);
	
	              device = _this2.getDeviceFromUserAgent();
	
	            case 15:
	              return _context2.abrupt('return', device);
	
	            case 16:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[3, 12]]);
	    }))();
	  }
	};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(77);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(76);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _asyncToGenerator2 = __webpack_require__(74);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  request: function request(url, options) {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var defaultHeaders, commonOptions, fetchOptions, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              defaultHeaders = (0, _extends3.default)({
	                'Content-Type': 'application/json'
	              }, options.headers);
	              commonOptions = {
	                headers: new Headers(defaultHeaders)
	              };
	              fetchOptions = (0, _extends3.default)({}, options, commonOptions);
	              _context.next = 5;
	              return fetch(url, fetchOptions);
	
	            case 5:
	              response = _context.sent;
	
	              if (!response.ok) {
	                _context.next = 8;
	                break;
	              }
	
	              return _context.abrupt('return', response.json());
	
	            case 8:
	              throw response;
	
	            case 9:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(155);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = setupTest;
	
	var _cdevWebSdk = __webpack_require__(70);
	
	var _cdevWebSdk2 = _interopRequireDefault(_cdevWebSdk);
	
	var _getResult2 = __webpack_require__(71);
	
	var _getResult3 = _interopRequireDefault(_getResult2);
	
	var _i18n = __webpack_require__(72);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (_i18n2.default.rtl) {
	  document.body.dir = 'rtl';
	}
	
	var isIE = navigator.userAgent.includes('Trident');
	if (isIE) {
	  document.body.classList.add('is-ie');
	}
	
	var startBtnEl = document.querySelector('.test-animated-el .js-start');
	var errorMssgEl = document.querySelector('.test-animated-el .js-error');
	
	var resultEls = void 0;
	var initResultEls = function initResultEls() {
	  resultEls = {
	    latency: {
	      val: document.querySelector('.test-animated-el .result-latency-val'),
	      unit: document.querySelector('.test-animated-el .result-latency-unit'),
	      parent: document.querySelector('.test-animated-el .box__main-latency')
	    },
	    jitter: {
	      val: document.querySelector('.test-animated-el .result-jitter-val'),
	      unit: document.querySelector('.test-animated-el .result-jitter-unit'),
	      parent: document.querySelector('.test-animated-el .box__main-jitter')
	    },
	    download: {
	      val: document.querySelector('.test-animated-el .result-download-val'),
	      unit: document.querySelector('.test-animated-el .result-download-unit'),
	      parent: document.querySelector('.test-animated-el .box__main-download')
	    },
	    upload: {
	      val: document.querySelector('.test-animated-el .result-upload-val'),
	      unit: document.querySelector('.test-animated-el .result-upload-unit'),
	      parent: document.querySelector('.test-animated-el .box__main-upload')
	    }
	  };
	};
	
	initResultEls();
	
	var animationEls = {
	  latency: document.querySelector('#animate-latency'),
	  download: document.querySelector('#animate-download'),
	  upload: {
	    line: document.querySelector('#animate-upload-line'),
	    arrow: document.querySelector('#animate-upload-arrow')
	  }
	};
	
	function setupTest(options) {
	  startBtnEl.addEventListener('click', function () {
	    if (startBtnEl.classList.contains('start__btn--disabled')) {
	      return;
	    }
	
	    errorMssgEl.textContent = '';
	    errorMssgEl.classList.add('u-hidden');
	    startBtnEl.classList.add('start__btn--disabled');
	
	    window.parent.postMessage({ type: 'reset' }, '*');
	
	    (0, _keys2.default)(resultEls).forEach(function (resultEl) {
	      resultEls[resultEl].parent.classList.remove('display-result');
	    });
	
	    animationEls.latency.className.baseVal = 'animate-latency';
	    resultEls.latency.parent.classList.add('animating');
	
	    if (window.ga) {
	      window.ga('send', 'test-start');
	    }
	
	    var st = new _cdevWebSdk2.default(options);
	
	    st.on('test-done', function (test, results) {
	      var _getResult = (0, _getResult3.default)(results),
	          unit = _getResult.unit,
	          val = _getResult.val;
	
	      if (test === 'latency') {
	        animationEls.latency.className.baseVal = '';
	        animationEls.download.className.baseVal = 'animate-download';
	        resultEls.latency.parent.classList.remove('animating');
	        resultEls.download.parent.classList.add('animating');
	
	        if (isIE) {
	          setTimeout(function () {
	            resultEls.latency.parent.outerHTML = resultEls.latency.parent.outerHTML;
	            initResultEls();
	          }, 5);
	        }
	
	        var jitterRes = (0, _getResult3.default)(results, 'jitter');
	
	        if (jitterRes) {
	          setTimeout(function () {
	            resultEls.jitter.val.innerHTML = jitterRes.val >= 10 ? Math.round(jitterRes.val) : Math.round(jitterRes.val * 10) / 10;
	            resultEls.jitter.unit.innerHTML = _i18n2.default[jitterRes.unit];
	            resultEls.jitter.parent.classList.add('display-result');
	          }, 450);
	        }
	      } else if (test === 'download') {
	        animationEls.download.className.baseVal = '';
	        animationEls.upload.line.className.baseVal = 'animate-upload-line';
	        animationEls.upload.arrow.className.baseVal = 'animate-upload-arrow';
	        resultEls.download.parent.classList.remove('animating');
	        resultEls.upload.parent.classList.add('animating');
	
	        if (isIE) {
	          setTimeout(function () {
	            resultEls.download.parent.outerHTML = resultEls.download.parent.outerHTML;
	            initResultEls();
	          }, 5);
	        }
	      } else if (test === 'upload') {
	        animationEls.upload.line.className.baseVal = '';
	        animationEls.upload.arrow.className.baseVal = '';
	        resultEls.upload.parent.classList.remove('animating');
	
	        if (isIE) {
	          setTimeout(function () {
	            resultEls.upload.parent.outerHTML = resultEls.upload.parent.outerHTML;
	            initResultEls();
	          }, 5);
	        }
	      }
	
	      resultEls[test].val.innerHTML = val >= 10 ? Math.round(val) : Math.round(val * 10) / 10;
	      resultEls[test].unit.innerHTML = _i18n2.default[unit];
	      resultEls[test].parent.classList.add('display-result');
	    });
	
	    st.on('done', function () {
	      startBtnEl.classList.remove('start__btn--disabled');
	
	      if (window.ga) {
	        window.ga('send', 'test-end');
	      }
	    });
	
	    st.on('warning', function (code) {
	      window.parent.postMessage({ type: 'warning', code: code }, '*');
	    });
	
	    st.on('test-id', function (testId) {
	      window.parent.postMessage({ type: 'test-id', data: testId }, '*');
	    });
	
	    st.on('error', function (error) {
	      var errorType = error && error.type || null;
	      var errorCode = 'TEST_FAILED';
	
	      if (errorType && errorType === 'INITIATE_ERROR') {
	        var errorMssg = error.message;
	        window.parent.postMessage({ type: 'warning', code: errorCode, error: errorMssg.toString() }, '*');
	
	        errorMssgEl.textContent = _i18n2.default.initiateFail;
	        errorMssgEl.classList.remove('u-hidden');
	        startBtnEl.classList.remove('start__btn--disabled');
	        animationEls.latency.className.baseVal = '';
	        resultEls.latency.parent.classList.remove('animating');
	        return;
	      }
	
	      var code = typeof error === 'string' ? error : errorCode;
	      window.parent.postMessage({ type: 'warning', code: code, error: error.toString() }, '*');
	    });
	
	    st.runSpeedTest();
	  });
	}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setupTest;
	
	var _cdevWebSdk = __webpack_require__(70);
	
	var _cdevWebSdk2 = _interopRequireDefault(_cdevWebSdk);
	
	var _animator = __webpack_require__(144);
	
	var _animator2 = _interopRequireDefault(_animator);
	
	var _calcDeg = __webpack_require__(145);
	
	var _calcDeg2 = _interopRequireDefault(_calcDeg);
	
	var _getResult3 = __webpack_require__(71);
	
	var _getResult4 = _interopRequireDefault(_getResult3);
	
	var _qs = __webpack_require__(24);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _i18n = __webpack_require__(72);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (_i18n2.default.rtl) {
	  document.body.dir = 'rtl';
	}
	
	var arcEl = document.querySelector('.test-default-el .js-arc');
	var needleEl = document.querySelector('.test-default-el .js-needle');
	var startBtnEl = document.querySelector('.test-default-el .js-start');
	var statusEl = document.querySelector('.test-default-el .js-status');
	var resultsEl = document.querySelector('.test-default-el .results');
	var resultEls = {
	  download: {
	    val: document.querySelector('.test-default-el .js-download-val'),
	    unit: document.querySelector('.test-default-el .js-download-unit')
	  },
	  upload: {
	    val: document.querySelector('.test-default-el .js-upload-val'),
	    unit: document.querySelector('.test-default-el .js-upload-unit')
	  },
	  latency: {
	    val: document.querySelector('.test-default-el .js-latency-val'),
	    unit: document.querySelector('.test-default-el .js-latency-unit')
	  },
	  jitter: {
	    val: document.querySelector('.test-default-el .js-jitter-val'),
	    unit: document.querySelector('.test-default-el .js-jitter-unit')
	  }
	};
	
	startBtnEl.addEventListener('click', function () {
	  if (window.ga) {
	    window.ga('send', 'test-start');
	  }
	});
	
	var availableTests = ['latency', 'jitter', 'download', 'upload'];
	
	function setupTest(options) {
	  var totalArcLength = arcEl.getTotalLength();
	  arcEl.setAttribute('stroke-dasharray', totalArcLength);
	  arcEl.setAttribute('stroke-dashoffset', totalArcLength);
	
	  var animator = new _animator2.default(0, 0.1);
	  animator.on('change', function (deg) {
	    needleEl.setAttribute('transform', 'rotate(' + deg + ' 160 160)');
	    arcEl.setAttribute('stroke-dashoffset', totalArcLength * (1 - deg / 270));
	  });
	
	  startBtnEl.addEventListener('click', function () {
	    resultsEl.classList.remove('u-hidden');
	    startBtnEl.classList.add('u-hidden');
	    statusEl.classList.remove('u-hidden');
	    statusEl.textContent = _i18n2.default.testing.replace('#{test}', _i18n2.default.latency);
	
	    availableTests.forEach(function (test) {
	      resultEls[test].val.textContent = '--';
	      resultEls[test].unit.textContent = '';
	    });
	
	    var st = new _cdevWebSdk2.default(options);
	
	    var results = void 0;
	
	    var i = 0;
	    var frame = function frame() {
	      if (results && !results.inProgress) {
	        return;
	      }
	
	      requestAnimationFrame(frame);
	
	      if (results) {
	        var _getResult = (0, _getResult4.default)(results),
	            unit = _getResult.unit,
	            val = _getResult.val;
	
	        if (unit === 'kbps' || unit === 'mbps') {
	          animator.set((0, _calcDeg2.default)(unit === 'kbps' ? val / 1024 : val));
	        } else {
	          animator.reset();
	        }
	
	        if (val === '0.00') {
	          return;
	        }
	
	        if (i % 10 === 0) {
	          resultEls[results.inProgress].val.innerHTML = val;
	          resultEls[results.inProgress].unit.innerHTML = _i18n2.default[unit];
	
	          if ((0, _qs2.default)('status') !== 'result') {
	            statusEl.textContent = _i18n2.default.testing.replace('#{test}', _i18n2.default[results.inProgress]);
	          } else {
	            var displayResult = unit === 'kbps' || unit === 'mbps';
	            statusEl.textContent = displayResult ? val + ' ' + _i18n2.default[unit] : '';
	          }
	        }
	        i += 1;
	      }
	    };
	
	    requestAnimationFrame(frame);
	
	    st.on('progress', function (innerResults) {
	      results = innerResults;
	    });
	
	    st.on('test-done', function (test, results) {
	      window.parent.postMessage({ type: 'progress', data: results }, '*');
	
	      animator.reset();
	
	      var _getResult2 = (0, _getResult4.default)(results, test),
	          unit = _getResult2.unit,
	          val = _getResult2.val;
	
	      var next = {
	        latency: 'download',
	        download: 'upload'
	      };
	
	      statusEl.textContent = _i18n2.default.testing.replace('#{test}', _i18n2.default[next[test]]);
	
	      resultEls[test].val.innerHTML = val;
	      resultEls[test].unit.innerHTML = _i18n2.default[unit];
	
	      if (test === 'latency') {
	        var jitterRes = (0, _getResult4.default)(results, 'jitter');
	
	        resultEls.jitter.val.innerHTML = jitterRes.val;
	        resultEls.jitter.unit.innerHTML = _i18n2.default[jitterRes.unit];
	      }
	    });
	
	    st.on('done', function (results) {
	      window.parent.postMessage({ type: 'complete', data: results }, '*');
	
	      startBtnEl.classList.remove('u-hidden');
	      statusEl.classList.add('u-hidden');
	      startBtnEl.textContent = _i18n2.default.restart;
	
	      animator.reset();
	
	      if (window.ga) {
	        window.ga('send', 'test-end');
	      }
	    });
	
	    st.on('warning', function (code) {
	      window.parent.postMessage({ type: 'warning', code: code }, '*');
	    });
	
	    st.on('test-id', function (testId) {
	      window.parent.postMessage({ type: 'test-id', data: testId }, '*');
	    });
	
	    st.on('error', function (error) {
	      var errorType = error && error.type || null;
	      var errorCode = 'TEST_FAILED';
	
	      if (errorType && errorType === 'INITIATE_ERROR') {
	        var errorMssg = error.message;
	        window.parent.postMessage({ type: 'warning', code: errorCode, error: errorMssg.toString() }, '*');
	
	        statusEl.textContent = _i18n2.default.initiateFail;
	        startBtnEl.classList.remove('u-hidden');
	        startBtnEl.textContent = _i18n2.default.restart;
	        return;
	      }
	
	      var code = typeof error === 'string' ? error : errorCode;
	      window.parent.postMessage({ type: 'warning', code: code, error: error.toString() }, '*');
	    });
	
	    st.runSpeedTest();
	  });
	}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(157), __esModule: true };

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(158), __esModule: true };

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(159), __esModule: true };

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(160), __esModule: true };

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(161), __esModule: true };

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.bowser=t():e.bowser=t()}(this,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=r(18),i=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),10===t[0])switch(t[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";case 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,n){void 0===n&&(n=!1);var i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),a=Math.max(i,s),o=0,u=e.map([t,r],(function(t){var r=a-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(n&&(o=a-Math.min(i,s)),a-=1;a>=o;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===o)return 0;a-=1}else if(u[0][a]<u[1][a])return-1}},e.map=function(e,t){var r,n=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)n.push(t(e[r]));return n},e.find=function(e,t){var r,n;if(Array.prototype.find)return Array.prototype.find.call(e,t);for(r=0,n=e.length;r<n;r+=1){var i=e[r];if(t(i,r))return i}},e.assign=function(e){for(var t,r,n=e,i=arguments.length,s=new Array(i>1?i-1:0),a=1;a<i;a++)s[a-1]=arguments[a];if(Object.assign)return Object.assign.apply(Object,[e].concat(s));var o=function(){var e=s[t];"object"==typeof e&&null!==e&&Object.keys(e).forEach((function(t){n[t]=e[t]}))};for(t=0,r=s.length;t<r;t+=1)o();return e},e.getBrowserAlias=function(e){return n.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return n.BROWSER_MAP[e]||""},e}();t.default=i,e.exports=t.default},18:function(e,t,r){"use strict";t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"};t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(91))&&n.__esModule?n:{default:n},s=r(18);function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var o=function(){function e(){}var t,r,n;return e.getParser=function(e,t){if(void 0===t&&(t=!1),"string"!=typeof e)throw new Error("UserAgent should be a string");return new i.default(e,t)},e.parse=function(e){return new i.default(e).getResult()},t=e,n=[{key:"BROWSER_MAP",get:function(){return s.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return s.ENGINE_MAP}},{key:"OS_MAP",get:function(){return s.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return s.PLATFORMS_MAP}}],(r=null)&&a(t.prototype,r),n&&a(t,n),e}();t.default=o,e.exports=t.default},91:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=u(r(92)),i=u(r(93)),s=u(r(94)),a=u(r(95)),o=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t){if(void 0===t&&(t=!1),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},!0!==t&&this.parse()}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=o.default.find(n.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=o.default.find(i.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=o.default.find(s.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=o.default.find(a.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return o.default.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},n=0,i={},s=0;if(Object.keys(e).forEach((function(t){var a=e[t];"string"==typeof a?(i[t]=a,s+=1):"object"==typeof a&&(r[t]=a,n+=1)})),n>0){var a=Object.keys(r),u=o.default.find(a,(function(e){return t.isOS(e)}));if(u){var d=this.satisfies(r[u]);if(void 0!==d)return d}var c=o.default.find(a,(function(e){return t.isPlatform(e)}));if(c){var f=this.satisfies(r[c]);if(void 0!==f)return f}}if(s>0){var l=Object.keys(i),h=o.default.find(l,(function(e){return t.isBrowser(e,!0)}));if(void 0!==h)return this.compareVersion(i[h])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),n=e.toLowerCase(),i=o.default.getBrowserTypeByAlias(n);return t&&i&&(n=i.toLowerCase()),n===r},t.compareVersion=function(e){var t=[0],r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(n=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),t.indexOf(o.default.compareVersions(i,r,n))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e,t){return void 0===t&&(t=!1),this.isBrowser(e,t)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=d,e.exports=t.default},92:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n};var s=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opt\/\d+(?:.?_?\d+)+/i],describe:function(e){var t={name:"Opera Touch"},r=i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},r=i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/electron/i],describe:function(e){var t={name:"Electron"},r=i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MiuiBrowser/i],describe:function(e){var t={name:"Miui"},r=i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},r=i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return{name:i.default.getFirstMatch(t,e),version:i.default.getSecondMatch(t,e)}}}];t.default=a,e.exports=t.default},93:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/Roku\/DVP/],describe:function(e){var t=i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return{name:s.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.WindowsPhone,version:t}}},{test:[/windows /i],describe:function(e){var t=i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=i.default.getWindowsVersionName(t);return{name:s.OS_MAP.Windows,version:t,versionName:r}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(e){var t={name:s.OS_MAP.iOS},r=i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/,e);return r&&(t.version=r),t}},{test:[/macintosh/i],describe:function(e){var t=i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=i.default.getMacOSVersionName(t),n={name:s.OS_MAP.MacOS,version:t};return r&&(n.versionName=r),n}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:s.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),r=i.default.getAndroidVersionName(t),n={name:s.OS_MAP.Android,version:t};return r&&(n.versionName=r),n}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:s.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||i.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:s.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return{name:s.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:s.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.PlayStation4,version:t}}}];t.default=a,e.exports=t.default},94:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=i.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=i.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:s.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}},{test:function(e){return"roku"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}}];t.default=a,e.exports=t.default},95:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return{name:s.ENGINE_MAP.Blink};var t=i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:s.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:s.ENGINE_MAP.Trident},r=i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:s.ENGINE_MAP.Presto},r=i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:s.ENGINE_MAP.Gecko},r=i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:s.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:s.ENGINE_MAP.WebKit},r=i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=a,e.exports=t.default}})}));

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(4);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(191);
	module.exports = __webpack_require__(4).Object.assign;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(192);
	var $Object = __webpack_require__(4).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(193);
	var $Object = __webpack_require__(4).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(194);
	module.exports = __webpack_require__(4).Object.keys;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(195);
	__webpack_require__(197);
	__webpack_require__(200);
	__webpack_require__(196);
	__webpack_require__(198);
	__webpack_require__(199);
	module.exports = __webpack_require__(4).Promise;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 164 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(55);
	var toLength = __webpack_require__(90);
	var toAbsoluteIndex = __webpack_require__(186);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(27);
	var call = __webpack_require__(170);
	var isArrayIter = __webpack_require__(169);
	var anObject = __webpack_require__(12);
	var toLength = __webpack_require__(90);
	var getIterFn = __webpack_require__(189);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(13) && !__webpack_require__(28)(function () {
	  return Object.defineProperty(__webpack_require__(48)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 168 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(20);
	var ITERATOR = __webpack_require__(6)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(12);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(83);
	var descriptor = __webpack_require__(86);
	var setToStringTag = __webpack_require__(52);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(15)(IteratorPrototype, __webpack_require__(6)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(6)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var macrotask = __webpack_require__(89).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(26)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(13);
	var getKeys = __webpack_require__(51);
	var gOPS = __webpack_require__(177);
	var pIE = __webpack_require__(180);
	var toObject = __webpack_require__(56);
	var IObject = __webpack_require__(81);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(28)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(21);
	var anObject = __webpack_require__(12);
	var getKeys = __webpack_require__(51);
	
	module.exports = __webpack_require__(13) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(29);
	var toObject = __webpack_require__(56);
	var IE_PROTO = __webpack_require__(53)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(29);
	var toIObject = __webpack_require__(55);
	var arrayIndexOf = __webpack_require__(165)(false);
	var IE_PROTO = __webpack_require__(53)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 180 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(9);
	var core = __webpack_require__(4);
	var fails = __webpack_require__(28);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(15);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(15);


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var core = __webpack_require__(4);
	var dP = __webpack_require__(21);
	var DESCRIPTORS = __webpack_require__(13);
	var SPECIES = __webpack_require__(6)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(54);
	var defined = __webpack_require__(47);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(54);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(19);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(78);
	var ITERATOR = __webpack_require__(6)('iterator');
	var Iterators = __webpack_require__(20);
	module.exports = __webpack_require__(4).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(163);
	var step = __webpack_require__(173);
	var Iterators = __webpack_require__(20);
	var toIObject = __webpack_require__(55);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(82)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(9);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(175) });


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(83) });


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(13), 'Object', { defineProperty: __webpack_require__(21).f });


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(56);
	var $keys = __webpack_require__(51);
	
	__webpack_require__(181)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 195 */
/***/ (function(module, exports) {



/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(49);
	var global = __webpack_require__(5);
	var ctx = __webpack_require__(27);
	var classof = __webpack_require__(78);
	var $export = __webpack_require__(9);
	var isObject = __webpack_require__(19);
	var aFunction = __webpack_require__(25);
	var anInstance = __webpack_require__(164);
	var forOf = __webpack_require__(166);
	var speciesConstructor = __webpack_require__(88);
	var task = __webpack_require__(89).set;
	var microtask = __webpack_require__(174)();
	var newPromiseCapabilityModule = __webpack_require__(50);
	var perform = __webpack_require__(84);
	var userAgent = __webpack_require__(188);
	var promiseResolve = __webpack_require__(85);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(6)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(182)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(52)($Promise, PROMISE);
	__webpack_require__(184)(PROMISE);
	Wrapper = __webpack_require__(4)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(172)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(185)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(82)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(9);
	var core = __webpack_require__(4);
	var global = __webpack_require__(5);
	var speciesConstructor = __webpack_require__(88);
	var promiseResolve = __webpack_require__(85);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(9);
	var newPromiseCapability = __webpack_require__(50);
	var perform = __webpack_require__(84);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(190);
	var global = __webpack_require__(5);
	var hide = __webpack_require__(15);
	var Iterators = __webpack_require__(20);
	var TO_STRING_TAG = __webpack_require__(6)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 202 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	module.exports = {"start":"إبدأ","restart":"إعادة اختبار القياس","testing":"#{test} جاري الاختبار","download":"سرعة التحميل","upload":"الرفع","latency":"وقت الإستجابة","jitter":"التقطع","poweredBy":"مدعوم من","mbps":"ميغابت في الثانية","kbps":"كيلوبت في الثانية","ms":"ملي ثانية","s":"","internetPerformanceTest":"","yourIp":"","testServerLocation":"","referenceNumber":"","startTest":"","initialising":"","initiateFail":"كانت هناك مشكلة، يرجى المحاولة مرة أخرى"}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	module.exports = {"start":"start","restart":"restart","testing":"Testing #{test}","download":"Download","upload":"Upload","latency":"Latency","jitter":"Jitter","poweredBy":"Powered by","mbps":"Mbps","kbps":"Kbps","ms":"ms","s":"s","internetPerformanceTest":"Internet performance test","yourIp":"Your IP:","testServerLocation":"Test server location:","referenceNumber":"Reference number:","startTest":"Start test","initialising":"Initialising #{test}","initiateFail":"There has been a problem, please try again"}

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	module.exports = {"start":"开始","restart":"重新开始","testing":"测试 #{test}","download":"下载","upload":"上载","latency":"时延","jitter":"抖动","poweredBy":"提供者","mbps":"兆比特/秒","kbps":"千比特/秒","ms":"毫秒","s":"秒","internetPerformanceTest":"互联网性能测试","yourIp":"你的互联网地址","testServerLocation":"测试服务器位置","referenceNumber":"参考编号","startTest":"开始测试","initialising":"初始化 #{test}","initiateFail":"发生了问题，请再试"}

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	module.exports = {"start":"開始","restart":"重新開始","testing":"測試 #{test}","download":"下載","upload":"上載","latency":"時延","jitter":"抖動","poweredBy":"提供者","mbps":"兆比特/秒","kbps":"千比特/秒","ms":"毫秒","s":"秒","internetPerformanceTest":"互聯網性能測試","yourIp":"你的互聯網地址","testServerLocation":"測試服務器位置","referenceNumber":"參考編號","startTest":"開始測試","initialising":"初始化 #{test}","initiateFail":"發生了問題，請再試"}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(208);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
	/* UAParser.js v0.7.40
	   Copyright © 2012-2024 Faisal Salman <f@faisalman.com>
	   MIT License *//*
	   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
	   Supports browser & node.js environment. 
	   Demo   : https://faisalman.github.io/ua-parser-js
	   Source : https://github.com/faisalman/ua-parser-js */
	/////////////////////////////////////////////////////////////////////////////////
	
	(function (window, undefined) {
	
	    'use strict';
	
	    //////////////
	    // Constants
	    /////////////
	
	
	    var LIBVERSION  = '0.7.40',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major',
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded',
	        UA_MAX_LENGTH = 500;
	
	    var AMAZON  = 'Amazon',
	        APPLE   = 'Apple',
	        ASUS    = 'ASUS',
	        BLACKBERRY = 'BlackBerry',
	        BROWSER = 'Browser',
	        CHROME  = 'Chrome',
	        EDGE    = 'Edge',
	        FIREFOX = 'Firefox',
	        GOOGLE  = 'Google',
	        HUAWEI  = 'Huawei',
	        LG      = 'LG',
	        MICROSOFT = 'Microsoft',
	        MOTOROLA  = 'Motorola',
	        OPERA   = 'Opera',
	        SAMSUNG = 'Samsung',
	        SHARP   = 'Sharp',
	        SONY    = 'Sony',
	        XIAOMI  = 'Xiaomi',
	        ZEBRA   = 'Zebra',
	        FACEBOOK    = 'Facebook',
	        CHROMIUM_OS = 'Chromium OS',
	        MAC_OS  = 'Mac OS',
	        SUFFIX_BROWSER = ' Browser';
	
	    ///////////
	    // Helper
	    //////////
	
	    var extend = function (regexes, extensions) {
	            var mergedRegexes = {};
	            for (var i in regexes) {
	                if (extensions[i] && extensions[i].length % 2 === 0) {
	                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
	                } else {
	                    mergedRegexes[i] = regexes[i];
	                }
	            }
	            return mergedRegexes;
	        },
	        enumerize = function (arr) {
	            var enums = {};
	            for (var i=0; i<arr.length; i++) {
	                enums[arr[i].toUpperCase()] = arr[i];
	            }
	            return enums;
	        },
	        has = function (str1, str2) {
	            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
	        },
	        lowerize = function (str) {
	            return str.toLowerCase();
	        },
	        majorize = function (version) {
	            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
	        },
	        trim = function (str, len) {
	            if (typeof(str) === STR_TYPE) {
	                str = str.replace(/^\s\s*/, EMPTY);
	                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
	            }
	    };
	
	    ///////////////
	    // Map helper
	    //////////////
	
	    var rgxMapper = function (ua, arrays) {
	
	            var i = 0, j, k, p, q, matches, match;
	
	            // loop through all regexes maps
	            while (i < arrays.length && !matches) {
	
	                var regex = arrays[i],       // even sequence (0,2,4,..)
	                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
	                j = k = 0;
	
	                // try matching uastring with regexes
	                while (j < regex.length && !matches) {
	
	                    if (!regex[j]) { break; }
	                    matches = regex[j++].exec(ua);
	
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length === 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        this[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        this[q[0]] = q[1];
	                                    }
	                                } else if (q.length === 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length === 4) {
	                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                this[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	        },
	
	        strMapper = function (str, map) {
	
	            for (var i in map) {
	                // check if current value is array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined : i;
	                        }
	                    }
	                } else if (has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined : i;
	                }
	            }
	            return map.hasOwnProperty('*') ? map['*'] : str;
	    };
	
	    ///////////////
	    // String map
	    //////////////
	
	    // Safari < 3.0
	    var oldSafariMap = {
	            '1.0'   : '/8',
	            '1.2'   : '/1',
	            '1.3'   : '/3',
	            '2.0'   : '/412',
	            '2.0.2' : '/416',
	            '2.0.3' : '/417',
	            '2.0.4' : '/419',
	            '?'     : '/'
	        },
	        windowsVersionMap = {
	            'ME'        : '4.90',
	            'NT 3.11'   : 'NT3.51',
	            'NT 4.0'    : 'NT4.0',
	            '2000'      : 'NT 5.0',
	            'XP'        : ['NT 5.1', 'NT 5.2'],
	            'Vista'     : 'NT 6.0',
	            '7'         : 'NT 6.1',
	            '8'         : 'NT 6.2',
	            '8.1'       : 'NT 6.3',
	            '10'        : ['NT 6.4', 'NT 10.0'],
	            'RT'        : 'ARM'
	    };
	
	    //////////////
	    // Regex map
	    /////////////
	
	    var regexes = {
	
	        browser : [[
	
	            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
	            ], [VERSION, [NAME, 'Chrome']], [
	            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
	            ], [VERSION, [NAME, 'Edge']], [
	
	            // Presto based
	            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
	            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
	            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
	            ], [NAME, VERSION], [
	            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
	            ], [VERSION, [NAME, OPERA+' Mini']], [
	            /\bop(?:rg)?x\/([\w\.]+)/i                                          // Opera GX
	            ], [VERSION, [NAME, OPERA+' GX']], [
	            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
	            ], [VERSION, [NAME, OPERA]], [
	
	            // Mixed
	            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i            // Baidu
	            ], [VERSION, [NAME, 'Baidu']], [
	            /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i                       // Maxthon
	            ], [VERSION, [NAME, 'Maxthon']], [
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,      
	                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
	            // Trident based
	            /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,        // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
	            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer
	
	            // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
	            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
	                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
	            /(heytap|ovi|115)browser\/([\d\.]+)/i,                              // HeyTap/Ovi/115
	            /(weibo)__([\d\.]+)/i                                               // Weibo
	            ], [NAME, VERSION], [
	            /quark(?:pc)?\/([-\w\.]+)/i                                         // Quark
	            ], [VERSION, [NAME, 'Quark']], [
	            /\bddg\/([\w\.]+)/i                                                 // DuckDuckGo
	            ], [VERSION, [NAME, 'DuckDuckGo']], [
	            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
	            ], [VERSION, [NAME, 'UC'+BROWSER]], [
	            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
	            /\bqbcore\/([\w\.]+).+microm/i,
	            /micromessenger\/([\w\.]+)/i                                        // WeChat
	            ], [VERSION, [NAME, 'WeChat']], [
	            /konqueror\/([\w\.]+)/i                                             // Konqueror
	            ], [VERSION, [NAME, 'Konqueror']], [
	            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
	            ], [VERSION, [NAME, 'IE']], [
	            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
	            ], [VERSION, [NAME, 'Yandex']], [
	            /slbrowser\/([\w\.]+)/i                                             // Smart Lenovo Browser
	            ], [VERSION, [NAME, 'Smart Lenovo '+BROWSER]], [
	            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
	            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
	            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
	            ], [VERSION, [NAME, FIREFOX+' Focus']], [
	            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
	            ], [VERSION, [NAME, OPERA+' Touch']], [
	            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
	            ], [VERSION, [NAME, 'Coc Coc']], [
	            /dolfin\/([\w\.]+)/i                                                // Dolphin
	            ], [VERSION, [NAME, 'Dolphin']], [
	            /coast\/([\w\.]+)/i                                                 // Opera Coast
	            ], [VERSION, [NAME, OPERA+' Coast']], [
	            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI' + SUFFIX_BROWSER]], [
	            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, FIREFOX]], [
	            /\bqihoobrowser\/?([\w\.]*)/i                                       // 360
	            ], [VERSION, [NAME, '360']], [
	            /\b(qq)\/([\w\.]+)/i                                                // QQ
	            ], [[NAME, /(.+)/, '$1Browser'], VERSION], [
	            /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
	            ], [[NAME, /(.+)/, '$1' + SUFFIX_BROWSER], VERSION], [              // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
	            /samsungbrowser\/([\w\.]+)/i                                        // Samsung Internet
	            ], [VERSION, [NAME, SAMSUNG + ' Internet']], [
	            /metasr[\/ ]?([\d\.]+)/i                                            // Sogou Explorer
	            ], [VERSION, [NAME, 'Sogou Explorer']], [
	            /(sogou)mo\w+\/([\d\.]+)/i                                          // Sogou Mobile
	            ], [[NAME, 'Sogou Mobile'], VERSION], [
	            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
	            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
	            /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i   // QQ/2345
	            ], [NAME, VERSION], [
	            /(lbbrowser|rekonq)/i,                                              // LieBao Browser/Rekonq
	            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
	            ], [NAME], [
	            /ome\/([\w\.]+) \w* ?(iron) saf/i,                                  // Iron
	            /ome\/([\w\.]+).+qihu (360)[es]e/i                                  // 360
	            ], [VERSION, NAME], [
	
	            // WebView
	            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
	            ], [[NAME, FACEBOOK], VERSION], [
	            /(Klarna)\/([\w\.]+)/i,                                             // Klarna Shopping Browser for iOS & Android
	            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
	            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
	            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
	            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
	            /(alipay)client\/([\w\.]+)/i,                                       // Alipay
	            /(twitter)(?:and| f.+e\/([\w\.]+))/i,                               // Twitter
	            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i                     // Chromium/Instagram/Snapchat
	            ], [NAME, VERSION], [
	            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
	            ], [VERSION, [NAME, 'GSA']], [
	            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
	            ], [VERSION, [NAME, 'TikTok']], [
	
	            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
	            ], [VERSION, [NAME, CHROME+' Headless']], [
	
	            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
	            ], [[NAME, CHROME+' WebView'], VERSION], [
	
	            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
	            ], [VERSION, [NAME, 'Android '+BROWSER]], [
	
	            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
	            ], [NAME, VERSION], [
	
	            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [
	            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
	            ], [VERSION, NAME], [
	            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
	            ], [NAME, [VERSION, strMapper, oldSafariMap]], [
	
	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [
	
	            // Gecko based
	            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /(wolvic|librewolf)\/([\w\.]+)/i                                    // Wolvic/LibreWolf
	            ], [NAME, VERSION], [
	            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
	            ], [VERSION, [NAME, FIREFOX+' Reality']], [
	            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
	            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla
	
	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
	            /(links) \(([\w\.]+)/i                                              // Links
	            ], [NAME, [VERSION, /_/g, '.']], [
	            
	            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
	            ], [NAME, [VERSION, /master.|lts./, ""]]
	        ],
	
	        cpu : [[
	
	            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
	            ], [[ARCHITECTURE, 'amd64']], [
	
	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, lowerize]], [
	
	            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
	            ], [[ARCHITECTURE, 'ia32']], [
	
	            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
	            ], [[ARCHITECTURE, 'arm64']], [
	
	            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
	            ], [[ARCHITECTURE, 'armhf']], [
	
	            // PocketPC mistakenly identified as PowerPC
	            /windows (ce|mobile); ppc;/i
	            ], [[ARCHITECTURE, 'arm']], [
	
	            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
	            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [
	
	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [
	
	            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, lowerize]]
	        ],
	
	        device : [[
	
	            //////////////////////////
	            // MOBILES & TABLETS
	            /////////////////////////
	
	            // Samsung
	            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
	            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
	            /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
	            /samsung[- ]((?!sm-[lr])[-\w]+)/i,
	            /sec-(sgh\w+)/i
	            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [
	
	            // Apple
	            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
	            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
	            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
	            /applecoremedia\/[\w\.]+ \((ipad)/i,
	            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
	            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
	            /(macintosh);/i
	            ], [MODEL, [VENDOR, APPLE]], [
	
	            // Sharp
	            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
	            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [
	
	            // Honor
	            /(?:honor)([-\w ]+)[;\)]/i
	            ], [MODEL, [VENDOR, 'Honor'], [TYPE, MOBILE]], [
	
	            // Huawei
	            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
	            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
	            /(?:huawei)([-\w ]+)[;\)]/i,
	            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
	            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [
	
	            // Xiaomi
	            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,                  // Xiaomi POCO
	            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
	            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
	            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
	            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,        // Xiaomi Redmi 'numeric' models
	            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i // Xiaomi Mi
	            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
	            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,                     // Redmi Pad
	            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
	            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [
	
	            // OPPO
	            /; (\w+) bui.+ oppo/i,
	            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
	            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
	            /\b(opd2\d{3}a?) bui/i
	            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, TABLET]], [
	
	            // Vivo
	            /vivo (\w+)(?: bui|\))/i,
	            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
	            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [
	
	            // Realme
	            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
	            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [
	
	            // Motorola
	            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
	            /\bmot(?:orola)?[- ](\w*)/i,
	            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
	            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
	            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
	            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [
	
	            // LG
	            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
	            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
	            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
	            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
	            /\blg-?([\d\w]+) bui/i
	            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [
	
	            // Lenovo
	            /(ideatab[-\w ]+)/i,
	            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
	
	            // Nokia
	            /(?:maemo|nokia).*(n900|lumia \d+)/i,
	            /nokia[-_ ]?([-\w\.]*)/i
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [
	
	            // Google
	            /(pixel c)\b/i                                                      // Google Pixel C
	            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
	            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
	            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [
	
	            // Sony
	            /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
	            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
	            /sony tablet [ps]/i,
	            /\b(?:sony)?sgp\w+(?: bui|\))/i
	            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [
	
	            // OnePlus
	            / (kb2005|in20[12]5|be20[12][59])\b/i,
	            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
	            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [
	
	            // Amazon
	            /(alexa)webm/i,
	            /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,                           // Kindle Fire without Silk / Echo Show
	            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
	            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
	            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
	            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [
	
	            // BlackBerry
	            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [
	            /\b((?:bb[a-f]|st[hv])100-\d)/i,
	            /\(bb10; (\w+)/i                                                    // BlackBerry 10
	            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [
	
	            // Asus
	            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
	            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
	            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
	            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [
	
	            // HTC
	            /(nexus 9)/i                                                        // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
	            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC
	
	            // ZTE
	            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
	            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
	
	            // TCL
	            /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
	            ], [MODEL, [VENDOR, 'TCL'], [TYPE, TABLET]], [
	
	            // itel
	            /(itel) ((\w+))/i
	            ], [[VENDOR, lowerize], MODEL, [TYPE, strMapper, { 'tablet' : ['p10001l', 'w7001'], '*' : 'mobile' }]], [
	
	            // Acer
	            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
	
	            // Meizu
	            /droid.+; (m[1-5] note) bui/i,
	            /\bmz-([-\w]{2,})/i
	            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
	                
	            // Ulefone
	            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
	            ], [MODEL, [VENDOR, 'Ulefone'], [TYPE, MOBILE]], [
	
	            // Energizer
	            /; (energy ?\w+)(?: bui|\))/i,
	            /; energizer ([\w ]+)(?: bui|\))/i
	            ], [MODEL, [VENDOR, 'Energizer'], [TYPE, MOBILE]], [
	
	            // Cat
	            /; cat (b35);/i,
	            /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
	            ], [MODEL, [VENDOR, 'Cat'], [TYPE, MOBILE]], [
	
	            // Smartfren
	            /((?:new )?andromax[\w- ]+)(?: bui|\))/i
	            ], [MODEL, [VENDOR, 'Smartfren'], [TYPE, MOBILE]], [
	
	            // Nothing
	            /droid.+; (a(?:015|06[35]|142p?))/i
	            ], [MODEL, [VENDOR, 'Nothing'], [TYPE, MOBILE]], [
	
	            // MIXED
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
	                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
	            /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i,                             // IMO
	            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
	            /(asus)-?(\w+)/i,                                                   // Asus
	            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
	            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
	            /(jolla)/i,                                                         // Jolla
	            /(oppo) ?([\w ]+) bui/i                                             // OPPO
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /(imo) (tab \w+)/i,                                                 // IMO
	            /(kobo)\s(ereader|touch)/i,                                         // Kobo
	            /(archos) (gamepad2?)/i,                                            // Archos
	            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
	            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
	            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
	            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
	            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
	            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(surface duo)/i                                                    // Surface Duo
	            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
	            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
	            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
	            /(u304aa)/i                                                         // AT&T
	            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
	            /\bsie-(\w*)/i                                                      // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
	            /\b(rct\w+) b/i                                                     // RCA Tablets
	            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
	            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
	            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
	            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
	            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
	            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
	            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
	            /\b(tm\d{3}\w+) b/i
	            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
	            /\b(k88) b/i                                                        // ZTE K Series Tablet
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
	            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
	            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
	            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
	            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
	            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
	            /\b([yr]\d{2}) b/i,
	            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
	            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
	            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
	            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
	            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
	            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
	            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
	            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
	            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
	            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
	            /\b(ph-1) /i                                                        // Essential PH-1
	            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
	            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
	            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
	            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
	            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
	            /\btu_(1491) b/i                                                    // Rotor Tablets
	            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
	            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
	            /(sprint) (\w+)/i                                                   // Sprint Phones
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
	            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
	            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
	            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
	            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [
	
	            ///////////////////
	            // SMARTTVS
	            ///////////////////
	
	            /smart-tv.+(samsung)/i                                              // Samsung
	            ], [VENDOR, [TYPE, SMARTTV]], [
	            /hbbtv.+maple;(\d+)/i
	            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
	            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
	            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
	            /(apple) ?tv/i                                                      // Apple TV
	            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
	            /crkey/i                                                            // Google Chromecast
	            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
	            /droid.+aft(\w+)( bui|\))/i                                         // Fire TV
	            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
	            /\(dtv[\);].+(aquos)/i,
	            /(aquos-tv[\w ]+)\)/i                                               // Sharp
	            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
	            /(bravia[\w ]+)( bui|\))/i                                              // Sony
	            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
	            /(mitv-\w{5}) bui/i                                                 // Xiaomi
	            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
	            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
	            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
	            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
	            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
	            ], [[TYPE, SMARTTV]], [
	
	            ///////////////////
	            // CONSOLES
	            ///////////////////
	
	            /(ouya)/i,                                                          // Ouya
	            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
	            /droid.+; (shield) bui/i                                            // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
	            /(playstation [345portablevi]+)/i                                   // Playstation
	            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
	            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
	            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [
	
	            ///////////////////
	            // WEARABLES
	            ///////////////////
	
	            /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i                                   // Samsung Galaxy Watch
	            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, WEARABLE]], [
	            /((pebble))app/i                                                    // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
	            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
	            /droid.+; (glass) \d/i                                              // Google Glass
	            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
	            /droid.+; (wt63?0{2,3})\)/i
	            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
	
	            ///////////////////
	            // XR
	            ///////////////////
	
	            /droid.+; (glass) \d/i                                              // Google Glass
	            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
	            /(pico) (4|neo3(?: link|pro)?)/i                                    // Pico
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	            /; (quest( \d| pro)?)/i                                             // Oculus Quest
	            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [
	
	            ///////////////////
	            // EMBEDDED
	            ///////////////////
	
	            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
	            ], [VENDOR, [TYPE, EMBEDDED]], [
	            /(aeobc)\b/i                                                        // Echo Dot
	            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [
	
	            ////////////////////
	            // MIXED (GENERIC)
	            ///////////////////
	
	            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i    // Android Phones from Unidentified Vendors
	            ], [MODEL, [TYPE, MOBILE]], [
	            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
	            ], [MODEL, [TYPE, TABLET]], [
	            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
	            ], [[TYPE, TABLET]], [
	            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
	            ], [[TYPE, MOBILE]], [
	            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
	            ], [MODEL, [VENDOR, 'Generic']]
	        ],
	
	        engine : [[
	
	            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, EDGE+'HTML']], [
	
	            /(arkweb)\/([\w\.]+)/i                                              // ArkWeb
	            ], [NAME, VERSION], [
	
	            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
	            ], [VERSION, [NAME, 'Blink']], [
	
	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
	            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
	            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
	            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
	            /\b(libweb)/i
	            ], [NAME, VERSION], [
	
	            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
	            ], [VERSION, NAME]
	        ],
	
	        os : [[
	
	            // Windows
	            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i             // Windows Phone
	            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
	            /windows nt 6\.2; (arm)/i,                                        // Windows RT
	            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
	            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
	            ], [[VERSION, strMapper, windowsVersionMap], [NAME, 'Windows']], [
	
	            // iOS/macOS
	            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
	            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
	            /cfnetwork\/.+darwin/i
	            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
	            /(mac os x) ?([\w\. ]*)/i,
	            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
	            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [
	
	            // Mobile OSes
	            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
	            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS/OpenHarmony
	            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i,
	            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
	            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
	            /\((series40);/i                                                    // Series 40
	            ], [NAME, VERSION], [
	            /\(bb(10);/i                                                        // BlackBerry 10
	            ], [VERSION, [NAME, BLACKBERRY]], [
	            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
	            ], [VERSION, [NAME, 'Symbian']], [
	            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
	            ], [VERSION, [NAME, FIREFOX+' OS']], [
	            /web0s;.+rt(tv)/i,
	            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
	            ], [VERSION, [NAME, 'webOS']], [
	            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
	            ], [VERSION, [NAME, 'watchOS']], [
	
	            // Google Chromecast
	            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
	            ], [VERSION, [NAME, CHROME+'cast']], [
	            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
	            ], [[NAME, CHROMIUM_OS], VERSION],[
	
	            // Smart TVs
	            /panasonic;(viera)/i,                                               // Panasonic Viera
	            /(netrange)mmh/i,                                                   // Netrange
	            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV
	
	            // Console
	            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
	            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)
	
	            // Other
	            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
	            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
	            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
	            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
	                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
	            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
	            /(gnu) ?([\w\.]*)/i,                                                // GNU
	            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
	            /(haiku) (\w+)/i                                                    // Haiku
	            ], [NAME, VERSION], [
	            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [
	            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
	            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
	            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
	            /(unix) ?([\w\.]*)/i                                                // UNIX
	            ], [NAME, VERSION]
	        ]
	    };
	
	    /////////////////
	    // Constructor
	    ////////////////
	
	    var UAParser = function (ua, extensions) {
	
	        if (typeof ua === OBJ_TYPE) {
	            extensions = ua;
	            ua = undefined;
	        }
	
	        if (!(this instanceof UAParser)) {
	            return new UAParser(ua, extensions).getResult();
	        }
	
	        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined;
	        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
	        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined;
	        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
	        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
	
	        this.getBrowser = function () {
	            var _browser = {};
	            _browser[NAME] = undefined;
	            _browser[VERSION] = undefined;
	            rgxMapper.call(_browser, _ua, _rgxmap.browser);
	            _browser[MAJOR] = majorize(_browser[VERSION]);
	            // Brave-specific detection
	            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
	                _browser[NAME] = 'Brave';
	            }
	            return _browser;
	        };
	        this.getCPU = function () {
	            var _cpu = {};
	            _cpu[ARCHITECTURE] = undefined;
	            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
	            return _cpu;
	        };
	        this.getDevice = function () {
	            var _device = {};
	            _device[VENDOR] = undefined;
	            _device[MODEL] = undefined;
	            _device[TYPE] = undefined;
	            rgxMapper.call(_device, _ua, _rgxmap.device);
	            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
	                _device[TYPE] = MOBILE;
	            }
	            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
	            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
	                _device[MODEL] = 'iPad';
	                _device[TYPE] = TABLET;
	            }
	            return _device;
	        };
	        this.getEngine = function () {
	            var _engine = {};
	            _engine[NAME] = undefined;
	            _engine[VERSION] = undefined;
	            rgxMapper.call(_engine, _ua, _rgxmap.engine);
	            return _engine;
	        };
	        this.getOS = function () {
	            var _os = {};
	            _os[NAME] = undefined;
	            _os[VERSION] = undefined;
	            rgxMapper.call(_os, _ua, _rgxmap.os);
	            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') {
	                _os[NAME] = _uach.platform  
	                                    .replace(/chrome os/i, CHROMIUM_OS)
	                                    .replace(/macos/i, MAC_OS);           // backward compatibility
	            }
	            return _os;
	        };
	        this.getResult = function () {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return _ua;
	        };
	        this.setUA = function (ua) {
	            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
	            return this;
	        };
	        this.setUA(_ua);
	        return this;
	    };
	
	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
	    UAParser.CPU = enumerize([ARCHITECTURE]);
	    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
	    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);
	
	    ///////////
	    // Export
	    //////////
	
	    // check js environment
	    if (typeof(exports) !== UNDEF_TYPE) {
	        // nodejs env
	        if (typeof module !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if ("function" === FUNC_TYPE && __webpack_require__(210)) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else if (typeof window !== UNDEF_TYPE) {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }
	
	    // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
	    if ($ && !$.ua) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function () {
	            return parser.getUA();
	        };
	        $.ua.set = function (ua) {
	            parser.setUA(ua);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }
	
	})(typeof window === 'object' ? window : this);


/***/ }),
/* 210 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/app.210466d953db73418019.js